import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** https://docs.aws.amazon.com/appsync/latest/devguide/scalars.html */
  AWSJSON: { input: { [key: string]: any }; output: { [key: string]: any }; }
};

export type AccessControlAck = {
  __typename?: 'AccessControlAck';
  status: Scalars['String']['output'];
};

export enum AccessControlRole {
  Admin = 'admin',
  Editor = 'editor',
  Invoker = 'invoker',
  Member = 'member',
  Owner = 'owner',
  Viewer = 'viewer'
}

export type AlangParser = {
  __typename?: 'AlangParser';
  ast?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** A action that a worker can take to attempt to resolve a question or request. */
export type AnswerAction = {
  _?: Maybe<Scalars['String']['output']>;
};

export type AppSecrets = {
  __typename?: 'AppSecrets';
  googleMapApiKey: Scalars['String']['output'];
};

/** Approve a review request. */
export type ApproveReviewAction = AnswerAction & {
  __typename?: 'ApproveReviewAction';
  _?: Maybe<Scalars['String']['output']>;
};

export type ArchiveWorkerInput = {
  id: Scalars['ID']['input'];
  isArchived: Scalars['Boolean']['input'];
};

export type AssignRequestsInput = {
  assignmentPolicy: AssignmentPolicyInput;
  requestIds: Array<Scalars['ID']['input']>;
};

export type AssignRequestsResult = {
  __typename?: 'AssignRequestsResult';
  assignments: Array<RequestAssignment>;
};

export type AssignmentPolicy = {
  __typename?: 'AssignmentPolicy';
  collaborator?: Maybe<Scalars['String']['output']>;
  policyType: AssignmentPolicyType;
};

export type AssignmentPolicyInput = {
  collaborator?: InputMaybe<Scalars['String']['input']>;
  policyType: AssignmentPolicyType;
};

export enum AssignmentPolicyType {
  Collaborator = 'COLLABORATOR',
  ProcedureOwner = 'PROCEDURE_OWNER'
}

/** Base Block */
export type Block = {
  boundingBox: BoundingBox;
  confidence: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
};

export enum BlockType {
  KeyValue = 'KEY_VALUE',
  Line = 'LINE',
  Table = 'TABLE',
  Word = 'WORD'
}

export type BlocksByPage = {
  __typename?: 'BlocksByPage';
  blocksByType: Array<BlocksByType>;
  pageNum: Scalars['Int']['output'];
};

export type BlocksByType = {
  __typename?: 'BlocksByType';
  blockType: BlockType;
  blocks: Array<Block>;
};

export type BlocksResponse = {
  __typename?: 'BlocksResponse';
  blocksByPage: Array<BlocksByPage>;
  rawText?: Maybe<Scalars['String']['output']>;
};

export type Book = {
  __typename?: 'Book';
  author?: Maybe<Scalars['String']['output']>;
  commandId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  learnedAt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export type BookConnection = {
  __typename?: 'BookConnection';
  items?: Maybe<Array<Book>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type BoundingBox = {
  __typename?: 'BoundingBox';
  height: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  top: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
};

export type BoundingBoxInput = {
  height: Scalars['Float']['input'];
  left: Scalars['Float']['input'];
  top: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export type BoundingBoxWithPageInput = {
  boundingBox: BoundingBoxInput;
  pageNum: Scalars['Int']['input'];
};

export type BrainProvisionedConcurrencyInput = {
  concurrency: Scalars['Int']['input'];
  departmentId: Scalars['ID']['input'];
};

/** Koncierge chat message */
export type ChatMessage = {
  __typename?: 'ChatMessage';
  departmentId: Scalars['ID']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
  workerId: Scalars['ID']['output'];
};

/** Paginated list of chat messages. */
export type ChatMessageConnection = {
  __typename?: 'ChatMessageConnection';
  items: Array<ChatMessage>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type Command = WorkItem & {
  __typename?: 'Command';
  ast?: Maybe<Scalars['AWSJSON']['output']>;
  contextId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  debug?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  editors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  failedAt?: Maybe<Array<Scalars['String']['output']>>;
  forwardedAt?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  invokedAt?: Maybe<Array<Scalars['String']['output']>>;
  isMultilineText?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated deprecated */
  notifications?: Maybe<NotificationConnection>;
  output?: Maybe<Scalars['AWSJSON']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  positionInContext?: Maybe<Scalars['Int']['output']>;
  procedureId?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Array<Scalars['String']['output']>>;
  processingAt?: Maybe<Array<Scalars['String']['output']>>;
  readers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  receivedAt?: Maybe<Array<Scalars['String']['output']>>;
  sentenceId?: Maybe<Scalars['Int']['output']>;
  skippedAt?: Maybe<Array<Scalars['String']['output']>>;
  source?: Maybe<Scalars['String']['output']>;
  sourceMetadata?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  subText?: Maybe<Scalars['String']['output']>;
  subTextLanguage?: Maybe<Scalars['String']['output']>;
  subTextProperties?: Maybe<Array<Scalars['String']['output']>>;
  text?: Maybe<Scalars['String']['output']>;
  useAutopilot?: Maybe<Scalars['Boolean']['output']>;
  workErrors?: Maybe<Array<Scalars['String']['output']>>;
  workStatus?: Maybe<Scalars['String']['output']>;
  workerId: Scalars['ID']['output'];
};

export type CommandConnection = {
  __typename?: 'CommandConnection';
  items?: Maybe<Array<Maybe<Command>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type CommandParamsInput = {
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceMetadata?: InputMaybe<Scalars['String']['input']>;
  subTextParams: Array<Subtext>;
};

export type CommunicationItem = {
  __typename?: 'CommunicationItem';
  method: Scalars['String']['output'];
  parameters: Scalars['AWSJSON']['output'];
  recipients: Array<Scalars['String']['output']>;
};

export type Context = {
  __typename?: 'Context';
  commandId?: Maybe<Scalars['ID']['output']>;
  commands?: Maybe<Array<Maybe<Command>>>;
  concepts?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  depth?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  stepList?: Maybe<Array<Maybe<Step>>>;
  workerId: Scalars['ID']['output'];
};

export type ContextConnection = {
  __typename?: 'ContextConnection';
  items?: Maybe<Array<Maybe<Context>>>;
};

/** The contextual info contains the context as well as the learning id for that context */
export type ContextualLearningInfo = {
  __typename?: 'ContextualLearningInfo';
  /** The facts associated with the context */
  contextFactsInfo?: Maybe<Array<Maybe<Fact>>>;
  /**
   * The Metadata associated with the context.
   * @deprecated Use contextFactsInfo instead.
   */
  contextMetadata?: Maybe<Scalars['String']['output']>;
  /** The context string. */
  contextValue?: Maybe<Scalars['String']['output']>;
  /** The context vector embedding. */
  contextVector?: Maybe<Array<Scalars['Float']['output']>>;
  /** The time that this contextual_learning_info was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The id of the user that created this answer. */
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The flag to check if the context is deleted. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** The id of the learning that has this context */
  learningId?: Maybe<Scalars['String']['output']>;
  /** The id of the procedure that this learning belongs to. */
  procedureId?: Maybe<Scalars['ID']['output']>;
  /** The name of the procedure that this learning belongs to. */
  procedureName?: Maybe<Scalars['String']['output']>;
  /** The id of the request that has this context */
  requestId: Scalars['String']['output'];
};

/** The contextual info list */
export type ContextualLearningInfoConnection = {
  __typename?: 'ContextualLearningInfoConnection';
  items: Array<ContextualLearningInfo>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

/** Export format for contextual learning information */
export type ContextualLearningInfoExport = {
  __typename?: 'ContextualLearningInfoExport';
  /** Any other metadata associated with the context */
  contextMetadata?: Maybe<Scalars['String']['output']>;
  /** The string representation of the context */
  contextValue?: Maybe<Scalars['String']['output']>;
  /** The vector representation of the context, created from the value */
  contextVector?: Maybe<Scalars['String']['output']>;
  /** The id of the learning this is associated with */
  learningId?: Maybe<Scalars['String']['output']>;
  /** The lexical path */
  lexicalPath?: Maybe<Scalars['String']['output']>;
  /** The id of the procedure where this context was created */
  procedureId?: Maybe<Scalars['String']['output']>;
  /** The type of request question for that context */
  questionType?: Maybe<Scalars['String']['output']>;
  /** The step path of the procedure that is associated with the context */
  stepPath?: Maybe<Scalars['String']['output']>;
};

/** Import format for contextual learning information */
export type ContextualLearningInfoImport = {
  /** Any other metadata associated with the context */
  contextMetadata?: InputMaybe<Scalars['String']['input']>;
  /** The string representation of the context */
  contextValue?: InputMaybe<Scalars['String']['input']>;
  /** The vector representation of the context, created from the value */
  contextVector?: InputMaybe<Scalars['String']['input']>;
  /** The id of the learning this is associated with */
  learningId?: InputMaybe<Scalars['String']['input']>;
  /** The lexical path */
  lexicalPath?: InputMaybe<Scalars['String']['input']>;
  /** The id of the procedure where this context was created */
  procedureId?: InputMaybe<Scalars['String']['input']>;
  /** The type of request question for that context */
  questionType?: InputMaybe<Scalars['String']['input']>;
  /** The step path of the procedure that is associated with the context */
  stepPath?: InputMaybe<Scalars['String']['input']>;
};

/** Input for the createAnswer mutation. Exactly one of the question fields must be provided. */
export type CreateAnswerActionInput = {
  approveReviewAction?: InputMaybe<CreateApproveReviewActionInput>;
  oauth2MissingAction?: InputMaybe<OAuth2MissingActionInput>;
  replaceStepAction?: InputMaybe<CreateReplaceStepActionInput>;
  retryStepAction?: InputMaybe<CreateRetryStepActionInput>;
  skipStepAction?: InputMaybe<CreateSkipStepActionInput>;
  skipToEndOfRunAction?: InputMaybe<CreateSkipToEndOfRunActionInput>;
  useConceptAction?: InputMaybe<CreateUseConceptActionInput>;
  useLiteralValueAction?: InputMaybe<CreateUseLiteralValueActionInput>;
  useNoValueAction?: InputMaybe<CreateUseNoValueActionInput>;
  useTechniqueAction?: InputMaybe<CreateUseTechniqueActionInput>;
};

export type CreateApproveReviewActionInput = {
  _?: InputMaybe<Scalars['String']['input']>;
};

export type CreateChatMessageInput = {
  departmentId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  user?: InputMaybe<Scalars['String']['input']>;
  workerId: Scalars['ID']['input'];
};

export type CreateCommandInput = {
  ast?: InputMaybe<Scalars['AWSJSON']['input']>;
  contextId?: InputMaybe<Scalars['Int']['input']>;
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isMultilineText?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  output?: InputMaybe<Scalars['AWSJSON']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  procedureId?: InputMaybe<Scalars['String']['input']>;
  readers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sentenceId?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceMetadata?: InputMaybe<Scalars['String']['input']>;
  subText?: InputMaybe<Scalars['String']['input']>;
  subTextLanguage?: InputMaybe<Scalars['String']['input']>;
  subTextProperties?: InputMaybe<Array<Scalars['String']['input']>>;
  text: Scalars['String']['input'];
  useAutopilot?: InputMaybe<Scalars['Boolean']['input']>;
  workerId: Scalars['ID']['input'];
};

/** Create a department fact */
export type CreateDepartmentFactInput = {
  departmentId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type CreateDepartmentInput = {
  brainVersion?: InputMaybe<Scalars['String']['input']>;
  editors?: InputMaybe<Array<Scalars['String']['input']>>;
  featureFlags?: InputMaybe<Array<DepartmentFeatureFlag>>;
  features?: InputMaybe<Array<DepartmentFeature>>;
  local?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifyProcedureInvocation?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  purgeWorkerDataAfter?: InputMaybe<DataPurgeInterval>;
  readers?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<DepartmentStatus>;
  testContext?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLearnedAnswerInput = {
  action?: InputMaybe<CreateAnswerActionInput>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<CreateRequestQuestionFilterInput>;
  /** The id of the answer that this learning was created from, if any. */
  originalAnswerId?: InputMaybe<Scalars['ID']['input']>;
  /** The id of the worker where this learning was created. */
  originalWorkerId?: InputMaybe<Scalars['ID']['input']>;
  /** The id of the procedure that this learning was created from, if any. */
  procedureId?: InputMaybe<Scalars['ID']['input']>;
  /** The stage of the learning. */
  stage?: InputMaybe<Array<LearningStage>>;
};

export type CreateMiniPlayground = WorkItem & {
  __typename?: 'CreateMiniPlayground';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Array<Scalars['AWSJSON']['output']>>;
  failedAt?: Maybe<Array<Scalars['String']['output']>>;
  forwardedAt?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  invokedAt?: Maybe<Array<Scalars['String']['output']>>;
  lineId: Scalars['String']['output'];
  lineToken: Scalars['String']['output'];
  processedAt?: Maybe<Array<Scalars['String']['output']>>;
  processingAt?: Maybe<Array<Scalars['String']['output']>>;
  receivedAt?: Maybe<Array<Scalars['String']['output']>>;
  skippedAt?: Maybe<Array<Scalars['String']['output']>>;
  workErrors?: Maybe<Array<Scalars['String']['output']>>;
  workStatus?: Maybe<Scalars['String']['output']>;
  workerId: Scalars['ID']['output'];
};

export type CreateMiniPlaygroundInput = {
  document?: InputMaybe<Array<SentenceInput>>;
  lineId: Scalars['ID']['input'];
  lineToken: Scalars['String']['input'];
  sourceLearningId?: InputMaybe<Scalars['ID']['input']>;
  workerId: Scalars['ID']['input'];
};

export type CreateNotificationInput = {
  commandId: Scalars['ID']['input'];
  contextId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  info?: InputMaybe<Scalars['AWSJSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  readers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sentenceId?: InputMaybe<Scalars['Int']['input']>;
  workerId: Scalars['ID']['input'];
};

export type CreateOrganizationInput = {
  billingStatus?: InputMaybe<OrganizationBillingStatus>;
  name: Scalars['String']['input'];
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProcedureInput = {
  assignmentPolicy?: InputMaybe<AssignmentPolicyInput>;
  departmentId: Scalars['ID']['input'];
  knowledgeId?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReplaceStepActionInput = {
  newSteps?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateRequestAnswerInput = {
  action?: InputMaybe<CreateAnswerActionInput>;
  /** The id of the question that this answer is in response to. */
  questionId?: InputMaybe<Scalars['ID']['input']>;
  requestId: Scalars['ID']['input'];
};

export type CreateRequestAnswerSuggestionInput = {
  action?: InputMaybe<CreateAnswerActionInput>;
};

export type CreateRequestInput = {
  /** Boolean value to hint UI if brain requires all answers or one is enough */
  allQuestionsRequireAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  contextId?: InputMaybe<Scalars['Int']['input']>;
  /** List of instruction location were the request was created. */
  contextPath?: InputMaybe<Array<InstructionLocationByIdInput>>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  /** The line ID of the document where the request was raised. */
  lineId?: InputMaybe<Scalars['String']['input']>;
  /** The line token of the document where the request was raised. */
  lineToken?: InputMaybe<Scalars['String']['input']>;
  procedureId?: InputMaybe<Scalars['String']['input']>;
  procedureName?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<CreateRequestQuestionInput>>;
  sentenceId?: InputMaybe<Scalars['Int']['input']>;
  sourceMetadata?: InputMaybe<Scalars['String']['input']>;
  /** List of steps that contain this request, starting with the outermost step. Each step is identified by its english text. Similar to breadcrumbs. */
  stepPath?: InputMaybe<Array<Scalars['String']['input']>>;
  suggestedAnswers?: InputMaybe<Array<CreateRequestAnswerSuggestionInput>>;
  /** Top level text message in case of multiple questions in request */
  text?: InputMaybe<Scalars['String']['input']>;
  workerId: Scalars['ID']['input'];
};

export type CreateRequestQuestionFilterInput = {
  /** The lexical path that this learning applies to. */
  lexicalPath?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The type of question that this learning applies to. Example 'ValueNotKnownQuestion'. */
  questionType?: InputMaybe<Scalars['String']['input']>;
  stepPath?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Input for the createRequest mutation. Exactly one of the question fields must be provided. */
export type CreateRequestQuestionInput = {
  domainNotIntegrated?: InputMaybe<DomainNotIntegratedQuestionInput>;
  ensureFailed?: InputMaybe<EnsureFailedInput>;
  missingIntegrationCredential?: InputMaybe<MissingIntegrationCredentialInput>;
  nativeCodeError?: InputMaybe<NativeCodeErrorInput>;
  oauth2Missing?: InputMaybe<OAuth2MissingInput>;
  parseError?: InputMaybe<ParseErrorInput>;
  procedureNotKnown?: InputMaybe<ProcedureNotKnownInput>;
  reviewConcept?: InputMaybe<ReviewConceptInput>;
  valueNotKnown?: InputMaybe<ValueNotKnownInput>;
};

export type CreateRetryStepActionInput = {
  minimumDelay?: Scalars['Int']['input'];
  timeout?: InputMaybe<Scalars['Int']['input']>;
};

/** Input parameters for to schedule wakeup */
export type CreateScheduledWakeupCallInput = {
  scheduledTime: Scalars['String']['input'];
  workerId: Scalars['ID']['input'];
};

export type CreateSecretValueInput = {
  /** The confidence of the value. 0.0 is least confident, 1.0 is most confident. */
  confidence?: InputMaybe<Scalars['Float']['input']>;
  /** The value to be stored as a secret. */
  content: Scalars['String']['input'];
  /** The department to store the secret in */
  departmentId: Scalars['ID']['input'];
  /** The filename of the value. Can be null for non-file values. */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** Whether the value is a secret or not */
  secret?: InputMaybe<Scalars['Boolean']['input']>;
  /** The content type of the value */
  type: Scalars['String']['input'];
  /** The worker to store the secret for */
  workerId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateServiceCommandInput = {
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  error?: InputMaybe<Scalars['String']['input']>;
  method: Scalars['String']['input'];
  owner?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['String']['input']>;
  readers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  result?: InputMaybe<Scalars['String']['input']>;
  workerId: Scalars['ID']['input'];
};

export type CreateSharedEntityInput = {
  departmentId: Scalars['ID']['input'];
  departmentVersion?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['ID']['input'];
  shareName: Scalars['String']['input'];
};

export type CreateSkipStepActionInput = {
  _?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSkipToEndOfRunActionInput = {
  _?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUseConceptActionInput = {
  conceptId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUseLiteralValueActionInput = {
  choices?: InputMaybe<Array<Scalars['String']['input']>>;
  literalValue?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUseNoValueActionInput = {
  _?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUseTechniqueActionInput = {
  documentToken?: InputMaybe<Scalars['String']['input']>;
  technique?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWakeupCallInput = {
  documentToken?: InputMaybe<Scalars['String']['input']>;
  scheduledTime?: InputMaybe<Scalars['String']['input']>;
  workerId: Scalars['ID']['input'];
};

export type CreateWorkerInput = {
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  departmentVersion?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryCommand?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idempotencyToken?: InputMaybe<Scalars['String']['input']>;
  knowledgeId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  procedureId?: InputMaybe<Scalars['ID']['input']>;
  readers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stage?: InputMaybe<ProcedureStage>;
  state?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** structure of credential that each domain requires */
export type CredentialForm = {
  __typename?: 'CredentialForm';
  fields?: Maybe<Array<FormField>>;
  integrationId: Scalars['ID']['output'];
};

/** metadata for credentials */
export type CredentialMetadata = {
  __typename?: 'CredentialMetadata';
  departmentId: Scalars['ID']['output'];
  integrationId: Scalars['ID']['output'];
  /** Hint for UI to know if user has already given the required credentials.  This would be false if the provided credentials fails the validation check. */
  isCredentialProvided?: Maybe<Scalars['Boolean']['output']>;
  /** Let UI knows if oauth login is done once before */
  isRedirectionFlowDone?: Maybe<Scalars['Boolean']['output']>;
  lastChangedAt?: Maybe<Scalars['String']['output']>;
  lastChangedBy?: Maybe<Scalars['String']['output']>;
  lastValidatedAt?: Maybe<Scalars['String']['output']>;
  lastValidationMessage?: Maybe<Scalars['String']['output']>;
  lastValidationStatus?: Maybe<ValidationStatus>;
  /** This field would allow UI to display flow for integration that requires explicit user consent. After login is done once. It would be continue to be true, To allow user re-login. */
  redirectionFlowRequired?: Maybe<Scalars['Boolean']['output']>;
};

/** customer credentials for an integration */
export type CredentialValue = {
  __typename?: 'CredentialValue';
  data?: Maybe<Array<Maybe<Value>>>;
  departmentId: Scalars['ID']['output'];
  integrationId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** input for credential value mutation */
export type CredentialValueInput = {
  data?: InputMaybe<Array<InputMaybe<ValueInput>>>;
  departmentId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum DataPurgeInterval {
  Never = 'NEVER',
  OneDay = 'ONE_DAY',
  OneMinute = 'ONE_MINUTE',
  TenSeconds = 'TEN_SECONDS',
  TwentyDays = 'TWENTY_DAYS'
}

export type DayAggregatedValue = {
  __typename?: 'DayAggregatedValue';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

/** Delete a department fact. */
export type DeleteDepartmentFactInput = {
  departmentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type DeleteDepartmentInput = {
  id: Scalars['ID']['input'];
};

export type DeleteLearnedAnswerInput = {
  learnedAnswerId: Scalars['ID']['input'];
};

export type DeleteOrganizationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteProcedureInput = {
  departmentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  knowledgeId?: InputMaybe<Scalars['ID']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteRequestAnswerInput = {
  answerId: Scalars['ID']['input'];
  requestId: Scalars['ID']['input'];
};

export type DeleteRestoreContextualLearningInfoInput = {
  contextualLearningInfoIds: Array<Scalars['ID']['input']>;
  departmentId: Scalars['ID']['input'];
};

export type DeleteWorkerInput = {
  id: Scalars['ID']['input'];
};

/** A department is a collection of workers and knowledge. */
export type Department = {
  __typename?: 'Department';
  brainVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  /** @deprecated deprecated */
  draftKnowledge?: Maybe<Knowledge>;
  draftKnowledgeId?: Maybe<Scalars['String']['output']>;
  editors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  features?: Maybe<Array<DepartmentFeature>>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  learnedAnswers?: Maybe<LearnedAnswerConnection>;
  local?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notifyProcedureInvocation?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  provisionedConcurrency?: Maybe<Scalars['Int']['output']>;
  publishedKnowledge?: Maybe<Knowledge>;
  publishedKnowledgeId?: Maybe<Scalars['ID']['output']>;
  purgeWorkerDataAfter?: Maybe<DataPurgeInterval>;
  readers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requests?: Maybe<RequestConnection>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  testContext?: Maybe<Scalars['String']['output']>;
  upgradeCommandId?: Maybe<Scalars['String']['output']>;
  worker?: Maybe<Worker>;
  workerId?: Maybe<Scalars['ID']['output']>;
};


/** A department is a collection of workers and knowledge. */
export type DepartmentLearnedAnswersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


/** A department is a collection of workers and knowledge. */
export type DepartmentRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export enum DepartmentBookEntity {
  Fact = 'FACT',
  LearnedBook = 'LEARNED_BOOK',
  Procedure = 'PROCEDURE',
  Rollback = 'ROLLBACK'
}

export type DepartmentConnection = {
  __typename?: 'DepartmentConnection';
  items?: Maybe<Array<Maybe<Department>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type DepartmentExport = {
  __typename?: 'DepartmentExport';
  checksum?: Maybe<Scalars['String']['output']>;
  contextualLearningInfo?: Maybe<Array<Maybe<ContextualLearningInfoExport>>>;
  departmentID: Scalars['ID']['output'];
  departmentVersion?: Maybe<Scalars['String']['output']>;
  facts: Array<Maybe<FactExport>>;
  features?: Maybe<Array<Maybe<DepartmentFeature>>>;
  formatVersion: Scalars['Int']['output'];
  learnedBooks?: Maybe<LearnedBookExport>;
  learnings?: Maybe<Array<Maybe<LearningExport>>>;
  procedures: Array<Maybe<ProcedureExport>>;
};

/** A fact within a department. */
export type DepartmentFact = {
  __typename?: 'DepartmentFact';
  departmentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Paginated department facts. */
export type DepartmentFactConnection = {
  __typename?: 'DepartmentFactConnection';
  items?: Maybe<Array<Maybe<DepartmentFact>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export enum DepartmentFeature {
  Autopilot = 'AUTOPILOT',
  DepartmentBook = 'DEPARTMENT_BOOK',
  DocumentModel = 'DOCUMENT_MODEL',
  ExceptionRequest = 'EXCEPTION_REQUEST',
  ExceptionVectorDb = 'EXCEPTION_VECTOR_DB',
  KnowledgeEpochs = 'KNOWLEDGE_EPOCHS',
  MockSuggestedAnswers = 'MOCK_SUGGESTED_ANSWERS',
  SuggestAnswers = 'SUGGEST_ANSWERS'
}

export type DepartmentFeatureFlag = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  feature?: InputMaybe<DepartmentFeature>;
};

/** Paginated department history. */
export type DepartmentHistoryConnection = {
  __typename?: 'DepartmentHistoryConnection';
  items?: Maybe<Array<Maybe<DepartmentHistoryEvent>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

/** History event of the department book. */
export type DepartmentHistoryEvent = {
  __typename?: 'DepartmentHistoryEvent';
  entityId: Scalars['ID']['output'];
  entityName: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  operation: Scalars['String']['output'];
  publishedVersion?: Maybe<Scalars['String']['output']>;
  rollbackVersion?: Maybe<Scalars['String']['output']>;
  sharedEntities?: Maybe<Array<Maybe<SharedEntity>>>;
  timestamp: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type DepartmentImport = {
  checksum?: InputMaybe<Scalars['String']['input']>;
  contextualLearningInfo?: InputMaybe<Array<InputMaybe<ContextualLearningInfoImport>>>;
  departmentID: Scalars['ID']['input'];
  departmentVersion?: InputMaybe<Scalars['String']['input']>;
  facts: Array<InputMaybe<FactImport>>;
  features?: InputMaybe<Array<InputMaybe<DepartmentFeature>>>;
  formatVersion: Scalars['Int']['input'];
  learnedBooks?: InputMaybe<LearnedBookImport>;
  learnings?: InputMaybe<Array<InputMaybe<LearningImport>>>;
  procedures: Array<InputMaybe<ProcedureImport>>;
};

export type DepartmentImportInput = {
  /** A list of feature flags to override the feature flags for the department. */
  featureOverrides?: InputMaybe<Array<DepartmentFeatureFlag>>;
  /** Department data to import. Required. */
  importData?: InputMaybe<DepartmentImport>;
  /** The name of the department to be created. Required. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** This field is deprecated and any value provided is ignored. */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** The owner of the department to be created. Current user if not specified. */
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type DepartmentRollback = {
  __typename?: 'DepartmentRollback';
  currentVersion: Scalars['String']['output'];
  departmentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  previousVersion: Scalars['String']['output'];
  rollbackVersion: Scalars['String']['output'];
};

/** rollback a department to a given version. */
export type DepartmentRollbackInput = {
  departmentId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};

export enum DepartmentStatus {
  Paid = 'PAID',
  Pending = 'PENDING',
  Unpaid = 'UNPAID'
}

export type DepartmentUser = {
  __typename?: 'DepartmentUser';
  id: Scalars['ID']['output'];
  role: AccessControlRole;
  userId: Scalars['String']['output'];
};

export type DepartmentUserConnection = {
  __typename?: 'DepartmentUserConnection';
  items?: Maybe<Array<Maybe<DepartmentUser>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type DepartmentWorkerFactConnection = {
  __typename?: 'DepartmentWorkerFactConnection';
  items?: Maybe<Array<Maybe<Fact>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type Description = {
  __typename?: 'Description';
  factId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DictionaryItem = {
  __typename?: 'DictionaryItem';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DictionaryItemInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type DiscardProcedureDraftInput = {
  departmentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentInfo = {
  __typename?: 'DocumentInfo';
  sentences: Array<Maybe<Sentence>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  workerId: Scalars['ID']['output'];
};

/** Notifies the a particular domain was not learned. */
export type DomainNotIntegratedQuestion = RequestQuestion & {
  __typename?: 'DomainNotIntegratedQuestion';
  answer?: Maybe<RequestAnswer>;
  answerTypeHint?: Maybe<Scalars['String']['output']>;
  contextId?: Maybe<Scalars['Int']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  failedAnswerId?: Maybe<Scalars['ID']['output']>;
  failedAnswerReason?: Maybe<Scalars['String']['output']>;
  /** The answers that have been applied to and failed to resolve previous identical questions. */
  failedAnswers?: Maybe<Array<FailedAnswer>>;
  id: Scalars['ID']['output'];
  request?: Maybe<Request>;
  sentenceId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type DomainNotIntegratedQuestionInput = {
  answerTypeHint?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['Int']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  failedAnswerId?: InputMaybe<Scalars['ID']['input']>;
  failedAnswerReason?: InputMaybe<Scalars['String']['input']>;
  sentenceId?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type EnsureFailedInput = {
  answerTypeHint?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['Int']['input']>;
  failedAnswerId?: InputMaybe<Scalars['ID']['input']>;
  failedAnswerReason?: InputMaybe<Scalars['String']['input']>;
  sentenceId?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** The worker was not able to ensure that the statement is true. */
export type EnsureFailedQuestion = RequestQuestion & {
  __typename?: 'EnsureFailedQuestion';
  answer?: Maybe<RequestAnswer>;
  answerTypeHint?: Maybe<Scalars['String']['output']>;
  contextId?: Maybe<Scalars['Int']['output']>;
  failedAnswerId?: Maybe<Scalars['ID']['output']>;
  failedAnswerReason?: Maybe<Scalars['String']['output']>;
  /** The answers that have been applied to and failed to resolve previous identical questions. */
  failedAnswers?: Maybe<Array<FailedAnswer>>;
  id: Scalars['ID']['output'];
  request?: Maybe<Request>;
  sentenceId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export enum ExecutionStatus {
  Error = 'ERROR',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Success = 'SUCCESS'
}

export type Fact = {
  __typename?: 'Fact';
  childProperties?: Maybe<Scalars['String']['output']>;
  dereferencedId?: Maybe<Scalars['ID']['output']>;
  descriptions?: Maybe<Array<Maybe<Description>>>;
  editors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  knowledge?: Maybe<Knowledge>;
  knowledgeId?: Maybe<Scalars['ID']['output']>;
  locations?: Maybe<Array<Scalars['AWSJSON']['output']>>;
  names?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  owner?: Maybe<Scalars['String']['output']>;
  parentFact?: Maybe<Fact>;
  parentFactId?: Maybe<Scalars['ID']['output']>;
  readers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  referenceTo?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  relations?: Maybe<Array<Maybe<Relation>>>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  viewUrl?: Maybe<Scalars['String']['output']>;
};

export type FactExport = {
  __typename?: 'FactExport';
  name: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type FactImport = {
  name: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

/** A description of a previous answer that failed to resolve a question or request. */
export type FailedAnswer = {
  __typename?: 'FailedAnswer';
  /** Answer that was already applied and failed to resolve an earlier question. */
  answer: RequestAnswer;
  /** Reason that the earlier question failed to resolve. */
  message?: Maybe<Scalars['String']['output']>;
};

/** structure of a form field for a credential */
export type FormField = {
  __typename?: 'FormField';
  description?: Maybe<Scalars['String']['output']>;
  example?: Maybe<Scalars['String']['output']>;
  /** unique key for the field. The key will be used to store the value */
  key: Scalars['String']['output'];
  /** descriptive label for the field */
  label: Scalars['String']['output'];
  type: FormFieldType;
};

export enum FormFieldType {
  Email = 'email',
  Json = 'json',
  Number = 'number',
  Password = 'password',
  String = 'string'
}

export type GetDocumentBlocksInput = {
  boundingBoxWithPage?: InputMaybe<Array<BoundingBoxWithPageInput>>;
};

export type HandledRequest = WorkItem & {
  __typename?: 'HandledRequest';
  createdAt?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Array<Scalars['String']['output']>>;
  forwardedAt?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  invokedAt?: Maybe<Array<Scalars['String']['output']>>;
  processedAt?: Maybe<Array<Scalars['String']['output']>>;
  processingAt?: Maybe<Array<Scalars['String']['output']>>;
  receivedAt?: Maybe<Array<Scalars['String']['output']>>;
  requestId?: Maybe<Scalars['ID']['output']>;
  skippedAt?: Maybe<Array<Scalars['String']['output']>>;
  workErrors?: Maybe<Array<Scalars['String']['output']>>;
  workStatus?: Maybe<Scalars['String']['output']>;
  workerId: Scalars['ID']['output'];
};

export type HistoricalFactId = {
  epoch: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};

/** Location where the request was raised */
export type InstructionLocationById = {
  __typename?: 'InstructionLocationById';
  ctxId: Scalars['Int']['output'];
  sentenceId?: Maybe<Scalars['Int']['output']>;
};

export type InstructionLocationByIdInput = {
  ctxId: Scalars['Int']['input'];
  sentenceId?: InputMaybe<Scalars['Int']['input']>;
};

export type Integration = {
  __typename?: 'Integration';
  author?: Maybe<Scalars['String']['output']>;
  credentialMetadata?: Maybe<CredentialMetadata>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  integratedAt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

/** authorization url for user consent login */
export type IntegrationAuthorizationUrl = {
  __typename?: 'IntegrationAuthorizationURL';
  url?: Maybe<Scalars['String']['output']>;
};

export type IntegrationConnection = {
  __typename?: 'IntegrationConnection';
  items?: Maybe<Array<Integration>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

/** Console for Kognitos Administrators to view internal information about the service. */
export type InternalAdminConsole = {
  __typename?: 'InternalAdminConsole';
  /** The url to the CircleCI job that built the app that is currently running. */
  appBuildJobUrl: Scalars['String']['output'];
  /** The version string of the app that is servicing this request. Example: main-36387e7d5d-21040 */
  appBuildString: Scalars['String']['output'];
  /** List departments across all customers. Includes internal notes when available. */
  departments: InternalAdminDepartmentTable;
};


/** Console for Kognitos Administrators to view internal information about the service. */
export type InternalAdminConsoleDepartmentsArgs = {
  filter?: InputMaybe<InternalAdminDepartmentFilter>;
};

export type InternalAdminDepartmentFilter = {
  /** Include departments that are present in the app but do not have notes. */
  includeAppOnlyDepartments?: Scalars['Boolean']['input'];
  /** Include departments that have notes but are not present in the app. */
  includeNoteOnlyDepartments?: Scalars['Boolean']['input'];
};

/** Internal information about a department for the Internal Admin Console. */
export type InternalAdminDepartmentInfo = {
  __typename?: 'InternalAdminDepartmentInfo';
  /** The ID of the department. Example: "4t3vvvhxup558pkvojxjfjvzl"  */
  id: Scalars['ID']['output'];
  /**
   * A JSON dictionary containing internal app info about the department. The keys may change when the app is updated. May be "null". Example:
   *         "{\"name\": \"aaron1\", \"createdAt\": \"2023-11-22T00:16:40.941183+00:00\", \"isDeleted\": false, \"owner\": \"aaron@kognitos.com\", \"notifyProcedureInvocation\": null, \"upgradeCommandId\": null, \"features\": [\"KNOWLEDGE_EPOCHS\", \"EXCEPTION_REQUEST\", \"DOCUMENT_MODEL\", \"DEPARTMENT_BOOK\"], \"organizationId\": \"abbeo40sn7c2q69la56ms1rzu\", \"brainVersion\": \"experimental-run-watchdog-c1904ad53a-20231121235439\", \"status\": \"UNPAID\", \"purgeWorkerDataAfter\": null}",
   *
   */
  info: Scalars['String']['output'];
  /** A unique identifier for this department when using the InternalAdminConsole. (department id might not be unique within department notes) */
  key: Scalars['ID']['output'];
  /** The URL to use to view the department context in LaunchDarkly. */
  launchdarklyContextUrl?: Maybe<Scalars['String']['output']>;
  /**
   * A JSON dictionary containing the department's notes from Notion. The keys may change as the Notion database changes. May be "null". Example:
   *         "{\"Person\": [\"aaron@kognitos.com\"], \"Tags\": [\"foo\"], \"Name\": \"aaron1\", \"icon\": \"\\ud83e\\ude91\"}"
   *
   */
  notes: Scalars['String']['output'];
  /** The URL to view the department's notes in Notion. */
  notionDepartmentNotesUrl?: Maybe<Scalars['String']['output']>;
};

export type InternalAdminDepartmentTable = {
  __typename?: 'InternalAdminDepartmentTable';
  departments?: Maybe<Array<InternalAdminDepartmentInfo>>;
};

export type KeyValueBlock = Block & {
  __typename?: 'KeyValueBlock';
  boundingBox: BoundingBox;
  confidence: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Knowledge = {
  __typename?: 'Knowledge';
  brainVersion?: Maybe<Scalars['String']['output']>;
  departmentId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  editors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  parentKnowledgeId?: Maybe<Scalars['ID']['output']>;
  readers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  state?: Maybe<Scalars['String']['output']>;
  workerId?: Maybe<Scalars['ID']['output']>;
};

/** A learning automatically generates an answer for matching questions. */
export type LearnedAnswer = {
  __typename?: 'LearnedAnswer';
  /** The action to take to resolve the question. */
  action?: Maybe<AnswerAction>;
  /**
   * The contextMetadata associated with the learning
   * @deprecated Use contextualLearningInfos instead
   */
  contextMetadata?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * The contextValue associated with the learning
   * @deprecated Use contextalLearningInfos instead
   */
  contextValue?: Maybe<Array<Scalars['String']['output']>>;
  /** The contextual learning infos for this learning */
  contextualLearningInfos?: Maybe<ContextualLearningInfoConnection>;
  /** The time that this answer was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The id of the user that created this answer. */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The time that this answer was deleted. */
  deletedAt?: Maybe<Scalars['String']['output']>;
  /** The id of the user that deleted this answer. */
  deletedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The answer id from which this learning was created */
  originalAnswerId?: Maybe<Scalars['String']['output']>;
  /** The procedure that this learning belongs to. */
  procedure?: Maybe<Procedure>;
  /** The id of the procedure that this learning belongs to. */
  procedureId?: Maybe<Scalars['ID']['output']>;
  /** The name of the procedure that this learning belongs to. */
  procedureName?: Maybe<Scalars['String']['output']>;
  /** The filter that determines which questions this learning applies to. */
  questionFilter?: Maybe<RequestQuestionFilter>;
  /** The stage of the learning. */
  stage?: Maybe<Array<LearningStage>>;
  /** The time that this answer was updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type LearnedAnswerConnection = {
  __typename?: 'LearnedAnswerConnection';
  items: Array<LearnedAnswer>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

/** To fetch the most relevant learnings for a given exception/line/step path */
export type LearnedAnswerSuggestionsInput = {
  /** The id of the department that this learning belongs to. */
  departmentId: Scalars['ID']['input'];
  /** The lexical path for the learned answer suggestions */
  lexicalPath?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Number of learnings at a time */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Next token */
  nextToken?: InputMaybe<Scalars['String']['input']>;
  /** The id of the procedure that this learning belongs to. */
  procedureId: Scalars['ID']['input'];
  /** The id of the request, against which we want to get suggestions */
  requestId?: InputMaybe<Scalars['ID']['input']>;
  /** The step path for the learned answer suggestions */
  stepPath?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The id of the worker where learned answer suggestions are required. */
  workerId?: InputMaybe<Scalars['ID']['input']>;
};

export type LearnedAnswersSummary = {
  __typename?: 'LearnedAnswersSummary';
  draftLearningsCreatedCount: Scalars['Int']['output'];
  draftLearningsUpdatedCount: Scalars['Int']['output'];
  procedureId: Scalars['ID']['output'];
  publishedLearningsCreatedCount: Scalars['Int']['output'];
  publishedLearningsUpdatedCount: Scalars['Int']['output'];
};

export type LearnedAnswersSummaryResponse = {
  __typename?: 'LearnedAnswersSummaryResponse';
  items: Array<LearnedAnswersSummary>;
};

export type LearnedBookExport = {
  __typename?: 'LearnedBookExport';
  ids: Array<Maybe<Scalars['ID']['output']>>;
};

export type LearnedBookImport = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type LearningExport = {
  __typename?: 'LearningExport';
  action?: Maybe<Scalars['String']['output']>;
  choices?: Maybe<Scalars['String']['output']>;
  conceptId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lexicalPath?: Maybe<Scalars['String']['output']>;
  literalValue?: Maybe<Scalars['String']['output']>;
  newSteps?: Maybe<Scalars['String']['output']>;
  oauth2Metadata?: Maybe<Scalars['String']['output']>;
  procedureId?: Maybe<Scalars['String']['output']>;
  questionType?: Maybe<Scalars['String']['output']>;
  retryMinimumDelay?: Maybe<Scalars['Int']['output']>;
  retryTimeout?: Maybe<Scalars['Int']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  stepPath?: Maybe<Scalars['String']['output']>;
  technique?: Maybe<Scalars['String']['output']>;
};

export type LearningImport = {
  action?: InputMaybe<Scalars['String']['input']>;
  choices?: InputMaybe<Scalars['String']['input']>;
  conceptId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lexicalPath?: InputMaybe<Scalars['String']['input']>;
  literalValue?: InputMaybe<Scalars['String']['input']>;
  newSteps?: InputMaybe<Scalars['String']['input']>;
  oauth2Metadata?: InputMaybe<Scalars['String']['input']>;
  procedureId?: InputMaybe<Scalars['String']['input']>;
  questionType?: InputMaybe<Scalars['String']['input']>;
  retryMinimumDelay?: InputMaybe<Scalars['Int']['input']>;
  retryTimeout?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  stepPath?: InputMaybe<Scalars['String']['input']>;
  technique?: InputMaybe<Scalars['String']['input']>;
};

export enum LearningStage {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type LearningsFilters = {
  stage?: InputMaybe<LearningStage>;
  updatedAfter?: InputMaybe<Scalars['String']['input']>;
};

export type LineBlock = Block & {
  __typename?: 'LineBlock';
  boundingBox: BoundingBox;
  confidence: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type ListDepartmentsFilter = {
  creationDateFrom?: InputMaybe<Scalars['String']['input']>;
  creationDateTo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum ListProcedureSortFieldName {
  LatestRun = 'latestRun',
  UpdatedAt = 'updatedAt'
}

export type ListProceduresByDepartmentInput = {
  departmentId: Scalars['String']['input'];
  filter?: InputMaybe<ListProceduresFilter>;
  paginationInput?: InputMaybe<PaginationInput>;
  /** @deprecated deprecated */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** list of sort fields that applies to *all the pages of the result set*. */
  sortFields?: InputMaybe<Array<SortField>>;
};

export type ListProceduresFilter = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<ProcedureStage>;
};

export type ListQuestionsByDepartmentInput = {
  /** Page number of results to return. Starts at 1. */
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  departmentId: Scalars['ID']['input'];
  /** Filters to apply to the result set. Filters apply to the entire result set, not just the current page. */
  filters?: InputMaybe<QuestionListFilters>;
  /** If true, include questions that have been answered automatically by the learning service. */
  includeLearnedAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of questions per page of results. */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /**
   *
   *         Field to sort results by. Should be a path to the field, starting with the root type. For example, to sort by the request's createdAt field, use ["request", "createdAt"].
   *         Sort applies to the entire result set, not just the current page.
   */
  sortField?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Order to sort results by. Sort applies to the entire result set, not just the current page. */
  sortOrder?: InputMaybe<SortOrder>;
};

export type ListWorkersDataFilter = {
  createdAfter?: InputMaybe<Scalars['String']['input']>;
  createdBefore?: InputMaybe<Scalars['String']['input']>;
  excludeArchivedWorkers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricData = {
  __typename?: 'MetricData';
  /** Displays the growth trend for the runs and exceptions. */
  trendData?: Maybe<TrendData>;
  /** List of daily aggregated values and count */
  values?: Maybe<Array<DayAggregatedValue>>;
};

export type MissingIntegrationCredentialInput = {
  answerTypeHint?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['Int']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  failedAnswerId?: InputMaybe<Scalars['ID']['input']>;
  failedAnswerReason?: InputMaybe<Scalars['String']['input']>;
  sentenceId?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** The worker was not able to resolve the credential for the statement that makes third part api call. */
export type MissingIntegrationCredentialQuestion = RequestQuestion & {
  __typename?: 'MissingIntegrationCredentialQuestion';
  answer?: Maybe<RequestAnswer>;
  answerTypeHint?: Maybe<Scalars['String']['output']>;
  contextId?: Maybe<Scalars['Int']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  failedAnswerId?: Maybe<Scalars['ID']['output']>;
  failedAnswerReason?: Maybe<Scalars['String']['output']>;
  /** The answers that have been applied to and failed to resolve previous identical questions. */
  failedAnswers?: Maybe<Array<FailedAnswer>>;
  id: Scalars['ID']['output'];
  request?: Maybe<Request>;
  sentenceId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ModelProcedureConnection = {
  __typename?: 'ModelProcedureConnection';
  items?: Maybe<Array<Maybe<Procedure>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  assignRequests: AssignRequestsResult;
  createBulkRequestAnswer: Array<Maybe<RequestAnswer>>;
  createCommand?: Maybe<Command>;
  createDepartment?: Maybe<Department>;
  createDepartmentFact?: Maybe<DepartmentFact>;
  createKChatMessage: ChatMessageConnection;
  createKnowledgeSnapshot?: Maybe<Knowledge>;
  createLearnedAnswer?: Maybe<LearnedAnswer>;
  createMiniPlayground: CreateMiniPlayground;
  /** @deprecated deprecated */
  createMutableKnowledge?: Maybe<Knowledge>;
  /** @deprecated deprecated */
  createNotification?: Maybe<Notification>;
  createOrganization?: Maybe<Organization>;
  /** @deprecated This mutation is deprecated. Use createProcedureV2 instead to create the draft procedure and use publishDepartment mutation to publish all the draft procedures in a department. */
  createProcedure?: Maybe<Procedure>;
  /** This mutation creates the draft procedure. This will not publish the draft. Use publishDepartment mutation to publish all the draft procedures in a department. */
  createProcedureV2?: Maybe<Procedure>;
  /** Create a request. Only a worker can create a request. */
  createRequest?: Maybe<Request>;
  createRequestAnswer?: Maybe<RequestAnswer>;
  /** Create a request (new implementation) for new teach a technique. Only a worker can create a request. */
  createRequestV2?: Maybe<Request>;
  createSandboxProxyRequest?: Maybe<SandboxProxyMessage>;
  createSandboxProxyResponse?: Maybe<SandboxProxyMessage>;
  /** Mutation to schedule brain workload at a later point in time */
  createScheduledWakeupCall?: Maybe<ScheduledWakeup>;
  /** Stores the given value as a secret. Returns an equivalent value with the content hidden. */
  createSecretValue?: Maybe<Scalars['String']['output']>;
  createServiceCommand?: Maybe<ServiceCommand>;
  createSharedEntity?: Maybe<SharedEntity>;
  createWakeupCall?: Maybe<WakeupCall>;
  createWorker?: Maybe<Worker>;
  deleteContextualLearningInfos?: Maybe<ContextualLearningInfoConnection>;
  deleteDepartment?: Maybe<Department>;
  deleteDepartmentFact?: Maybe<DepartmentFact>;
  deleteLearnedAnswer?: Maybe<LearnedAnswer>;
  deleteOrganization?: Maybe<Organization>;
  deleteProcedure?: Maybe<Procedure>;
  deleteRequestAnswer?: Maybe<Request>;
  deleteSharedEntity?: Maybe<SharedEntity>;
  deleteWorker?: Maybe<Worker>;
  /** This mutation discards the active procedure draft. */
  discardProcedureDraft?: Maybe<Procedure>;
  /** @deprecated This mutation is deprecated. Use duplicateWorkers instead */
  duplicateWorker: Worker;
  duplicateWorkers: Array<Worker>;
  forgetBooks: Array<Book>;
  generateIntegrationAuthorizationUrl: IntegrationAuthorizationUrl;
  generateProcessVisualization?: Maybe<ProcessVisualizationAck>;
  /** Generates a number of sample requests for the given department. This is useful for testing the UX for listing requests. */
  generateSampleRequests: Scalars['Int']['output'];
  /**
   * Generates a short-term, single-use token that can be used to authenticate a single subscription request.
   *         Single-use tokens can be used in a browser where it is not possible to use a cookie to authenticate a websocket connection.
   */
  generateSubscriptionAuthToken?: Maybe<Scalars['String']['output']>;
  importDepartment?: Maybe<Department>;
  invokeLocalWorker: WorkerInvocation;
  /** This mutation invokes a procedure with the given procedureId and departmentId.If the stage is not specified, published version of the procedure will be invoked. */
  invokeProcedure2: Worker;
  learnBooks: Array<Book>;
  markWorkItemFailed?: Maybe<Scalars['ID']['output']>;
  markWorkItemProcessed?: Maybe<Scalars['ID']['output']>;
  markWorkItemProcessing?: Maybe<Scalars['ID']['output']>;
  markWorkItemReceived?: Maybe<Scalars['ID']['output']>;
  markWorkItemSkipped?: Maybe<Scalars['ID']['output']>;
  notifyKChatMessageUpdate: ChatMessage;
  notifyMiniPlaygroundCreation?: Maybe<Worker>;
  notifyWorkerUpdate: Worker;
  /** Has no effect other than to trigger the subscription. Used for testing. */
  ping: Ping;
  /** This mutation publishes all the draft procedures in a department. */
  publishDepartment: PublishDepartment;
  publishToDepartment?: Maybe<Department>;
  removeIntegrationCredential: CredentialMetadata;
  removeUserFromDepartment?: Maybe<AccessControlAck>;
  requestSandboxes: Array<Sandbox>;
  restoreContextLearningInfos?: Maybe<ContextualLearningInfoConnection>;
  restoreDepartment?: Maybe<Department>;
  rollbackDepartment?: Maybe<Department>;
  rollbackDepartmentVersion?: Maybe<DepartmentRollback>;
  /** Set user preferences for a logged in user in cognito user attributes */
  setUserPreferences?: Maybe<UserPreferences>;
  /** @deprecated This mutation is deprecated. Use `toggleWorkerArchiveStatus` instead */
  setWorkerArchived?: Maybe<Worker>;
  shareProcedure?: Maybe<AccessControlAck>;
  /** store integration credentials, Only admin can access this API */
  storeIntegrationCredential: CredentialMetadata;
  /** Store integration credentials, supports multiple credentials.  Only admin can access this API */
  storeIntegrationCredentials: CredentialMetadata;
  storeIntegrationRedirectionFlowCredential: CredentialMetadata;
  toggleWorkerArchiveStatus?: Maybe<Worker>;
  updateBrainProvisionedConcurrency?: Maybe<Department>;
  updateCommand?: Maybe<Command>;
  updateCommandState?: Maybe<Command>;
  updateDepartment?: Maybe<Department>;
  updateDepartmentFact?: Maybe<DepartmentFact>;
  updateDocument: Array<Sentence>;
  updateLearnedAnswer?: Maybe<LearnedAnswer>;
  updateOrganization?: Maybe<Organization>;
  /** @deprecated This mutation is deprecated. Use updateProcedureV2 instead to update the draft and use publishDepartment mutation to publish all the draft procedures in a department. */
  updateProcedure?: Maybe<Procedure>;
  updateProcedureMetadata?: Maybe<Procedure>;
  updateProcedureSchedule?: Maybe<Procedure>;
  /** This mutation updates the draft procedure. This will not publish the draft. Use publishDepartment mutation to publish all the draft procedures in a department. */
  updateProcedureV2?: Maybe<Procedure>;
  updateRequestState?: Maybe<Request>;
  updateSentences: Sentences;
  updateServiceCommand?: Maybe<ServiceCommand>;
  updateSharedEntity?: Maybe<SharedEntity>;
  updateSteps: Steps;
  updateWorker?: Maybe<Worker>;
  updateWorkerDocument: DocumentInfo;
  updateWorkerInternalState: Worker;
  upgradeDepartment?: Maybe<Department>;
  upgradeWorkerVersion: WorkerVersionUpgrade;
  /** Creates a new value whose content is set by uploading a file via a POST request. */
  uploadValue?: Maybe<ValueUpload>;
  upsertUserToDepartment?: Maybe<AccessControlAck>;
  workerStatus: WorkerStatus;
};


export type MutationAssignRequestsArgs = {
  input: AssignRequestsInput;
};


export type MutationCreateBulkRequestAnswerArgs = {
  inputs: Array<CreateRequestAnswerInput>;
};


export type MutationCreateCommandArgs = {
  input: CreateCommandInput;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateDepartmentArgs = {
  input: CreateDepartmentInput;
};


export type MutationCreateDepartmentFactArgs = {
  input: CreateDepartmentFactInput;
};


export type MutationCreateKChatMessageArgs = {
  input: CreateChatMessageInput;
};


export type MutationCreateKnowledgeSnapshotArgs = {
  workerId: Scalars['ID']['input'];
};


export type MutationCreateLearnedAnswerArgs = {
  input: CreateLearnedAnswerInput;
};


export type MutationCreateMiniPlaygroundArgs = {
  input: CreateMiniPlaygroundInput;
};


export type MutationCreateMutableKnowledgeArgs = {
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  knowledgeId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateNotificationArgs = {
  input: CreateNotificationInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateProcedureArgs = {
  input: CreateProcedureInput;
};


export type MutationCreateProcedureV2Args = {
  input: CreateProcedureInput;
};


export type MutationCreateRequestArgs = {
  input: CreateRequestInput;
};


export type MutationCreateRequestAnswerArgs = {
  input: CreateRequestAnswerInput;
};


export type MutationCreateRequestV2Args = {
  input: CreateRequestInput;
};


export type MutationCreateSandboxProxyRequestArgs = {
  departmentId: Scalars['ID']['input'];
  proxyId: Scalars['ID']['input'];
  request: Scalars['String']['input'];
  workerId: Scalars['ID']['input'];
};


export type MutationCreateSandboxProxyResponseArgs = {
  departmentId: Scalars['ID']['input'];
  proxyId: Scalars['ID']['input'];
  requestId: Scalars['ID']['input'];
  response: Scalars['String']['input'];
  workerId: Scalars['ID']['input'];
};


export type MutationCreateScheduledWakeupCallArgs = {
  input: CreateScheduledWakeupCallInput;
};


export type MutationCreateSecretValueArgs = {
  input: CreateSecretValueInput;
};


export type MutationCreateServiceCommandArgs = {
  input: CreateServiceCommandInput;
};


export type MutationCreateSharedEntityArgs = {
  input: CreateSharedEntityInput;
};


export type MutationCreateWakeupCallArgs = {
  input: CreateWakeupCallInput;
};


export type MutationCreateWorkerArgs = {
  input: CreateWorkerInput;
  local?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteContextualLearningInfosArgs = {
  input: DeleteRestoreContextualLearningInfoInput;
};


export type MutationDeleteDepartmentArgs = {
  input: DeleteDepartmentInput;
};


export type MutationDeleteDepartmentFactArgs = {
  input: DeleteDepartmentFactInput;
};


export type MutationDeleteLearnedAnswerArgs = {
  input: DeleteLearnedAnswerInput;
};


export type MutationDeleteOrganizationArgs = {
  input: DeleteOrganizationInput;
};


export type MutationDeleteProcedureArgs = {
  input: DeleteProcedureInput;
};


export type MutationDeleteRequestAnswerArgs = {
  input: DeleteRequestAnswerInput;
};


export type MutationDeleteSharedEntityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWorkerArgs = {
  input: DeleteWorkerInput;
};


export type MutationDiscardProcedureDraftArgs = {
  input: DiscardProcedureDraftInput;
};


export type MutationDuplicateWorkerArgs = {
  departmentId: Scalars['ID']['input'];
  owner?: InputMaybe<Scalars['String']['input']>;
  runWorker?: InputMaybe<Scalars['Boolean']['input']>;
  workerId: Scalars['ID']['input'];
};


export type MutationDuplicateWorkersArgs = {
  brainVersion?: InputMaybe<Scalars['String']['input']>;
  departmentId: Scalars['ID']['input'];
  isReplay?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  runWorker?: InputMaybe<Scalars['Boolean']['input']>;
  workerIds: Array<Scalars['ID']['input']>;
};


export type MutationForgetBooksArgs = {
  departmentId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']>;
};


export type MutationGenerateIntegrationAuthorizationUrlArgs = {
  departmentId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
  procedureId?: InputMaybe<Scalars['ID']['input']>;
  workerId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationGenerateProcessVisualizationArgs = {
  departmentId: Scalars['ID']['input'];
  procedureId: Scalars['ID']['input'];
  procedureStage?: InputMaybe<ProcedureStage>;
};


export type MutationGenerateSampleRequestsArgs = {
  count: Scalars['Int']['input'];
  departmentId: Scalars['ID']['input'];
};


export type MutationImportDepartmentArgs = {
  input: DepartmentImportInput;
};


export type MutationInvokeLocalWorkerArgs = {
  input: WorkerInvocationInput;
};


export type MutationInvokeProcedure2Args = {
  commandParamsInput?: InputMaybe<CommandParamsInput>;
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  departmentId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  idempotencyToken?: InputMaybe<Scalars['String']['input']>;
  knowledgeId?: InputMaybe<Scalars['ID']['input']>;
  local?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  procedureId: Scalars['ID']['input'];
  procedureStage?: InputMaybe<ProcedureStage>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLearnBooksArgs = {
  departmentId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']>;
};


export type MutationMarkWorkItemFailedArgs = {
  errors?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
};


export type MutationMarkWorkItemProcessedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkWorkItemProcessingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkWorkItemReceivedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkWorkItemSkippedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNotifyKChatMessageUpdateArgs = {
  input: NotifyChatMessageUpdateInput;
};


export type MutationNotifyMiniPlaygroundCreationArgs = {
  documentToken: Scalars['String']['input'];
  workItemId: Scalars['String']['input'];
  workerId: Scalars['String']['input'];
};


export type MutationNotifyWorkerUpdateArgs = {
  input: NotifyWorkerUpdateInput;
};


export type MutationPingArgs = {
  input: PingInput;
};


export type MutationPublishDepartmentArgs = {
  input: PublishDepartmentInput;
};


export type MutationPublishToDepartmentArgs = {
  departmentId: Scalars['ID']['input'];
  knowledgeId: Scalars['ID']['input'];
};


export type MutationRemoveIntegrationCredentialArgs = {
  departmentId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
};


export type MutationRemoveUserFromDepartmentArgs = {
  departmentId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRequestSandboxesArgs = {
  brainVersion: Scalars['String']['input'];
  departmentId: Scalars['ID']['input'];
};


export type MutationRestoreContextLearningInfosArgs = {
  input: DeleteRestoreContextualLearningInfoInput;
};


export type MutationRestoreDepartmentArgs = {
  input: RestoreDepartmentInput;
};


export type MutationRollbackDepartmentArgs = {
  departmentId: Scalars['ID']['input'];
};


export type MutationRollbackDepartmentVersionArgs = {
  input: DepartmentRollbackInput;
};


export type MutationSetUserPreferencesArgs = {
  input: UserPreferencesInput;
};


export type MutationSetWorkerArchivedArgs = {
  input: ArchiveWorkerInput;
};


export type MutationShareProcedureArgs = {
  input: ShareProcedureInput;
};


export type MutationStoreIntegrationCredentialArgs = {
  input: CredentialValueInput;
};


export type MutationStoreIntegrationCredentialsArgs = {
  input: Array<CredentialValueInput>;
};


export type MutationStoreIntegrationRedirectionFlowCredentialArgs = {
  input: RedirectionUriCredentialValueInput;
};


export type MutationToggleWorkerArchiveStatusArgs = {
  input: ToggleWorkerArchiveStatusInput;
};


export type MutationUpdateBrainProvisionedConcurrencyArgs = {
  input: BrainProvisionedConcurrencyInput;
};


export type MutationUpdateCommandArgs = {
  input: UpdateCommandInput;
};


export type MutationUpdateCommandStateArgs = {
  id: Scalars['ID']['input'];
  output?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};


export type MutationUpdateDepartmentArgs = {
  input: UpdateDepartmentInput;
};


export type MutationUpdateDepartmentFactArgs = {
  input: UpdateDepartmentFactInput;
};


export type MutationUpdateDocumentArgs = {
  input: UpdateDocumentInput;
};


export type MutationUpdateLearnedAnswerArgs = {
  input: UpdateLearnedAnswerInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateProcedureArgs = {
  input: UpdateProcedureInput;
};


export type MutationUpdateProcedureMetadataArgs = {
  input: UpdateProcedureMetadataInput;
};


export type MutationUpdateProcedureScheduleArgs = {
  input: UpdateProcedureScheduleInput;
};


export type MutationUpdateProcedureV2Args = {
  input: UpdateProcedureInput;
};


export type MutationUpdateRequestStateArgs = {
  input: UpdateRequestStateInput;
};


export type MutationUpdateSentencesArgs = {
  input: SentencesUpdateInput;
};


export type MutationUpdateServiceCommandArgs = {
  input: UpdateServiceCommandInput;
};


export type MutationUpdateSharedEntityArgs = {
  input: UpdateSharedEntityInput;
};


export type MutationUpdateStepsArgs = {
  input: StepsInput;
};


export type MutationUpdateWorkerArgs = {
  input: UpdateWorkerInput;
};


export type MutationUpdateWorkerDocumentArgs = {
  input: UpdateDocumentInput;
};


export type MutationUpdateWorkerInternalStateArgs = {
  documentToken?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  procedureId?: InputMaybe<Scalars['ID']['input']>;
  state: Scalars['String']['input'];
};


export type MutationUpgradeDepartmentArgs = {
  brainVersion?: InputMaybe<Scalars['String']['input']>;
  departmentId: Scalars['ID']['input'];
};


export type MutationUpgradeWorkerVersionArgs = {
  input: WorkerVersionUpgradeInput;
};


export type MutationUploadValueArgs = {
  input: UploadValueInput;
};


export type MutationUpsertUserToDepartmentArgs = {
  departmentId: Scalars['ID']['input'];
  role: AccessControlRole;
  userId: Scalars['ID']['input'];
};


export type MutationWorkerStatusArgs = {
  input: WorkerStatusInput;
};

export type NativeCodeErrorInput = {
  answerTypeHint?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['Int']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  errorMetadataDict?: InputMaybe<Scalars['String']['input']>;
  errorTraceback?: InputMaybe<Scalars['String']['input']>;
  errorType?: InputMaybe<Scalars['String']['input']>;
  failedAnswerId?: InputMaybe<Scalars['ID']['input']>;
  failedAnswerReason?: InputMaybe<Scalars['String']['input']>;
  sentenceId?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** The worker encountered an error while running native computer code. */
export type NativeCodeErrorQuestion = RequestQuestion & {
  __typename?: 'NativeCodeErrorQuestion';
  answer?: Maybe<RequestAnswer>;
  answerTypeHint?: Maybe<Scalars['String']['output']>;
  contextId?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorMetadataDict?: Maybe<Scalars['String']['output']>;
  errorTraceback?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  failedAnswerId?: Maybe<Scalars['ID']['output']>;
  failedAnswerReason?: Maybe<Scalars['String']['output']>;
  /** The answers that have been applied to and failed to resolve previous identical questions. */
  failedAnswers?: Maybe<Array<FailedAnswer>>;
  id: Scalars['ID']['output'];
  request?: Maybe<Request>;
  sentenceId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Notification = {
  __typename?: 'Notification';
  commandId: Scalars['ID']['output'];
  contextId: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  editors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  info?: Maybe<Scalars['AWSJSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  readers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sentenceId?: Maybe<Scalars['Int']['output']>;
  workerId: Scalars['ID']['output'];
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  items?: Maybe<Array<Notification>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type NotifyChatMessageUpdateInput = {
  departmentId: Scalars['ID']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  workerId: Scalars['ID']['input'];
};

export type NotifyWorkerUpdateInput = {
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  departmentVersion?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryCommand?: InputMaybe<Scalars['String']['input']>;
  entryCommandId?: InputMaybe<Scalars['ID']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  knowledgeId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originalWorkerId?: InputMaybe<Scalars['ID']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  procedureId?: InputMaybe<Scalars['ID']['input']>;
  readers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateLastUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusLastUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Input for the Oauth2 answer.All the query params which UI got in the redirect URI gets passed as a string */
export type OAuth2MissingActionInput = {
  queryParam?: InputMaybe<Scalars['String']['input']>;
};

export type OAuth2MissingInput = {
  authPageURL?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['Int']['input']>;
  domainName?: InputMaybe<Scalars['String']['input']>;
  failedAnswerId?: InputMaybe<Scalars['ID']['input']>;
  failedAnswerReason?: InputMaybe<Scalars['String']['input']>;
  grantType?: InputMaybe<Scalars['String']['input']>;
  learningExpired?: InputMaybe<Scalars['Boolean']['input']>;
  redirectURI?: InputMaybe<Scalars['String']['input']>;
  responseMode?: InputMaybe<Scalars['String']['input']>;
  responseType?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  sentenceId?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  tokenEndPoint?: InputMaybe<Scalars['String']['input']>;
};

/** A question asked by a worker for generating Oauth2 */
export type OAuth2MissingQuestion = RequestQuestion & {
  __typename?: 'OAuth2MissingQuestion';
  answer?: Maybe<RequestAnswer>;
  answerTypeHint?: Maybe<Scalars['String']['output']>;
  authPageURL?: Maybe<Scalars['String']['output']>;
  contextId?: Maybe<Scalars['Int']['output']>;
  failedAnswerId?: Maybe<Scalars['ID']['output']>;
  failedAnswerReason?: Maybe<Scalars['String']['output']>;
  /** The answers that have been applied to and failed to resolve previous identical questions. */
  failedAnswers?: Maybe<Array<FailedAnswer>>;
  id: Scalars['ID']['output'];
  request?: Maybe<Request>;
  sentenceId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Organization = {
  __typename?: 'Organization';
  billingStatus?: Maybe<OrganizationBillingStatus>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum OrganizationBillingStatus {
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  nextToken?: Maybe<Scalars['String']['output']>;
  previousToken?: Maybe<Scalars['String']['output']>;
};

export type PaginationInput = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type ParseErrorInput = {
  answerTypeHint?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['Int']['input']>;
  errorTraceback?: InputMaybe<Scalars['String']['input']>;
  failedAnswerId?: InputMaybe<Scalars['ID']['input']>;
  failedAnswerReason?: InputMaybe<Scalars['String']['input']>;
  sentenceId?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** The worker received a parse error from alang parser. */
export type ParseErrorQuestion = RequestQuestion & {
  __typename?: 'ParseErrorQuestion';
  answer?: Maybe<RequestAnswer>;
  answerTypeHint?: Maybe<Scalars['String']['output']>;
  contextId?: Maybe<Scalars['Int']['output']>;
  errorTraceback?: Maybe<Scalars['String']['output']>;
  failedAnswerId?: Maybe<Scalars['ID']['output']>;
  failedAnswerReason?: Maybe<Scalars['String']['output']>;
  /** The answers that have been applied to and failed to resolve previous identical questions. */
  failedAnswers?: Maybe<Array<FailedAnswer>>;
  id: Scalars['ID']['output'];
  request?: Maybe<Request>;
  sentenceId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Ping = {
  __typename?: 'Ping';
  channel: Scalars['String']['output'];
  data?: Maybe<Scalars['String']['output']>;
};

export type PingInput = {
  channel: Scalars['String']['input'];
  data?: InputMaybe<Scalars['String']['input']>;
};

export type Procedure = {
  __typename?: 'Procedure';
  assignmentPolicy?: Maybe<AssignmentPolicy>;
  bookReference?: Maybe<Scalars['String']['output']>;
  departmentId?: Maybe<Scalars['ID']['output']>;
  /** Latest version for the entire department. when associated data is updated, this field reflect the latest version. */
  departmentVersion?: Maybe<Scalars['String']['output']>;
  /** @deprecated Post department book, we don't require this field */
  email?: Maybe<Array<StageEmail>>;
  id: Scalars['ID']['output'];
  knowledgeId?: Maybe<Scalars['ID']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  /** metadata of latest run of the procedure. Used for display to client and sorting based on last run timestamp. */
  latestRunData?: Maybe<RunData>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  /** This field is deprecated. */
  public: Scalars['Boolean']['output'];
  requests?: Maybe<RequestConnection>;
  schedules: Array<Maybe<Schedule>>;
  stage?: Maybe<ProcedureStage>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** latest version when the procedure is updated. Think of this as a updated timestamp.if the procedure is updated then `version` and `departmentVersion` will reflect the sameversion value. */
  version?: Maybe<Scalars['String']['output']>;
};


export type ProcedureRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type ProcedureExport = {
  __typename?: 'ProcedureExport';
  id?: Maybe<Scalars['ID']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ProcedureFactTable = {
  __typename?: 'ProcedureFactTable';
  columns?: Maybe<Array<Scalars['String']['output']>>;
  data?: Maybe<Scalars['String']['output']>;
};

export type ProcedureGroup = {
  __typename?: 'ProcedureGroup';
  draftProcedure?: Maybe<Procedure>;
  publishedProcedure?: Maybe<Procedure>;
};

export type ProcedureGroupConnection = {
  __typename?: 'ProcedureGroupConnection';
  items?: Maybe<Array<ProcedureGroup>>;
  /** @deprecated This is deprecated in favor of `PaginationInfo` */
  nextToken?: Maybe<Scalars['String']['output']>;
  paginationInfo: PaginationInfo;
};

export type ProcedureImport = {
  id?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ProcedureMetric = {
  __typename?: 'ProcedureMetric';
  requestMetric?: Maybe<Array<Maybe<RequestMetricResult>>>;
  runMetric?: Maybe<Array<Maybe<RunMetricResult>>>;
};


export type ProcedureMetricRequestMetricArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type ProcedureMetricRunMetricArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export enum ProcedureMetricError {
  InvalidDate = 'INVALID_DATE',
  InvalidTimezone = 'INVALID_TIMEZONE'
}

export type ProcedureNotKnownInput = {
  answerTypeHint?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['Int']['input']>;
  failedAnswerId?: InputMaybe<Scalars['ID']['input']>;
  failedAnswerReason?: InputMaybe<Scalars['String']['input']>;
  sentenceId?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** The worker does not know how to execute the step because it has not learned any matching procedure. */
export type ProcedureNotKnownQuestion = RequestQuestion & {
  __typename?: 'ProcedureNotKnownQuestion';
  answer?: Maybe<RequestAnswer>;
  answerTypeHint?: Maybe<Scalars['String']['output']>;
  contextId?: Maybe<Scalars['Int']['output']>;
  failedAnswerId?: Maybe<Scalars['ID']['output']>;
  failedAnswerReason?: Maybe<Scalars['String']['output']>;
  /** The answers that have been applied to and failed to resolve previous identical questions. */
  failedAnswers?: Maybe<Array<FailedAnswer>>;
  id: Scalars['ID']['output'];
  request?: Maybe<Request>;
  sentenceId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ProcedureOutputTable = {
  __typename?: 'ProcedureOutputTable';
  columns?: Maybe<Array<Scalars['String']['output']>>;
  data?: Maybe<Scalars['String']['output']>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export enum ProcedureStage {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type ProceduresMetricInput = {
  departmentId: Scalars['ID']['input'];
  procedureIDs: Array<Scalars['ID']['input']>;
  /** value sent by the client. It is used to transform aggregated date to the timezone requested. */
  timezone: Scalars['String']['input'];
};

export type ProcessVisualizationAck = {
  __typename?: 'ProcessVisualizationAck';
  message: Scalars['String']['output'];
  status: ProcessVisualizationStatus;
};

export enum ProcessVisualizationStatus {
  Error = 'ERROR',
  Triggered = 'TRIGGERED'
}

export type PublishDepartment = {
  __typename?: 'PublishDepartment';
  departmentId: Scalars['ID']['output'];
  departmentVersion: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  publishedAt: Scalars['String']['output'];
  publishedBy: Scalars['String']['output'];
  restoredFrom?: Maybe<Scalars['String']['output']>;
};

/** publishes a given department version. If version is not provided, the latest version is published */
export type PublishDepartmentInput = {
  departmentId: Scalars['ID']['input'];
  departmentVersion?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  appSecrets: AppSecrets;
  autoCompleteCommand: Array<Scalars['String']['output']>;
  exportCodeForContext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exportDepartment?: Maybe<DepartmentExport>;
  generateOpenAICompletions: Array<Scalars['String']['output']>;
  getCommand?: Maybe<Command>;
  getContextsForStep?: Maybe<ContextConnection>;
  getContextualLearningInfoByLearning?: Maybe<ContextualLearningInfoConnection>;
  /** This query is primarily for testing, please do not use it */
  getContextualLearningInfoByRequest?: Maybe<ContextualLearningInfoConnection>;
  getDepartment?: Maybe<Department>;
  getDepartmentFact?: Maybe<DepartmentFact>;
  getDepartmentForWorker?: Maybe<Department>;
  getDepartmentHistory?: Maybe<DepartmentHistoryConnection>;
  /** Return the OCR blocks for a document. This API will be called by the UI */
  getDocumentBlocks?: Maybe<Array<BlocksResponse>>;
  getDownloadFromS3Url?: Maybe<S3PresignedUrl>;
  getFact?: Maybe<Fact>;
  getFacts: Array<Maybe<Fact>>;
  getFactsAtStepPath: StepPathFactTable;
  getHistoricalFacts: Array<Maybe<Fact>>;
  getIntegrationCredentialForm?: Maybe<CredentialForm>;
  getInternalAdminConsole: InternalAdminConsole;
  getKnowledge?: Maybe<Knowledge>;
  getLearnedAnswer?: Maybe<LearnedAnswer>;
  getLearnedAnswerByRequestAnswerId?: Maybe<LearnedAnswer>;
  /** Given the request from an unresolved exception, find the best matching learning suggestions */
  getLearnedAnswerSuggestions: LearnedAnswerConnection;
  /** This query is primarily for testing, please do not use it */
  getLearnedAnswersByDepartmentId?: Maybe<LearnedAnswerConnection>;
  /** LearnedAnswers summary by procedure ids. */
  getLearnedAnswersSummaryByProcedureIds?: Maybe<LearnedAnswersSummaryResponse>;
  getOrganization?: Maybe<Organization>;
  getOwnerOrganization?: Maybe<Organization>;
  getProcedure?: Maybe<Procedure>;
  getProcedureByName?: Maybe<Procedure>;
  getProcedureVisualizationUrl?: Maybe<VisualizationAccessUrl>;
  getRequest?: Maybe<Request>;
  getRequestAnswer?: Maybe<RequestAnswer>;
  getRequestQuestion?: Maybe<RequestQuestion>;
  getSentenceExecutionData: Array<SentenceExecutionData>;
  getServiceCommand?: Maybe<ServiceCommand>;
  getSharedEntity?: Maybe<SharedEntity>;
  getStepPathForRun: Array<Scalars['String']['output']>;
  getUploadToS3Url: S3PresignedPost;
  /** gets the details about current logged in user */
  getUser?: Maybe<User>;
  /**
   *
   *         Returns a URL that can be used to download a value from the system.
   *         The URL is valid for 5 minutes.
   *
   *         value: The serialized value as a json string
   *         departmentId: The id of the department that the value belongs to
   *         workerId: The id of the worker that the value belongs to
   *         secret: If the value is a secret value
   *         disposition: Sets the Content-Disposition header of the response, can be "inline" or "attachment"
   *
   */
  getValueDownloadUrl?: Maybe<Scalars['String']['output']>;
  getWorkItem?: Maybe<WorkItem>;
  getWorker?: Maybe<Worker>;
  getWorkerDocument: Array<Sentence>;
  getWorkerOutputFacts?: Maybe<Array<Maybe<WorkerOutput>>>;
  listAllDepartments?: Maybe<DepartmentConnection>;
  /** @deprecated This query is *deprecated* - do not make changes here. Change listIntegrationByDepartment instead. */
  listBooksByDepartment?: Maybe<BookConnection>;
  listCommandsByWorker?: Maybe<CommandConnection>;
  listDepartmentCollaborators?: Maybe<DepartmentUserConnection>;
  listDepartmentFacts?: Maybe<DepartmentFactConnection>;
  listDepartmentWorkerFacts?: Maybe<DepartmentWorkerFactConnection>;
  listDepartments?: Maybe<DepartmentConnection>;
  listFactsByProcedure?: Maybe<ProcedureFactTable>;
  listIntegrationsByDepartment?: Maybe<IntegrationConnection>;
  listKChatMessagesByWorker?: Maybe<ChatMessageConnection>;
  listLearnedAnswersByProcedure?: Maybe<LearnedAnswerConnection>;
  /** This query returns a list of tuples of draft procedure and its published version. */
  listProcedureGroupsByDepartmentv2?: Maybe<ProcedureGroupConnection>;
  /** @deprecated This query is deprecated. This query returns all the procedures in the given stage. If no stage is given, it will return all the draft procedures. Use listProcedureGroupsByDepartment to get a list of tuples of draft procedure and its published version. */
  listProceduresByDepartment?: Maybe<ModelProcedureConnection>;
  /**
   *
   *         List all questions runs in a department. Only includes request questions (not legacy questions).
   *
   */
  listQuestionsByDepartment?: Maybe<RequestQuestionConnection>;
  listRequestsByProcedure?: Maybe<RequestConnection>;
  listServiceCommandsByWorker?: Maybe<ServiceCommandConnection>;
  listSharedEntityByProcedure?: Maybe<SharedEntityConnection>;
  listWorkerOutputsByProcedure?: Maybe<ProcedureOutputTable>;
  listWorkersByDepartment?: Maybe<WorkerConnection>;
  listWorkersByProcedure?: Maybe<WorkerConnection>;
  listWorkersByUser?: Maybe<WorkerConnection>;
  listWorkersDataByDepartments: WorkerDataConnection;
  parseAlangText?: Maybe<AlangParser>;
  /** Get the draft procedure and associated published procedure for the given procedure id */
  procedureGroup?: Maybe<ProcedureGroup>;
  proceduresMetric: ProcedureMetric;
  /** This query returns the draft and published procedures without any joins to worker table.not sending latest worker data is fundamental difference from listProcedureGroupsByDepartmentv2.Ideally this is not the best solution and is added only to support a specific usecase andunblock release of ALC. More details in KOG-8431 */
  proceduresSummary: ProcedureGroupConnection;
  questionsMetricsByDepartment?: Maybe<Array<QuestionsMetrics>>;
  /** Gets the credential for the give worker id stage, test credentials for draft worker and production credentials for published worker. This API will be used by brain. */
  resolveIntegrationCredentialValue?: Maybe<CredentialValue>;
  /** gets the credential. This API will be used by UI */
  revealIntegrationCredential?: Maybe<CredentialValue>;
  /** gets all the credentials. This API will be used by UI */
  revealIntegrationCredentials: Array<CredentialValue>;
  revealSecretValue?: Maybe<Scalars['String']['output']>;
  validateIntegrationCredential?: Maybe<CredentialMetadata>;
};


export type QueryAutoCompleteCommandArgs = {
  text: Scalars['String']['input'];
};


export type QueryExportCodeForContextArgs = {
  contextId?: InputMaybe<Scalars['ID']['input']>;
  workerId: Scalars['ID']['input'];
};


export type QueryExportDepartmentArgs = {
  departmentId: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGenerateOpenAiCompletionsArgs = {
  prompt: Scalars['String']['input'];
};


export type QueryGetCommandArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetContextsForStepArgs = {
  contextId?: InputMaybe<Scalars['ID']['input']>;
  stepId?: InputMaybe<Scalars['ID']['input']>;
  workerId: Scalars['ID']['input'];
};


export type QueryGetContextualLearningInfoByLearningArgs = {
  learningId: Scalars['ID']['input'];
};


export type QueryGetContextualLearningInfoByRequestArgs = {
  requestId: Scalars['ID']['input'];
};


export type QueryGetDepartmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDepartmentFactArgs = {
  departmentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDepartmentForWorkerArgs = {
  workerId: Scalars['ID']['input'];
};


export type QueryGetDepartmentHistoryArgs = {
  departmentId: Scalars['ID']['input'];
  end?: InputMaybe<Scalars['String']['input']>;
  entityIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  entityName?: InputMaybe<DepartmentBookEntity>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDocumentBlocksArgs = {
  boundingBoxes?: InputMaybe<GetDocumentBlocksInput>;
  documentFactId: Scalars['ID']['input'];
  knowledgeId: Scalars['ID']['input'];
};


export type QueryGetDownloadFromS3UrlArgs = {
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  objectKey: Scalars['String']['input'];
  objectType?: InputMaybe<S3ObjectType>;
  onlyIfExists?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetFactArgs = {
  epoch?: Scalars['Int']['input'];
  factId: Scalars['ID']['input'];
  knowledgeId: Scalars['ID']['input'];
};


export type QueryGetFactsArgs = {
  factIds: Array<Scalars['ID']['input']>;
  knowledgeId: Scalars['ID']['input'];
};


export type QueryGetFactsAtStepPathArgs = {
  stepPath: Array<Scalars['String']['input']>;
  workerId: Scalars['ID']['input'];
};


export type QueryGetHistoricalFactsArgs = {
  factIds: Array<HistoricalFactId>;
  knowledgeId: Scalars['ID']['input'];
};


export type QueryGetIntegrationCredentialFormArgs = {
  departmentId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
};


export type QueryGetKnowledgeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLearnedAnswerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLearnedAnswerByRequestAnswerIdArgs = {
  requestAnswerId: Scalars['ID']['input'];
};


export type QueryGetLearnedAnswerSuggestionsArgs = {
  input: LearnedAnswerSuggestionsInput;
};


export type QueryGetLearnedAnswersByDepartmentIdArgs = {
  departmentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLearnedAnswersSummaryByProcedureIdsArgs = {
  departmentId: Scalars['ID']['input'];
  procedureIds: Array<Scalars['ID']['input']>;
  sinceTimestamp?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOwnerOrganizationArgs = {
  owner?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProcedureArgs = {
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  knowledgeId?: InputMaybe<Scalars['ID']['input']>;
  procedureId: Scalars['ID']['input'];
  procedureStage?: InputMaybe<ProcedureStage>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProcedureByNameArgs = {
  departmentId: Scalars['ID']['input'];
  departmentVersion: Scalars['String']['input'];
  procedureName: Scalars['String']['input'];
};


export type QueryGetProcedureVisualizationUrlArgs = {
  departmentId: Scalars['ID']['input'];
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  onlyIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  procedureId: Scalars['ID']['input'];
  procedureStage?: InputMaybe<ProcedureStage>;
};


export type QueryGetRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRequestAnswerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRequestQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSentenceExecutionDataArgs = {
  documentToken?: InputMaybe<Scalars['String']['input']>;
  iterationToken?: InputMaybe<Scalars['String']['input']>;
  workerId: Scalars['ID']['input'];
};


export type QueryGetServiceCommandArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSharedEntityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetStepPathForRunArgs = {
  contextId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
  workerId: Scalars['ID']['input'];
};


export type QueryGetUploadToS3UrlArgs = {
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  fields?: InputMaybe<Scalars['AWSJSON']['input']>;
  filename: Scalars['String']['input'];
  scope: S3FileScope;
  scopeId: Scalars['ID']['input'];
};


export type QueryGetUserArgs = {
  departmentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetValueDownloadUrlArgs = {
  departmentId: Scalars['ID']['input'];
  disposition?: InputMaybe<Scalars['String']['input']>;
  secret?: Scalars['Boolean']['input'];
  value: Scalars['String']['input'];
  workerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetWorkItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWorkerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWorkerDocumentArgs = {
  documentToken?: InputMaybe<Scalars['String']['input']>;
  workerId: Scalars['ID']['input'];
};


export type QueryGetWorkerOutputFactsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListAllDepartmentsArgs = {
  deptFilter?: InputMaybe<ListDepartmentsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListBooksByDepartmentArgs = {
  departmentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCommandsByWorkerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  workerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryListDepartmentCollaboratorsArgs = {
  departmentId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<AccessControlRole>;
};


export type QueryListDepartmentFactsArgs = {
  departmentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListDepartmentWorkerFactsArgs = {
  knowledgeId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListDepartmentsArgs = {
  deptFilter?: InputMaybe<ListDepartmentsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListFactsByProcedureArgs = {
  contextId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
  workerIds: Array<Scalars['String']['input']>;
};


export type QueryListIntegrationsByDepartmentArgs = {
  departmentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListKChatMessagesByWorkerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  workerId: Scalars['ID']['input'];
};


export type QueryListLearnedAnswersByProcedureArgs = {
  departmentId: Scalars['ID']['input'];
  filters?: InputMaybe<LearningsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  procedureId: Scalars['ID']['input'];
};


export type QueryListProcedureGroupsByDepartmentv2Args = {
  input: ListProceduresByDepartmentInput;
};


export type QueryListProceduresByDepartmentArgs = {
  departmentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  procedureFilter?: InputMaybe<ListProceduresFilter>;
  stage?: InputMaybe<ProcedureStage>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListQuestionsByDepartmentArgs = {
  input: ListQuestionsByDepartmentInput;
};


export type QueryListRequestsByProcedureArgs = {
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  procedureId: Scalars['ID']['input'];
  procedureStage?: InputMaybe<ProcedureStage>;
  state?: InputMaybe<RequestState>;
};


export type QueryListServiceCommandsByWorkerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  workerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryListSharedEntityByProcedureArgs = {
  departmentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  procedureId: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWorkerOutputsByProcedureArgs = {
  decodeConcepts?: InputMaybe<Scalars['Boolean']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  knowledgeId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  procedureId: Scalars['ID']['input'];
  stage?: InputMaybe<ProcedureStage>;
  stateFilter?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWorkersByDepartmentArgs = {
  departmentId: Scalars['ID']['input'];
  fromCreationDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  procedureId?: InputMaybe<Scalars['ID']['input']>;
  stage?: InputMaybe<ProcedureStage>;
  toCreationDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWorkersByProcedureArgs = {
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  fromCreationDate?: InputMaybe<Scalars['String']['input']>;
  includeReplayWorker?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  procedureId?: InputMaybe<Scalars['ID']['input']>;
  stage?: InputMaybe<ProcedureStage>;
  stateFilter?: InputMaybe<Scalars['String']['input']>;
  toCreationDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWorkersByUserArgs = {
  fromCreationDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  toCreationDate?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryListWorkersDataByDepartmentsArgs = {
  departmentIds: Array<Scalars['ID']['input']>;
  filter?: InputMaybe<ListWorkersDataFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<ProcedureStage>;
};


export type QueryParseAlangTextArgs = {
  departmentId: Scalars['ID']['input'];
  language: Scalars['String']['input'];
  scopeCode: Scalars['String']['input'];
  statement: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProcedureGroupArgs = {
  departmentId: Scalars['ID']['input'];
  procedureId: Scalars['ID']['input'];
};


export type QueryProceduresMetricArgs = {
  input: ProceduresMetricInput;
};


export type QueryProceduresSummaryArgs = {
  input: ListProceduresByDepartmentInput;
};


export type QueryQuestionsMetricsByDepartmentArgs = {
  departmentId: Scalars['ID']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  requestsMetrics?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryResolveIntegrationCredentialValueArgs = {
  departmentId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
  workerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRevealIntegrationCredentialArgs = {
  departmentId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
};


export type QueryRevealIntegrationCredentialsArgs = {
  departmentId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
};


export type QueryRevealSecretValueArgs = {
  departmentId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
  workerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryValidateIntegrationCredentialArgs = {
  departmentId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
};

export type Question = {
  __typename?: 'Question';
  answerId?: Maybe<Scalars['ID']['output']>;
  answerTypeHint?: Maybe<Scalars['String']['output']>;
  commandId: Scalars['ID']['output'];
  contextId: Scalars['Int']['output'];
  contextPath?: Maybe<Array<InstructionLocationById>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  delegationChain?: Maybe<Array<CommunicationItem>>;
  description?: Maybe<Scalars['String']['output']>;
  editors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  isAnswered: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  oauth2Metadata?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  procedureId?: Maybe<Scalars['ID']['output']>;
  rawException?: Maybe<Scalars['String']['output']>;
  readers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  secret?: Maybe<Scalars['Boolean']['output']>;
  sentenceId?: Maybe<Scalars['Int']['output']>;
  sourceMetadata?: Maybe<Scalars['String']['output']>;
  stepPath?: Maybe<Array<Scalars['String']['output']>>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  validationList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  workerId: Scalars['ID']['output'];
};

/** Filters to apply to the list of questions. If multiple filter fields are non-null, they are combined with AND. */
export type QuestionListFilters = {
  /** Question must be answered before this time to be included. Must be in ISO format in UTC (ex 2022-11-21T22:12:39.692815+00:00). */
  answerCreatedAfter?: InputMaybe<Scalars['String']['input']>;
  /** Question must be answered after this time to be included. Must be in ISO format in UTC (ex 2022-11-21T22:12:39.692815+00:00). */
  answerCreatedBefore?: InputMaybe<Scalars['String']['input']>;
  /** Space delimited list of words that must all be present in the question. Search is case insensitive. Several fields are searched. */
  containsWords?: InputMaybe<Scalars['String']['input']>;
  /** Question's procedure name must be in this list to be included. Null procedure name indicates a playground run. */
  procedureName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Question's request assignee must be in this list to be included. */
  requestAssignee?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Question must be created before this time to be included. Must be in ISO format in UTC (ex 2022-11-21T22:12:39.692815+00:00). */
  requestCreatedAfter?: InputMaybe<Scalars['String']['input']>;
  /** Question must be created after this time to be included. Must be in ISO format in UTC (ex 2022-11-21T22:12:39.692815+00:00). */
  requestCreatedBefore?: InputMaybe<Scalars['String']['input']>;
  /** This field is used to filter the questions based on the stage of the question's request/worker. */
  stage?: InputMaybe<Scalars['String']['input']>;
  /** Question's state must be in this list to be included. */
  state?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Question's typename must be in this list to be included. */
  typename?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QuestionsMetrics = {
  __typename?: 'QuestionsMetrics';
  departmentId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated deprecated */
  handled: Scalars['Int']['output'];
  handledRequests?: Maybe<Scalars['Int']['output']>;
  knowledgeId?: Maybe<Scalars['ID']['output']>;
  procedureId: Scalars['ID']['output'];
  procedureName: Scalars['String']['output'];
  procedureTitle?: Maybe<Scalars['String']['output']>;
  /** @deprecated deprecated */
  total: Scalars['Int']['output'];
  totalRequests?: Maybe<Scalars['Int']['output']>;
  totalRuns: Scalars['Int']['output'];
  /** @deprecated deprecated */
  unhandled: Scalars['Int']['output'];
  unhandledRequests?: Maybe<Scalars['Int']['output']>;
};

/** Credential values that are encoded in Oauth redirect uri. */
export type RedirectionUriCredentialValueInput = {
  departmentId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
  /** The redirectURIParams that oauth2 provider sends back as response in redirect uri query parameter. Example:`client_id=example-client-id&response_type=code&redirect_uri=app-main.kognitos.com%2Fredirect%2Foauth&response_mode=query&scope=test-scope+offline_mode` */
  redirectURIParams?: InputMaybe<Scalars['String']['input']>;
};

export type Relation = {
  __typename?: 'Relation';
  direction?: Maybe<Scalars['String']['output']>;
  fact?: Maybe<Fact>;
  factId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Replace the current step with the provided steps. */
export type ReplaceStepAction = AnswerAction & {
  __typename?: 'ReplaceStepAction';
  _?: Maybe<Scalars['String']['output']>;
  newSteps?: Maybe<Array<Scalars['String']['output']>>;
};

/** A request from a worker for help. The learning service will attempt to answer questions in the request automatically. Any remaining questions will need to be answered by a human. Once the request is handled, the worker resumes execution using the answers provided. */
export type Request = {
  __typename?: 'Request';
  /** Boolean value to hint UI if brain requires all answers or one is enough */
  allQuestionsRequireAnswers: Scalars['Boolean']['output'];
  /** List of answers created in response to this request. */
  answers?: Maybe<Array<RequestAnswer>>;
  /** The user that this request is assigned to. */
  assignee?: Maybe<Scalars['String']['output']>;
  /** The id of the (innermost) context that generated this request. */
  contextId?: Maybe<Scalars['Int']['output']>;
  /** List of instruction location were the request was created. */
  contextPath?: Maybe<Array<InstructionLocationById>>;
  /** The time at which this request was created. In ISO format (ex 2022-11-21T22:12:39.692815+00:00). */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The time at which this request was handled. In ISO format (ex 2022-11-21T22:12:39.692815+00:00). */
  handledAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The ID of the procedure this request is associated with. */
  procedureId?: Maybe<Scalars['String']['output']>;
  /** The name of the procedure this request is associated with. */
  procedureName?: Maybe<Scalars['String']['output']>;
  /** List of questions in this request. */
  questions?: Maybe<Array<RequestQuestion>>;
  /** The id of the sentence that generated this request. */
  sentenceId?: Maybe<Scalars['Int']['output']>;
  /** The state of this request. One of: 'pending', 'handled'. */
  state?: Maybe<Scalars['String']['output']>;
  /** List of steps that contain this request, starting with the outermost step. Each step is identified by its english text. Similar to breadcrumbs. */
  stepPath?: Maybe<Array<Scalars['String']['output']>>;
  /** List of suggested answers for this request. */
  suggestedAnswers?: Maybe<Array<RequestAnswerSuggestion>>;
  /** Top level text message in case of multiple questions in request */
  text?: Maybe<Scalars['String']['output']>;
  /** list of relevant concepts for UI to display to the user */
  uiConcepts?: Maybe<Scalars['String']['output']>;
  /** The worker object that made the request. */
  worker?: Maybe<Worker>;
  /** The worker id that made the request. */
  workerId?: Maybe<Scalars['ID']['output']>;
};

export type RequestAnswer = {
  __typename?: 'RequestAnswer';
  /** The action to take to resolve the question. */
  action?: Maybe<AnswerAction>;
  /** The time that this answer was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The id of the user that created this answer. */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The learning that was created as a result of this answer, if any. */
  derivedLearning?: Maybe<LearnedAnswer>;
  id: Scalars['ID']['output'];
  /** The id of the question that this answer is in response to, if any. */
  questionId?: Maybe<Scalars['ID']['output']>;
  /** The id of the request that this answer belongs to */
  requestId: Scalars['ID']['output'];
  /** The learning that was used to generate this answer, if any. */
  sourceLearning?: Maybe<LearnedAnswer>;
  /** The learning id that was used to generate this answer, if any. */
  sourceLearningId?: Maybe<Scalars['ID']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

/** A suggested answer. */
export type RequestAnswerSuggestion = {
  __typename?: 'RequestAnswerSuggestion';
  /** The action to take to resolve the question. */
  action?: Maybe<AnswerAction>;
  id: Scalars['ID']['output'];
  /** The id of the question that this answer is in response to, if any. */
  questionId?: Maybe<Scalars['ID']['output']>;
  /** The id of the request that this answer belongs to */
  requestId: Scalars['ID']['output'];
};

export type RequestAssignment = {
  __typename?: 'RequestAssignment';
  assignment: Scalars['String']['output'];
  assignmentPolicyType: AssignmentPolicyType;
  requestId: Scalars['ID']['output'];
};

export type RequestConnection = {
  __typename?: 'RequestConnection';
  items: Array<Request>;
  limit?: Maybe<Scalars['Int']['output']>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type RequestMetric = {
  __typename?: 'RequestMetric';
  /** This is a metric for pending unhandled request in a procedure. */
  unhandledRequest?: Maybe<MetricData>;
};

export type RequestMetricResult = {
  __typename?: 'RequestMetricResult';
  metric?: Maybe<RequestMetric>;
  procedureID: Scalars['ID']['output'];
};

/** A question asked by a worker to a user. Part of a request. */
export type RequestQuestion = {
  answer?: Maybe<RequestAnswer>;
  answerTypeHint?: Maybe<Scalars['String']['output']>;
  contextId?: Maybe<Scalars['Int']['output']>;
  failedAnswerId?: Maybe<Scalars['ID']['output']>;
  failedAnswerReason?: Maybe<Scalars['String']['output']>;
  /** The answers that have been applied to and failed to resolve previous identical questions. */
  failedAnswers?: Maybe<Array<FailedAnswer>>;
  id: Scalars['ID']['output'];
  request?: Maybe<Request>;
  sentenceId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type RequestQuestionConnection = {
  __typename?: 'RequestQuestionConnection';
  /** One page of request questions */
  items: Array<RequestQuestion>;
  /** Total number of request questions across all pages */
  total?: Maybe<Scalars['Int']['output']>;
  /** Unique values that occur across all pages and the occurrence count. Useful to provide a list of possible values for filtering. */
  valueCounts?: Maybe<RequestQuestionValueCounts>;
};

export type RequestQuestionFilter = {
  __typename?: 'RequestQuestionFilter';
  /** The lexical path that this learning applies to. */
  lexicalPath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The type of question that this learning applies to. Example 'ValueNotKnownQuestion'. */
  questionType?: Maybe<Scalars['String']['output']>;
  stepPath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RequestQuestionValueCounts = {
  __typename?: 'RequestQuestionValueCounts';
  assignees?: Maybe<Array<UniqueCount>>;
  procedures?: Maybe<Array<UniqueCount>>;
  states?: Maybe<Array<UniqueCount>>;
  typenames?: Maybe<Array<UniqueCount>>;
};

export enum RequestState {
  Archived = 'ARCHIVED',
  Cancelled = 'CANCELLED',
  Handled = 'HANDLED',
  Pending = 'PENDING'
}

export type RestoreDepartmentInput = {
  id: Scalars['ID']['input'];
};

/** Retry the current step. */
export type RetryStepAction = AnswerAction & {
  __typename?: 'RetryStepAction';
  _?: Maybe<Scalars['String']['output']>;
  minimumDelay: Scalars['Int']['output'];
  timeout?: Maybe<Scalars['Int']['output']>;
};

export type ReviewConceptInput = {
  answerTypeHint?: InputMaybe<Scalars['String']['input']>;
  conceptId?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['Int']['input']>;
  failedAnswerId?: InputMaybe<Scalars['ID']['input']>;
  failedAnswerReason?: InputMaybe<Scalars['String']['input']>;
  /** English lexical path to the concept. */
  lexicalPath?: InputMaybe<Array<Scalars['String']['input']>>;
  sentenceId?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** A request for a human to review the accuracy of the given concept. */
export type ReviewConceptQuestion = RequestQuestion & {
  __typename?: 'ReviewConceptQuestion';
  answer?: Maybe<RequestAnswer>;
  answerTypeHint?: Maybe<Scalars['String']['output']>;
  conceptId?: Maybe<Scalars['String']['output']>;
  contextId?: Maybe<Scalars['Int']['output']>;
  failedAnswerId?: Maybe<Scalars['ID']['output']>;
  failedAnswerReason?: Maybe<Scalars['String']['output']>;
  /** The answers that have been applied to and failed to resolve previous identical questions. */
  failedAnswers?: Maybe<Array<FailedAnswer>>;
  id: Scalars['ID']['output'];
  /** English lexical path to the concept. */
  lexicalPath?: Maybe<Array<Scalars['String']['output']>>;
  request?: Maybe<Request>;
  sentenceId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type RunData = {
  __typename?: 'RunData';
  id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  triggeredAt?: Maybe<Scalars['String']['output']>;
};

export type RunMetric = {
  __typename?: 'RunMetric';
  /** Completed runs whose sentinel state value is done */
  completedRuns?: Maybe<MetricData>;
  /** Subset of total runs. This include count of runs that have pending, handled, cancelled requests with one exception that runs whose requests are answered via learnings are excluded. */
  runsWithException?: Maybe<MetricData>;
  /** Total runs triggered for the procedure. This including completed, unhanlded requests run */
  totalRuns?: Maybe<MetricData>;
};

export type RunMetricResult = {
  __typename?: 'RunMetricResult';
  metric?: Maybe<RunMetric>;
  procedureID: Scalars['ID']['output'];
};

export enum S3FileScope {
  Department = 'department',
  Worker = 'worker'
}

export enum S3ObjectType {
  BrainFiles = 'BRAIN_FILES',
  ProcessVisualization = 'PROCESS_VISUALIZATION'
}

export type S3PresignedPost = {
  __typename?: 'S3PresignedPost';
  fields: Scalars['AWSJSON']['output'];
  s3Url: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type S3PresignedUrl = {
  __typename?: 'S3PresignedUrl';
  s3Url: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Sandbox = {
  __typename?: 'Sandbox';
  arn: Scalars['String']['output'];
  language: Scalars['String']['output'];
};

export type SandboxProxyMessage = {
  __typename?: 'SandboxProxyMessage';
  departmentId: Scalars['ID']['output'];
  proxyId: Scalars['ID']['output'];
  request?: Maybe<Scalars['String']['output']>;
  requestId: Scalars['ID']['output'];
  response?: Maybe<Scalars['String']['output']>;
  workerId: Scalars['ID']['output'];
};

export type Schedule = {
  __typename?: 'Schedule';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  expression?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** worker scheduled to ran later. */
export type ScheduledWakeup = {
  __typename?: 'ScheduledWakeup';
  executionDate: Scalars['String']['output'];
  itemId: Scalars['ID']['output'];
  scheduledTime: Scalars['String']['output'];
  workerId: Scalars['ID']['output'];
};

export type Sentence = {
  __typename?: 'Sentence';
  documentToken?: Maybe<Scalars['String']['output']>;
  internalMetadata?: Maybe<Array<DictionaryItem>>;
  language?: Maybe<Scalars['String']['output']>;
  lineId: Scalars['ID']['output'];
  metadata?: Maybe<SentenceMetadata>;
  parentId?: Maybe<Scalars['ID']['output']>;
  shouldPause?: Maybe<Scalars['Boolean']['output']>;
  text: Scalars['String']['output'];
};

export type SentenceExecutionData = {
  __typename?: 'SentenceExecutionData';
  answer?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  concepts?: Maybe<Scalars['String']['output']>;
  documentToken?: Maybe<Scalars['String']['output']>;
  epoch?: Maybe<Scalars['Int']['output']>;
  internalMetadata?: Maybe<Array<DictionaryItem>>;
  iterationTokens: Array<Scalars['String']['output']>;
  lineId: Scalars['ID']['output'];
  miniPlaygrounds?: Maybe<Array<SubDocumentInfo>>;
  requests?: Maybe<Array<Scalars['String']['output']>>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ExecutionStatus>;
  subDocuments?: Maybe<Array<SubDocumentInfo>>;
  token?: Maybe<Scalars['String']['output']>;
};

export type SentenceInput = {
  internalMetadata?: InputMaybe<Array<DictionaryItemInput>>;
  language?: InputMaybe<Scalars['String']['input']>;
  lineId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<SentenceMetadataInput>;
  shouldPause?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
};

export type SentenceLocationById = {
  __typename?: 'SentenceLocationById';
  ctxId: Scalars['Int']['output'];
  sentenceId: Scalars['Int']['output'];
};

export type SentenceLocationByIdInput = {
  ctxId: Scalars['Int']['input'];
  sentenceId: Scalars['Int']['input'];
};

export type SentenceMetadata = {
  __typename?: 'SentenceMetadata';
  lineId?: Maybe<Scalars['ID']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
};

export type SentenceMetadataInput = {
  lineId: Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type SentenceUpdateInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  childContextIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  completedAt?: InputMaybe<Scalars['String']['input']>;
  concepts?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  epoch?: InputMaybe<Scalars['Int']['input']>;
  internalMetadata?: InputMaybe<Array<DictionaryItemInput>>;
  iterationLimit?: InputMaybe<Scalars['Int']['input']>;
  lineId: Scalars['ID']['input'];
  lineage: Scalars['String']['input'];
  miniPlaygroundsInvoked?: InputMaybe<Array<SubDocumentInfoInput>>;
  pausedAt?: InputMaybe<Scalars['String']['input']>;
  requestIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startedAt?: InputMaybe<Scalars['String']['input']>;
  subprocedureLineage?: InputMaybe<Scalars['String']['input']>;
  subproceduresInvoked?: InputMaybe<Array<SubDocumentInfoInput>>;
};

export type Sentences = {
  __typename?: 'Sentences';
  documentToken?: Maybe<Scalars['String']['output']>;
  sentences: Array<Maybe<SentenceExecutionData>>;
  workerId: Scalars['ID']['output'];
};

export type SentencesUpdateInput = {
  documentToken?: InputMaybe<Scalars['String']['input']>;
  sentences?: InputMaybe<Array<InputMaybe<SentenceUpdateInput>>>;
  workerId: Scalars['ID']['input'];
};

export type ServiceCommand = WorkItem & {
  __typename?: 'ServiceCommand';
  createdAt?: Maybe<Scalars['String']['output']>;
  editors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  error?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Array<Scalars['String']['output']>>;
  forwardedAt?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  invokedAt?: Maybe<Array<Scalars['String']['output']>>;
  method?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  params?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Array<Scalars['String']['output']>>;
  processingAt?: Maybe<Array<Scalars['String']['output']>>;
  readers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  receivedAt?: Maybe<Array<Scalars['String']['output']>>;
  result?: Maybe<Scalars['String']['output']>;
  skippedAt?: Maybe<Array<Scalars['String']['output']>>;
  workErrors?: Maybe<Array<Scalars['String']['output']>>;
  workStatus?: Maybe<Scalars['String']['output']>;
  workerId: Scalars['ID']['output'];
};

export type ServiceCommandConnection = {
  __typename?: 'ServiceCommandConnection';
  items?: Maybe<Array<Maybe<ServiceCommand>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ShareProcedureInput = {
  departmentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  procedureType: Scalars['String']['input'];
  role: AccessControlRole;
  userId: Scalars['String']['input'];
};

export type SharedEntity = {
  __typename?: 'SharedEntity';
  departmentId: Scalars['ID']['output'];
  departmentVersion?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['ID']['output'];
  fullShareId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  shareName: Scalars['String']['output'];
};

/** Paginated list of shared entity. */
export type SharedEntityConnection = {
  __typename?: 'SharedEntityConnection';
  items?: Maybe<Array<Maybe<SharedEntity>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

/** Skip the current step and proceed with the rest of the procedure. */
export type SkipStepAction = AnswerAction & {
  __typename?: 'SkipStepAction';
  _?: Maybe<Scalars['String']['output']>;
};

/** Skip the rest of the current run. Use this to indicate that the run has been completed manually or is abandoned. */
export type SkipToEndOfRunAction = AnswerAction & {
  __typename?: 'SkipToEndOfRunAction';
  _?: Maybe<Scalars['String']['output']>;
};

export type SortField = {
  name: ListProcedureSortFieldName;
  order: SortOrder;
};

export enum SortOrder {
  Ascend = 'ASCEND',
  Descend = 'DESCEND'
}

export type StageEmail = {
  __typename?: 'StageEmail';
  email: Scalars['String']['output'];
  stage: Scalars['String']['output'];
};

export type Step = {
  __typename?: 'Step';
  answer?: Maybe<Scalars['String']['output']>;
  childContextIdList?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  commandId?: Maybe<Scalars['ID']['output']>;
  concepts?: Maybe<Scalars['String']['output']>;
  contextId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  epoch?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  line?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  positionInContext?: Maybe<Scalars['Int']['output']>;
  questionIds?: Maybe<Array<Scalars['String']['output']>>;
  requestIds?: Maybe<Array<Scalars['String']['output']>>;
  scratchedAt?: Maybe<Scalars['String']['output']>;
  sentencePath?: Maybe<Array<SentenceLocationById>>;
  text?: Maybe<Scalars['String']['output']>;
  workerId: Scalars['ID']['output'];
};

export type StepInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  childContextIdList?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  commandId?: InputMaybe<Scalars['ID']['input']>;
  concepts?: InputMaybe<Scalars['String']['input']>;
  contextId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['String']['input']>;
  epoch?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  line?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  questionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  requestIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scratchedAt?: InputMaybe<Scalars['String']['input']>;
  /** List of sentences from the root context to the current step. Each sentence is identified by its contextId and sentenceId. */
  sentencePath?: InputMaybe<Array<SentenceLocationByIdInput>>;
  text?: InputMaybe<Scalars['String']['input']>;
  workerId: Scalars['ID']['input'];
};

export type StepPathFactTable = {
  __typename?: 'StepPathFactTable';
  columns?: Maybe<Array<Scalars['String']['output']>>;
  data?: Maybe<Scalars['String']['output']>;
};

export type Steps = {
  __typename?: 'Steps';
  stepList?: Maybe<Array<Maybe<Step>>>;
  workerId: Scalars['ID']['output'];
};

export type StepsInput = {
  stepList?: InputMaybe<Array<InputMaybe<StepInput>>>;
  workerId: Scalars['ID']['input'];
};

export type SubDocumentInfo = {
  __typename?: 'SubDocumentInfo';
  documentToken: Scalars['String']['output'];
  processName: Scalars['String']['output'];
};

export type SubDocumentInfoInput = {
  documentToken: Scalars['String']['input'];
  processName: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  onCreateCommandByWorkerId?: Maybe<Command>;
  onCreateNotificationByWorkerId?: Maybe<Notification>;
  onCreateSandboxProxyRequest?: Maybe<SandboxProxyMessage>;
  onCreateSandboxProxyResponse?: Maybe<SandboxProxyMessage>;
  onCreateServiceCommandByWorker?: Maybe<ServiceCommand>;
  onInvokeLocalWorker?: Maybe<WorkerInvocation>;
  onNotifyKChatMessageUpdate?: Maybe<ChatMessage>;
  /** Notify on every procedure invocation */
  onNotifyWorkerCreation?: Maybe<Worker>;
  /** Notify on completion of worker's knowledge creation and on worker's state update */
  onNotifyWorkerUpdate?: Maybe<Worker>;
  /** Used for testing */
  onPing?: Maybe<Ping>;
  onSentenceUpdate?: Maybe<Sentences>;
  onStepsUpdated?: Maybe<Steps>;
  onUpdateCommandByWorkerId?: Maybe<Command>;
  onWorkerDocumentUpdate?: Maybe<DocumentInfo>;
  onWorkerStatus?: Maybe<WorkerStatus>;
};


export type SubscriptionOnCreateCommandByWorkerIdArgs = {
  workerId: Scalars['ID']['input'];
};


export type SubscriptionOnCreateNotificationByWorkerIdArgs = {
  workerId: Scalars['ID']['input'];
};


export type SubscriptionOnCreateSandboxProxyRequestArgs = {
  departmentId: Scalars['ID']['input'];
  proxyId: Scalars['ID']['input'];
};


export type SubscriptionOnCreateSandboxProxyResponseArgs = {
  departmentId: Scalars['ID']['input'];
  workerId: Scalars['ID']['input'];
};


export type SubscriptionOnCreateServiceCommandByWorkerArgs = {
  workerId: Scalars['ID']['input'];
};


export type SubscriptionOnInvokeLocalWorkerArgs = {
  departmentId: Scalars['ID']['input'];
};


export type SubscriptionOnNotifyKChatMessageUpdateArgs = {
  departmentId: Scalars['ID']['input'];
  workerId: Scalars['ID']['input'];
};


export type SubscriptionOnNotifyWorkerCreationArgs = {
  procedureId: Scalars['ID']['input'];
};


export type SubscriptionOnNotifyWorkerUpdateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  procedureId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionOnPingArgs = {
  channel: Scalars['String']['input'];
};


export type SubscriptionOnSentenceUpdateArgs = {
  documentToken?: InputMaybe<Scalars['String']['input']>;
  workerId: Scalars['ID']['input'];
};


export type SubscriptionOnStepsUpdatedArgs = {
  workerId: Scalars['ID']['input'];
};


export type SubscriptionOnUpdateCommandByWorkerIdArgs = {
  workerId: Scalars['ID']['input'];
};


export type SubscriptionOnWorkerDocumentUpdateArgs = {
  workerId: Scalars['ID']['input'];
};


export type SubscriptionOnWorkerStatusArgs = {
  id: Scalars['ID']['input'];
};

export type Subtext = {
  helpingVerb: Scalars['String']['input'];
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type TableBlock = Block & {
  __typename?: 'TableBlock';
  boundingBox: BoundingBox;
  confidence: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
};

export type ToggleWorkerArchiveStatusInput = {
  id: Scalars['ID']['input'];
  isArchived: Scalars['Boolean']['input'];
};

export type TrendData = {
  __typename?: 'TrendData';
  /** Float value that represents the percentage of growth for completed runs, unhandled exception. 0 represent constant growth, postive percentage represents upward growth and negative percentage reprents downward growth. */
  percentageChange?: Maybe<Scalars['Float']['output']>;
};

export type UniqueCount = {
  __typename?: 'UniqueCount';
  count?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type UpdateCommandInput = {
  ast?: InputMaybe<Scalars['AWSJSON']['input']>;
  contextId?: InputMaybe<Scalars['Int']['input']>;
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  output?: InputMaybe<Scalars['AWSJSON']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  procedureId?: InputMaybe<Scalars['String']['input']>;
  processingAt?: InputMaybe<Scalars['String']['input']>;
  readers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  receivedAt?: InputMaybe<Scalars['String']['input']>;
  sentenceId?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceMetadata?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  subText?: InputMaybe<Scalars['String']['input']>;
  subTextLanguage?: InputMaybe<Scalars['String']['input']>;
  subTextProperties?: InputMaybe<Array<Scalars['String']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
  workerId?: InputMaybe<Scalars['ID']['input']>;
};

/** Update a department fact. */
export type UpdateDepartmentFactInput = {
  departmentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type UpdateDepartmentInput = {
  editors?: InputMaybe<Array<Scalars['String']['input']>>;
  featureFlags?: InputMaybe<Array<DepartmentFeatureFlag>>;
  features?: InputMaybe<Array<DepartmentFeature>>;
  id: Scalars['ID']['input'];
  local?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifyProcedureInvocation?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  purgeWorkerDataAfter?: InputMaybe<DataPurgeInterval>;
  readers?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<DepartmentStatus>;
  testContext?: InputMaybe<Scalars['String']['input']>;
  workerId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateDocument = WorkItem & {
  __typename?: 'UpdateDocument';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Array<Scalars['AWSJSON']['output']>>;
  documentToken?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Array<Scalars['String']['output']>>;
  forwardedAt?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  invokedAt?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated breakpoints have been moved to the document, we will soon remove this field */
  pauseAtLineId?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Array<Scalars['String']['output']>>;
  processingAt?: Maybe<Array<Scalars['String']['output']>>;
  receivedAt?: Maybe<Array<Scalars['String']['output']>>;
  shouldStartExecution: Scalars['Boolean']['output'];
  skippedAt?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Discontinuing autopilot support. flex parser will replace it */
  useAutopilot?: Maybe<Scalars['Boolean']['output']>;
  workErrors?: Maybe<Array<Scalars['String']['output']>>;
  workStatus?: Maybe<Scalars['String']['output']>;
  workerId: Scalars['ID']['output'];
};

export type UpdateDocumentInput = {
  document: Array<SentenceInput>;
  documentToken?: InputMaybe<Scalars['String']['input']>;
  ifLastUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated breakpoints have been moved to the document, we will soon remove this field */
  pauseAtUiLineId?: InputMaybe<Scalars['String']['input']>;
  shouldStartExecution?: Scalars['Boolean']['input'];
  startFromUiLineId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Discontinuing autopilot support. flex parser will replace it */
  useAutopilot?: InputMaybe<Scalars['Boolean']['input']>;
  workerId: Scalars['ID']['input'];
};

export type UpdateLearnedAnswerInput = {
  /** The action to take to resolve the question. */
  action?: InputMaybe<CreateAnswerActionInput>;
  /** The filter that determines which questions this learning applies to. */
  filter?: InputMaybe<CreateRequestQuestionFilterInput>;
  learnedAnswerId: Scalars['ID']['input'];
  /** The id of the procedure that this learning was created from, if any. */
  procedureId?: InputMaybe<Scalars['ID']['input']>;
  /** The stage of the learning. */
  stage?: InputMaybe<Array<LearningStage>>;
};

export type UpdateOrganizationInput = {
  billingStatus?: InputMaybe<OrganizationBillingStatus>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProcedureInput = {
  assignmentPolicy?: InputMaybe<AssignmentPolicyInput>;
  departmentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  knowledgeId?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleExpression?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProcedureMetadataInput = {
  departmentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  knowledgeId?: InputMaybe<Scalars['ID']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleExpression?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProcedureScheduleInput = {
  departmentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  knowledgeId?: InputMaybe<Scalars['ID']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleExpression?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRequestStateInput = {
  id: Scalars['ID']['input'];
};

export type UpdateServiceCommandInput = {
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  error?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  method?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['String']['input']>;
  readers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  result?: InputMaybe<Scalars['String']['input']>;
  workerId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSharedEntityInput = {
  departmentVersion?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  shareName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkerInput = {
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryCommand?: InputMaybe<Scalars['String']['input']>;
  entryCommandId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  knowledgeId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  procedureId?: InputMaybe<Scalars['ID']['input']>;
  readers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UploadValueInput = {
  /** The confidence of the value. 0.0 is least confident, 1.0 is most confident. */
  confidence?: InputMaybe<Scalars['Float']['input']>;
  /** The department to store the secret in */
  departmentId: Scalars['ID']['input'];
  /** The filename of the value. Can be null for non-file values. */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** Whether the value is a secret or not */
  secret?: InputMaybe<Scalars['Boolean']['input']>;
  /** The content type of the value */
  type: Scalars['String']['input'];
  /** The worker to store the secret for */
  workerId?: InputMaybe<Scalars['ID']['input']>;
};

/** Use the provided concept as the answer to a question that is asking for a value of a concept. The value need not be one of the choices provided in the question. This type of action cannot be learned. */
export type UseConceptAction = AnswerAction & {
  __typename?: 'UseConceptAction';
  _?: Maybe<Scalars['String']['output']>;
  conceptId?: Maybe<Scalars['String']['output']>;
};

/** Use the provided literal value as the answer to a question that is asking for a value of a concept. The value need not be one of the choices provided in the question. */
export type UseLiteralValueAction = AnswerAction & {
  __typename?: 'UseLiteralValueAction';
  _?: Maybe<Scalars['String']['output']>;
  choices?: Maybe<Array<Scalars['String']['output']>>;
  literalValue?: Maybe<Scalars['String']['output']>;
};

/** Provide no value for a question that is asking for a value of a concept. This is used to complete a request when some questions are optional. */
export type UseNoValueAction = AnswerAction & {
  __typename?: 'UseNoValueAction';
  _?: Maybe<Scalars['String']['output']>;
};

/** Oauth2 answer */
export type UseOauth2Action = AnswerAction & {
  __typename?: 'UseOauth2Action';
  _?: Maybe<Scalars['String']['output']>;
  accessToken?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
};

/** Use a technique to answer a question.  */
export type UseTechniqueAction = AnswerAction & {
  __typename?: 'UseTechniqueAction';
  _?: Maybe<Scalars['String']['output']>;
  documentToken?: Maybe<Scalars['String']['output']>;
  technique?: Maybe<Scalars['String']['output']>;
};

/** details about logged in User */
export type User = {
  __typename?: 'User';
  company?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<UserPreferences>;
  /** user role in a department. It can be one of `admin`, `member` */
  role?: Maybe<AccessControlRole>;
  username: Scalars['String']['output'];
};

/** preferences for logged in User */
export type UserPreferences = {
  __typename?: 'UserPreferences';
  /** ID of the department the user access last.This will be used to load the user directly into that department when they load the UI again. */
  lastUsedDepartmentId?: Maybe<Scalars['String']['output']>;
};

/** Input to set user preferences */
export type UserPreferencesInput = {
  lastUsedDepartmentId?: InputMaybe<Scalars['String']['input']>;
};

export enum ValidationStatus {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export type Value = {
  __typename?: 'Value';
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ValueInput = {
  /** unique key for the field. The key will be used to store the value */
  key?: InputMaybe<Scalars['String']['input']>;
  /** descriptive label for the field */
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ValueNotKnownInput = {
  answerNotKnown?: InputMaybe<Scalars['String']['input']>;
  answerTypeHint?: InputMaybe<Scalars['String']['input']>;
  choices?: InputMaybe<Array<Scalars['String']['input']>>;
  contextId?: InputMaybe<Scalars['Int']['input']>;
  failedAnswerId?: InputMaybe<Scalars['ID']['input']>;
  failedAnswerReason?: InputMaybe<Scalars['String']['input']>;
  helpText?: InputMaybe<Scalars['String']['input']>;
  isPlural?: InputMaybe<Scalars['Boolean']['input']>;
  /** English lexical path to the concept. */
  lexicalPath?: InputMaybe<Array<Scalars['String']['input']>>;
  sentenceId?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** The value of a concept is not known. */
export type ValueNotKnownQuestion = RequestQuestion & {
  __typename?: 'ValueNotKnownQuestion';
  answer?: Maybe<RequestAnswer>;
  answerTypeHint?: Maybe<Scalars['String']['output']>;
  choices?: Maybe<Array<Scalars['String']['output']>>;
  contextId?: Maybe<Scalars['Int']['output']>;
  failedAnswerId?: Maybe<Scalars['ID']['output']>;
  failedAnswerReason?: Maybe<Scalars['String']['output']>;
  /** The answers that have been applied to and failed to resolve previous identical questions. */
  failedAnswers?: Maybe<Array<FailedAnswer>>;
  helpText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPlural?: Maybe<Scalars['Boolean']['output']>;
  /** English lexical path to the concept. */
  lexicalPath?: Maybe<Array<Scalars['String']['output']>>;
  request?: Maybe<Request>;
  sentenceId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ValueUpload = {
  __typename?: 'ValueUpload';
  /** Additional fields that must be included in form data of the upload. */
  fields: Array<ValueUploadField>;
  /** The URL to upload the value to. */
  url: Scalars['String']['output'];
  /** The serialized form of the value. Can be provided to the brain after the upload is complete. */
  value: Scalars['String']['output'];
};

export type ValueUploadField = {
  __typename?: 'ValueUploadField';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type VisualizationAccessUrl = {
  __typename?: 'VisualizationAccessUrl';
  presignedUrl: Scalars['String']['output'];
  s3Url: Scalars['String']['output'];
};

export type WakeupCall = WorkItem & {
  __typename?: 'WakeupCall';
  createdAt?: Maybe<Scalars['String']['output']>;
  documentToken?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Array<Scalars['String']['output']>>;
  forwardedAt?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  invokedAt?: Maybe<Array<Scalars['String']['output']>>;
  processedAt?: Maybe<Array<Scalars['String']['output']>>;
  processingAt?: Maybe<Array<Scalars['String']['output']>>;
  receivedAt?: Maybe<Array<Scalars['String']['output']>>;
  scheduledTime?: Maybe<Scalars['String']['output']>;
  skippedAt?: Maybe<Array<Scalars['String']['output']>>;
  workErrors?: Maybe<Array<Scalars['String']['output']>>;
  workStatus?: Maybe<Scalars['String']['output']>;
  workerId: Scalars['ID']['output'];
};

export type WordBlock = Block & {
  __typename?: 'WordBlock';
  boundingBox: BoundingBox;
  confidence: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  lineId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

/** Something that the brain needs to process in a reliable way. */
export type WorkItem = {
  createdAt?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Array<Scalars['String']['output']>>;
  forwardedAt?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  invokedAt?: Maybe<Array<Scalars['String']['output']>>;
  processedAt?: Maybe<Array<Scalars['String']['output']>>;
  processingAt?: Maybe<Array<Scalars['String']['output']>>;
  receivedAt?: Maybe<Array<Scalars['String']['output']>>;
  skippedAt?: Maybe<Array<Scalars['String']['output']>>;
  workErrors?: Maybe<Array<Scalars['String']['output']>>;
  workStatus?: Maybe<Scalars['String']['output']>;
  workerId: Scalars['ID']['output'];
};

/** A worker has its own knowledge and can run commands. A worker is typically created from a department, in which case its knowledge will start as a copy of the department knowledge.  */
export type Worker = {
  __typename?: 'Worker';
  attachments?: Maybe<Array<Scalars['String']['output']>>;
  /** The time this worker was created. Example: 2024-03-19T00:05:25.641957+00:00 */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The id of the department that this worker belongs to. Example: 7b7g6n3gf2188t636tiean6oz */
  departmentId?: Maybe<Scalars['ID']['output']>;
  /** The department version used to created this worker's knowledge. Example: 2024-03-11T21:56:34.366296+00:00 */
  departmentVersion?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Not used */
  editors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entryCommand?: Maybe<Scalars['String']['output']>;
  entryCommandId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated deprecated */
  exceptions: Array<Question>;
  features?: Maybe<Array<Scalars['String']['output']>>;
  /** For storing states of all sub-executions, i.e. clone contexts, miniplaygrounds */
  forkExecutionInfo?: Maybe<WorkerForkExecutionConnection>;
  /** The globally unique identifier for the worker. Example: bfxmumyrr2e71z5jgyeawift0 */
  id: Scalars['ID']['output'];
  /** Whether the worker is archived. Archived workers are hidden by default. Example: false */
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  /** The id of the worker's knowledge, used for facts. Example: 3b9aphcu75qiaoq48r9tr8twq */
  knowledgeId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** If this worker was duplicated from another worker, the id of the original worker. Example: bfxmumyrr2e71z5jgyeawift0 */
  originalWorkerId?: Maybe<Scalars['ID']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  /** If this worker was invoked from a procedure, the id of that procedure. Example: cnzy29uzi0hyrf5jdpajbcp8w */
  procedureId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated deprecated */
  questions: Array<Question>;
  /** Not used */
  readers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Id of a previous worker, if the worker is replaying a previous worker */
  replayWorkerId?: Maybe<Scalars['String']['output']>;
  requests?: Maybe<RequestConnection>;
  /** The stage of the worker in the procedure, DRAFT or PUBLISHED */
  stage?: Maybe<ProcedureStage>;
  /**
   * The state of the worker:
   *         creating | created | preparing_knowledge | ready | processing | user stopped | waiting_for_user_input | waiting to retry | done | deleted | error
   *
   */
  state?: Maybe<Scalars['String']['output']>;
  /** The time the state of the worker was last updated. Example: 2024-03-19T00:05:25.641957+00:00 */
  stateLastUpdatedAt?: Maybe<Scalars['String']['output']>;
  /** This field is deprecated. Use `state` instead. */
  status?: Maybe<Scalars['String']['output']>;
  /** This field is deprecated. Use `stateLastUpdatedAt` instead. */
  statusLastUpdatedAt?: Maybe<Scalars['String']['output']>;
  /** The version string of this worker's brain. Example: experimental-rest-import-205955ec21-20240318214859 */
  version?: Maybe<Scalars['String']['output']>;
};


/** A worker has its own knowledge and can run commands. A worker is typically created from a department, in which case its knowledge will start as a copy of the department knowledge.  */
export type WorkerRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkerConnection = {
  __typename?: 'WorkerConnection';
  items?: Maybe<Array<Maybe<Worker>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type WorkerData = {
  __typename?: 'WorkerData';
  brainVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  departmentId?: Maybe<Scalars['ID']['output']>;
  departmentName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  procedureId?: Maybe<Scalars['ID']['output']>;
  procedureName?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<ProcedureStage>;
  state?: Maybe<Scalars['String']['output']>;
};

export type WorkerDataConnection = {
  __typename?: 'WorkerDataConnection';
  nextToken?: Maybe<Scalars['String']['output']>;
  workersData: Array<WorkerData>;
};

export type WorkerForkExecution = {
  __typename?: 'WorkerForkExecution';
  /** The answer of the fork execution, if any */
  answer?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The document_token of the fork execution */
  documentToken?: Maybe<Scalars['String']['output']>;
  /** The internal state of the fork execution */
  internalState: Scalars['String']['output'];
  internalStateLastUpdatedAt: Scalars['String']['output'];
  internalStateMessage: Scalars['String']['output'];
  /** The line_id of the line in the document where we created this fork execution */
  lineId?: Maybe<Scalars['String']['output']>;
  /** The line_token of the line in the document where we created this fork execution */
  lineToken?: Maybe<Scalars['String']['output']>;
  /** Metadata about the fork execution */
  metadata?: Maybe<WorkerForkExecutionMetadata>;
  version?: Maybe<Scalars['Int']['output']>;
  /** The work_item_id of the fork execution (miniplayground or otherwise) */
  workItemId: Scalars['String']['output'];
  /** The worker_id of which this fork execution is a part of */
  workerId: Scalars['String']['output'];
};

export type WorkerForkExecutionConnection = {
  __typename?: 'WorkerForkExecutionConnection';
  items: Array<WorkerForkExecution>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type WorkerForkExecutionMetadata = {
  __typename?: 'WorkerForkExecutionMetadata';
  /** The (technique) learning which is used to answer this fork execution */
  learningId?: Maybe<Scalars['String']['output']>;
  /** The question which is potentially answered by this fork execution */
  questionId?: Maybe<Scalars['String']['output']>;
  /** The request which is potentially answered by this fork execution */
  requestId?: Maybe<Scalars['String']['output']>;
};

/** A request to begin running a worker. */
export type WorkerInvocation = {
  __typename?: 'WorkerInvocation';
  departmentId: Scalars['ID']['output'];
  event: Scalars['String']['output'];
};

export type WorkerInvocationInput = {
  departmentId: Scalars['ID']['input'];
  event: Scalars['String']['input'];
};

export type WorkerOutput = {
  __typename?: 'WorkerOutput';
  facts: Array<Maybe<Fact>>;
  name: Scalars['String']['output'];
};

/** Information about what the worker is currently doing. */
export type WorkerStatus = {
  __typename?: 'WorkerStatus';
  icons: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mood: Scalars['String']['output'];
  operation: Scalars['String']['output'];
  what: Scalars['String']['output'];
};

export type WorkerStatusInput = {
  icons: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  mood: Scalars['String']['input'];
  operation: Scalars['String']['input'];
  what: Scalars['String']['input'];
};

export type WorkerVersionUpgrade = {
  __typename?: 'WorkerVersionUpgrade';
  brainVersion: Scalars['String']['output'];
  knowledgeId: Scalars['String']['output'];
  workerId: Scalars['ID']['output'];
};

export type WorkerVersionUpgradeInput = {
  brainVersion: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type OnWorkerKnowledgeIdUpdateSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OnWorkerKnowledgeIdUpdateSubscription = { __typename?: 'Subscription', onNotifyWorkerUpdate?: { __typename?: 'Worker', id: string, knowledgeId?: string | null } | null };

export type OnProcedureWorkersStateUpdateSubscriptionVariables = Exact<{
  procedureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type OnProcedureWorkersStateUpdateSubscription = { __typename?: 'Subscription', onNotifyWorkerUpdate?: { __typename?: 'Worker', id: string, state?: string | null } | null };

export type WorkerDataPartsFragmentFragment = { __typename?: 'WorkerData', id: string, departmentId?: string | null, departmentName?: string | null, procedureId?: string | null, procedureName?: string | null, createdAt?: string | null, state?: string | null, brainVersion?: string | null, isArchived?: boolean | null, owner?: string | null };

export type InternalAdminDepartmentInfoFragmentFragment = { __typename?: 'InternalAdminDepartmentInfo', key: string, id: string, info: string, notes: string, notionDepartmentNotesUrl?: string | null, launchdarklyContextUrl?: string | null };

export type ContextualLearningInfoFragmentFragment = { __typename?: 'ContextualLearningInfo', id: string, isDeleted?: boolean | null, requestId: string, contextFactsInfo?: Array<{ __typename?: 'Fact', id: string, names?: Array<string | null> | null, locations?: Array<{ [key: string]: any }> | null, dereferencedId?: string | null, type?: string | null, value?: string | null } | null> | null };

export type ProcedureDataFragment = { __typename?: 'Procedure', id: string, departmentId?: string | null, name?: string | null, owner?: string | null, language?: string | null, title?: string | null, stage?: ProcedureStage | null, text?: string | null, departmentVersion?: string | null, version?: string | null, knowledgeId?: string | null, assignmentPolicy?: { __typename?: 'AssignmentPolicy', policyType: AssignmentPolicyType, collaborator?: string | null } | null, latestRunData?: { __typename?: 'RunData', id?: string | null, triggeredAt?: string | null, status?: string | null } | null };

export type ProcedureSummaryFragment = { __typename?: 'Procedure', id: string, departmentId?: string | null, name?: string | null, stage?: ProcedureStage | null, departmentVersion?: string | null, version?: string | null };

export type WorkerDataFragment = { __typename?: 'Worker', id: string, owner?: string | null, name?: string | null, version?: string | null, departmentVersion?: string | null, knowledgeId?: string | null, departmentId?: string | null, procedureId?: string | null, originalWorkerId?: string | null, createdAt?: string | null, state?: string | null, isArchived?: boolean | null, features?: Array<string> | null, stage?: ProcedureStage | null, replayWorkerId?: string | null };

export type WorkerForkExecutionInfoFragment = { __typename?: 'Worker', forkExecutionInfo?: { __typename?: 'WorkerForkExecutionConnection', items: Array<{ __typename?: 'WorkerForkExecution', answer?: string | null, createdBy?: string | null, documentToken?: string | null, internalState: string, internalStateLastUpdatedAt: string, internalStateMessage: string, lineId?: string | null, lineToken?: string | null, version?: number | null, workItemId: string, workerId: string, metadata?: { __typename?: 'WorkerForkExecutionMetadata', learningId?: string | null, questionId?: string | null, requestId?: string | null } | null }> } | null };

export type StoreIntegrationCredentialMutationVariables = Exact<{
  input: CredentialValueInput;
}>;


export type StoreIntegrationCredentialMutation = { __typename?: 'Mutation', storeIntegrationCredential: { __typename?: 'CredentialMetadata', integrationId: string, departmentId: string, lastChangedAt?: string | null, lastChangedBy?: string | null, lastValidatedAt?: string | null, lastValidationStatus?: ValidationStatus | null, lastValidationMessage?: string | null, isCredentialProvided?: boolean | null, redirectionFlowRequired?: boolean | null, isRedirectionFlowDone?: boolean | null } };

export type StoreIntegrationCredentialsMutationVariables = Exact<{
  input: Array<CredentialValueInput> | CredentialValueInput;
}>;


export type StoreIntegrationCredentialsMutation = { __typename?: 'Mutation', storeIntegrationCredentials: { __typename?: 'CredentialMetadata', integrationId: string, departmentId: string, lastChangedAt?: string | null, lastChangedBy?: string | null, lastValidatedAt?: string | null, lastValidationStatus?: ValidationStatus | null, lastValidationMessage?: string | null, isCredentialProvided?: boolean | null, redirectionFlowRequired?: boolean | null, isRedirectionFlowDone?: boolean | null } };

export type LearnBooksMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
}>;


export type LearnBooksMutation = { __typename?: 'Mutation', learnBooks: Array<{ __typename?: 'Book', id: string, name?: string | null }> };

export type RemoveIntegrationCredentialMutationVariables = Exact<{
  integrationId: Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
}>;


export type RemoveIntegrationCredentialMutation = { __typename?: 'Mutation', removeIntegrationCredential: { __typename?: 'CredentialMetadata', integrationId: string } };

export type ForgetBooksMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
}>;


export type ForgetBooksMutation = { __typename?: 'Mutation', forgetBooks: Array<{ __typename?: 'Book', id: string }> };

export type GenerateIntegrationAuthorizationUrlMutationVariables = Exact<{
  integrationId: Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
  workerId?: InputMaybe<Scalars['ID']['input']>;
  procedureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GenerateIntegrationAuthorizationUrlMutation = { __typename?: 'Mutation', generateIntegrationAuthorizationUrl: { __typename?: 'IntegrationAuthorizationURL', url?: string | null } };

export type StoreIntegrationRedirectionFlowCredentialMutationVariables = Exact<{
  departmentId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
  redirectURIParams?: InputMaybe<Scalars['String']['input']>;
}>;


export type StoreIntegrationRedirectionFlowCredentialMutation = { __typename?: 'Mutation', storeIntegrationRedirectionFlowCredential: { __typename?: 'CredentialMetadata', integrationId: string, departmentId: string, lastChangedAt?: string | null, lastChangedBy?: string | null, lastValidatedAt?: string | null, lastValidationStatus?: ValidationStatus | null, lastValidationMessage?: string | null, isCredentialProvided?: boolean | null, redirectionFlowRequired?: boolean | null, isRedirectionFlowDone?: boolean | null } };

export type CreateDepartmentMutationVariables = Exact<{
  input: CreateDepartmentInput;
}>;


export type CreateDepartmentMutation = { __typename?: 'Mutation', createDepartment?: { __typename?: 'Department', id: string, owner?: string | null, organizationId?: string | null, name?: string | null, draftKnowledgeId?: string | null, publishedKnowledgeId?: string | null, workerId?: string | null, local?: boolean | null, state?: string | null, errors?: Array<string> | null, createdAt?: string | null, isDeleted: boolean, brainVersion?: string | null, features?: Array<DepartmentFeature> | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, draftKnowledge?: { __typename?: 'Knowledge', id: string, brainVersion?: string | null } | null } | null };

export type UpgradeDepartmentMutationVariables = Exact<{
  departmentId: Scalars['ID']['input'];
  brainVersion?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpgradeDepartmentMutation = { __typename?: 'Mutation', upgradeDepartment?: { __typename?: 'Department', id: string, owner?: string | null, organizationId?: string | null, name?: string | null, draftKnowledgeId?: string | null, publishedKnowledgeId?: string | null, workerId?: string | null, local?: boolean | null, state?: string | null, errors?: Array<string> | null, createdAt?: string | null, isDeleted: boolean, brainVersion?: string | null, features?: Array<DepartmentFeature> | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, draftKnowledge?: { __typename?: 'Knowledge', id: string, brainVersion?: string | null } | null } | null };

export type RollbackDepartmentMutationVariables = Exact<{
  departmentId: Scalars['ID']['input'];
}>;


export type RollbackDepartmentMutation = { __typename?: 'Mutation', rollbackDepartment?: { __typename?: 'Department', id: string, owner?: string | null, organizationId?: string | null, name?: string | null, draftKnowledgeId?: string | null, publishedKnowledgeId?: string | null, workerId?: string | null, local?: boolean | null, state?: string | null, errors?: Array<string> | null, createdAt?: string | null, isDeleted: boolean, brainVersion?: string | null, features?: Array<DepartmentFeature> | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, draftKnowledge?: { __typename?: 'Knowledge', id: string, brainVersion?: string | null } | null } | null };

export type RemoveUserFromDepartmentMutationVariables = Exact<{
  departmentId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type RemoveUserFromDepartmentMutation = { __typename?: 'Mutation', removeUserFromDepartment?: { __typename?: 'AccessControlAck', status: string } | null };

export type RollbackDepartmentVersionMutationVariables = Exact<{
  input: DepartmentRollbackInput;
}>;


export type RollbackDepartmentVersionMutation = { __typename?: 'Mutation', rollbackDepartmentVersion?: { __typename?: 'DepartmentRollback', id: string, departmentId: string, previousVersion: string, currentVersion: string, rollbackVersion: string } | null };

export type DeleteDepartmentMutationVariables = Exact<{
  input: DeleteDepartmentInput;
}>;


export type DeleteDepartmentMutation = { __typename?: 'Mutation', deleteDepartment?: { __typename?: 'Department', id: string, owner?: string | null, organizationId?: string | null, readers?: Array<string | null> | null, editors?: Array<string | null> | null, name?: string | null, draftKnowledgeId?: string | null, publishedKnowledgeId?: string | null, workerId?: string | null, local?: boolean | null, state?: string | null, errors?: Array<string> | null, createdAt?: string | null, isDeleted: boolean, upgradeCommandId?: string | null, notifyProcedureInvocation?: boolean | null, features?: Array<DepartmentFeature> | null, brainVersion?: string | null, status?: string | null, purgeWorkerDataAfter?: DataPurgeInterval | null, provisionedConcurrency?: number | null, worker?: { __typename?: 'Worker', id: string, owner?: string | null, readers?: Array<string | null> | null, editors?: Array<string | null> | null, name?: string | null, description?: string | null, version?: string | null, departmentVersion?: string | null, knowledgeId?: string | null, departmentId?: string | null, procedureId?: string | null, entryCommand?: string | null, entryCommandId?: string | null, originalWorkerId?: string | null, createdAt?: string | null, state?: string | null, stateLastUpdatedAt?: string | null, status?: string | null, statusLastUpdatedAt?: string | null, attachments?: Array<string> | null, isArchived?: boolean | null, features?: Array<string> | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, owner: string, createdAt: string, updatedAt: string, billingStatus?: OrganizationBillingStatus | null } | null, draftKnowledge?: { __typename?: 'Knowledge', id: string, owner?: string | null, readers?: Array<string | null> | null, editors?: Array<string | null> | null, name?: string | null, description?: string | null, departmentId: string, workerId?: string | null, parentKnowledgeId?: string | null, state?: string | null, brainVersion?: string | null } | null, publishedKnowledge?: { __typename?: 'Knowledge', id: string, owner?: string | null, readers?: Array<string | null> | null, editors?: Array<string | null> | null, name?: string | null, description?: string | null, departmentId: string, workerId?: string | null, parentKnowledgeId?: string | null, state?: string | null, brainVersion?: string | null } | null, requests?: { __typename?: 'RequestConnection', limit?: number | null, nextToken?: string | null } | null, learnedAnswers?: { __typename?: 'LearnedAnswerConnection', nextToken?: string | null } | null } | null };

export type UpdateDepartmentMutationVariables = Exact<{
  input: UpdateDepartmentInput;
}>;


export type UpdateDepartmentMutation = { __typename?: 'Mutation', updateDepartment?: { __typename?: 'Department', id: string, owner?: string | null, organizationId?: string | null, readers?: Array<string | null> | null, editors?: Array<string | null> | null, name?: string | null, draftKnowledgeId?: string | null, publishedKnowledgeId?: string | null, workerId?: string | null, local?: boolean | null, state?: string | null, errors?: Array<string> | null, createdAt?: string | null, isDeleted: boolean, upgradeCommandId?: string | null, notifyProcedureInvocation?: boolean | null, features?: Array<DepartmentFeature> | null, brainVersion?: string | null, status?: string | null, purgeWorkerDataAfter?: DataPurgeInterval | null, provisionedConcurrency?: number | null, worker?: { __typename?: 'Worker', id: string, owner?: string | null, readers?: Array<string | null> | null, editors?: Array<string | null> | null, name?: string | null, description?: string | null, version?: string | null, departmentVersion?: string | null, knowledgeId?: string | null, departmentId?: string | null, procedureId?: string | null, entryCommand?: string | null, entryCommandId?: string | null, originalWorkerId?: string | null, createdAt?: string | null, state?: string | null, stateLastUpdatedAt?: string | null, status?: string | null, statusLastUpdatedAt?: string | null, attachments?: Array<string> | null, isArchived?: boolean | null, features?: Array<string> | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, owner: string, createdAt: string, updatedAt: string, billingStatus?: OrganizationBillingStatus | null } | null, draftKnowledge?: { __typename?: 'Knowledge', id: string, owner?: string | null, readers?: Array<string | null> | null, editors?: Array<string | null> | null, name?: string | null, description?: string | null, departmentId: string, workerId?: string | null, parentKnowledgeId?: string | null, state?: string | null, brainVersion?: string | null } | null, publishedKnowledge?: { __typename?: 'Knowledge', id: string, owner?: string | null, readers?: Array<string | null> | null, editors?: Array<string | null> | null, name?: string | null, description?: string | null, departmentId: string, workerId?: string | null, parentKnowledgeId?: string | null, state?: string | null, brainVersion?: string | null } | null, requests?: { __typename?: 'RequestConnection', limit?: number | null, nextToken?: string | null } | null, learnedAnswers?: { __typename?: 'LearnedAnswerConnection', nextToken?: string | null } | null } | null };

export type ImportDepartmentMutationVariables = Exact<{
  input: DepartmentImportInput;
}>;


export type ImportDepartmentMutation = { __typename?: 'Mutation', importDepartment?: { __typename?: 'Department', id: string, owner?: string | null, organizationId?: string | null, name?: string | null, draftKnowledgeId?: string | null, publishedKnowledgeId?: string | null, workerId?: string | null, local?: boolean | null, state?: string | null, errors?: Array<string> | null, createdAt?: string | null, isDeleted: boolean, brainVersion?: string | null, features?: Array<DepartmentFeature> | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, draftKnowledge?: { __typename?: 'Knowledge', id: string, brainVersion?: string | null } | null } | null };

export type UpsertUserToDepartmentMutationVariables = Exact<{
  departmentId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  role: AccessControlRole;
}>;


export type UpsertUserToDepartmentMutation = { __typename?: 'Mutation', upsertUserToDepartment?: { __typename?: 'AccessControlAck', status: string } | null };

export type PublishDepartmentMutationVariables = Exact<{
  input: PublishDepartmentInput;
}>;


export type PublishDepartmentMutation = { __typename?: 'Mutation', publishDepartment: { __typename?: 'PublishDepartment', id: string, departmentId: string, departmentVersion: string, publishedAt: string, publishedBy: string } };

export type AssignRequestsMutationVariables = Exact<{
  input: AssignRequestsInput;
}>;


export type AssignRequestsMutation = { __typename?: 'Mutation', assignRequests: { __typename?: 'AssignRequestsResult', assignments: Array<{ __typename?: 'RequestAssignment', requestId: string, assignment: string, assignmentPolicyType: AssignmentPolicyType }> } };

export type CreateKChatMessageMutationVariables = Exact<{
  input: CreateChatMessageInput;
}>;


export type CreateKChatMessageMutation = { __typename?: 'Mutation', createKChatMessage: { __typename?: 'ChatMessageConnection', nextToken?: string | null, items: Array<{ __typename?: 'ChatMessage', id: string, departmentId: string, workerId: string, message: string, timestamp: string, displayName?: string | null, role?: string | null }> } };

export type CreateLearnedAnswerMutationVariables = Exact<{
  input: CreateLearnedAnswerInput;
}>;


export type CreateLearnedAnswerMutation = { __typename?: 'Mutation', createLearnedAnswer?: { __typename?: 'LearnedAnswer', id: string, stage?: Array<LearningStage> | null, createdAt?: string | null, createdBy?: string | null, deletedAt?: string | null, deletedBy?: string | null, procedureId?: string | null, procedureName?: string | null, contextValue?: Array<string> | null, contextMetadata?: Array<string> | null, questionFilter?: { __typename?: 'RequestQuestionFilter', stepPath?: Array<string | null> | null, questionType?: string | null, lexicalPath?: Array<string | null> | null } | null, action?: { __typename?: 'ApproveReviewAction', _?: string | null } | { __typename?: 'ReplaceStepAction', newSteps?: Array<string> | null, _?: string | null } | { __typename?: 'RetryStepAction', minimumDelay: number, timeout?: number | null, _?: string | null } | { __typename?: 'SkipStepAction', _?: string | null } | { __typename?: 'SkipToEndOfRunAction', _?: string | null } | { __typename?: 'UseConceptAction', conceptId?: string | null, _?: string | null } | { __typename?: 'UseLiteralValueAction', literalValue?: string | null, choices?: Array<string> | null, _?: string | null } | { __typename?: 'UseNoValueAction', _?: string | null } | { __typename?: 'UseOauth2Action', _?: string | null } | { __typename?: 'UseTechniqueAction', technique?: string | null, _?: string | null } | null, procedure?: { __typename?: 'Procedure', id: string } | null } | null };

export type DeleteLearnedAnswerMutationVariables = Exact<{
  input: DeleteLearnedAnswerInput;
}>;


export type DeleteLearnedAnswerMutation = { __typename?: 'Mutation', deleteLearnedAnswer?: { __typename?: 'LearnedAnswer', id: string } | null };

export type DeleteContextualLearningInfosMutationVariables = Exact<{
  input: DeleteRestoreContextualLearningInfoInput;
}>;


export type DeleteContextualLearningInfosMutation = { __typename?: 'Mutation', deleteContextualLearningInfos?: { __typename?: 'ContextualLearningInfoConnection', items: Array<{ __typename?: 'ContextualLearningInfo', id: string, isDeleted?: boolean | null, requestId: string, contextFactsInfo?: Array<{ __typename?: 'Fact', id: string, names?: Array<string | null> | null, locations?: Array<{ [key: string]: any }> | null, dereferencedId?: string | null, type?: string | null, value?: string | null } | null> | null }> } | null };

export type RestoreContextualLearningInfosMutationVariables = Exact<{
  input: DeleteRestoreContextualLearningInfoInput;
}>;


export type RestoreContextualLearningInfosMutation = { __typename?: 'Mutation', restoreContextLearningInfos?: { __typename?: 'ContextualLearningInfoConnection', items: Array<{ __typename?: 'ContextualLearningInfo', id: string, isDeleted?: boolean | null, requestId: string, contextFactsInfo?: Array<{ __typename?: 'Fact', id: string, names?: Array<string | null> | null, locations?: Array<{ [key: string]: any }> | null, dereferencedId?: string | null, type?: string | null, value?: string | null } | null> | null }> } | null };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization?: { __typename?: 'Organization', id: string, name: string, owner: string, createdAt: string, updatedAt: string, billingStatus?: OrganizationBillingStatus | null } | null };

export type PingMutationVariables = Exact<{
  channel: Scalars['String']['input'];
  data?: InputMaybe<Scalars['String']['input']>;
}>;


export type PingMutation = { __typename?: 'Mutation', ping: { __typename?: 'Ping', channel: string, data?: string | null } };

export type UpdateWorkerDocumentMutationVariables = Exact<{
  workerId: Scalars['ID']['input'];
  document: Array<SentenceInput> | SentenceInput;
  shouldStartExecution: Scalars['Boolean']['input'];
  useAutopilot?: InputMaybe<Scalars['Boolean']['input']>;
  documentToken?: InputMaybe<Scalars['String']['input']>;
  startFromUiLineId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateWorkerDocumentMutation = { __typename?: 'Mutation', updateWorkerDocument: { __typename?: 'DocumentInfo', updatedAt?: string | null, sentences: Array<{ __typename?: 'Sentence', lineId: string, text: string, shouldPause?: boolean | null, parentId?: string | null, language?: string | null, metadata?: { __typename?: 'SentenceMetadata', lineId?: string | null, parentId?: string | null } | null, internalMetadata?: Array<{ __typename?: 'DictionaryItem', key: string, value: string }> | null } | null> } };

export type CreateMiniPlaygroundMutationVariables = Exact<{
  input: CreateMiniPlaygroundInput;
}>;


export type CreateMiniPlaygroundMutation = { __typename?: 'Mutation', createMiniPlayground: { __typename?: 'CreateMiniPlayground', id: string, workerId: string, createdAt?: string | null, forwardedAt?: Array<string> | null, invokedAt?: Array<string> | null, receivedAt?: Array<string> | null, processingAt?: Array<string> | null, skippedAt?: Array<string> | null, processedAt?: Array<string> | null, failedAt?: Array<string> | null, workErrors?: Array<string> | null, createdBy?: string | null, lineId: string, lineToken: string } };

export type DuplicateWorkersMutationVariables = Exact<{
  departmentId: Scalars['ID']['input'];
  workerIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  owner?: InputMaybe<Scalars['String']['input']>;
  runWorker?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DuplicateWorkersMutation = { __typename?: 'Mutation', duplicateWorkers: Array<{ __typename?: 'Worker', id: string, owner?: string | null, name?: string | null, version?: string | null, departmentVersion?: string | null, knowledgeId?: string | null, departmentId?: string | null, procedureId?: string | null, originalWorkerId?: string | null, createdAt?: string | null, state?: string | null, isArchived?: boolean | null, features?: Array<string> | null, stage?: ProcedureStage | null, replayWorkerId?: string | null }> };

export type ReplayWorkersMutationVariables = Exact<{
  departmentId: Scalars['ID']['input'];
  workerIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  owner?: InputMaybe<Scalars['String']['input']>;
  runWorker?: InputMaybe<Scalars['Boolean']['input']>;
  brainVersion?: InputMaybe<Scalars['String']['input']>;
  isReplay?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ReplayWorkersMutation = { __typename?: 'Mutation', duplicateWorkers: Array<{ __typename?: 'Worker', id: string, owner?: string | null, name?: string | null, version?: string | null, departmentVersion?: string | null, knowledgeId?: string | null, departmentId?: string | null, procedureId?: string | null, originalWorkerId?: string | null, createdAt?: string | null, state?: string | null, isArchived?: boolean | null, features?: Array<string> | null, stage?: ProcedureStage | null, replayWorkerId?: string | null }> };

export type UpdateWorkerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateWorkerMutation = { __typename?: 'Mutation', updateWorker?: { __typename?: 'Worker', id: string, name?: string | null } | null };

export type ToggleWorkerArchiveStatusMutationVariables = Exact<{
  input: ToggleWorkerArchiveStatusInput;
}>;


export type ToggleWorkerArchiveStatusMutation = { __typename?: 'Mutation', toggleWorkerArchiveStatus?: { __typename?: 'Worker', id: string, name?: string | null } | null };

export type CreateWorkerMutationVariables = Exact<{
  input: CreateWorkerInput;
  local?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateWorkerMutation = { __typename?: 'Mutation', createWorker?: { __typename?: 'Worker', id: string, owner?: string | null, readers?: Array<string | null> | null, editors?: Array<string | null> | null, name?: string | null, description?: string | null, version?: string | null, departmentVersion?: string | null, knowledgeId?: string | null, departmentId?: string | null, procedureId?: string | null, entryCommand?: string | null, entryCommandId?: string | null, originalWorkerId?: string | null, createdAt?: string | null, state?: string | null, stateLastUpdatedAt?: string | null, attachments?: Array<string> | null, isArchived?: boolean | null, features?: Array<string> | null, replayWorkerId?: string | null } | null };

export type InvokeProcedure2MutationVariables = Exact<{
  departmentId: Scalars['ID']['input'];
  procedureId: Scalars['ID']['input'];
  knowledgeId?: InputMaybe<Scalars['ID']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  local?: InputMaybe<Scalars['Boolean']['input']>;
  commandParamsInput?: InputMaybe<CommandParamsInput>;
  version?: InputMaybe<Scalars['String']['input']>;
  procedureStage?: InputMaybe<ProcedureStage>;
}>;


export type InvokeProcedure2Mutation = { __typename?: 'Mutation', invokeProcedure2: { __typename?: 'Worker', id: string, owner?: string | null, readers?: Array<string | null> | null, editors?: Array<string | null> | null, name?: string | null, description?: string | null, version?: string | null, departmentVersion?: string | null, knowledgeId?: string | null, departmentId?: string | null, procedureId?: string | null, entryCommand?: string | null, entryCommandId?: string | null, originalWorkerId?: string | null, createdAt?: string | null, state?: string | null, stage?: ProcedureStage | null, stateLastUpdatedAt?: string | null, attachments?: Array<string> | null, isArchived?: boolean | null } };

export type CreateProcedureMutationVariables = Exact<{
  input: CreateProcedureInput;
}>;


export type CreateProcedureMutation = { __typename?: 'Mutation', createProcedure?: { __typename?: 'Procedure', id: string, knowledgeId?: string | null, departmentId?: string | null, text?: string | null, name?: string | null, owner?: string | null, language?: string | null, public: boolean, bookReference?: string | null, title?: string | null, version?: string | null, stage?: ProcedureStage | null, email?: Array<{ __typename?: 'StageEmail', stage: string, email: string }> | null, assignmentPolicy?: { __typename?: 'AssignmentPolicy', policyType: AssignmentPolicyType, collaborator?: string | null } | null, schedules: Array<{ __typename?: 'Schedule', name?: string | null, expression?: string | null, enabled?: boolean | null } | null>, requests?: { __typename?: 'RequestConnection', limit?: number | null, nextToken?: string | null } | null } | null };

export type UpdateProcedureMutationVariables = Exact<{
  input: UpdateProcedureInput;
}>;


export type UpdateProcedureMutation = { __typename?: 'Mutation', updateProcedure?: { __typename?: 'Procedure', id: string, knowledgeId?: string | null, departmentId?: string | null, text?: string | null, name?: string | null, owner?: string | null, language?: string | null, bookReference?: string | null, stage?: ProcedureStage | null, title?: string | null, version?: string | null, schedules: Array<{ __typename?: 'Schedule', name?: string | null, expression?: string | null, enabled?: boolean | null } | null>, email?: Array<{ __typename?: 'StageEmail', stage: string, email: string }> | null, assignmentPolicy?: { __typename?: 'AssignmentPolicy', policyType: AssignmentPolicyType, collaborator?: string | null } | null } | null };

export type GenerateProcessVisualizationMutationVariables = Exact<{
  procedureId: Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
  procedureStage?: InputMaybe<ProcedureStage>;
}>;


export type GenerateProcessVisualizationMutation = { __typename?: 'Mutation', generateProcessVisualization?: { __typename?: 'ProcessVisualizationAck', status: ProcessVisualizationStatus, message: string } | null };

export type DeleteProcedureMutationVariables = Exact<{
  input: DeleteProcedureInput;
}>;


export type DeleteProcedureMutation = { __typename?: 'Mutation', deleteProcedure?: { __typename?: 'Procedure', id: string, knowledgeId?: string | null, departmentId?: string | null, text?: string | null, name?: string | null, owner?: string | null, language?: string | null, public: boolean, bookReference?: string | null, title?: string | null, version?: string | null, stage?: ProcedureStage | null, email?: Array<{ __typename?: 'StageEmail', stage: string, email: string }> | null, assignmentPolicy?: { __typename?: 'AssignmentPolicy', policyType: AssignmentPolicyType, collaborator?: string | null } | null, schedules: Array<{ __typename?: 'Schedule', name?: string | null, expression?: string | null, enabled?: boolean | null } | null>, requests?: { __typename?: 'RequestConnection', limit?: number | null, nextToken?: string | null } | null } | null };

export type UpdateProcedureScheduleMutationVariables = Exact<{
  input: UpdateProcedureScheduleInput;
}>;


export type UpdateProcedureScheduleMutation = { __typename?: 'Mutation', updateProcedureSchedule?: { __typename?: 'Procedure', id: string, knowledgeId?: string | null, departmentId?: string | null, text?: string | null, name?: string | null, owner?: string | null, language?: string | null, public: boolean, bookReference?: string | null, title?: string | null, version?: string | null, stage?: ProcedureStage | null, email?: Array<{ __typename?: 'StageEmail', stage: string, email: string }> | null, assignmentPolicy?: { __typename?: 'AssignmentPolicy', policyType: AssignmentPolicyType, collaborator?: string | null } | null, schedules: Array<{ __typename?: 'Schedule', name?: string | null, expression?: string | null, enabled?: boolean | null } | null>, requests?: { __typename?: 'RequestConnection', limit?: number | null, nextToken?: string | null } | null } | null };

export type CreateProcedureV2MutationVariables = Exact<{
  input: CreateProcedureInput;
}>;


export type CreateProcedureV2Mutation = { __typename?: 'Mutation', createProcedureV2?: { __typename?: 'Procedure', id: string, knowledgeId?: string | null, departmentId?: string | null, text?: string | null, name?: string | null, owner?: string | null, language?: string | null, public: boolean, bookReference?: string | null, title?: string | null, version?: string | null, stage?: ProcedureStage | null, email?: Array<{ __typename?: 'StageEmail', stage: string, email: string }> | null, assignmentPolicy?: { __typename?: 'AssignmentPolicy', policyType: AssignmentPolicyType, collaborator?: string | null } | null, schedules: Array<{ __typename?: 'Schedule', name?: string | null, expression?: string | null, enabled?: boolean | null } | null>, requests?: { __typename?: 'RequestConnection', limit?: number | null, nextToken?: string | null } | null } | null };

export type UpdateProcedureV2MutationVariables = Exact<{
  input: UpdateProcedureInput;
}>;


export type UpdateProcedureV2Mutation = { __typename?: 'Mutation', updateProcedureV2?: { __typename?: 'Procedure', id: string, knowledgeId?: string | null, departmentId?: string | null, text?: string | null, name?: string | null, owner?: string | null, language?: string | null, bookReference?: string | null, stage?: ProcedureStage | null, title?: string | null, version?: string | null, schedules: Array<{ __typename?: 'Schedule', name?: string | null, expression?: string | null, enabled?: boolean | null } | null>, email?: Array<{ __typename?: 'StageEmail', stage: string, email: string }> | null, assignmentPolicy?: { __typename?: 'AssignmentPolicy', policyType: AssignmentPolicyType, collaborator?: string | null } | null } | null };

export type DiscardProcedureDraftMutationVariables = Exact<{
  input: DiscardProcedureDraftInput;
}>;


export type DiscardProcedureDraftMutation = { __typename?: 'Mutation', discardProcedureDraft?: { __typename?: 'Procedure', id: string, departmentVersion?: string | null, stage?: ProcedureStage | null } | null };

export type CreateBulkRequestAnswerMutationVariables = Exact<{
  inputs: Array<CreateRequestAnswerInput> | CreateRequestAnswerInput;
}>;


export type CreateBulkRequestAnswerMutation = { __typename?: 'Mutation', createBulkRequestAnswer: Array<{ __typename?: 'RequestAnswer', id: string, requestId: string, questionId?: string | null, createdAt?: string | null, createdBy?: string | null, action?: { __typename?: 'ApproveReviewAction', _?: string | null } | { __typename?: 'ReplaceStepAction', newSteps?: Array<string> | null, _?: string | null } | { __typename?: 'RetryStepAction', minimumDelay: number, timeout?: number | null, _?: string | null } | { __typename?: 'SkipStepAction', _?: string | null } | { __typename?: 'SkipToEndOfRunAction', _?: string | null } | { __typename?: 'UseConceptAction', conceptId?: string | null, _?: string | null } | { __typename?: 'UseLiteralValueAction', literalValue?: string | null, choices?: Array<string> | null, _?: string | null } | { __typename?: 'UseNoValueAction', _?: string | null } | { __typename?: 'UseOauth2Action', _?: string | null } | { __typename?: 'UseTechniqueAction', technique?: string | null, _?: string | null } | null } | null> };

export type CreateRequestAnswerMutationVariables = Exact<{
  input: CreateRequestAnswerInput;
}>;


export type CreateRequestAnswerMutation = { __typename?: 'Mutation', createRequestAnswer?: { __typename?: 'RequestAnswer', id: string, requestId: string, questionId?: string | null, createdAt?: string | null, createdBy?: string | null, summary?: string | null, action?: { __typename?: 'ApproveReviewAction', _?: string | null } | { __typename?: 'ReplaceStepAction', newSteps?: Array<string> | null, _?: string | null } | { __typename?: 'RetryStepAction', minimumDelay: number, timeout?: number | null, _?: string | null } | { __typename?: 'SkipStepAction', _?: string | null } | { __typename?: 'SkipToEndOfRunAction', _?: string | null } | { __typename?: 'UseConceptAction', conceptId?: string | null, _?: string | null } | { __typename?: 'UseLiteralValueAction', literalValue?: string | null, choices?: Array<string> | null, _?: string | null } | { __typename?: 'UseNoValueAction', _?: string | null } | { __typename?: 'UseOauth2Action', _?: string | null } | { __typename?: 'UseTechniqueAction', technique?: string | null, _?: string | null } | null, sourceLearning?: { __typename?: 'LearnedAnswer', id: string, createdAt?: string | null, createdBy?: string | null, deletedAt?: string | null, deletedBy?: string | null, procedureId?: string | null, procedureName?: string | null, contextValue?: Array<string> | null, contextMetadata?: Array<string> | null } | null } | null };

export type UpdateLearnedAnswerMutationVariables = Exact<{
  input: UpdateLearnedAnswerInput;
}>;


export type UpdateLearnedAnswerMutation = { __typename?: 'Mutation', updateLearnedAnswer?: { __typename?: 'LearnedAnswer', id: string, stage?: Array<LearningStage> | null, originalAnswerId?: string | null, createdAt?: string | null, createdBy?: string | null, deletedAt?: string | null, deletedBy?: string | null, procedureId?: string | null, procedureName?: string | null, contextValue?: Array<string> | null, contextMetadata?: Array<string> | null, questionFilter?: { __typename?: 'RequestQuestionFilter', stepPath?: Array<string | null> | null, questionType?: string | null, lexicalPath?: Array<string | null> | null } | null, action?: { __typename?: 'ApproveReviewAction', _?: string | null } | { __typename?: 'ReplaceStepAction', newSteps?: Array<string> | null, _?: string | null } | { __typename?: 'RetryStepAction', minimumDelay: number, timeout?: number | null, _?: string | null } | { __typename?: 'SkipStepAction', _?: string | null } | { __typename?: 'SkipToEndOfRunAction', _?: string | null } | { __typename?: 'UseConceptAction', conceptId?: string | null, _?: string | null } | { __typename?: 'UseLiteralValueAction', literalValue?: string | null, choices?: Array<string> | null, _?: string | null } | { __typename?: 'UseNoValueAction', _?: string | null } | { __typename?: 'UseOauth2Action', accessToken?: string | null, refreshToken?: string | null, _?: string | null } | { __typename?: 'UseTechniqueAction', technique?: string | null, _?: string | null } | null, procedure?: { __typename?: 'Procedure', id: string, name?: string | null, stage?: ProcedureStage | null } | null } | null };

export type SetUserPreferencesMutationVariables = Exact<{
  input: UserPreferencesInput;
}>;


export type SetUserPreferencesMutation = { __typename?: 'Mutation', setUserPreferences?: { __typename?: 'UserPreferences', lastUsedDepartmentId?: string | null } | null };

export type ListWorkersDataByDepartmentsQueryVariables = Exact<{
  departmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListWorkersDataFilter>;
}>;


export type ListWorkersDataByDepartmentsQuery = { __typename?: 'Query', listWorkersDataByDepartments: { __typename?: 'WorkerDataConnection', nextToken?: string | null, workersData: Array<{ __typename?: 'WorkerData', id: string, departmentId?: string | null, departmentName?: string | null, procedureId?: string | null, procedureName?: string | null, createdAt?: string | null, state?: string | null, brainVersion?: string | null, isArchived?: boolean | null, owner?: string | null }> } };

export type GetInternalAdminConsoleQueryVariables = Exact<{
  filter?: InputMaybe<InternalAdminDepartmentFilter>;
}>;


export type GetInternalAdminConsoleQuery = { __typename?: 'Query', getInternalAdminConsole: { __typename?: 'InternalAdminConsole', appBuildString: string, appBuildJobUrl: string, departments: { __typename?: 'InternalAdminDepartmentTable', departments?: Array<{ __typename?: 'InternalAdminDepartmentInfo', key: string, id: string, info: string, notes: string, notionDepartmentNotesUrl?: string | null, launchdarklyContextUrl?: string | null }> | null } } };

export type ListIntegrationsByDepartmentQueryVariables = Exact<{
  departmentId: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListIntegrationsByDepartmentQuery = { __typename?: 'Query', listIntegrationsByDepartment?: { __typename?: 'IntegrationConnection', nextToken?: string | null, items?: Array<{ __typename?: 'Integration', id: string, url: string, name?: string | null, author?: string | null, description?: string | null, integratedAt?: string | null, version?: string | null, credentialMetadata?: { __typename?: 'CredentialMetadata', isCredentialProvided?: boolean | null, redirectionFlowRequired?: boolean | null, isRedirectionFlowDone?: boolean | null } | null }> | null } | null };

export type GetIntegrationCredentialFormQueryVariables = Exact<{
  integrationId: Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
}>;


export type GetIntegrationCredentialFormQuery = { __typename?: 'Query', getIntegrationCredentialForm?: { __typename?: 'CredentialForm', integrationId: string, fields?: Array<{ __typename?: 'FormField', label: string, key: string, type: FormFieldType, description?: string | null, example?: string | null }> | null } | null };

export type RevealIntegrationCredentialQueryVariables = Exact<{
  integrationId: Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
}>;


export type RevealIntegrationCredentialQuery = { __typename?: 'Query', revealIntegrationCredential?: { __typename?: 'CredentialValue', integrationId: string, departmentId: string, data?: Array<{ __typename?: 'Value', label?: string | null, key?: string | null, value?: string | null } | null> | null } | null };

export type RevealIntegrationCredentialsQueryVariables = Exact<{
  integrationId: Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
}>;


export type RevealIntegrationCredentialsQuery = { __typename?: 'Query', revealIntegrationCredentials: Array<{ __typename?: 'CredentialValue', integrationId: string, departmentId: string, name?: string | null, data?: Array<{ __typename?: 'Value', label?: string | null, key?: string | null, value?: string | null } | null> | null }> };

export type QuestionsMetricsByDepartmentQueryVariables = Exact<{
  departmentId: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  requestsMetrics?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type QuestionsMetricsByDepartmentQuery = { __typename?: 'Query', questionsMetricsByDepartment?: Array<{ __typename?: 'QuestionsMetrics', procedureId: string, procedureName: string, totalRuns: number, procedureTitle?: string | null, unhandledRequests?: number | null, handledRequests?: number | null, totalRequests?: number | null, knowledgeId?: string | null, departmentId?: string | null }> | null };

export type ListDepartmentsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  deptFilter?: InputMaybe<ListDepartmentsFilter>;
}>;


export type ListDepartmentsQuery = { __typename?: 'Query', listDepartments?: { __typename?: 'DepartmentConnection', nextToken?: string | null, items?: Array<{ __typename?: 'Department', id: string, owner?: string | null, organizationId?: string | null, name?: string | null, draftKnowledgeId?: string | null, publishedKnowledgeId?: string | null, workerId?: string | null, local?: boolean | null, state?: string | null, errors?: Array<string> | null, createdAt?: string | null, isDeleted: boolean, brainVersion?: string | null, features?: Array<DepartmentFeature> | null, organization?: { __typename?: 'Organization', id: string, name: string, createdAt: string, owner: string, updatedAt: string } | null, draftKnowledge?: { __typename?: 'Knowledge', departmentId: string, id: string, brainVersion?: string | null } | null } | null> | null } | null };

export type ListAllDepartmentsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListAllDepartmentsQuery = { __typename?: 'Query', listAllDepartments?: { __typename?: 'DepartmentConnection', nextToken?: string | null, items?: Array<{ __typename?: 'Department', id: string, owner?: string | null, name?: string | null, local?: boolean | null, createdAt?: string | null, brainVersion?: string | null, features?: Array<DepartmentFeature> | null, organization?: { __typename?: 'Organization', id: string, name: string } | null } | null> | null } | null };

export type GetDepartmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDepartmentQuery = { __typename?: 'Query', getDepartment?: { __typename?: 'Department', id: string, owner?: string | null, organizationId?: string | null, name?: string | null, draftKnowledgeId?: string | null, publishedKnowledgeId?: string | null, workerId?: string | null, local?: boolean | null, state?: string | null, errors?: Array<string> | null, createdAt?: string | null, isDeleted: boolean, brainVersion?: string | null, features?: Array<DepartmentFeature> | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, draftKnowledge?: { __typename?: 'Knowledge', id: string, brainVersion?: string | null } | null } | null };

export type ListDepartmentCollaboratorsQueryVariables = Exact<{
  departmentId: Scalars['String']['input'];
  role?: InputMaybe<AccessControlRole>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListDepartmentCollaboratorsQuery = { __typename?: 'Query', listDepartmentCollaborators?: { __typename?: 'DepartmentUserConnection', nextToken?: string | null, items?: Array<{ __typename?: 'DepartmentUser', id: string, userId: string, role: AccessControlRole } | null> | null } | null };

export type GetDepartmentHistoryQueryVariables = Exact<{
  departmentId: Scalars['ID']['input'];
  entityName?: InputMaybe<DepartmentBookEntity>;
  entityIDs?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDepartmentHistoryQuery = { __typename?: 'Query', getDepartmentHistory?: { __typename?: 'DepartmentHistoryConnection', nextToken?: string | null, items?: Array<{ __typename?: 'DepartmentHistoryEvent', entityId: string, user: string, operation: string, entityName: string, timestamp: string, name?: string | null, rollbackVersion?: string | null, publishedVersion?: string | null } | null> | null } | null };

export type ExportDepartmentQueryVariables = Exact<{
  departmentId: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExportDepartmentQuery = { __typename?: 'Query', exportDepartment?: { __typename?: 'DepartmentExport', formatVersion: number, departmentID: string, departmentVersion?: string | null, checksum?: string | null, features?: Array<DepartmentFeature | null> | null, procedures: Array<{ __typename?: 'ProcedureExport', id?: string | null, name?: string | null, text?: string | null, language?: string | null } | null>, facts: Array<{ __typename?: 'FactExport', name: string, values: Array<string> } | null>, learnedBooks?: { __typename?: 'LearnedBookExport', ids: Array<string | null> } | null, learnings?: Array<{ __typename?: 'LearningExport', id?: string | null, stage?: string | null, questionType?: string | null, stepPath?: string | null, lexicalPath?: string | null, procedureId?: string | null, action?: string | null, literalValue?: string | null, choices?: string | null, conceptId?: string | null, technique?: string | null, retryTimeout?: number | null, retryMinimumDelay?: number | null, newSteps?: string | null, oauth2Metadata?: string | null } | null> | null, contextualLearningInfo?: Array<{ __typename?: 'ContextualLearningInfoExport', procedureId?: string | null, learningId?: string | null, questionType?: string | null, stepPath?: string | null, lexicalPath?: string | null, contextValue?: string | null, contextVector?: string | null, contextMetadata?: string | null } | null> | null } | null };

export type GetRequestQuestionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRequestQuestionQuery = { __typename?: 'Query', getRequestQuestion?: { __typename?: 'DomainNotIntegratedQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null, failedAnswerId?: string | null, failedAnswerReason?: string | null, summary?: string | null, request?: { __typename?: 'Request', id: string, createdAt?: string | null, state?: string | null, procedureId?: string | null, procedureName?: string | null, assignee?: string | null } | null } | { __typename?: 'EnsureFailedQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null, failedAnswerId?: string | null, failedAnswerReason?: string | null, summary?: string | null, request?: { __typename?: 'Request', id: string, createdAt?: string | null, state?: string | null, procedureId?: string | null, procedureName?: string | null, assignee?: string | null } | null } | { __typename?: 'MissingIntegrationCredentialQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null, failedAnswerId?: string | null, failedAnswerReason?: string | null, summary?: string | null, request?: { __typename?: 'Request', id: string, createdAt?: string | null, state?: string | null, procedureId?: string | null, procedureName?: string | null, assignee?: string | null } | null } | { __typename?: 'NativeCodeErrorQuestion', errorType?: string | null, errorMessage?: string | null, errorTraceback?: string | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null, failedAnswerId?: string | null, failedAnswerReason?: string | null, summary?: string | null, request?: { __typename?: 'Request', id: string, createdAt?: string | null, state?: string | null, procedureId?: string | null, procedureName?: string | null, assignee?: string | null } | null } | { __typename?: 'OAuth2MissingQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null, failedAnswerId?: string | null, failedAnswerReason?: string | null, summary?: string | null, request?: { __typename?: 'Request', id: string, createdAt?: string | null, state?: string | null, procedureId?: string | null, procedureName?: string | null, assignee?: string | null } | null } | { __typename?: 'ParseErrorQuestion', errorTraceback?: string | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null, failedAnswerId?: string | null, failedAnswerReason?: string | null, summary?: string | null, request?: { __typename?: 'Request', id: string, createdAt?: string | null, state?: string | null, procedureId?: string | null, procedureName?: string | null, assignee?: string | null } | null } | { __typename?: 'ProcedureNotKnownQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null, failedAnswerId?: string | null, failedAnswerReason?: string | null, summary?: string | null, request?: { __typename?: 'Request', id: string, createdAt?: string | null, state?: string | null, procedureId?: string | null, procedureName?: string | null, assignee?: string | null } | null } | { __typename?: 'ReviewConceptQuestion', lexicalPath?: Array<string> | null, conceptId?: string | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null, failedAnswerId?: string | null, failedAnswerReason?: string | null, summary?: string | null, request?: { __typename?: 'Request', id: string, createdAt?: string | null, state?: string | null, procedureId?: string | null, procedureName?: string | null, assignee?: string | null } | null } | { __typename?: 'ValueNotKnownQuestion', lexicalPath?: Array<string> | null, choices?: Array<string> | null, helpText?: string | null, isPlural?: boolean | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null, failedAnswerId?: string | null, failedAnswerReason?: string | null, summary?: string | null, request?: { __typename?: 'Request', id: string, createdAt?: string | null, state?: string | null, procedureId?: string | null, procedureName?: string | null, assignee?: string | null } | null } | null };

export type ListQuestionsByDepartmentQueryVariables = Exact<{
  input: ListQuestionsByDepartmentInput;
}>;


export type ListQuestionsByDepartmentQuery = { __typename?: 'Query', listQuestionsByDepartment?: { __typename?: 'RequestQuestionConnection', total?: number | null, items: Array<{ __typename?: 'DomainNotIntegratedQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null, failedAnswerId?: string | null, failedAnswerReason?: string | null, summary?: string | null, request?: { __typename?: 'Request', id: string, createdAt?: string | null, state?: string | null, procedureId?: string | null, procedureName?: string | null, assignee?: string | null, worker?: { __typename?: 'Worker', id: string } | null } | null } | { __typename?: 'EnsureFailedQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null, failedAnswerId?: string | null, failedAnswerReason?: string | null, summary?: string | null, request?: { __typename?: 'Request', id: string, createdAt?: string | null, state?: string | null, procedureId?: string | null, procedureName?: string | null, assignee?: string | null, worker?: { __typename?: 'Worker', id: string } | null } | null } | { __typename?: 'MissingIntegrationCredentialQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null, failedAnswerId?: string | null, failedAnswerReason?: string | null, summary?: string | null, request?: { __typename?: 'Request', id: string, createdAt?: string | null, state?: string | null, procedureId?: string | null, procedureName?: string | null, assignee?: string | null, worker?: { __typename?: 'Worker', id: string } | null } | null } | { __typename?: 'NativeCodeErrorQuestion', errorType?: string | null, errorMessage?: string | null, errorTraceback?: string | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null, failedAnswerId?: string | null, failedAnswerReason?: string | null, summary?: string | null, request?: { __typename?: 'Request', id: string, createdAt?: string | null, state?: string | null, procedureId?: string | null, procedureName?: string | null, assignee?: string | null, worker?: { __typename?: 'Worker', id: string } | null } | null } | { __typename?: 'OAuth2MissingQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null, failedAnswerId?: string | null, failedAnswerReason?: string | null, summary?: string | null, request?: { __typename?: 'Request', id: string, createdAt?: string | null, state?: string | null, procedureId?: string | null, procedureName?: string | null, assignee?: string | null, worker?: { __typename?: 'Worker', id: string } | null } | null } | { __typename?: 'ParseErrorQuestion', errorTraceback?: string | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null, failedAnswerId?: string | null, failedAnswerReason?: string | null, summary?: string | null, request?: { __typename?: 'Request', id: string, createdAt?: string | null, state?: string | null, procedureId?: string | null, procedureName?: string | null, assignee?: string | null, worker?: { __typename?: 'Worker', id: string } | null } | null } | { __typename?: 'ProcedureNotKnownQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null, failedAnswerId?: string | null, failedAnswerReason?: string | null, summary?: string | null, request?: { __typename?: 'Request', id: string, createdAt?: string | null, state?: string | null, procedureId?: string | null, procedureName?: string | null, assignee?: string | null, worker?: { __typename?: 'Worker', id: string } | null } | null } | { __typename?: 'ReviewConceptQuestion', lexicalPath?: Array<string> | null, conceptId?: string | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null, failedAnswerId?: string | null, failedAnswerReason?: string | null, summary?: string | null, request?: { __typename?: 'Request', id: string, createdAt?: string | null, state?: string | null, procedureId?: string | null, procedureName?: string | null, assignee?: string | null, worker?: { __typename?: 'Worker', id: string } | null } | null } | { __typename?: 'ValueNotKnownQuestion', lexicalPath?: Array<string> | null, choices?: Array<string> | null, helpText?: string | null, isPlural?: boolean | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null, failedAnswerId?: string | null, failedAnswerReason?: string | null, summary?: string | null, request?: { __typename?: 'Request', id: string, createdAt?: string | null, state?: string | null, procedureId?: string | null, procedureName?: string | null, assignee?: string | null, worker?: { __typename?: 'Worker', id: string } | null } | null }>, valueCounts?: { __typename?: 'RequestQuestionValueCounts', states?: Array<{ __typename?: 'UniqueCount', value?: string | null, count?: number | null }> | null, procedures?: Array<{ __typename?: 'UniqueCount', value?: string | null, count?: number | null }> | null } | null } | null };

export type GetExceptionsStatusCountsQueryVariables = Exact<{
  input: ListQuestionsByDepartmentInput;
}>;


export type GetExceptionsStatusCountsQuery = { __typename?: 'Query', listQuestionsByDepartment?: { __typename?: 'RequestQuestionConnection', valueCounts?: { __typename?: 'RequestQuestionValueCounts', states?: Array<{ __typename?: 'UniqueCount', value?: string | null, count?: number | null }> | null } | null } | null };

export type GetExceptionRequestQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetExceptionRequestQuery = { __typename?: 'Query', getRequest?: { __typename?: 'Request', id: string, stepPath?: Array<string> | null, contextId?: number | null, sentenceId?: number | null, createdAt?: string | null, handledAt?: string | null, state?: string | null, procedureId?: string | null, uiConcepts?: string | null, worker?: { __typename?: 'Worker', id: string, owner?: string | null, readers?: Array<string | null> | null, editors?: Array<string | null> | null, name?: string | null, description?: string | null, version?: string | null, departmentVersion?: string | null, knowledgeId?: string | null, departmentId?: string | null, procedureId?: string | null, entryCommand?: string | null, entryCommandId?: string | null, originalWorkerId?: string | null, createdAt?: string | null, state?: string | null, stateLastUpdatedAt?: string | null, attachments?: Array<string> | null, isArchived?: boolean | null, features?: Array<string> | null } | null, questions?: Array<{ __typename?: 'DomainNotIntegratedQuestion', id: string, text?: string | null, summary?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'EnsureFailedQuestion', id: string, text?: string | null, summary?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'MissingIntegrationCredentialQuestion', id: string, text?: string | null, summary?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'NativeCodeErrorQuestion', errorType?: string | null, errorMessage?: string | null, errorTraceback?: string | null, id: string, text?: string | null, summary?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'OAuth2MissingQuestion', id: string, text?: string | null, summary?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'ParseErrorQuestion', id: string, text?: string | null, summary?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'ProcedureNotKnownQuestion', id: string, text?: string | null, summary?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'ReviewConceptQuestion', lexicalPath?: Array<string> | null, conceptId?: string | null, id: string, text?: string | null, summary?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'ValueNotKnownQuestion', lexicalPath?: Array<string> | null, choices?: Array<string> | null, helpText?: string | null, isPlural?: boolean | null, id: string, text?: string | null, summary?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null }> | null, answers?: Array<{ __typename?: 'RequestAnswer', id: string, requestId: string, questionId?: string | null }> | null, suggestedAnswers?: Array<{ __typename?: 'RequestAnswerSuggestion', id: string, requestId: string, questionId?: string | null, action?: { __typename?: 'ApproveReviewAction' } | { __typename?: 'ReplaceStepAction', _?: string | null, newSteps?: Array<string> | null } | { __typename?: 'RetryStepAction' } | { __typename?: 'SkipStepAction' } | { __typename?: 'SkipToEndOfRunAction' } | { __typename?: 'UseConceptAction' } | { __typename?: 'UseLiteralValueAction' } | { __typename?: 'UseNoValueAction' } | { __typename?: 'UseOauth2Action' } | { __typename?: 'UseTechniqueAction' } | null }> | null, contextPath?: Array<{ __typename?: 'InstructionLocationById', ctxId: number, sentenceId?: number | null }> | null } | null };

export type GetDocumentBlocksQueryVariables = Exact<{
  knowledgeId: Scalars['ID']['input'];
  documentFactId: Scalars['ID']['input'];
  boundingBoxes?: InputMaybe<GetDocumentBlocksInput>;
}>;


export type GetDocumentBlocksQuery = { __typename?: 'Query', getDocumentBlocks?: Array<{ __typename?: 'BlocksResponse', rawText?: string | null, blocksByPage: Array<{ __typename?: 'BlocksByPage', pageNum: number }> }> | null };

export type GetHistoricalFactsQueryVariables = Exact<{
  knowledgeId: Scalars['ID']['input'];
  factIds: Array<HistoricalFactId> | HistoricalFactId;
}>;


export type GetHistoricalFactsQuery = { __typename?: 'Query', getHistoricalFacts: Array<{ __typename?: 'Fact', id: string, names?: Array<string | null> | null, locations?: Array<{ [key: string]: any }> | null, dereferencedId?: string | null, type?: string | null, value?: string | null, referenceTo?: Array<string | null> | null, isDeleted?: boolean | null, parentFactId?: string | null, relations?: Array<{ __typename?: 'Relation', factId?: string | null, name?: string | null, direction?: string | null } | null> | null, descriptions?: Array<{ __typename?: 'Description', name?: string | null, factId?: string | null } | null> | null, parentFact?: { __typename?: 'Fact', id: string, knowledgeId?: string | null, names?: Array<string | null> | null, parentFactId?: string | null, locations?: Array<{ [key: string]: any }> | null, value?: string | null, owner?: string | null, readers?: Array<string | null> | null, editors?: Array<string | null> | null, referenceTo?: Array<string | null> | null, viewUrl?: string | null, childProperties?: string | null, isDeleted?: boolean | null } | null } | null> };

export type GetFactValueQueryVariables = Exact<{
  knowledgeId: Scalars['ID']['input'];
  factId: Scalars['ID']['input'];
  epoch: Scalars['Int']['input'];
}>;


export type GetFactValueQuery = { __typename?: 'Query', getFact?: { __typename?: 'Fact', id: string, knowledgeId?: string | null, value?: string | null } | null };

export type GetFactsAtStepPathQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
  stepPath: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetFactsAtStepPathQuery = { __typename?: 'Query', getFactsAtStepPath: { __typename?: 'StepPathFactTable', columns?: Array<string> | null, data?: string | null } };

export type GetFactQueryVariables = Exact<{
  knowledgeId: Scalars['ID']['input'];
  factId: Scalars['ID']['input'];
  epoch: Scalars['Int']['input'];
}>;


export type GetFactQuery = { __typename?: 'Query', getFact?: { __typename?: 'Fact', id: string, knowledgeId?: string | null, names?: Array<string | null> | null, parentFactId?: string | null, locations?: Array<{ [key: string]: any }> | null, value?: string | null, owner?: string | null, readers?: Array<string | null> | null, editors?: Array<string | null> | null, referenceTo?: Array<string | null> | null, dereferencedId?: string | null, type?: string | null, viewUrl?: string | null, childProperties?: string | null, isDeleted?: boolean | null, knowledge?: { __typename?: 'Knowledge', id: string, owner?: string | null, readers?: Array<string | null> | null, editors?: Array<string | null> | null, name?: string | null, description?: string | null, departmentId: string, workerId?: string | null, parentKnowledgeId?: string | null, state?: string | null, brainVersion?: string | null } | null, parentFact?: { __typename?: 'Fact', id: string, knowledgeId?: string | null, names?: Array<string | null> | null, parentFactId?: string | null, locations?: Array<{ [key: string]: any }> | null, value?: string | null, owner?: string | null, readers?: Array<string | null> | null, editors?: Array<string | null> | null, referenceTo?: Array<string | null> | null, dereferencedId?: string | null, type?: string | null, viewUrl?: string | null, childProperties?: string | null, isDeleted?: boolean | null } | null, relations?: Array<{ __typename?: 'Relation', factId?: string | null, name?: string | null, direction?: string | null } | null> | null, descriptions?: Array<{ __typename?: 'Description', name?: string | null, factId?: string | null } | null> | null } | null };

export type GetFactsQueryVariables = Exact<{
  knowledgeId: Scalars['ID']['input'];
  factIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetFactsQuery = { __typename?: 'Query', getFacts: Array<{ __typename?: 'Fact', id: string, dereferencedId?: string | null, value?: string | null, names?: Array<string | null> | null } | null> };

export type ListKChatMessagesByWorkerQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListKChatMessagesByWorkerQuery = { __typename?: 'Query', listKChatMessagesByWorker?: { __typename?: 'ChatMessageConnection', nextToken?: string | null, items: Array<{ __typename?: 'ChatMessage', id: string, departmentId: string, workerId: string, message: string, timestamp: string, displayName?: string | null, role?: string | null }> } | null };

export type ListDepartmentLearnedAnswersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListDepartmentLearnedAnswersQuery = { __typename?: 'Query', getDepartment?: { __typename?: 'Department', learnedAnswers?: { __typename?: 'LearnedAnswerConnection', nextToken?: string | null, items: Array<{ __typename?: 'LearnedAnswer', id: string, createdAt?: string | null, createdBy?: string | null, deletedAt?: string | null, deletedBy?: string | null, procedureId?: string | null, procedureName?: string | null, stage?: Array<LearningStage> | null, contextValue?: Array<string> | null, contextMetadata?: Array<string> | null, questionFilter?: { __typename?: 'RequestQuestionFilter', stepPath?: Array<string | null> | null, questionType?: string | null, lexicalPath?: Array<string | null> | null } | null, action?: { __typename?: 'ApproveReviewAction', _?: string | null } | { __typename?: 'ReplaceStepAction', _?: string | null } | { __typename?: 'RetryStepAction', minimumDelay: number, timeout?: number | null, _?: string | null } | { __typename?: 'SkipStepAction', _?: string | null } | { __typename?: 'SkipToEndOfRunAction', _?: string | null } | { __typename?: 'UseConceptAction', conceptId?: string | null, _?: string | null } | { __typename?: 'UseLiteralValueAction', literalValue?: string | null, choices?: Array<string> | null, _?: string | null } | { __typename?: 'UseNoValueAction', _?: string | null } | { __typename?: 'UseOauth2Action', _?: string | null } | { __typename?: 'UseTechniqueAction', technique?: string | null, _?: string | null } | null, procedure?: { __typename?: 'Procedure', id: string, name?: string | null, knowledgeId?: string | null, stage?: ProcedureStage | null } | null, contextualLearningInfos?: { __typename?: 'ContextualLearningInfoConnection', items: Array<{ __typename?: 'ContextualLearningInfo', id: string, isDeleted?: boolean | null, requestId: string, contextFactsInfo?: Array<{ __typename?: 'Fact', id: string, names?: Array<string | null> | null, locations?: Array<{ [key: string]: any }> | null, dereferencedId?: string | null, type?: string | null, value?: string | null } | null> | null }> } | null }> } | null } | null };

export type ListLearnedAnswersByProcedureQueryVariables = Exact<{
  procedureId: Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<LearningsFilters>;
}>;


export type ListLearnedAnswersByProcedureQuery = { __typename?: 'Query', listLearnedAnswersByProcedure?: { __typename?: 'LearnedAnswerConnection', nextToken?: string | null, items: Array<{ __typename?: 'LearnedAnswer', id: string, stage?: Array<LearningStage> | null, createdAt?: string | null, createdBy?: string | null, deletedAt?: string | null, deletedBy?: string | null, updatedAt?: string | null, contextValue?: Array<string> | null, contextMetadata?: Array<string> | null, questionFilter?: { __typename?: 'RequestQuestionFilter', stepPath?: Array<string | null> | null, questionType?: string | null, lexicalPath?: Array<string | null> | null } | null, action?: { __typename?: 'ApproveReviewAction' } | { __typename?: 'ReplaceStepAction' } | { __typename?: 'RetryStepAction', minimumDelay: number, timeout?: number | null } | { __typename?: 'SkipStepAction' } | { __typename?: 'SkipToEndOfRunAction' } | { __typename?: 'UseConceptAction', conceptId?: string | null } | { __typename?: 'UseLiteralValueAction', literalValue?: string | null, choices?: Array<string> | null } | { __typename?: 'UseNoValueAction' } | { __typename?: 'UseOauth2Action' } | { __typename?: 'UseTechniqueAction', technique?: string | null } | null, procedure?: { __typename?: 'Procedure', id: string, name?: string | null, stage?: ProcedureStage | null } | null, contextualLearningInfos?: { __typename?: 'ContextualLearningInfoConnection', items: Array<{ __typename?: 'ContextualLearningInfo', id: string, isDeleted?: boolean | null, requestId: string, contextFactsInfo?: Array<{ __typename?: 'Fact', id: string, names?: Array<string | null> | null, locations?: Array<{ [key: string]: any }> | null, dereferencedId?: string | null, type?: string | null, value?: string | null } | null> | null }> } | null }> } | null };

export type GetLearnedAnswerSuggestionsQueryVariables = Exact<{
  input: LearnedAnswerSuggestionsInput;
}>;


export type GetLearnedAnswerSuggestionsQuery = { __typename?: 'Query', getLearnedAnswerSuggestions: { __typename?: 'LearnedAnswerConnection', nextToken?: string | null, items: Array<{ __typename?: 'LearnedAnswer', id: string, createdAt?: string | null, createdBy?: string | null, deletedAt?: string | null, deletedBy?: string | null, procedureId?: string | null, procedureName?: string | null, contextValue?: Array<string> | null, contextMetadata?: Array<string> | null, questionFilter?: { __typename?: 'RequestQuestionFilter', stepPath?: Array<string | null> | null, questionType?: string | null, lexicalPath?: Array<string | null> | null } | null, action?: { __typename?: 'ApproveReviewAction', _?: string | null } | { __typename?: 'ReplaceStepAction', _?: string | null } | { __typename?: 'RetryStepAction', minimumDelay: number, timeout?: number | null, _?: string | null } | { __typename?: 'SkipStepAction', _?: string | null } | { __typename?: 'SkipToEndOfRunAction', _?: string | null } | { __typename?: 'UseConceptAction', conceptId?: string | null, _?: string | null } | { __typename?: 'UseLiteralValueAction', literalValue?: string | null, choices?: Array<string> | null, _?: string | null } | { __typename?: 'UseNoValueAction', _?: string | null } | { __typename?: 'UseOauth2Action', _?: string | null } | { __typename?: 'UseTechniqueAction', technique?: string | null, _?: string | null } | null }> } };

export type GetContextualLearningInfoByRequestQueryVariables = Exact<{
  requestId: Scalars['ID']['input'];
}>;


export type GetContextualLearningInfoByRequestQuery = { __typename?: 'Query', getContextualLearningInfoByRequest?: { __typename?: 'ContextualLearningInfoConnection', items: Array<{ __typename?: 'ContextualLearningInfo', id: string, createdAt?: string | null, createdBy?: string | null, procedureId?: string | null, learningId?: string | null, requestId: string, procedureName?: string | null, contextMetadata?: string | null }> } | null };

export type GetLearnedAnswerByRequestAnswerIdQueryVariables = Exact<{
  requestAnswerId: Scalars['ID']['input'];
}>;


export type GetLearnedAnswerByRequestAnswerIdQuery = { __typename?: 'Query', getLearnedAnswerByRequestAnswerId?: { __typename?: 'LearnedAnswer', id: string, originalAnswerId?: string | null, createdAt?: string | null, createdBy?: string | null, deletedAt?: string | null, deletedBy?: string | null, procedureId?: string | null, procedureName?: string | null, contextValue?: Array<string> | null, contextMetadata?: Array<string> | null, questionFilter?: { __typename?: 'RequestQuestionFilter', stepPath?: Array<string | null> | null, questionType?: string | null, lexicalPath?: Array<string | null> | null } | null, action?: { __typename?: 'ApproveReviewAction', _?: string | null } | { __typename?: 'ReplaceStepAction', newSteps?: Array<string> | null, _?: string | null } | { __typename?: 'RetryStepAction', minimumDelay: number, timeout?: number | null, _?: string | null } | { __typename?: 'SkipStepAction', _?: string | null } | { __typename?: 'SkipToEndOfRunAction', _?: string | null } | { __typename?: 'UseConceptAction', conceptId?: string | null, _?: string | null } | { __typename?: 'UseLiteralValueAction', literalValue?: string | null, choices?: Array<string> | null, _?: string | null } | { __typename?: 'UseNoValueAction', _?: string | null } | { __typename?: 'UseOauth2Action', accessToken?: string | null, refreshToken?: string | null, _?: string | null } | { __typename?: 'UseTechniqueAction', technique?: string | null, _?: string | null } | null, procedure?: { __typename?: 'Procedure', id: string, knowledgeId?: string | null, departmentId?: string | null, text?: string | null, name?: string | null, owner?: string | null, language?: string | null, public: boolean, bookReference?: string | null, title?: string | null, version?: string | null } | null } | null };

export type GetLearnedAnswersSummaryByProcedureIdsQueryVariables = Exact<{
  departmentId: Scalars['ID']['input'];
  procedureIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  sinceTimestamp?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLearnedAnswersSummaryByProcedureIdsQuery = { __typename?: 'Query', getLearnedAnswersSummaryByProcedureIds?: { __typename?: 'LearnedAnswersSummaryResponse', items: Array<{ __typename?: 'LearnedAnswersSummary', procedureId: string, draftLearningsCreatedCount: number, publishedLearningsCreatedCount: number, draftLearningsUpdatedCount: number, publishedLearningsUpdatedCount: number }> } | null };

export type GetLearnedAnswerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLearnedAnswerQuery = { __typename?: 'Query', getLearnedAnswer?: { __typename?: 'LearnedAnswer', id: string, createdAt?: string | null, createdBy?: string | null, deletedAt?: string | null, deletedBy?: string | null, stage?: Array<LearningStage> | null, contextValue?: Array<string> | null, contextMetadata?: Array<string> | null, questionFilter?: { __typename?: 'RequestQuestionFilter', stepPath?: Array<string | null> | null, questionType?: string | null, lexicalPath?: Array<string | null> | null } | null, action?: { __typename?: 'ApproveReviewAction', _?: string | null } | { __typename?: 'ReplaceStepAction', _?: string | null } | { __typename?: 'RetryStepAction', minimumDelay: number, timeout?: number | null, _?: string | null } | { __typename?: 'SkipStepAction', _?: string | null } | { __typename?: 'SkipToEndOfRunAction', _?: string | null } | { __typename?: 'UseConceptAction', conceptId?: string | null, _?: string | null } | { __typename?: 'UseLiteralValueAction', literalValue?: string | null, choices?: Array<string> | null, _?: string | null } | { __typename?: 'UseNoValueAction', _?: string | null } | { __typename?: 'UseOauth2Action', _?: string | null } | { __typename?: 'UseTechniqueAction', technique?: string | null, _?: string | null } | null, procedure?: { __typename?: 'Procedure', id: string, name?: string | null, knowledgeId?: string | null } | null } | null };

export type GetUploadToS3UrlQueryVariables = Exact<{
  scope: S3FileScope;
  scopeId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
  fields?: InputMaybe<Scalars['AWSJSON']['input']>;
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUploadToS3UrlQuery = { __typename?: 'Query', getUploadToS3Url: { __typename?: 'S3PresignedPost', url: string, s3Url: string, fields: { [key: string]: any } } };

export type GetDownloadFromS3UrlQueryVariables = Exact<{
  objectKey: Scalars['String']['input'];
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  objectType?: InputMaybe<S3ObjectType>;
  onlyIfExists?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDownloadFromS3UrlQuery = { __typename?: 'Query', getDownloadFromS3Url?: { __typename?: 'S3PresignedUrl', url: string, s3Url: string } | null };

export type AppSecretsQueryVariables = Exact<{ [key: string]: never; }>;


export type AppSecretsQuery = { __typename?: 'Query', appSecrets: { __typename?: 'AppSecrets', googleMapApiKey: string } };

export type GetOwnerOrganizationQueryVariables = Exact<{
  owner?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOwnerOrganizationQuery = { __typename?: 'Query', getOwnerOrganization?: { __typename?: 'Organization', id: string, name: string, owner: string, createdAt: string, updatedAt: string, billingStatus?: OrganizationBillingStatus | null } | null };

export type GetWorkerDocumentQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
  documentToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkerDocumentQuery = { __typename?: 'Query', getWorkerDocument: Array<{ __typename?: 'Sentence', lineId: string, text: string, parentId?: string | null, shouldPause?: boolean | null, language?: string | null, metadata?: { __typename?: 'SentenceMetadata', lineId?: string | null, parentId?: string | null } | null, internalMetadata?: Array<{ __typename?: 'DictionaryItem', key: string, value: string }> | null }> };

export type GetSentenceExecutionDataQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  documentToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSentenceExecutionDataQuery = { __typename?: 'Query', getSentenceExecutionData: Array<{ __typename?: 'SentenceExecutionData', lineId: string, token?: string | null, status?: ExecutionStatus | null, answer?: string | null, concepts?: string | null, requests?: Array<string> | null, iterationTokens: Array<string>, epoch?: number | null, startedAt?: string | null, completedAt?: string | null, subDocuments?: Array<{ __typename?: 'SubDocumentInfo', documentToken: string, processName: string }> | null, miniPlaygrounds?: Array<{ __typename?: 'SubDocumentInfo', documentToken: string, processName: string }> | null }> };

export type GetDepartmentForWorkerQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
}>;


export type GetDepartmentForWorkerQuery = { __typename?: 'Query', getDepartmentForWorker?: { __typename?: 'Department', id: string } | null };

export type GetWorkerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWorkerQuery = { __typename?: 'Query', getWorker?: { __typename?: 'Worker', id: string, owner?: string | null, readers?: Array<string | null> | null, editors?: Array<string | null> | null, name?: string | null, description?: string | null, version?: string | null, departmentVersion?: string | null, knowledgeId?: string | null, departmentId?: string | null, procedureId?: string | null, entryCommand?: string | null, entryCommandId?: string | null, originalWorkerId?: string | null, createdAt?: string | null, state?: string | null, stage?: ProcedureStage | null, stateLastUpdatedAt?: string | null, attachments?: Array<string> | null, isArchived?: boolean | null, features?: Array<string> | null, replayWorkerId?: string | null, forkExecutionInfo?: { __typename?: 'WorkerForkExecutionConnection', items: Array<{ __typename?: 'WorkerForkExecution', answer?: string | null, createdBy?: string | null, documentToken?: string | null, internalState: string, internalStateLastUpdatedAt: string, internalStateMessage: string, lineId?: string | null, lineToken?: string | null, version?: number | null, workItemId: string, workerId: string, metadata?: { __typename?: 'WorkerForkExecutionMetadata', learningId?: string | null, questionId?: string | null, requestId?: string | null } | null }> } | null } | null };

export type GetWorkerDependenciesQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
}>;


export type GetWorkerDependenciesQuery = { __typename?: 'Query', getWorker?: { __typename?: 'Worker', requests?: { __typename?: 'RequestConnection', limit?: number | null, nextToken?: string | null, items: Array<{ __typename?: 'Request', id: string, stepPath?: Array<string> | null, contextId?: number | null, sentenceId?: number | null, createdAt?: string | null, handledAt?: string | null, state?: string | null, uiConcepts?: string | null, worker?: { __typename?: 'Worker', id: string } | null, questions?: Array<{ __typename?: 'DomainNotIntegratedQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'EnsureFailedQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'MissingIntegrationCredentialQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'NativeCodeErrorQuestion', errorType?: string | null, errorMessage?: string | null, errorTraceback?: string | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'OAuth2MissingQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'ParseErrorQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'ProcedureNotKnownQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'ReviewConceptQuestion', lexicalPath?: Array<string> | null, conceptId?: string | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'ValueNotKnownQuestion', lexicalPath?: Array<string> | null, choices?: Array<string> | null, helpText?: string | null, isPlural?: boolean | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null }> | null, answers?: Array<{ __typename?: 'RequestAnswer', id: string, requestId: string, questionId?: string | null }> | null, suggestedAnswers?: Array<{ __typename?: 'RequestAnswerSuggestion', id: string, requestId: string, questionId?: string | null, action?: { __typename?: 'ApproveReviewAction' } | { __typename?: 'ReplaceStepAction', _?: string | null, newSteps?: Array<string> | null } | { __typename?: 'RetryStepAction' } | { __typename?: 'SkipStepAction' } | { __typename?: 'SkipToEndOfRunAction' } | { __typename?: 'UseConceptAction' } | { __typename?: 'UseLiteralValueAction' } | { __typename?: 'UseNoValueAction' } | { __typename?: 'UseOauth2Action' } | { __typename?: 'UseTechniqueAction' } | null }> | null, contextPath?: Array<{ __typename?: 'InstructionLocationById', ctxId: number, sentenceId?: number | null }> | null }> } | null } | null };

export type ListWorkersByDepartmentQueryVariables = Exact<{
  departmentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListWorkersByDepartmentQuery = { __typename?: 'Query', listWorkersByDepartment?: { __typename?: 'WorkerConnection', nextToken?: string | null, items?: Array<{ __typename?: 'Worker', id: string, owner?: string | null, name?: string | null, createdAt?: string | null, isArchived?: boolean | null, features?: Array<string> | null } | null> | null } | null };

export type GetStepPathForRunQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
  contextId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
}>;


export type GetStepPathForRunQuery = { __typename?: 'Query', getStepPathForRun: Array<string> };

export type ParseAlangTextQueryVariables = Exact<{
  statement: Scalars['String']['input'];
  scopeCode: Scalars['String']['input'];
  language: Scalars['String']['input'];
  departmentId: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
}>;


export type ParseAlangTextQuery = { __typename?: 'Query', parseAlangText?: { __typename?: 'AlangParser', ast?: string | null, text?: string | null, error?: string | null } | null };

export type GetProcedureQueryVariables = Exact<{
  procedureId: Scalars['ID']['input'];
  knowledgeId?: InputMaybe<Scalars['ID']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  procedureStage?: InputMaybe<ProcedureStage>;
}>;


export type GetProcedureQuery = { __typename?: 'Query', getProcedure?: { __typename?: 'Procedure', id: string, knowledgeId?: string | null, departmentId?: string | null, text?: string | null, name?: string | null, owner?: string | null, language?: string | null, bookReference?: string | null, stage?: ProcedureStage | null, title?: string | null, version?: string | null, schedules: Array<{ __typename?: 'Schedule', name?: string | null, expression?: string | null, enabled?: boolean | null } | null>, email?: Array<{ __typename?: 'StageEmail', stage: string, email: string }> | null, assignmentPolicy?: { __typename?: 'AssignmentPolicy', policyType: AssignmentPolicyType, collaborator?: string | null } | null } | null };

export type ListProceduresByDepartmentQueryVariables = Exact<{
  departmentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  procedureFilter?: InputMaybe<ListProceduresFilter>;
}>;


export type ListProceduresByDepartmentQuery = { __typename?: 'Query', listProceduresByDepartment?: { __typename?: 'ModelProcedureConnection', nextToken?: string | null, items?: Array<{ __typename?: 'Procedure', id: string, knowledgeId?: string | null, departmentId?: string | null, name?: string | null, owner?: string | null, language?: string | null, public: boolean, bookReference?: string | null, title?: string | null, version?: string | null, stage?: ProcedureStage | null, latestRunData?: { __typename?: 'RunData', id?: string | null, triggeredAt?: string | null, status?: string | null } | null } | null> | null } | null };

export type ListBasicWorkersByProcedureQueryVariables = Exact<{
  procedureId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  stateFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListBasicWorkersByProcedureQuery = { __typename?: 'Query', listWorkersByProcedure?: { __typename?: 'WorkerConnection', nextToken?: string | null, items?: Array<{ __typename?: 'Worker', id: string, name?: string | null, createdAt?: string | null, originalWorkerId?: string | null, state?: string | null, stage?: ProcedureStage | null } | null> | null } | null };

export type ListWorkersByProcedureQueryVariables = Exact<{
  procedureId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  stateFilter?: InputMaybe<Scalars['String']['input']>;
  fromCreationDate?: InputMaybe<Scalars['String']['input']>;
  toCreationDate?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<ProcedureStage>;
  includeReplayWorker?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListWorkersByProcedureQuery = { __typename?: 'Query', listWorkersByProcedure?: { __typename?: 'WorkerConnection', nextToken?: string | null, items?: Array<{ __typename?: 'Worker', id: string, owner?: string | null, name?: string | null, state?: string | null, knowledgeId?: string | null, departmentId?: string | null, procedureId?: string | null, createdAt?: string | null, originalWorkerId?: string | null, stateLastUpdatedAt?: string | null, attachments?: Array<string> | null, replayWorkerId?: string | null } | null> | null } | null };

export type ListWorkerOutputsByProcedureQueryVariables = Exact<{
  procedureId: Scalars['ID']['input'];
  knowledgeId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  decodeConcepts?: InputMaybe<Scalars['Boolean']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  stateFilter?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<ProcedureStage>;
}>;


export type ListWorkerOutputsByProcedureQuery = { __typename?: 'Query', listWorkerOutputsByProcedure?: { __typename?: 'ProcedureOutputTable', columns?: Array<string> | null, data?: string | null, nextToken?: string | null } | null };

export type ListSharedEntityByProcedureQueryVariables = Exact<{
  departmentId: Scalars['ID']['input'];
  procedureId: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListSharedEntityByProcedureQuery = { __typename?: 'Query', listSharedEntityByProcedure?: { __typename?: 'SharedEntityConnection', nextToken?: string | null, items?: Array<{ __typename?: 'SharedEntity', id: string, entityId: string, departmentId: string, shareName: string, fullShareId?: string | null, departmentVersion?: string | null } | null> | null } | null };

export type ExportCodeForContextQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
  contextId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ExportCodeForContextQuery = { __typename?: 'Query', exportCodeForContext?: Array<string | null> | null };

export type ListProcedureGroupsByDepartmentQueryVariables = Exact<{
  departmentId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  procedureFilter?: InputMaybe<ListProceduresFilter>;
}>;


export type ListProcedureGroupsByDepartmentQuery = { __typename?: 'Query', listProcedureGroupsByDepartmentv2?: { __typename?: 'ProcedureGroupConnection', nextToken?: string | null, items?: Array<{ __typename?: 'ProcedureGroup', draftProcedure?: { __typename?: 'Procedure', id: string, departmentId?: string | null, name?: string | null, owner?: string | null, language?: string | null, title?: string | null, stage?: ProcedureStage | null, text?: string | null, departmentVersion?: string | null, version?: string | null, knowledgeId?: string | null, assignmentPolicy?: { __typename?: 'AssignmentPolicy', policyType: AssignmentPolicyType, collaborator?: string | null } | null, latestRunData?: { __typename?: 'RunData', id?: string | null, triggeredAt?: string | null, status?: string | null } | null } | null, publishedProcedure?: { __typename?: 'Procedure', id: string, departmentId?: string | null, name?: string | null, owner?: string | null, language?: string | null, title?: string | null, stage?: ProcedureStage | null, text?: string | null, departmentVersion?: string | null, version?: string | null, knowledgeId?: string | null, assignmentPolicy?: { __typename?: 'AssignmentPolicy', policyType: AssignmentPolicyType, collaborator?: string | null } | null, latestRunData?: { __typename?: 'RunData', id?: string | null, triggeredAt?: string | null, status?: string | null } | null } | null }> | null } | null };

export type ListProcedureGroupsSummaryByDepartmentQueryVariables = Exact<{
  departmentId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  procedureFilter?: InputMaybe<ListProceduresFilter>;
}>;


export type ListProcedureGroupsSummaryByDepartmentQuery = { __typename?: 'Query', proceduresSummary: { __typename?: 'ProcedureGroupConnection', nextToken?: string | null, items?: Array<{ __typename?: 'ProcedureGroup', draftProcedure?: { __typename?: 'Procedure', id: string, departmentId?: string | null, name?: string | null, stage?: ProcedureStage | null, departmentVersion?: string | null, version?: string | null } | null, publishedProcedure?: { __typename?: 'Procedure', id: string, departmentId?: string | null, name?: string | null, stage?: ProcedureStage | null, departmentVersion?: string | null, version?: string | null } | null }> | null } };

export type GetProcedureVisualizationUrlQueryVariables = Exact<{
  procedureId: Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
  onlyIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  procedureStage?: InputMaybe<ProcedureStage>;
}>;


export type GetProcedureVisualizationUrlQuery = { __typename?: 'Query', getProcedureVisualizationUrl?: { __typename?: 'VisualizationAccessUrl', s3Url: string, presignedUrl: string } | null };

export type ProcedureGroupQueryVariables = Exact<{
  procedureId: Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
}>;


export type ProcedureGroupQuery = { __typename?: 'Query', procedureGroup?: { __typename?: 'ProcedureGroup', draftProcedure?: { __typename?: 'Procedure', id: string, departmentId?: string | null, name?: string | null, owner?: string | null, language?: string | null, title?: string | null, stage?: ProcedureStage | null, text?: string | null, departmentVersion?: string | null, version?: string | null, knowledgeId?: string | null, assignmentPolicy?: { __typename?: 'AssignmentPolicy', policyType: AssignmentPolicyType, collaborator?: string | null } | null, latestRunData?: { __typename?: 'RunData', id?: string | null, triggeredAt?: string | null, status?: string | null } | null } | null, publishedProcedure?: { __typename?: 'Procedure', id: string, departmentId?: string | null, name?: string | null, owner?: string | null, language?: string | null, title?: string | null, stage?: ProcedureStage | null, text?: string | null, departmentVersion?: string | null, version?: string | null, knowledgeId?: string | null, schedules: Array<{ __typename?: 'Schedule', name?: string | null, expression?: string | null, enabled?: boolean | null } | null>, assignmentPolicy?: { __typename?: 'AssignmentPolicy', policyType: AssignmentPolicyType, collaborator?: string | null } | null, latestRunData?: { __typename?: 'RunData', id?: string | null, triggeredAt?: string | null, status?: string | null } | null } | null } | null };

export type ProceduresMetricQueryVariables = Exact<{
  procedureIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
}>;


export type ProceduresMetricQuery = { __typename?: 'Query', proceduresMetric: { __typename?: 'ProcedureMetric', runMetric?: Array<{ __typename?: 'RunMetricResult', procedureID: string, metric?: { __typename?: 'RunMetric', totalRuns?: { __typename?: 'MetricData', values?: Array<{ __typename?: 'DayAggregatedValue', date: string, count: number }> | null } | null, runsWithException?: { __typename?: 'MetricData', values?: Array<{ __typename?: 'DayAggregatedValue', date: string, count: number }> | null, trendData?: { __typename?: 'TrendData', percentageChange?: number | null } | null } | null, completedRuns?: { __typename?: 'MetricData', values?: Array<{ __typename?: 'DayAggregatedValue', date: string, count: number }> | null, trendData?: { __typename?: 'TrendData', percentageChange?: number | null } | null } | null } | null } | null> | null } };

export type GetUnhandledRequestMetricQueryVariables = Exact<{
  procedureIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
  endDate: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
}>;


export type GetUnhandledRequestMetricQuery = { __typename?: 'Query', proceduresMetric: { __typename?: 'ProcedureMetric', requestMetric?: Array<{ __typename?: 'RequestMetricResult', procedureID: string, metric?: { __typename?: 'RequestMetric', unhandledRequest?: { __typename?: 'MetricData', values?: Array<{ __typename?: 'DayAggregatedValue', date: string, count: number }> | null, trendData?: { __typename?: 'TrendData', percentageChange?: number | null } | null } | null } | null } | null> | null } };

export type ListRequestsByProcedureQueryVariables = Exact<{
  procedureId: Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<RequestState>;
  procedureStage?: InputMaybe<ProcedureStage>;
}>;


export type ListRequestsByProcedureQuery = { __typename?: 'Query', listRequestsByProcedure?: { __typename?: 'RequestConnection', limit?: number | null, nextToken?: string | null, items: Array<{ __typename?: 'Request', id: string, stepPath?: Array<string> | null, contextId?: number | null, sentenceId?: number | null, createdAt?: string | null, handledAt?: string | null, state?: string | null, uiConcepts?: string | null, worker?: { __typename?: 'Worker', id: string, knowledgeId?: string | null } | null, questions?: Array<{ __typename?: 'DomainNotIntegratedQuestion', domain?: string | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'EnsureFailedQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'MissingIntegrationCredentialQuestion', domain?: string | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'NativeCodeErrorQuestion', errorType?: string | null, errorMessage?: string | null, errorTraceback?: string | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'OAuth2MissingQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'ParseErrorQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'ProcedureNotKnownQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'ReviewConceptQuestion', lexicalPath?: Array<string> | null, conceptId?: string | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'ValueNotKnownQuestion', lexicalPath?: Array<string> | null, choices?: Array<string> | null, helpText?: string | null, isPlural?: boolean | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null }> | null, answers?: Array<{ __typename?: 'RequestAnswer', id: string, requestId: string, questionId?: string | null, createdAt?: string | null, createdBy?: string | null, action?: { __typename?: 'ApproveReviewAction', _?: string | null } | { __typename?: 'ReplaceStepAction', _?: string | null } | { __typename?: 'RetryStepAction', minimumDelay: number, timeout?: number | null, _?: string | null } | { __typename?: 'SkipStepAction', _?: string | null } | { __typename?: 'SkipToEndOfRunAction', _?: string | null } | { __typename?: 'UseConceptAction', conceptId?: string | null, _?: string | null } | { __typename?: 'UseLiteralValueAction', literalValue?: string | null, _?: string | null } | { __typename?: 'UseNoValueAction', _?: string | null } | { __typename?: 'UseOauth2Action', _?: string | null } | { __typename?: 'UseTechniqueAction', technique?: string | null, _?: string | null } | null }> | null, contextPath?: Array<{ __typename?: 'InstructionLocationById', ctxId: number, sentenceId?: number | null }> | null }> } | null };

export type GetRequestQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRequestQuery = { __typename?: 'Query', getRequest?: { __typename?: 'Request', id: string, stepPath?: Array<string> | null, contextId?: number | null, sentenceId?: number | null, createdAt?: string | null, handledAt?: string | null, state?: string | null, procedureId?: string | null, uiConcepts?: string | null, worker?: { __typename?: 'Worker', id: string, knowledgeId?: string | null } | null, questions?: Array<{ __typename?: 'DomainNotIntegratedQuestion', domain?: string | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'EnsureFailedQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'MissingIntegrationCredentialQuestion', domain?: string | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'NativeCodeErrorQuestion', errorType?: string | null, errorMessage?: string | null, errorTraceback?: string | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'OAuth2MissingQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'ParseErrorQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'ProcedureNotKnownQuestion', id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'ReviewConceptQuestion', lexicalPath?: Array<string> | null, conceptId?: string | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null } | { __typename?: 'ValueNotKnownQuestion', lexicalPath?: Array<string> | null, choices?: Array<string> | null, helpText?: string | null, isPlural?: boolean | null, id: string, text?: string | null, contextId?: number | null, sentenceId?: number | null, answerTypeHint?: string | null }> | null, answers?: Array<{ __typename?: 'RequestAnswer', id: string, requestId: string, questionId?: string | null, createdAt?: string | null, createdBy?: string | null, action?: { __typename?: 'ApproveReviewAction', _?: string | null } | { __typename?: 'ReplaceStepAction', _?: string | null } | { __typename?: 'RetryStepAction', minimumDelay: number, timeout?: number | null, _?: string | null } | { __typename?: 'SkipStepAction', _?: string | null } | { __typename?: 'SkipToEndOfRunAction', _?: string | null } | { __typename?: 'UseConceptAction', conceptId?: string | null, _?: string | null } | { __typename?: 'UseLiteralValueAction', literalValue?: string | null, _?: string | null } | { __typename?: 'UseNoValueAction', _?: string | null } | { __typename?: 'UseOauth2Action', _?: string | null } | { __typename?: 'UseTechniqueAction', technique?: string | null, _?: string | null } | null }> | null, contextPath?: Array<{ __typename?: 'InstructionLocationById', ctxId: number, sentenceId?: number | null }> | null } | null };

export type GetRequestAnswerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRequestAnswerQuery = { __typename?: 'Query', getRequestAnswer?: { __typename?: 'RequestAnswer', id: string, requestId: string, questionId?: string | null, createdAt?: string | null, createdBy?: string | null, summary?: string | null, action?: { __typename?: 'ApproveReviewAction', _?: string | null } | { __typename?: 'ReplaceStepAction', newSteps?: Array<string> | null, _?: string | null } | { __typename?: 'RetryStepAction', minimumDelay: number, timeout?: number | null, _?: string | null } | { __typename?: 'SkipStepAction', _?: string | null } | { __typename?: 'SkipToEndOfRunAction', _?: string | null } | { __typename?: 'UseConceptAction', conceptId?: string | null, _?: string | null } | { __typename?: 'UseLiteralValueAction', literalValue?: string | null, choices?: Array<string> | null, _?: string | null } | { __typename?: 'UseNoValueAction', _?: string | null } | { __typename?: 'UseOauth2Action', _?: string | null } | { __typename?: 'UseTechniqueAction', technique?: string | null, _?: string | null } | null, sourceLearning?: { __typename?: 'LearnedAnswer', id: string } | null, derivedLearning?: { __typename?: 'LearnedAnswer', id: string } | null } | null };

export type GetUserQueryVariables = Exact<{
  departmentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetUserQuery = { __typename?: 'Query', getUser?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, username: string, company?: string | null, role?: AccessControlRole | null, preferences?: { __typename?: 'UserPreferences', lastUsedDepartmentId?: string | null } | null } | null };

export type OnNotifyKChatMessageUpdateSubscriptionVariables = Exact<{
  workerId: Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
}>;


export type OnNotifyKChatMessageUpdateSubscription = { __typename?: 'Subscription', onNotifyKChatMessageUpdate?: { __typename?: 'ChatMessage', id: string, departmentId: string, workerId: string, message: string, timestamp: string, displayName?: string | null, role?: string | null } | null };

export type OnPingSubscriptionVariables = Exact<{
  channel: Scalars['String']['input'];
}>;


export type OnPingSubscription = { __typename?: 'Subscription', onPing?: { __typename?: 'Ping', channel: string, data?: string | null } | null };

export type OnWorkerSentenceUpdateSubscriptionVariables = Exact<{
  workerId: Scalars['ID']['input'];
  documentToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type OnWorkerSentenceUpdateSubscription = { __typename?: 'Subscription', onSentenceUpdate?: { __typename?: 'Sentences', sentences: Array<{ __typename?: 'SentenceExecutionData', answer?: string | null, concepts?: string | null, epoch?: number | null, iterationTokens: Array<string>, lineId: string, requests?: Array<string> | null, status?: ExecutionStatus | null, token?: string | null, startedAt?: string | null, completedAt?: string | null, subDocuments?: Array<{ __typename?: 'SubDocumentInfo', documentToken: string, processName: string }> | null, miniPlaygrounds?: Array<{ __typename?: 'SubDocumentInfo', documentToken: string, processName: string }> | null } | null> } | null };

export type OnMiniPgSentenceUpdateSubscriptionVariables = Exact<{
  workerId: Scalars['ID']['input'];
  documentToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type OnMiniPgSentenceUpdateSubscription = { __typename?: 'Subscription', onSentenceUpdate?: { __typename?: 'Sentences', sentences: Array<{ __typename?: 'SentenceExecutionData', lineId: string, token?: string | null, miniPlaygrounds?: Array<{ __typename?: 'SubDocumentInfo', documentToken: string, processName: string }> | null } | null> } | null };

export type OnWorkerUpdateSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OnWorkerUpdateSubscription = { __typename?: 'Subscription', onNotifyWorkerUpdate?: { __typename?: 'Worker', id: string, owner?: string | null, readers?: Array<string | null> | null, editors?: Array<string | null> | null, name?: string | null, description?: string | null, version?: string | null, departmentVersion?: string | null, knowledgeId?: string | null, departmentId?: string | null, procedureId?: string | null, entryCommand?: string | null, entryCommandId?: string | null, originalWorkerId?: string | null, createdAt?: string | null, state?: string | null, stage?: ProcedureStage | null, stateLastUpdatedAt?: string | null, attachments?: Array<string> | null, isArchived?: boolean | null, features?: Array<string> | null, replayWorkerId?: string | null, forkExecutionInfo?: { __typename?: 'WorkerForkExecutionConnection', items: Array<{ __typename?: 'WorkerForkExecution', answer?: string | null, createdBy?: string | null, documentToken?: string | null, internalState: string, internalStateLastUpdatedAt: string, internalStateMessage: string, lineId?: string | null, lineToken?: string | null, version?: number | null, workItemId: string, workerId: string, metadata?: { __typename?: 'WorkerForkExecutionMetadata', learningId?: string | null, questionId?: string | null, requestId?: string | null } | null }> } | null } | null };

export type OnWorkerStateUpdateSubscriptionVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  procedureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type OnWorkerStateUpdateSubscription = { __typename?: 'Subscription', onNotifyWorkerUpdate?: { __typename?: 'Worker', id: string, state?: string | null } | null };

export type OnWorkerDocumentUpdateSubscriptionVariables = Exact<{
  workerId: Scalars['ID']['input'];
}>;


export type OnWorkerDocumentUpdateSubscription = { __typename?: 'Subscription', onWorkerDocumentUpdate?: { __typename?: 'DocumentInfo', updatedAt?: string | null, sentences: Array<{ __typename?: 'Sentence', text: string, parentId?: string | null, language?: string | null, lineId: string, metadata?: { __typename?: 'SentenceMetadata', lineId?: string | null, parentId?: string | null } | null, internalMetadata?: Array<{ __typename?: 'DictionaryItem', key: string, value: string }> | null } | null> } | null };

export type OnWorkerStatusSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OnWorkerStatusSubscription = { __typename?: 'Subscription', onWorkerStatus?: { __typename?: 'WorkerStatus', id: string, mood: string, operation: string, icons: Array<string>, what: string } | null };

export type OnNotifyWorkerCreationSubscriptionVariables = Exact<{
  procedureId: Scalars['ID']['input'];
}>;


export type OnNotifyWorkerCreationSubscription = { __typename?: 'Subscription', onNotifyWorkerCreation?: { __typename?: 'Worker', id: string, name?: string | null, createdAt?: string | null, originalWorkerId?: string | null, state?: string | null, attachments?: Array<string> | null, owner?: string | null, departmentId?: string | null, procedureId?: string | null, stage?: ProcedureStage | null } | null };

export const WorkerDataPartsFragmentFragmentDoc = gql`
    fragment WorkerDataPartsFragment on WorkerData {
  id
  departmentId
  departmentName
  procedureId
  procedureName
  createdAt
  state
  brainVersion
  isArchived
  owner
}
    `;
export const InternalAdminDepartmentInfoFragmentFragmentDoc = gql`
    fragment InternalAdminDepartmentInfoFragment on InternalAdminDepartmentInfo {
  key
  id
  info
  notes
  notionDepartmentNotesUrl
  launchdarklyContextUrl
}
    `;
export const ContextualLearningInfoFragmentFragmentDoc = gql`
    fragment ContextualLearningInfoFragment on ContextualLearningInfo {
  id
  isDeleted
  requestId
  contextFactsInfo {
    id
    names
    locations
    dereferencedId
    type
    value
  }
}
    `;
export const ProcedureDataFragmentDoc = gql`
    fragment procedureData on Procedure {
  id
  departmentId
  name
  owner
  language
  title
  stage
  text
  departmentVersion
  version
  knowledgeId
  assignmentPolicy {
    policyType
    collaborator
  }
  latestRunData {
    id
    triggeredAt
    status
  }
}
    `;
export const ProcedureSummaryFragmentDoc = gql`
    fragment procedureSummary on Procedure {
  id
  departmentId
  name
  stage
  departmentVersion
  version
}
    `;
export const WorkerDataFragmentDoc = gql`
    fragment workerData on Worker {
  id
  owner
  name
  version
  departmentVersion
  knowledgeId
  departmentId
  procedureId
  originalWorkerId
  createdAt
  state
  isArchived
  features
  stage
  replayWorkerId
}
    `;
export const WorkerForkExecutionInfoFragmentDoc = gql`
    fragment WorkerForkExecutionInfo on Worker {
  forkExecutionInfo {
    items {
      answer
      createdBy
      documentToken
      internalState
      internalStateLastUpdatedAt
      internalStateMessage
      lineId
      lineToken
      metadata {
        learningId
        questionId
        requestId
      }
      version
      workItemId
      workerId
    }
  }
}
    `;
export const OnWorkerKnowledgeIdUpdateDocument = gql`
    subscription onWorkerKnowledgeIdUpdate($id: ID!) {
  onNotifyWorkerUpdate(id: $id) {
    id
    knowledgeId
  }
}
    `;

/**
 * __useOnWorkerKnowledgeIdUpdateSubscription__
 *
 * To run a query within a React component, call `useOnWorkerKnowledgeIdUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnWorkerKnowledgeIdUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnWorkerKnowledgeIdUpdateSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnWorkerKnowledgeIdUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnWorkerKnowledgeIdUpdateSubscription, OnWorkerKnowledgeIdUpdateSubscriptionVariables> & ({ variables: OnWorkerKnowledgeIdUpdateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnWorkerKnowledgeIdUpdateSubscription, OnWorkerKnowledgeIdUpdateSubscriptionVariables>(OnWorkerKnowledgeIdUpdateDocument, options);
      }
export type OnWorkerKnowledgeIdUpdateSubscriptionHookResult = ReturnType<typeof useOnWorkerKnowledgeIdUpdateSubscription>;
export type OnWorkerKnowledgeIdUpdateSubscriptionResult = Apollo.SubscriptionResult<OnWorkerKnowledgeIdUpdateSubscription>;
export const OnProcedureWorkersStateUpdateDocument = gql`
    subscription onProcedureWorkersStateUpdate($procedureId: ID) {
  onNotifyWorkerUpdate(procedureId: $procedureId) {
    id
    state
  }
}
    `;

/**
 * __useOnProcedureWorkersStateUpdateSubscription__
 *
 * To run a query within a React component, call `useOnProcedureWorkersStateUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnProcedureWorkersStateUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnProcedureWorkersStateUpdateSubscription({
 *   variables: {
 *      procedureId: // value for 'procedureId'
 *   },
 * });
 */
export function useOnProcedureWorkersStateUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnProcedureWorkersStateUpdateSubscription, OnProcedureWorkersStateUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnProcedureWorkersStateUpdateSubscription, OnProcedureWorkersStateUpdateSubscriptionVariables>(OnProcedureWorkersStateUpdateDocument, options);
      }
export type OnProcedureWorkersStateUpdateSubscriptionHookResult = ReturnType<typeof useOnProcedureWorkersStateUpdateSubscription>;
export type OnProcedureWorkersStateUpdateSubscriptionResult = Apollo.SubscriptionResult<OnProcedureWorkersStateUpdateSubscription>;
export const StoreIntegrationCredentialDocument = gql`
    mutation StoreIntegrationCredential($input: CredentialValueInput!) {
  storeIntegrationCredential(input: $input) {
    integrationId
    departmentId
    lastChangedAt
    lastChangedBy
    lastValidatedAt
    lastValidationStatus
    lastValidationMessage
    isCredentialProvided
    redirectionFlowRequired
    isRedirectionFlowDone
  }
}
    `;
export type StoreIntegrationCredentialMutationFn = Apollo.MutationFunction<StoreIntegrationCredentialMutation, StoreIntegrationCredentialMutationVariables>;

/**
 * __useStoreIntegrationCredentialMutation__
 *
 * To run a mutation, you first call `useStoreIntegrationCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreIntegrationCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeIntegrationCredentialMutation, { data, loading, error }] = useStoreIntegrationCredentialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStoreIntegrationCredentialMutation(baseOptions?: Apollo.MutationHookOptions<StoreIntegrationCredentialMutation, StoreIntegrationCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreIntegrationCredentialMutation, StoreIntegrationCredentialMutationVariables>(StoreIntegrationCredentialDocument, options);
      }
export type StoreIntegrationCredentialMutationHookResult = ReturnType<typeof useStoreIntegrationCredentialMutation>;
export type StoreIntegrationCredentialMutationResult = Apollo.MutationResult<StoreIntegrationCredentialMutation>;
export type StoreIntegrationCredentialMutationOptions = Apollo.BaseMutationOptions<StoreIntegrationCredentialMutation, StoreIntegrationCredentialMutationVariables>;
export const StoreIntegrationCredentialsDocument = gql`
    mutation StoreIntegrationCredentials($input: [CredentialValueInput!]!) {
  storeIntegrationCredentials(input: $input) {
    integrationId
    departmentId
    lastChangedAt
    lastChangedBy
    lastValidatedAt
    lastValidationStatus
    lastValidationMessage
    isCredentialProvided
    redirectionFlowRequired
    isRedirectionFlowDone
  }
}
    `;
export type StoreIntegrationCredentialsMutationFn = Apollo.MutationFunction<StoreIntegrationCredentialsMutation, StoreIntegrationCredentialsMutationVariables>;

/**
 * __useStoreIntegrationCredentialsMutation__
 *
 * To run a mutation, you first call `useStoreIntegrationCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreIntegrationCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeIntegrationCredentialsMutation, { data, loading, error }] = useStoreIntegrationCredentialsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStoreIntegrationCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<StoreIntegrationCredentialsMutation, StoreIntegrationCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreIntegrationCredentialsMutation, StoreIntegrationCredentialsMutationVariables>(StoreIntegrationCredentialsDocument, options);
      }
export type StoreIntegrationCredentialsMutationHookResult = ReturnType<typeof useStoreIntegrationCredentialsMutation>;
export type StoreIntegrationCredentialsMutationResult = Apollo.MutationResult<StoreIntegrationCredentialsMutation>;
export type StoreIntegrationCredentialsMutationOptions = Apollo.BaseMutationOptions<StoreIntegrationCredentialsMutation, StoreIntegrationCredentialsMutationVariables>;
export const LearnBooksDocument = gql`
    mutation LearnBooks($ids: [ID!]!, $departmentId: ID!) {
  learnBooks(ids: $ids, departmentId: $departmentId) {
    id
    name
  }
}
    `;
export type LearnBooksMutationFn = Apollo.MutationFunction<LearnBooksMutation, LearnBooksMutationVariables>;

/**
 * __useLearnBooksMutation__
 *
 * To run a mutation, you first call `useLearnBooksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearnBooksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learnBooksMutation, { data, loading, error }] = useLearnBooksMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useLearnBooksMutation(baseOptions?: Apollo.MutationHookOptions<LearnBooksMutation, LearnBooksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearnBooksMutation, LearnBooksMutationVariables>(LearnBooksDocument, options);
      }
export type LearnBooksMutationHookResult = ReturnType<typeof useLearnBooksMutation>;
export type LearnBooksMutationResult = Apollo.MutationResult<LearnBooksMutation>;
export type LearnBooksMutationOptions = Apollo.BaseMutationOptions<LearnBooksMutation, LearnBooksMutationVariables>;
export const RemoveIntegrationCredentialDocument = gql`
    mutation RemoveIntegrationCredential($integrationId: ID!, $departmentId: ID!) {
  removeIntegrationCredential(
    integrationId: $integrationId
    departmentId: $departmentId
  ) {
    integrationId
  }
}
    `;
export type RemoveIntegrationCredentialMutationFn = Apollo.MutationFunction<RemoveIntegrationCredentialMutation, RemoveIntegrationCredentialMutationVariables>;

/**
 * __useRemoveIntegrationCredentialMutation__
 *
 * To run a mutation, you first call `useRemoveIntegrationCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveIntegrationCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeIntegrationCredentialMutation, { data, loading, error }] = useRemoveIntegrationCredentialMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useRemoveIntegrationCredentialMutation(baseOptions?: Apollo.MutationHookOptions<RemoveIntegrationCredentialMutation, RemoveIntegrationCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveIntegrationCredentialMutation, RemoveIntegrationCredentialMutationVariables>(RemoveIntegrationCredentialDocument, options);
      }
export type RemoveIntegrationCredentialMutationHookResult = ReturnType<typeof useRemoveIntegrationCredentialMutation>;
export type RemoveIntegrationCredentialMutationResult = Apollo.MutationResult<RemoveIntegrationCredentialMutation>;
export type RemoveIntegrationCredentialMutationOptions = Apollo.BaseMutationOptions<RemoveIntegrationCredentialMutation, RemoveIntegrationCredentialMutationVariables>;
export const ForgetBooksDocument = gql`
    mutation ForgetBooks($ids: [ID!]!, $departmentId: ID!) {
  forgetBooks(ids: $ids, departmentId: $departmentId) {
    id
  }
}
    `;
export type ForgetBooksMutationFn = Apollo.MutationFunction<ForgetBooksMutation, ForgetBooksMutationVariables>;

/**
 * __useForgetBooksMutation__
 *
 * To run a mutation, you first call `useForgetBooksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgetBooksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgetBooksMutation, { data, loading, error }] = useForgetBooksMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useForgetBooksMutation(baseOptions?: Apollo.MutationHookOptions<ForgetBooksMutation, ForgetBooksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgetBooksMutation, ForgetBooksMutationVariables>(ForgetBooksDocument, options);
      }
export type ForgetBooksMutationHookResult = ReturnType<typeof useForgetBooksMutation>;
export type ForgetBooksMutationResult = Apollo.MutationResult<ForgetBooksMutation>;
export type ForgetBooksMutationOptions = Apollo.BaseMutationOptions<ForgetBooksMutation, ForgetBooksMutationVariables>;
export const GenerateIntegrationAuthorizationUrlDocument = gql`
    mutation GenerateIntegrationAuthorizationUrl($integrationId: ID!, $departmentId: ID!, $workerId: ID, $procedureId: ID) {
  generateIntegrationAuthorizationUrl(
    integrationId: $integrationId
    departmentId: $departmentId
    workerId: $workerId
    procedureId: $procedureId
  ) {
    url
  }
}
    `;
export type GenerateIntegrationAuthorizationUrlMutationFn = Apollo.MutationFunction<GenerateIntegrationAuthorizationUrlMutation, GenerateIntegrationAuthorizationUrlMutationVariables>;

/**
 * __useGenerateIntegrationAuthorizationUrlMutation__
 *
 * To run a mutation, you first call `useGenerateIntegrationAuthorizationUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateIntegrationAuthorizationUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateIntegrationAuthorizationUrlMutation, { data, loading, error }] = useGenerateIntegrationAuthorizationUrlMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      departmentId: // value for 'departmentId'
 *      workerId: // value for 'workerId'
 *      procedureId: // value for 'procedureId'
 *   },
 * });
 */
export function useGenerateIntegrationAuthorizationUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateIntegrationAuthorizationUrlMutation, GenerateIntegrationAuthorizationUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateIntegrationAuthorizationUrlMutation, GenerateIntegrationAuthorizationUrlMutationVariables>(GenerateIntegrationAuthorizationUrlDocument, options);
      }
export type GenerateIntegrationAuthorizationUrlMutationHookResult = ReturnType<typeof useGenerateIntegrationAuthorizationUrlMutation>;
export type GenerateIntegrationAuthorizationUrlMutationResult = Apollo.MutationResult<GenerateIntegrationAuthorizationUrlMutation>;
export type GenerateIntegrationAuthorizationUrlMutationOptions = Apollo.BaseMutationOptions<GenerateIntegrationAuthorizationUrlMutation, GenerateIntegrationAuthorizationUrlMutationVariables>;
export const StoreIntegrationRedirectionFlowCredentialDocument = gql`
    mutation StoreIntegrationRedirectionFlowCredential($departmentId: ID!, $integrationId: ID!, $redirectURIParams: String) {
  storeIntegrationRedirectionFlowCredential(
    input: {departmentId: $departmentId, integrationId: $integrationId, redirectURIParams: $redirectURIParams}
  ) {
    integrationId
    departmentId
    lastChangedAt
    lastChangedBy
    lastValidatedAt
    lastValidationStatus
    lastValidationMessage
    isCredentialProvided
    redirectionFlowRequired
    isRedirectionFlowDone
  }
}
    `;
export type StoreIntegrationRedirectionFlowCredentialMutationFn = Apollo.MutationFunction<StoreIntegrationRedirectionFlowCredentialMutation, StoreIntegrationRedirectionFlowCredentialMutationVariables>;

/**
 * __useStoreIntegrationRedirectionFlowCredentialMutation__
 *
 * To run a mutation, you first call `useStoreIntegrationRedirectionFlowCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreIntegrationRedirectionFlowCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeIntegrationRedirectionFlowCredentialMutation, { data, loading, error }] = useStoreIntegrationRedirectionFlowCredentialMutation({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      integrationId: // value for 'integrationId'
 *      redirectURIParams: // value for 'redirectURIParams'
 *   },
 * });
 */
export function useStoreIntegrationRedirectionFlowCredentialMutation(baseOptions?: Apollo.MutationHookOptions<StoreIntegrationRedirectionFlowCredentialMutation, StoreIntegrationRedirectionFlowCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreIntegrationRedirectionFlowCredentialMutation, StoreIntegrationRedirectionFlowCredentialMutationVariables>(StoreIntegrationRedirectionFlowCredentialDocument, options);
      }
export type StoreIntegrationRedirectionFlowCredentialMutationHookResult = ReturnType<typeof useStoreIntegrationRedirectionFlowCredentialMutation>;
export type StoreIntegrationRedirectionFlowCredentialMutationResult = Apollo.MutationResult<StoreIntegrationRedirectionFlowCredentialMutation>;
export type StoreIntegrationRedirectionFlowCredentialMutationOptions = Apollo.BaseMutationOptions<StoreIntegrationRedirectionFlowCredentialMutation, StoreIntegrationRedirectionFlowCredentialMutationVariables>;
export const CreateDepartmentDocument = gql`
    mutation CreateDepartment($input: CreateDepartmentInput!) {
  createDepartment(input: $input) {
    id
    owner
    organizationId
    name
    draftKnowledgeId
    publishedKnowledgeId
    workerId
    local
    state
    errors
    createdAt
    isDeleted
    brainVersion
    features
    organization {
      id
      name
    }
    draftKnowledge {
      id
      brainVersion
    }
  }
}
    `;
export type CreateDepartmentMutationFn = Apollo.MutationFunction<CreateDepartmentMutation, CreateDepartmentMutationVariables>;

/**
 * __useCreateDepartmentMutation__
 *
 * To run a mutation, you first call `useCreateDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDepartmentMutation, { data, loading, error }] = useCreateDepartmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDepartmentMutation, CreateDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDepartmentMutation, CreateDepartmentMutationVariables>(CreateDepartmentDocument, options);
      }
export type CreateDepartmentMutationHookResult = ReturnType<typeof useCreateDepartmentMutation>;
export type CreateDepartmentMutationResult = Apollo.MutationResult<CreateDepartmentMutation>;
export type CreateDepartmentMutationOptions = Apollo.BaseMutationOptions<CreateDepartmentMutation, CreateDepartmentMutationVariables>;
export const UpgradeDepartmentDocument = gql`
    mutation UpgradeDepartment($departmentId: ID!, $brainVersion: String) {
  upgradeDepartment(departmentId: $departmentId, brainVersion: $brainVersion) {
    id
    owner
    organizationId
    name
    draftKnowledgeId
    publishedKnowledgeId
    workerId
    local
    state
    errors
    createdAt
    isDeleted
    brainVersion
    features
    organization {
      id
      name
    }
    draftKnowledge {
      id
      brainVersion
    }
  }
}
    `;
export type UpgradeDepartmentMutationFn = Apollo.MutationFunction<UpgradeDepartmentMutation, UpgradeDepartmentMutationVariables>;

/**
 * __useUpgradeDepartmentMutation__
 *
 * To run a mutation, you first call `useUpgradeDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeDepartmentMutation, { data, loading, error }] = useUpgradeDepartmentMutation({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      brainVersion: // value for 'brainVersion'
 *   },
 * });
 */
export function useUpgradeDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeDepartmentMutation, UpgradeDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeDepartmentMutation, UpgradeDepartmentMutationVariables>(UpgradeDepartmentDocument, options);
      }
export type UpgradeDepartmentMutationHookResult = ReturnType<typeof useUpgradeDepartmentMutation>;
export type UpgradeDepartmentMutationResult = Apollo.MutationResult<UpgradeDepartmentMutation>;
export type UpgradeDepartmentMutationOptions = Apollo.BaseMutationOptions<UpgradeDepartmentMutation, UpgradeDepartmentMutationVariables>;
export const RollbackDepartmentDocument = gql`
    mutation RollbackDepartment($departmentId: ID!) {
  rollbackDepartment(departmentId: $departmentId) {
    id
    owner
    organizationId
    name
    draftKnowledgeId
    publishedKnowledgeId
    workerId
    local
    state
    errors
    createdAt
    isDeleted
    brainVersion
    features
    organization {
      id
      name
    }
    draftKnowledge {
      id
      brainVersion
    }
  }
}
    `;
export type RollbackDepartmentMutationFn = Apollo.MutationFunction<RollbackDepartmentMutation, RollbackDepartmentMutationVariables>;

/**
 * __useRollbackDepartmentMutation__
 *
 * To run a mutation, you first call `useRollbackDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRollbackDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rollbackDepartmentMutation, { data, loading, error }] = useRollbackDepartmentMutation({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useRollbackDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<RollbackDepartmentMutation, RollbackDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RollbackDepartmentMutation, RollbackDepartmentMutationVariables>(RollbackDepartmentDocument, options);
      }
export type RollbackDepartmentMutationHookResult = ReturnType<typeof useRollbackDepartmentMutation>;
export type RollbackDepartmentMutationResult = Apollo.MutationResult<RollbackDepartmentMutation>;
export type RollbackDepartmentMutationOptions = Apollo.BaseMutationOptions<RollbackDepartmentMutation, RollbackDepartmentMutationVariables>;
export const RemoveUserFromDepartmentDocument = gql`
    mutation RemoveUserFromDepartment($departmentId: ID!, $userId: ID!) {
  removeUserFromDepartment(departmentId: $departmentId, userId: $userId) {
    status
  }
}
    `;
export type RemoveUserFromDepartmentMutationFn = Apollo.MutationFunction<RemoveUserFromDepartmentMutation, RemoveUserFromDepartmentMutationVariables>;

/**
 * __useRemoveUserFromDepartmentMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromDepartmentMutation, { data, loading, error }] = useRemoveUserFromDepartmentMutation({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserFromDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromDepartmentMutation, RemoveUserFromDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromDepartmentMutation, RemoveUserFromDepartmentMutationVariables>(RemoveUserFromDepartmentDocument, options);
      }
export type RemoveUserFromDepartmentMutationHookResult = ReturnType<typeof useRemoveUserFromDepartmentMutation>;
export type RemoveUserFromDepartmentMutationResult = Apollo.MutationResult<RemoveUserFromDepartmentMutation>;
export type RemoveUserFromDepartmentMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromDepartmentMutation, RemoveUserFromDepartmentMutationVariables>;
export const RollbackDepartmentVersionDocument = gql`
    mutation RollbackDepartmentVersion($input: DepartmentRollbackInput!) {
  rollbackDepartmentVersion(input: $input) {
    id
    departmentId
    previousVersion
    currentVersion
    rollbackVersion
  }
}
    `;
export type RollbackDepartmentVersionMutationFn = Apollo.MutationFunction<RollbackDepartmentVersionMutation, RollbackDepartmentVersionMutationVariables>;

/**
 * __useRollbackDepartmentVersionMutation__
 *
 * To run a mutation, you first call `useRollbackDepartmentVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRollbackDepartmentVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rollbackDepartmentVersionMutation, { data, loading, error }] = useRollbackDepartmentVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRollbackDepartmentVersionMutation(baseOptions?: Apollo.MutationHookOptions<RollbackDepartmentVersionMutation, RollbackDepartmentVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RollbackDepartmentVersionMutation, RollbackDepartmentVersionMutationVariables>(RollbackDepartmentVersionDocument, options);
      }
export type RollbackDepartmentVersionMutationHookResult = ReturnType<typeof useRollbackDepartmentVersionMutation>;
export type RollbackDepartmentVersionMutationResult = Apollo.MutationResult<RollbackDepartmentVersionMutation>;
export type RollbackDepartmentVersionMutationOptions = Apollo.BaseMutationOptions<RollbackDepartmentVersionMutation, RollbackDepartmentVersionMutationVariables>;
export const DeleteDepartmentDocument = gql`
    mutation DeleteDepartment($input: DeleteDepartmentInput!) {
  deleteDepartment(input: $input) {
    id
    owner
    organizationId
    readers
    editors
    name
    draftKnowledgeId
    publishedKnowledgeId
    workerId
    local
    state
    errors
    createdAt
    isDeleted
    upgradeCommandId
    notifyProcedureInvocation
    features
    brainVersion
    status
    purgeWorkerDataAfter
    provisionedConcurrency
    worker {
      id
      owner
      readers
      editors
      name
      description
      version
      departmentVersion
      knowledgeId
      departmentId
      procedureId
      entryCommand
      entryCommandId
      originalWorkerId
      createdAt
      state
      stateLastUpdatedAt
      status
      statusLastUpdatedAt
      attachments
      isArchived
      features
    }
    organization {
      id
      name
      owner
      createdAt
      updatedAt
      billingStatus
    }
    draftKnowledge {
      id
      owner
      readers
      editors
      name
      description
      departmentId
      workerId
      parentKnowledgeId
      state
      brainVersion
    }
    publishedKnowledge {
      id
      owner
      readers
      editors
      name
      description
      departmentId
      workerId
      parentKnowledgeId
      state
      brainVersion
    }
    requests {
      limit
      nextToken
    }
    learnedAnswers {
      nextToken
    }
  }
}
    `;
export type DeleteDepartmentMutationFn = Apollo.MutationFunction<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>;

/**
 * __useDeleteDepartmentMutation__
 *
 * To run a mutation, you first call `useDeleteDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDepartmentMutation, { data, loading, error }] = useDeleteDepartmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>(DeleteDepartmentDocument, options);
      }
export type DeleteDepartmentMutationHookResult = ReturnType<typeof useDeleteDepartmentMutation>;
export type DeleteDepartmentMutationResult = Apollo.MutationResult<DeleteDepartmentMutation>;
export type DeleteDepartmentMutationOptions = Apollo.BaseMutationOptions<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>;
export const UpdateDepartmentDocument = gql`
    mutation UpdateDepartment($input: UpdateDepartmentInput!) {
  updateDepartment(input: $input) {
    id
    owner
    organizationId
    readers
    editors
    name
    draftKnowledgeId
    publishedKnowledgeId
    workerId
    local
    state
    errors
    createdAt
    isDeleted
    upgradeCommandId
    notifyProcedureInvocation
    features
    brainVersion
    status
    purgeWorkerDataAfter
    provisionedConcurrency
    worker {
      id
      owner
      readers
      editors
      name
      description
      version
      departmentVersion
      knowledgeId
      departmentId
      procedureId
      entryCommand
      entryCommandId
      originalWorkerId
      createdAt
      state
      stateLastUpdatedAt
      status
      statusLastUpdatedAt
      attachments
      isArchived
      features
    }
    organization {
      id
      name
      owner
      createdAt
      updatedAt
      billingStatus
    }
    draftKnowledge {
      id
      owner
      readers
      editors
      name
      description
      departmentId
      workerId
      parentKnowledgeId
      state
      brainVersion
    }
    publishedKnowledge {
      id
      owner
      readers
      editors
      name
      description
      departmentId
      workerId
      parentKnowledgeId
      state
      brainVersion
    }
    requests {
      limit
      nextToken
    }
    learnedAnswers {
      nextToken
    }
  }
}
    `;
export type UpdateDepartmentMutationFn = Apollo.MutationFunction<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>;

/**
 * __useUpdateDepartmentMutation__
 *
 * To run a mutation, you first call `useUpdateDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDepartmentMutation, { data, loading, error }] = useUpdateDepartmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>(UpdateDepartmentDocument, options);
      }
export type UpdateDepartmentMutationHookResult = ReturnType<typeof useUpdateDepartmentMutation>;
export type UpdateDepartmentMutationResult = Apollo.MutationResult<UpdateDepartmentMutation>;
export type UpdateDepartmentMutationOptions = Apollo.BaseMutationOptions<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>;
export const ImportDepartmentDocument = gql`
    mutation ImportDepartment($input: DepartmentImportInput!) {
  importDepartment(input: $input) {
    id
    owner
    organizationId
    name
    draftKnowledgeId
    publishedKnowledgeId
    workerId
    local
    state
    errors
    createdAt
    isDeleted
    brainVersion
    features
    organization {
      id
      name
    }
    draftKnowledge {
      id
      brainVersion
    }
  }
}
    `;
export type ImportDepartmentMutationFn = Apollo.MutationFunction<ImportDepartmentMutation, ImportDepartmentMutationVariables>;

/**
 * __useImportDepartmentMutation__
 *
 * To run a mutation, you first call `useImportDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importDepartmentMutation, { data, loading, error }] = useImportDepartmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<ImportDepartmentMutation, ImportDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportDepartmentMutation, ImportDepartmentMutationVariables>(ImportDepartmentDocument, options);
      }
export type ImportDepartmentMutationHookResult = ReturnType<typeof useImportDepartmentMutation>;
export type ImportDepartmentMutationResult = Apollo.MutationResult<ImportDepartmentMutation>;
export type ImportDepartmentMutationOptions = Apollo.BaseMutationOptions<ImportDepartmentMutation, ImportDepartmentMutationVariables>;
export const UpsertUserToDepartmentDocument = gql`
    mutation UpsertUserToDepartment($departmentId: ID!, $userId: ID!, $role: AccessControlRole!) {
  upsertUserToDepartment(
    departmentId: $departmentId
    userId: $userId
    role: $role
  ) {
    status
  }
}
    `;
export type UpsertUserToDepartmentMutationFn = Apollo.MutationFunction<UpsertUserToDepartmentMutation, UpsertUserToDepartmentMutationVariables>;

/**
 * __useUpsertUserToDepartmentMutation__
 *
 * To run a mutation, you first call `useUpsertUserToDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserToDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserToDepartmentMutation, { data, loading, error }] = useUpsertUserToDepartmentMutation({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpsertUserToDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserToDepartmentMutation, UpsertUserToDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserToDepartmentMutation, UpsertUserToDepartmentMutationVariables>(UpsertUserToDepartmentDocument, options);
      }
export type UpsertUserToDepartmentMutationHookResult = ReturnType<typeof useUpsertUserToDepartmentMutation>;
export type UpsertUserToDepartmentMutationResult = Apollo.MutationResult<UpsertUserToDepartmentMutation>;
export type UpsertUserToDepartmentMutationOptions = Apollo.BaseMutationOptions<UpsertUserToDepartmentMutation, UpsertUserToDepartmentMutationVariables>;
export const PublishDepartmentDocument = gql`
    mutation PublishDepartment($input: PublishDepartmentInput!) {
  publishDepartment(input: $input) {
    id
    departmentId
    departmentVersion
    publishedAt
    publishedBy
  }
}
    `;
export type PublishDepartmentMutationFn = Apollo.MutationFunction<PublishDepartmentMutation, PublishDepartmentMutationVariables>;

/**
 * __usePublishDepartmentMutation__
 *
 * To run a mutation, you first call `usePublishDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishDepartmentMutation, { data, loading, error }] = usePublishDepartmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<PublishDepartmentMutation, PublishDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishDepartmentMutation, PublishDepartmentMutationVariables>(PublishDepartmentDocument, options);
      }
export type PublishDepartmentMutationHookResult = ReturnType<typeof usePublishDepartmentMutation>;
export type PublishDepartmentMutationResult = Apollo.MutationResult<PublishDepartmentMutation>;
export type PublishDepartmentMutationOptions = Apollo.BaseMutationOptions<PublishDepartmentMutation, PublishDepartmentMutationVariables>;
export const AssignRequestsDocument = gql`
    mutation AssignRequests($input: AssignRequestsInput!) {
  assignRequests(input: $input) {
    assignments {
      requestId
      assignment
      assignmentPolicyType
    }
  }
}
    `;
export type AssignRequestsMutationFn = Apollo.MutationFunction<AssignRequestsMutation, AssignRequestsMutationVariables>;

/**
 * __useAssignRequestsMutation__
 *
 * To run a mutation, you first call `useAssignRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignRequestsMutation, { data, loading, error }] = useAssignRequestsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignRequestsMutation(baseOptions?: Apollo.MutationHookOptions<AssignRequestsMutation, AssignRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignRequestsMutation, AssignRequestsMutationVariables>(AssignRequestsDocument, options);
      }
export type AssignRequestsMutationHookResult = ReturnType<typeof useAssignRequestsMutation>;
export type AssignRequestsMutationResult = Apollo.MutationResult<AssignRequestsMutation>;
export type AssignRequestsMutationOptions = Apollo.BaseMutationOptions<AssignRequestsMutation, AssignRequestsMutationVariables>;
export const CreateKChatMessageDocument = gql`
    mutation CreateKChatMessage($input: CreateChatMessageInput!) {
  createKChatMessage(input: $input) {
    items {
      id
      departmentId
      workerId
      message
      timestamp
      displayName
      role
    }
    nextToken
  }
}
    `;
export type CreateKChatMessageMutationFn = Apollo.MutationFunction<CreateKChatMessageMutation, CreateKChatMessageMutationVariables>;

/**
 * __useCreateKChatMessageMutation__
 *
 * To run a mutation, you first call `useCreateKChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKChatMessageMutation, { data, loading, error }] = useCreateKChatMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateKChatMessageMutation, CreateKChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKChatMessageMutation, CreateKChatMessageMutationVariables>(CreateKChatMessageDocument, options);
      }
export type CreateKChatMessageMutationHookResult = ReturnType<typeof useCreateKChatMessageMutation>;
export type CreateKChatMessageMutationResult = Apollo.MutationResult<CreateKChatMessageMutation>;
export type CreateKChatMessageMutationOptions = Apollo.BaseMutationOptions<CreateKChatMessageMutation, CreateKChatMessageMutationVariables>;
export const CreateLearnedAnswerDocument = gql`
    mutation CreateLearnedAnswer($input: CreateLearnedAnswerInput!) {
  createLearnedAnswer(input: $input) {
    id
    questionFilter {
      stepPath
      questionType
      lexicalPath
    }
    stage
    action {
      _
      ... on ReplaceStepAction {
        newSteps
      }
      ... on RetryStepAction {
        minimumDelay
        timeout
      }
      ... on UseConceptAction {
        conceptId
      }
      ... on UseLiteralValueAction {
        literalValue
        choices
      }
      ... on UseTechniqueAction {
        technique
      }
    }
    createdAt
    createdBy
    deletedAt
    deletedBy
    procedureId
    procedureName
    procedure {
      id
    }
    contextValue
    contextMetadata
  }
}
    `;
export type CreateLearnedAnswerMutationFn = Apollo.MutationFunction<CreateLearnedAnswerMutation, CreateLearnedAnswerMutationVariables>;

/**
 * __useCreateLearnedAnswerMutation__
 *
 * To run a mutation, you first call `useCreateLearnedAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearnedAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearnedAnswerMutation, { data, loading, error }] = useCreateLearnedAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLearnedAnswerMutation(baseOptions?: Apollo.MutationHookOptions<CreateLearnedAnswerMutation, CreateLearnedAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLearnedAnswerMutation, CreateLearnedAnswerMutationVariables>(CreateLearnedAnswerDocument, options);
      }
export type CreateLearnedAnswerMutationHookResult = ReturnType<typeof useCreateLearnedAnswerMutation>;
export type CreateLearnedAnswerMutationResult = Apollo.MutationResult<CreateLearnedAnswerMutation>;
export type CreateLearnedAnswerMutationOptions = Apollo.BaseMutationOptions<CreateLearnedAnswerMutation, CreateLearnedAnswerMutationVariables>;
export const DeleteLearnedAnswerDocument = gql`
    mutation DeleteLearnedAnswer($input: DeleteLearnedAnswerInput!) {
  deleteLearnedAnswer(input: $input) {
    id
  }
}
    `;
export type DeleteLearnedAnswerMutationFn = Apollo.MutationFunction<DeleteLearnedAnswerMutation, DeleteLearnedAnswerMutationVariables>;

/**
 * __useDeleteLearnedAnswerMutation__
 *
 * To run a mutation, you first call `useDeleteLearnedAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLearnedAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLearnedAnswerMutation, { data, loading, error }] = useDeleteLearnedAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLearnedAnswerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLearnedAnswerMutation, DeleteLearnedAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLearnedAnswerMutation, DeleteLearnedAnswerMutationVariables>(DeleteLearnedAnswerDocument, options);
      }
export type DeleteLearnedAnswerMutationHookResult = ReturnType<typeof useDeleteLearnedAnswerMutation>;
export type DeleteLearnedAnswerMutationResult = Apollo.MutationResult<DeleteLearnedAnswerMutation>;
export type DeleteLearnedAnswerMutationOptions = Apollo.BaseMutationOptions<DeleteLearnedAnswerMutation, DeleteLearnedAnswerMutationVariables>;
export const DeleteContextualLearningInfosDocument = gql`
    mutation DeleteContextualLearningInfos($input: DeleteRestoreContextualLearningInfoInput!) {
  deleteContextualLearningInfos(input: $input) {
    items {
      ...ContextualLearningInfoFragment
    }
  }
}
    ${ContextualLearningInfoFragmentFragmentDoc}`;
export type DeleteContextualLearningInfosMutationFn = Apollo.MutationFunction<DeleteContextualLearningInfosMutation, DeleteContextualLearningInfosMutationVariables>;

/**
 * __useDeleteContextualLearningInfosMutation__
 *
 * To run a mutation, you first call `useDeleteContextualLearningInfosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContextualLearningInfosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContextualLearningInfosMutation, { data, loading, error }] = useDeleteContextualLearningInfosMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteContextualLearningInfosMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContextualLearningInfosMutation, DeleteContextualLearningInfosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContextualLearningInfosMutation, DeleteContextualLearningInfosMutationVariables>(DeleteContextualLearningInfosDocument, options);
      }
export type DeleteContextualLearningInfosMutationHookResult = ReturnType<typeof useDeleteContextualLearningInfosMutation>;
export type DeleteContextualLearningInfosMutationResult = Apollo.MutationResult<DeleteContextualLearningInfosMutation>;
export type DeleteContextualLearningInfosMutationOptions = Apollo.BaseMutationOptions<DeleteContextualLearningInfosMutation, DeleteContextualLearningInfosMutationVariables>;
export const RestoreContextualLearningInfosDocument = gql`
    mutation RestoreContextualLearningInfos($input: DeleteRestoreContextualLearningInfoInput!) {
  restoreContextLearningInfos(input: $input) {
    items {
      ...ContextualLearningInfoFragment
    }
  }
}
    ${ContextualLearningInfoFragmentFragmentDoc}`;
export type RestoreContextualLearningInfosMutationFn = Apollo.MutationFunction<RestoreContextualLearningInfosMutation, RestoreContextualLearningInfosMutationVariables>;

/**
 * __useRestoreContextualLearningInfosMutation__
 *
 * To run a mutation, you first call `useRestoreContextualLearningInfosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreContextualLearningInfosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreContextualLearningInfosMutation, { data, loading, error }] = useRestoreContextualLearningInfosMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreContextualLearningInfosMutation(baseOptions?: Apollo.MutationHookOptions<RestoreContextualLearningInfosMutation, RestoreContextualLearningInfosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreContextualLearningInfosMutation, RestoreContextualLearningInfosMutationVariables>(RestoreContextualLearningInfosDocument, options);
      }
export type RestoreContextualLearningInfosMutationHookResult = ReturnType<typeof useRestoreContextualLearningInfosMutation>;
export type RestoreContextualLearningInfosMutationResult = Apollo.MutationResult<RestoreContextualLearningInfosMutation>;
export type RestoreContextualLearningInfosMutationOptions = Apollo.BaseMutationOptions<RestoreContextualLearningInfosMutation, RestoreContextualLearningInfosMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    id
    name
    owner
    createdAt
    updatedAt
    billingStatus
  }
}
    `;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const PingDocument = gql`
    mutation Ping($channel: String!, $data: String) {
  ping(input: {channel: $channel, data: $data}) {
    channel
    data
  }
}
    `;
export type PingMutationFn = Apollo.MutationFunction<PingMutation, PingMutationVariables>;

/**
 * __usePingMutation__
 *
 * To run a mutation, you first call `usePingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pingMutation, { data, loading, error }] = usePingMutation({
 *   variables: {
 *      channel: // value for 'channel'
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePingMutation(baseOptions?: Apollo.MutationHookOptions<PingMutation, PingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PingMutation, PingMutationVariables>(PingDocument, options);
      }
export type PingMutationHookResult = ReturnType<typeof usePingMutation>;
export type PingMutationResult = Apollo.MutationResult<PingMutation>;
export type PingMutationOptions = Apollo.BaseMutationOptions<PingMutation, PingMutationVariables>;
export const UpdateWorkerDocumentDocument = gql`
    mutation updateWorkerDocument($workerId: ID!, $document: [SentenceInput!]!, $shouldStartExecution: Boolean!, $useAutopilot: Boolean, $documentToken: String, $startFromUiLineId: String) {
  updateWorkerDocument(
    input: {workerId: $workerId, document: $document, shouldStartExecution: $shouldStartExecution, useAutopilot: $useAutopilot, documentToken: $documentToken, startFromUiLineId: $startFromUiLineId}
  ) {
    sentences {
      lineId
      text
      shouldPause
      parentId
      language
      metadata {
        lineId
        parentId
      }
      internalMetadata {
        key
        value
      }
    }
    updatedAt
  }
}
    `;
export type UpdateWorkerDocumentMutationFn = Apollo.MutationFunction<UpdateWorkerDocumentMutation, UpdateWorkerDocumentMutationVariables>;

/**
 * __useUpdateWorkerDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateWorkerDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkerDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkerDocumentMutation, { data, loading, error }] = useUpdateWorkerDocumentMutation({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      document: // value for 'document'
 *      shouldStartExecution: // value for 'shouldStartExecution'
 *      useAutopilot: // value for 'useAutopilot'
 *      documentToken: // value for 'documentToken'
 *      startFromUiLineId: // value for 'startFromUiLineId'
 *   },
 * });
 */
export function useUpdateWorkerDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkerDocumentMutation, UpdateWorkerDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkerDocumentMutation, UpdateWorkerDocumentMutationVariables>(UpdateWorkerDocumentDocument, options);
      }
export type UpdateWorkerDocumentMutationHookResult = ReturnType<typeof useUpdateWorkerDocumentMutation>;
export type UpdateWorkerDocumentMutationResult = Apollo.MutationResult<UpdateWorkerDocumentMutation>;
export type UpdateWorkerDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateWorkerDocumentMutation, UpdateWorkerDocumentMutationVariables>;
export const CreateMiniPlaygroundDocument = gql`
    mutation CreateMiniPlayground($input: CreateMiniPlaygroundInput!) {
  createMiniPlayground(input: $input) {
    id
    workerId
    createdAt
    forwardedAt
    invokedAt
    receivedAt
    processingAt
    skippedAt
    processedAt
    failedAt
    workErrors
    createdBy
    lineId
    lineToken
  }
}
    `;
export type CreateMiniPlaygroundMutationFn = Apollo.MutationFunction<CreateMiniPlaygroundMutation, CreateMiniPlaygroundMutationVariables>;

/**
 * __useCreateMiniPlaygroundMutation__
 *
 * To run a mutation, you first call `useCreateMiniPlaygroundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMiniPlaygroundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMiniPlaygroundMutation, { data, loading, error }] = useCreateMiniPlaygroundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMiniPlaygroundMutation(baseOptions?: Apollo.MutationHookOptions<CreateMiniPlaygroundMutation, CreateMiniPlaygroundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMiniPlaygroundMutation, CreateMiniPlaygroundMutationVariables>(CreateMiniPlaygroundDocument, options);
      }
export type CreateMiniPlaygroundMutationHookResult = ReturnType<typeof useCreateMiniPlaygroundMutation>;
export type CreateMiniPlaygroundMutationResult = Apollo.MutationResult<CreateMiniPlaygroundMutation>;
export type CreateMiniPlaygroundMutationOptions = Apollo.BaseMutationOptions<CreateMiniPlaygroundMutation, CreateMiniPlaygroundMutationVariables>;
export const DuplicateWorkersDocument = gql`
    mutation DuplicateWorkers($departmentId: ID!, $workerIds: [ID!]!, $owner: String, $runWorker: Boolean = true) {
  duplicateWorkers(
    departmentId: $departmentId
    workerIds: $workerIds
    owner: $owner
    runWorker: $runWorker
  ) {
    ...workerData
  }
}
    ${WorkerDataFragmentDoc}`;
export type DuplicateWorkersMutationFn = Apollo.MutationFunction<DuplicateWorkersMutation, DuplicateWorkersMutationVariables>;

/**
 * __useDuplicateWorkersMutation__
 *
 * To run a mutation, you first call `useDuplicateWorkersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateWorkersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateWorkersMutation, { data, loading, error }] = useDuplicateWorkersMutation({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      workerIds: // value for 'workerIds'
 *      owner: // value for 'owner'
 *      runWorker: // value for 'runWorker'
 *   },
 * });
 */
export function useDuplicateWorkersMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateWorkersMutation, DuplicateWorkersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateWorkersMutation, DuplicateWorkersMutationVariables>(DuplicateWorkersDocument, options);
      }
export type DuplicateWorkersMutationHookResult = ReturnType<typeof useDuplicateWorkersMutation>;
export type DuplicateWorkersMutationResult = Apollo.MutationResult<DuplicateWorkersMutation>;
export type DuplicateWorkersMutationOptions = Apollo.BaseMutationOptions<DuplicateWorkersMutation, DuplicateWorkersMutationVariables>;
export const ReplayWorkersDocument = gql`
    mutation ReplayWorkers($departmentId: ID!, $workerIds: [ID!]!, $owner: String = null, $runWorker: Boolean = true, $brainVersion: String = null, $isReplay: Boolean = false) {
  duplicateWorkers(
    departmentId: $departmentId
    workerIds: $workerIds
    owner: $owner
    runWorker: $runWorker
    brainVersion: $brainVersion
    isReplay: $isReplay
  ) {
    ...workerData
  }
}
    ${WorkerDataFragmentDoc}`;
export type ReplayWorkersMutationFn = Apollo.MutationFunction<ReplayWorkersMutation, ReplayWorkersMutationVariables>;

/**
 * __useReplayWorkersMutation__
 *
 * To run a mutation, you first call `useReplayWorkersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplayWorkersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replayWorkersMutation, { data, loading, error }] = useReplayWorkersMutation({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      workerIds: // value for 'workerIds'
 *      owner: // value for 'owner'
 *      runWorker: // value for 'runWorker'
 *      brainVersion: // value for 'brainVersion'
 *      isReplay: // value for 'isReplay'
 *   },
 * });
 */
export function useReplayWorkersMutation(baseOptions?: Apollo.MutationHookOptions<ReplayWorkersMutation, ReplayWorkersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplayWorkersMutation, ReplayWorkersMutationVariables>(ReplayWorkersDocument, options);
      }
export type ReplayWorkersMutationHookResult = ReturnType<typeof useReplayWorkersMutation>;
export type ReplayWorkersMutationResult = Apollo.MutationResult<ReplayWorkersMutation>;
export type ReplayWorkersMutationOptions = Apollo.BaseMutationOptions<ReplayWorkersMutation, ReplayWorkersMutationVariables>;
export const UpdateWorkerDocument = gql`
    mutation updateWorker($id: ID!, $name: String) {
  updateWorker(input: {id: $id, name: $name}) {
    id
    name
  }
}
    `;
export type UpdateWorkerMutationFn = Apollo.MutationFunction<UpdateWorkerMutation, UpdateWorkerMutationVariables>;

/**
 * __useUpdateWorkerMutation__
 *
 * To run a mutation, you first call `useUpdateWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkerMutation, { data, loading, error }] = useUpdateWorkerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateWorkerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkerMutation, UpdateWorkerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkerMutation, UpdateWorkerMutationVariables>(UpdateWorkerDocument, options);
      }
export type UpdateWorkerMutationHookResult = ReturnType<typeof useUpdateWorkerMutation>;
export type UpdateWorkerMutationResult = Apollo.MutationResult<UpdateWorkerMutation>;
export type UpdateWorkerMutationOptions = Apollo.BaseMutationOptions<UpdateWorkerMutation, UpdateWorkerMutationVariables>;
export const ToggleWorkerArchiveStatusDocument = gql`
    mutation toggleWorkerArchiveStatus($input: ToggleWorkerArchiveStatusInput!) {
  toggleWorkerArchiveStatus(input: $input) {
    id
    name
  }
}
    `;
export type ToggleWorkerArchiveStatusMutationFn = Apollo.MutationFunction<ToggleWorkerArchiveStatusMutation, ToggleWorkerArchiveStatusMutationVariables>;

/**
 * __useToggleWorkerArchiveStatusMutation__
 *
 * To run a mutation, you first call `useToggleWorkerArchiveStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleWorkerArchiveStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleWorkerArchiveStatusMutation, { data, loading, error }] = useToggleWorkerArchiveStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleWorkerArchiveStatusMutation(baseOptions?: Apollo.MutationHookOptions<ToggleWorkerArchiveStatusMutation, ToggleWorkerArchiveStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleWorkerArchiveStatusMutation, ToggleWorkerArchiveStatusMutationVariables>(ToggleWorkerArchiveStatusDocument, options);
      }
export type ToggleWorkerArchiveStatusMutationHookResult = ReturnType<typeof useToggleWorkerArchiveStatusMutation>;
export type ToggleWorkerArchiveStatusMutationResult = Apollo.MutationResult<ToggleWorkerArchiveStatusMutation>;
export type ToggleWorkerArchiveStatusMutationOptions = Apollo.BaseMutationOptions<ToggleWorkerArchiveStatusMutation, ToggleWorkerArchiveStatusMutationVariables>;
export const CreateWorkerDocument = gql`
    mutation CreateWorker($input: CreateWorkerInput!, $local: Boolean) {
  createWorker(input: $input, local: $local) {
    id
    owner
    readers
    editors
    name
    description
    version
    departmentVersion
    knowledgeId
    departmentId
    procedureId
    entryCommand
    entryCommandId
    originalWorkerId
    createdAt
    state
    stateLastUpdatedAt
    attachments
    isArchived
    features
    replayWorkerId
  }
}
    `;
export type CreateWorkerMutationFn = Apollo.MutationFunction<CreateWorkerMutation, CreateWorkerMutationVariables>;

/**
 * __useCreateWorkerMutation__
 *
 * To run a mutation, you first call `useCreateWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkerMutation, { data, loading, error }] = useCreateWorkerMutation({
 *   variables: {
 *      input: // value for 'input'
 *      local: // value for 'local'
 *   },
 * });
 */
export function useCreateWorkerMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkerMutation, CreateWorkerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkerMutation, CreateWorkerMutationVariables>(CreateWorkerDocument, options);
      }
export type CreateWorkerMutationHookResult = ReturnType<typeof useCreateWorkerMutation>;
export type CreateWorkerMutationResult = Apollo.MutationResult<CreateWorkerMutation>;
export type CreateWorkerMutationOptions = Apollo.BaseMutationOptions<CreateWorkerMutation, CreateWorkerMutationVariables>;
export const InvokeProcedure2Document = gql`
    mutation InvokeProcedure2($departmentId: ID!, $procedureId: ID!, $knowledgeId: ID, $owner: String, $name: String, $description: String, $debug: Boolean, $local: Boolean, $commandParamsInput: CommandParamsInput, $version: String, $procedureStage: ProcedureStage) {
  invokeProcedure2(
    departmentId: $departmentId
    procedureId: $procedureId
    knowledgeId: $knowledgeId
    owner: $owner
    name: $name
    description: $description
    debug: $debug
    local: $local
    commandParamsInput: $commandParamsInput
    version: $version
    procedureStage: $procedureStage
  ) {
    id
    owner
    readers
    editors
    name
    description
    version
    departmentVersion
    knowledgeId
    departmentId
    procedureId
    entryCommand
    entryCommandId
    originalWorkerId
    createdAt
    state
    stage
    stateLastUpdatedAt
    attachments
    isArchived
  }
}
    `;
export type InvokeProcedure2MutationFn = Apollo.MutationFunction<InvokeProcedure2Mutation, InvokeProcedure2MutationVariables>;

/**
 * __useInvokeProcedure2Mutation__
 *
 * To run a mutation, you first call `useInvokeProcedure2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvokeProcedure2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invokeProcedure2Mutation, { data, loading, error }] = useInvokeProcedure2Mutation({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      procedureId: // value for 'procedureId'
 *      knowledgeId: // value for 'knowledgeId'
 *      owner: // value for 'owner'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      debug: // value for 'debug'
 *      local: // value for 'local'
 *      commandParamsInput: // value for 'commandParamsInput'
 *      version: // value for 'version'
 *      procedureStage: // value for 'procedureStage'
 *   },
 * });
 */
export function useInvokeProcedure2Mutation(baseOptions?: Apollo.MutationHookOptions<InvokeProcedure2Mutation, InvokeProcedure2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvokeProcedure2Mutation, InvokeProcedure2MutationVariables>(InvokeProcedure2Document, options);
      }
export type InvokeProcedure2MutationHookResult = ReturnType<typeof useInvokeProcedure2Mutation>;
export type InvokeProcedure2MutationResult = Apollo.MutationResult<InvokeProcedure2Mutation>;
export type InvokeProcedure2MutationOptions = Apollo.BaseMutationOptions<InvokeProcedure2Mutation, InvokeProcedure2MutationVariables>;
export const CreateProcedureDocument = gql`
    mutation CreateProcedure($input: CreateProcedureInput!) {
  createProcedure(input: $input) {
    id
    knowledgeId
    departmentId
    text
    name
    owner
    language
    public
    bookReference
    email {
      stage
      email
    }
    title
    version
    assignmentPolicy {
      policyType
      collaborator
    }
    stage
    schedules {
      name
      expression
      enabled
    }
    requests {
      limit
      nextToken
    }
  }
}
    `;
export type CreateProcedureMutationFn = Apollo.MutationFunction<CreateProcedureMutation, CreateProcedureMutationVariables>;

/**
 * __useCreateProcedureMutation__
 *
 * To run a mutation, you first call `useCreateProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcedureMutation, { data, loading, error }] = useCreateProcedureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProcedureMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcedureMutation, CreateProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcedureMutation, CreateProcedureMutationVariables>(CreateProcedureDocument, options);
      }
export type CreateProcedureMutationHookResult = ReturnType<typeof useCreateProcedureMutation>;
export type CreateProcedureMutationResult = Apollo.MutationResult<CreateProcedureMutation>;
export type CreateProcedureMutationOptions = Apollo.BaseMutationOptions<CreateProcedureMutation, CreateProcedureMutationVariables>;
export const UpdateProcedureDocument = gql`
    mutation UpdateProcedure($input: UpdateProcedureInput!) {
  updateProcedure(input: $input) {
    id
    knowledgeId
    departmentId
    text
    name
    owner
    language
    bookReference
    stage
    schedules {
      name
      expression
      enabled
    }
    email {
      stage
      email
    }
    title
    version
    assignmentPolicy {
      policyType
      collaborator
    }
  }
}
    `;
export type UpdateProcedureMutationFn = Apollo.MutationFunction<UpdateProcedureMutation, UpdateProcedureMutationVariables>;

/**
 * __useUpdateProcedureMutation__
 *
 * To run a mutation, you first call `useUpdateProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcedureMutation, { data, loading, error }] = useUpdateProcedureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProcedureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcedureMutation, UpdateProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcedureMutation, UpdateProcedureMutationVariables>(UpdateProcedureDocument, options);
      }
export type UpdateProcedureMutationHookResult = ReturnType<typeof useUpdateProcedureMutation>;
export type UpdateProcedureMutationResult = Apollo.MutationResult<UpdateProcedureMutation>;
export type UpdateProcedureMutationOptions = Apollo.BaseMutationOptions<UpdateProcedureMutation, UpdateProcedureMutationVariables>;
export const GenerateProcessVisualizationDocument = gql`
    mutation GenerateProcessVisualization($procedureId: ID!, $departmentId: ID!, $procedureStage: ProcedureStage) {
  generateProcessVisualization(
    procedureId: $procedureId
    departmentId: $departmentId
    procedureStage: $procedureStage
  ) {
    status
    message
  }
}
    `;
export type GenerateProcessVisualizationMutationFn = Apollo.MutationFunction<GenerateProcessVisualizationMutation, GenerateProcessVisualizationMutationVariables>;

/**
 * __useGenerateProcessVisualizationMutation__
 *
 * To run a mutation, you first call `useGenerateProcessVisualizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateProcessVisualizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateProcessVisualizationMutation, { data, loading, error }] = useGenerateProcessVisualizationMutation({
 *   variables: {
 *      procedureId: // value for 'procedureId'
 *      departmentId: // value for 'departmentId'
 *      procedureStage: // value for 'procedureStage'
 *   },
 * });
 */
export function useGenerateProcessVisualizationMutation(baseOptions?: Apollo.MutationHookOptions<GenerateProcessVisualizationMutation, GenerateProcessVisualizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateProcessVisualizationMutation, GenerateProcessVisualizationMutationVariables>(GenerateProcessVisualizationDocument, options);
      }
export type GenerateProcessVisualizationMutationHookResult = ReturnType<typeof useGenerateProcessVisualizationMutation>;
export type GenerateProcessVisualizationMutationResult = Apollo.MutationResult<GenerateProcessVisualizationMutation>;
export type GenerateProcessVisualizationMutationOptions = Apollo.BaseMutationOptions<GenerateProcessVisualizationMutation, GenerateProcessVisualizationMutationVariables>;
export const DeleteProcedureDocument = gql`
    mutation DeleteProcedure($input: DeleteProcedureInput!) {
  deleteProcedure(input: $input) {
    id
    knowledgeId
    departmentId
    text
    name
    owner
    language
    public
    bookReference
    email {
      stage
      email
    }
    title
    version
    assignmentPolicy {
      policyType
      collaborator
    }
    stage
    schedules {
      name
      expression
      enabled
    }
    requests {
      limit
      nextToken
    }
  }
}
    `;
export type DeleteProcedureMutationFn = Apollo.MutationFunction<DeleteProcedureMutation, DeleteProcedureMutationVariables>;

/**
 * __useDeleteProcedureMutation__
 *
 * To run a mutation, you first call `useDeleteProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProcedureMutation, { data, loading, error }] = useDeleteProcedureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProcedureMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProcedureMutation, DeleteProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProcedureMutation, DeleteProcedureMutationVariables>(DeleteProcedureDocument, options);
      }
export type DeleteProcedureMutationHookResult = ReturnType<typeof useDeleteProcedureMutation>;
export type DeleteProcedureMutationResult = Apollo.MutationResult<DeleteProcedureMutation>;
export type DeleteProcedureMutationOptions = Apollo.BaseMutationOptions<DeleteProcedureMutation, DeleteProcedureMutationVariables>;
export const UpdateProcedureScheduleDocument = gql`
    mutation UpdateProcedureSchedule($input: UpdateProcedureScheduleInput!) {
  updateProcedureSchedule(input: $input) {
    id
    knowledgeId
    departmentId
    text
    name
    owner
    language
    public
    bookReference
    email {
      stage
      email
    }
    title
    version
    assignmentPolicy {
      policyType
      collaborator
    }
    stage
    schedules {
      name
      expression
      enabled
    }
    requests {
      limit
      nextToken
    }
  }
}
    `;
export type UpdateProcedureScheduleMutationFn = Apollo.MutationFunction<UpdateProcedureScheduleMutation, UpdateProcedureScheduleMutationVariables>;

/**
 * __useUpdateProcedureScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateProcedureScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcedureScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcedureScheduleMutation, { data, loading, error }] = useUpdateProcedureScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProcedureScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcedureScheduleMutation, UpdateProcedureScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcedureScheduleMutation, UpdateProcedureScheduleMutationVariables>(UpdateProcedureScheduleDocument, options);
      }
export type UpdateProcedureScheduleMutationHookResult = ReturnType<typeof useUpdateProcedureScheduleMutation>;
export type UpdateProcedureScheduleMutationResult = Apollo.MutationResult<UpdateProcedureScheduleMutation>;
export type UpdateProcedureScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateProcedureScheduleMutation, UpdateProcedureScheduleMutationVariables>;
export const CreateProcedureV2Document = gql`
    mutation CreateProcedureV2($input: CreateProcedureInput!) {
  createProcedureV2(input: $input) {
    id
    knowledgeId
    departmentId
    text
    name
    owner
    language
    public
    bookReference
    email {
      stage
      email
    }
    title
    version
    assignmentPolicy {
      policyType
      collaborator
    }
    stage
    schedules {
      name
      expression
      enabled
    }
    requests {
      limit
      nextToken
    }
  }
}
    `;
export type CreateProcedureV2MutationFn = Apollo.MutationFunction<CreateProcedureV2Mutation, CreateProcedureV2MutationVariables>;

/**
 * __useCreateProcedureV2Mutation__
 *
 * To run a mutation, you first call `useCreateProcedureV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcedureV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcedureV2Mutation, { data, loading, error }] = useCreateProcedureV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProcedureV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateProcedureV2Mutation, CreateProcedureV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcedureV2Mutation, CreateProcedureV2MutationVariables>(CreateProcedureV2Document, options);
      }
export type CreateProcedureV2MutationHookResult = ReturnType<typeof useCreateProcedureV2Mutation>;
export type CreateProcedureV2MutationResult = Apollo.MutationResult<CreateProcedureV2Mutation>;
export type CreateProcedureV2MutationOptions = Apollo.BaseMutationOptions<CreateProcedureV2Mutation, CreateProcedureV2MutationVariables>;
export const UpdateProcedureV2Document = gql`
    mutation updateProcedureV2($input: UpdateProcedureInput!) {
  updateProcedureV2(input: $input) {
    id
    knowledgeId
    departmentId
    text
    name
    owner
    language
    bookReference
    stage
    schedules {
      name
      expression
      enabled
    }
    email {
      stage
      email
    }
    title
    version
    assignmentPolicy {
      policyType
      collaborator
    }
  }
}
    `;
export type UpdateProcedureV2MutationFn = Apollo.MutationFunction<UpdateProcedureV2Mutation, UpdateProcedureV2MutationVariables>;

/**
 * __useUpdateProcedureV2Mutation__
 *
 * To run a mutation, you first call `useUpdateProcedureV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcedureV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcedureV2Mutation, { data, loading, error }] = useUpdateProcedureV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProcedureV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcedureV2Mutation, UpdateProcedureV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcedureV2Mutation, UpdateProcedureV2MutationVariables>(UpdateProcedureV2Document, options);
      }
export type UpdateProcedureV2MutationHookResult = ReturnType<typeof useUpdateProcedureV2Mutation>;
export type UpdateProcedureV2MutationResult = Apollo.MutationResult<UpdateProcedureV2Mutation>;
export type UpdateProcedureV2MutationOptions = Apollo.BaseMutationOptions<UpdateProcedureV2Mutation, UpdateProcedureV2MutationVariables>;
export const DiscardProcedureDraftDocument = gql`
    mutation discardProcedureDraft($input: DiscardProcedureDraftInput!) {
  discardProcedureDraft(input: $input) {
    id
    departmentVersion
    stage
  }
}
    `;
export type DiscardProcedureDraftMutationFn = Apollo.MutationFunction<DiscardProcedureDraftMutation, DiscardProcedureDraftMutationVariables>;

/**
 * __useDiscardProcedureDraftMutation__
 *
 * To run a mutation, you first call `useDiscardProcedureDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardProcedureDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardProcedureDraftMutation, { data, loading, error }] = useDiscardProcedureDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDiscardProcedureDraftMutation(baseOptions?: Apollo.MutationHookOptions<DiscardProcedureDraftMutation, DiscardProcedureDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscardProcedureDraftMutation, DiscardProcedureDraftMutationVariables>(DiscardProcedureDraftDocument, options);
      }
export type DiscardProcedureDraftMutationHookResult = ReturnType<typeof useDiscardProcedureDraftMutation>;
export type DiscardProcedureDraftMutationResult = Apollo.MutationResult<DiscardProcedureDraftMutation>;
export type DiscardProcedureDraftMutationOptions = Apollo.BaseMutationOptions<DiscardProcedureDraftMutation, DiscardProcedureDraftMutationVariables>;
export const CreateBulkRequestAnswerDocument = gql`
    mutation CreateBulkRequestAnswer($inputs: [CreateRequestAnswerInput!]!) {
  createBulkRequestAnswer(inputs: $inputs) {
    id
    requestId
    questionId
    action {
      _
      ... on ReplaceStepAction {
        newSteps
      }
      ... on RetryStepAction {
        minimumDelay
        timeout
      }
      ... on UseConceptAction {
        conceptId
      }
      ... on UseLiteralValueAction {
        literalValue
        choices
      }
      ... on UseTechniqueAction {
        technique
      }
    }
    createdAt
    createdBy
  }
}
    `;
export type CreateBulkRequestAnswerMutationFn = Apollo.MutationFunction<CreateBulkRequestAnswerMutation, CreateBulkRequestAnswerMutationVariables>;

/**
 * __useCreateBulkRequestAnswerMutation__
 *
 * To run a mutation, you first call `useCreateBulkRequestAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkRequestAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBulkRequestAnswerMutation, { data, loading, error }] = useCreateBulkRequestAnswerMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateBulkRequestAnswerMutation(baseOptions?: Apollo.MutationHookOptions<CreateBulkRequestAnswerMutation, CreateBulkRequestAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBulkRequestAnswerMutation, CreateBulkRequestAnswerMutationVariables>(CreateBulkRequestAnswerDocument, options);
      }
export type CreateBulkRequestAnswerMutationHookResult = ReturnType<typeof useCreateBulkRequestAnswerMutation>;
export type CreateBulkRequestAnswerMutationResult = Apollo.MutationResult<CreateBulkRequestAnswerMutation>;
export type CreateBulkRequestAnswerMutationOptions = Apollo.BaseMutationOptions<CreateBulkRequestAnswerMutation, CreateBulkRequestAnswerMutationVariables>;
export const CreateRequestAnswerDocument = gql`
    mutation CreateRequestAnswer($input: CreateRequestAnswerInput!) {
  createRequestAnswer(input: $input) {
    id
    requestId
    questionId
    action {
      _
      ... on ReplaceStepAction {
        newSteps
      }
      ... on RetryStepAction {
        minimumDelay
        timeout
      }
      ... on UseConceptAction {
        conceptId
      }
      ... on UseLiteralValueAction {
        literalValue
        choices
      }
      ... on UseTechniqueAction {
        technique
      }
    }
    sourceLearning {
      id
      createdAt
      createdBy
      deletedAt
      deletedBy
      procedureId
      procedureName
      contextValue
      contextMetadata
    }
    createdAt
    createdBy
    summary
  }
}
    `;
export type CreateRequestAnswerMutationFn = Apollo.MutationFunction<CreateRequestAnswerMutation, CreateRequestAnswerMutationVariables>;

/**
 * __useCreateRequestAnswerMutation__
 *
 * To run a mutation, you first call `useCreateRequestAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRequestAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRequestAnswerMutation, { data, loading, error }] = useCreateRequestAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRequestAnswerMutation(baseOptions?: Apollo.MutationHookOptions<CreateRequestAnswerMutation, CreateRequestAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRequestAnswerMutation, CreateRequestAnswerMutationVariables>(CreateRequestAnswerDocument, options);
      }
export type CreateRequestAnswerMutationHookResult = ReturnType<typeof useCreateRequestAnswerMutation>;
export type CreateRequestAnswerMutationResult = Apollo.MutationResult<CreateRequestAnswerMutation>;
export type CreateRequestAnswerMutationOptions = Apollo.BaseMutationOptions<CreateRequestAnswerMutation, CreateRequestAnswerMutationVariables>;
export const UpdateLearnedAnswerDocument = gql`
    mutation UpdateLearnedAnswer($input: UpdateLearnedAnswerInput!) {
  updateLearnedAnswer(input: $input) {
    id
    questionFilter {
      stepPath
      questionType
      lexicalPath
    }
    stage
    action {
      _
      ... on ReplaceStepAction {
        newSteps
      }
      ... on RetryStepAction {
        minimumDelay
        timeout
      }
      ... on UseConceptAction {
        conceptId
      }
      ... on UseLiteralValueAction {
        literalValue
        choices
      }
      ... on UseOauth2Action {
        accessToken
        refreshToken
      }
      ... on UseTechniqueAction {
        technique
      }
    }
    originalAnswerId
    createdAt
    createdBy
    deletedAt
    deletedBy
    procedureId
    procedureName
    procedure {
      id
      name
      stage
    }
    contextValue
    contextMetadata
  }
}
    `;
export type UpdateLearnedAnswerMutationFn = Apollo.MutationFunction<UpdateLearnedAnswerMutation, UpdateLearnedAnswerMutationVariables>;

/**
 * __useUpdateLearnedAnswerMutation__
 *
 * To run a mutation, you first call `useUpdateLearnedAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearnedAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearnedAnswerMutation, { data, loading, error }] = useUpdateLearnedAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLearnedAnswerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLearnedAnswerMutation, UpdateLearnedAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLearnedAnswerMutation, UpdateLearnedAnswerMutationVariables>(UpdateLearnedAnswerDocument, options);
      }
export type UpdateLearnedAnswerMutationHookResult = ReturnType<typeof useUpdateLearnedAnswerMutation>;
export type UpdateLearnedAnswerMutationResult = Apollo.MutationResult<UpdateLearnedAnswerMutation>;
export type UpdateLearnedAnswerMutationOptions = Apollo.BaseMutationOptions<UpdateLearnedAnswerMutation, UpdateLearnedAnswerMutationVariables>;
export const SetUserPreferencesDocument = gql`
    mutation setUserPreferences($input: UserPreferencesInput!) {
  setUserPreferences(input: $input) {
    lastUsedDepartmentId
  }
}
    `;
export type SetUserPreferencesMutationFn = Apollo.MutationFunction<SetUserPreferencesMutation, SetUserPreferencesMutationVariables>;

/**
 * __useSetUserPreferencesMutation__
 *
 * To run a mutation, you first call `useSetUserPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserPreferencesMutation, { data, loading, error }] = useSetUserPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetUserPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<SetUserPreferencesMutation, SetUserPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserPreferencesMutation, SetUserPreferencesMutationVariables>(SetUserPreferencesDocument, options);
      }
export type SetUserPreferencesMutationHookResult = ReturnType<typeof useSetUserPreferencesMutation>;
export type SetUserPreferencesMutationResult = Apollo.MutationResult<SetUserPreferencesMutation>;
export type SetUserPreferencesMutationOptions = Apollo.BaseMutationOptions<SetUserPreferencesMutation, SetUserPreferencesMutationVariables>;
export const ListWorkersDataByDepartmentsDocument = gql`
    query ListWorkersDataByDepartments($departmentIds: [ID!]!, $limit: Int, $nextToken: String, $filter: ListWorkersDataFilter) {
  listWorkersDataByDepartments(
    departmentIds: $departmentIds
    limit: $limit
    filter: $filter
    nextToken: $nextToken
  ) {
    nextToken
    workersData {
      ...WorkerDataPartsFragment
    }
  }
}
    ${WorkerDataPartsFragmentFragmentDoc}`;

/**
 * __useListWorkersDataByDepartmentsQuery__
 *
 * To run a query within a React component, call `useListWorkersDataByDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkersDataByDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWorkersDataByDepartmentsQuery({
 *   variables: {
 *      departmentIds: // value for 'departmentIds'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListWorkersDataByDepartmentsQuery(baseOptions: Apollo.QueryHookOptions<ListWorkersDataByDepartmentsQuery, ListWorkersDataByDepartmentsQueryVariables> & ({ variables: ListWorkersDataByDepartmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWorkersDataByDepartmentsQuery, ListWorkersDataByDepartmentsQueryVariables>(ListWorkersDataByDepartmentsDocument, options);
      }
export function useListWorkersDataByDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWorkersDataByDepartmentsQuery, ListWorkersDataByDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWorkersDataByDepartmentsQuery, ListWorkersDataByDepartmentsQueryVariables>(ListWorkersDataByDepartmentsDocument, options);
        }
export function useListWorkersDataByDepartmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListWorkersDataByDepartmentsQuery, ListWorkersDataByDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWorkersDataByDepartmentsQuery, ListWorkersDataByDepartmentsQueryVariables>(ListWorkersDataByDepartmentsDocument, options);
        }
export type ListWorkersDataByDepartmentsQueryHookResult = ReturnType<typeof useListWorkersDataByDepartmentsQuery>;
export type ListWorkersDataByDepartmentsLazyQueryHookResult = ReturnType<typeof useListWorkersDataByDepartmentsLazyQuery>;
export type ListWorkersDataByDepartmentsSuspenseQueryHookResult = ReturnType<typeof useListWorkersDataByDepartmentsSuspenseQuery>;
export type ListWorkersDataByDepartmentsQueryResult = Apollo.QueryResult<ListWorkersDataByDepartmentsQuery, ListWorkersDataByDepartmentsQueryVariables>;
export const GetInternalAdminConsoleDocument = gql`
    query GetInternalAdminConsole($filter: InternalAdminDepartmentFilter) {
  getInternalAdminConsole {
    appBuildString
    appBuildJobUrl
    departments(filter: $filter) {
      departments {
        ...InternalAdminDepartmentInfoFragment
      }
    }
  }
}
    ${InternalAdminDepartmentInfoFragmentFragmentDoc}`;

/**
 * __useGetInternalAdminConsoleQuery__
 *
 * To run a query within a React component, call `useGetInternalAdminConsoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInternalAdminConsoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInternalAdminConsoleQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetInternalAdminConsoleQuery(baseOptions?: Apollo.QueryHookOptions<GetInternalAdminConsoleQuery, GetInternalAdminConsoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInternalAdminConsoleQuery, GetInternalAdminConsoleQueryVariables>(GetInternalAdminConsoleDocument, options);
      }
export function useGetInternalAdminConsoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInternalAdminConsoleQuery, GetInternalAdminConsoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInternalAdminConsoleQuery, GetInternalAdminConsoleQueryVariables>(GetInternalAdminConsoleDocument, options);
        }
export function useGetInternalAdminConsoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInternalAdminConsoleQuery, GetInternalAdminConsoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInternalAdminConsoleQuery, GetInternalAdminConsoleQueryVariables>(GetInternalAdminConsoleDocument, options);
        }
export type GetInternalAdminConsoleQueryHookResult = ReturnType<typeof useGetInternalAdminConsoleQuery>;
export type GetInternalAdminConsoleLazyQueryHookResult = ReturnType<typeof useGetInternalAdminConsoleLazyQuery>;
export type GetInternalAdminConsoleSuspenseQueryHookResult = ReturnType<typeof useGetInternalAdminConsoleSuspenseQuery>;
export type GetInternalAdminConsoleQueryResult = Apollo.QueryResult<GetInternalAdminConsoleQuery, GetInternalAdminConsoleQueryVariables>;
export const ListIntegrationsByDepartmentDocument = gql`
    query ListIntegrationsByDepartment($departmentId: ID!, $version: String, $limit: Int, $nextToken: String) {
  listIntegrationsByDepartment(
    departmentId: $departmentId
    version: $version
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      url
      name
      author
      description
      integratedAt
      version
      credentialMetadata {
        isCredentialProvided
        redirectionFlowRequired
        isRedirectionFlowDone
      }
    }
    nextToken
  }
}
    `;

/**
 * __useListIntegrationsByDepartmentQuery__
 *
 * To run a query within a React component, call `useListIntegrationsByDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useListIntegrationsByDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListIntegrationsByDepartmentQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      version: // value for 'version'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useListIntegrationsByDepartmentQuery(baseOptions: Apollo.QueryHookOptions<ListIntegrationsByDepartmentQuery, ListIntegrationsByDepartmentQueryVariables> & ({ variables: ListIntegrationsByDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListIntegrationsByDepartmentQuery, ListIntegrationsByDepartmentQueryVariables>(ListIntegrationsByDepartmentDocument, options);
      }
export function useListIntegrationsByDepartmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListIntegrationsByDepartmentQuery, ListIntegrationsByDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListIntegrationsByDepartmentQuery, ListIntegrationsByDepartmentQueryVariables>(ListIntegrationsByDepartmentDocument, options);
        }
export function useListIntegrationsByDepartmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListIntegrationsByDepartmentQuery, ListIntegrationsByDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListIntegrationsByDepartmentQuery, ListIntegrationsByDepartmentQueryVariables>(ListIntegrationsByDepartmentDocument, options);
        }
export type ListIntegrationsByDepartmentQueryHookResult = ReturnType<typeof useListIntegrationsByDepartmentQuery>;
export type ListIntegrationsByDepartmentLazyQueryHookResult = ReturnType<typeof useListIntegrationsByDepartmentLazyQuery>;
export type ListIntegrationsByDepartmentSuspenseQueryHookResult = ReturnType<typeof useListIntegrationsByDepartmentSuspenseQuery>;
export type ListIntegrationsByDepartmentQueryResult = Apollo.QueryResult<ListIntegrationsByDepartmentQuery, ListIntegrationsByDepartmentQueryVariables>;
export const GetIntegrationCredentialFormDocument = gql`
    query GetIntegrationCredentialForm($integrationId: ID!, $departmentId: ID!) {
  getIntegrationCredentialForm(
    integrationId: $integrationId
    departmentId: $departmentId
  ) {
    integrationId
    fields {
      label
      key
      type
      description
      example
    }
  }
}
    `;

/**
 * __useGetIntegrationCredentialFormQuery__
 *
 * To run a query within a React component, call `useGetIntegrationCredentialFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationCredentialFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationCredentialFormQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useGetIntegrationCredentialFormQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationCredentialFormQuery, GetIntegrationCredentialFormQueryVariables> & ({ variables: GetIntegrationCredentialFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationCredentialFormQuery, GetIntegrationCredentialFormQueryVariables>(GetIntegrationCredentialFormDocument, options);
      }
export function useGetIntegrationCredentialFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationCredentialFormQuery, GetIntegrationCredentialFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationCredentialFormQuery, GetIntegrationCredentialFormQueryVariables>(GetIntegrationCredentialFormDocument, options);
        }
export function useGetIntegrationCredentialFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntegrationCredentialFormQuery, GetIntegrationCredentialFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntegrationCredentialFormQuery, GetIntegrationCredentialFormQueryVariables>(GetIntegrationCredentialFormDocument, options);
        }
export type GetIntegrationCredentialFormQueryHookResult = ReturnType<typeof useGetIntegrationCredentialFormQuery>;
export type GetIntegrationCredentialFormLazyQueryHookResult = ReturnType<typeof useGetIntegrationCredentialFormLazyQuery>;
export type GetIntegrationCredentialFormSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationCredentialFormSuspenseQuery>;
export type GetIntegrationCredentialFormQueryResult = Apollo.QueryResult<GetIntegrationCredentialFormQuery, GetIntegrationCredentialFormQueryVariables>;
export const RevealIntegrationCredentialDocument = gql`
    query RevealIntegrationCredential($integrationId: ID!, $departmentId: ID!) {
  revealIntegrationCredential(
    integrationId: $integrationId
    departmentId: $departmentId
  ) {
    integrationId
    departmentId
    data {
      label
      key
      value
    }
  }
}
    `;

/**
 * __useRevealIntegrationCredentialQuery__
 *
 * To run a query within a React component, call `useRevealIntegrationCredentialQuery` and pass it any options that fit your needs.
 * When your component renders, `useRevealIntegrationCredentialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRevealIntegrationCredentialQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useRevealIntegrationCredentialQuery(baseOptions: Apollo.QueryHookOptions<RevealIntegrationCredentialQuery, RevealIntegrationCredentialQueryVariables> & ({ variables: RevealIntegrationCredentialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RevealIntegrationCredentialQuery, RevealIntegrationCredentialQueryVariables>(RevealIntegrationCredentialDocument, options);
      }
export function useRevealIntegrationCredentialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RevealIntegrationCredentialQuery, RevealIntegrationCredentialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RevealIntegrationCredentialQuery, RevealIntegrationCredentialQueryVariables>(RevealIntegrationCredentialDocument, options);
        }
export function useRevealIntegrationCredentialSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RevealIntegrationCredentialQuery, RevealIntegrationCredentialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RevealIntegrationCredentialQuery, RevealIntegrationCredentialQueryVariables>(RevealIntegrationCredentialDocument, options);
        }
export type RevealIntegrationCredentialQueryHookResult = ReturnType<typeof useRevealIntegrationCredentialQuery>;
export type RevealIntegrationCredentialLazyQueryHookResult = ReturnType<typeof useRevealIntegrationCredentialLazyQuery>;
export type RevealIntegrationCredentialSuspenseQueryHookResult = ReturnType<typeof useRevealIntegrationCredentialSuspenseQuery>;
export type RevealIntegrationCredentialQueryResult = Apollo.QueryResult<RevealIntegrationCredentialQuery, RevealIntegrationCredentialQueryVariables>;
export const RevealIntegrationCredentialsDocument = gql`
    query RevealIntegrationCredentials($integrationId: ID!, $departmentId: ID!) {
  revealIntegrationCredentials(
    integrationId: $integrationId
    departmentId: $departmentId
  ) {
    integrationId
    departmentId
    name
    data {
      label
      key
      value
    }
  }
}
    `;

/**
 * __useRevealIntegrationCredentialsQuery__
 *
 * To run a query within a React component, call `useRevealIntegrationCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRevealIntegrationCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRevealIntegrationCredentialsQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useRevealIntegrationCredentialsQuery(baseOptions: Apollo.QueryHookOptions<RevealIntegrationCredentialsQuery, RevealIntegrationCredentialsQueryVariables> & ({ variables: RevealIntegrationCredentialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RevealIntegrationCredentialsQuery, RevealIntegrationCredentialsQueryVariables>(RevealIntegrationCredentialsDocument, options);
      }
export function useRevealIntegrationCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RevealIntegrationCredentialsQuery, RevealIntegrationCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RevealIntegrationCredentialsQuery, RevealIntegrationCredentialsQueryVariables>(RevealIntegrationCredentialsDocument, options);
        }
export function useRevealIntegrationCredentialsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RevealIntegrationCredentialsQuery, RevealIntegrationCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RevealIntegrationCredentialsQuery, RevealIntegrationCredentialsQueryVariables>(RevealIntegrationCredentialsDocument, options);
        }
export type RevealIntegrationCredentialsQueryHookResult = ReturnType<typeof useRevealIntegrationCredentialsQuery>;
export type RevealIntegrationCredentialsLazyQueryHookResult = ReturnType<typeof useRevealIntegrationCredentialsLazyQuery>;
export type RevealIntegrationCredentialsSuspenseQueryHookResult = ReturnType<typeof useRevealIntegrationCredentialsSuspenseQuery>;
export type RevealIntegrationCredentialsQueryResult = Apollo.QueryResult<RevealIntegrationCredentialsQuery, RevealIntegrationCredentialsQueryVariables>;
export const QuestionsMetricsByDepartmentDocument = gql`
    query QuestionsMetricsByDepartment($departmentId: ID!, $language: String, $duration: Int = 24, $limit: Int = 1000, $nextToken: String, $requestsMetrics: Boolean) {
  questionsMetricsByDepartment(
    departmentId: $departmentId
    language: $language
    duration: $duration
    limit: $limit
    nextToken: $nextToken
    requestsMetrics: $requestsMetrics
  ) {
    procedureId
    procedureName
    totalRuns
    procedureTitle
    unhandledRequests
    handledRequests
    totalRequests
    knowledgeId
    departmentId
  }
}
    `;

/**
 * __useQuestionsMetricsByDepartmentQuery__
 *
 * To run a query within a React component, call `useQuestionsMetricsByDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionsMetricsByDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionsMetricsByDepartmentQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      language: // value for 'language'
 *      duration: // value for 'duration'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *      requestsMetrics: // value for 'requestsMetrics'
 *   },
 * });
 */
export function useQuestionsMetricsByDepartmentQuery(baseOptions: Apollo.QueryHookOptions<QuestionsMetricsByDepartmentQuery, QuestionsMetricsByDepartmentQueryVariables> & ({ variables: QuestionsMetricsByDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionsMetricsByDepartmentQuery, QuestionsMetricsByDepartmentQueryVariables>(QuestionsMetricsByDepartmentDocument, options);
      }
export function useQuestionsMetricsByDepartmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionsMetricsByDepartmentQuery, QuestionsMetricsByDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionsMetricsByDepartmentQuery, QuestionsMetricsByDepartmentQueryVariables>(QuestionsMetricsByDepartmentDocument, options);
        }
export function useQuestionsMetricsByDepartmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QuestionsMetricsByDepartmentQuery, QuestionsMetricsByDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionsMetricsByDepartmentQuery, QuestionsMetricsByDepartmentQueryVariables>(QuestionsMetricsByDepartmentDocument, options);
        }
export type QuestionsMetricsByDepartmentQueryHookResult = ReturnType<typeof useQuestionsMetricsByDepartmentQuery>;
export type QuestionsMetricsByDepartmentLazyQueryHookResult = ReturnType<typeof useQuestionsMetricsByDepartmentLazyQuery>;
export type QuestionsMetricsByDepartmentSuspenseQueryHookResult = ReturnType<typeof useQuestionsMetricsByDepartmentSuspenseQuery>;
export type QuestionsMetricsByDepartmentQueryResult = Apollo.QueryResult<QuestionsMetricsByDepartmentQuery, QuestionsMetricsByDepartmentQueryVariables>;
export const ListDepartmentsDocument = gql`
    query ListDepartments($limit: Int = 1000, $nextToken: String, $deptFilter: ListDepartmentsFilter) {
  listDepartments(limit: $limit, nextToken: $nextToken, deptFilter: $deptFilter) {
    items {
      id
      owner
      organizationId
      name
      draftKnowledgeId
      publishedKnowledgeId
      workerId
      local
      state
      errors
      createdAt
      isDeleted
      brainVersion
      features
      organization {
        id
        name
        createdAt
        owner
        updatedAt
      }
      draftKnowledge {
        departmentId
        id
        brainVersion
      }
    }
    nextToken
  }
}
    `;

/**
 * __useListDepartmentsQuery__
 *
 * To run a query within a React component, call `useListDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDepartmentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *      deptFilter: // value for 'deptFilter'
 *   },
 * });
 */
export function useListDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<ListDepartmentsQuery, ListDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDepartmentsQuery, ListDepartmentsQueryVariables>(ListDepartmentsDocument, options);
      }
export function useListDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDepartmentsQuery, ListDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDepartmentsQuery, ListDepartmentsQueryVariables>(ListDepartmentsDocument, options);
        }
export function useListDepartmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListDepartmentsQuery, ListDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDepartmentsQuery, ListDepartmentsQueryVariables>(ListDepartmentsDocument, options);
        }
export type ListDepartmentsQueryHookResult = ReturnType<typeof useListDepartmentsQuery>;
export type ListDepartmentsLazyQueryHookResult = ReturnType<typeof useListDepartmentsLazyQuery>;
export type ListDepartmentsSuspenseQueryHookResult = ReturnType<typeof useListDepartmentsSuspenseQuery>;
export type ListDepartmentsQueryResult = Apollo.QueryResult<ListDepartmentsQuery, ListDepartmentsQueryVariables>;
export const ListAllDepartmentsDocument = gql`
    query ListAllDepartments($limit: Int = 1000, $nextToken: String) {
  listAllDepartments(limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      name
      local
      createdAt
      brainVersion
      features
      organization {
        id
        name
      }
    }
    nextToken
  }
}
    `;

/**
 * __useListAllDepartmentsQuery__
 *
 * To run a query within a React component, call `useListAllDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllDepartmentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useListAllDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<ListAllDepartmentsQuery, ListAllDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAllDepartmentsQuery, ListAllDepartmentsQueryVariables>(ListAllDepartmentsDocument, options);
      }
export function useListAllDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAllDepartmentsQuery, ListAllDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAllDepartmentsQuery, ListAllDepartmentsQueryVariables>(ListAllDepartmentsDocument, options);
        }
export function useListAllDepartmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAllDepartmentsQuery, ListAllDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAllDepartmentsQuery, ListAllDepartmentsQueryVariables>(ListAllDepartmentsDocument, options);
        }
export type ListAllDepartmentsQueryHookResult = ReturnType<typeof useListAllDepartmentsQuery>;
export type ListAllDepartmentsLazyQueryHookResult = ReturnType<typeof useListAllDepartmentsLazyQuery>;
export type ListAllDepartmentsSuspenseQueryHookResult = ReturnType<typeof useListAllDepartmentsSuspenseQuery>;
export type ListAllDepartmentsQueryResult = Apollo.QueryResult<ListAllDepartmentsQuery, ListAllDepartmentsQueryVariables>;
export const GetDepartmentDocument = gql`
    query GetDepartment($id: ID!) {
  getDepartment(id: $id) {
    id
    owner
    organizationId
    name
    draftKnowledgeId
    publishedKnowledgeId
    workerId
    local
    state
    errors
    createdAt
    isDeleted
    brainVersion
    features
    organization {
      id
      name
    }
    draftKnowledge {
      id
      brainVersion
    }
  }
}
    `;

/**
 * __useGetDepartmentQuery__
 *
 * To run a query within a React component, call `useGetDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDepartmentQuery(baseOptions: Apollo.QueryHookOptions<GetDepartmentQuery, GetDepartmentQueryVariables> & ({ variables: GetDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDepartmentQuery, GetDepartmentQueryVariables>(GetDepartmentDocument, options);
      }
export function useGetDepartmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDepartmentQuery, GetDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDepartmentQuery, GetDepartmentQueryVariables>(GetDepartmentDocument, options);
        }
export function useGetDepartmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDepartmentQuery, GetDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDepartmentQuery, GetDepartmentQueryVariables>(GetDepartmentDocument, options);
        }
export type GetDepartmentQueryHookResult = ReturnType<typeof useGetDepartmentQuery>;
export type GetDepartmentLazyQueryHookResult = ReturnType<typeof useGetDepartmentLazyQuery>;
export type GetDepartmentSuspenseQueryHookResult = ReturnType<typeof useGetDepartmentSuspenseQuery>;
export type GetDepartmentQueryResult = Apollo.QueryResult<GetDepartmentQuery, GetDepartmentQueryVariables>;
export const ListDepartmentCollaboratorsDocument = gql`
    query ListDepartmentCollaborators($departmentId: String!, $role: AccessControlRole, $limit: Int = 1000, $nextToken: String) {
  listDepartmentCollaborators(
    departmentId: $departmentId
    role: $role
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      role
    }
    nextToken
  }
}
    `;

/**
 * __useListDepartmentCollaboratorsQuery__
 *
 * To run a query within a React component, call `useListDepartmentCollaboratorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDepartmentCollaboratorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDepartmentCollaboratorsQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      role: // value for 'role'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useListDepartmentCollaboratorsQuery(baseOptions: Apollo.QueryHookOptions<ListDepartmentCollaboratorsQuery, ListDepartmentCollaboratorsQueryVariables> & ({ variables: ListDepartmentCollaboratorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDepartmentCollaboratorsQuery, ListDepartmentCollaboratorsQueryVariables>(ListDepartmentCollaboratorsDocument, options);
      }
export function useListDepartmentCollaboratorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDepartmentCollaboratorsQuery, ListDepartmentCollaboratorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDepartmentCollaboratorsQuery, ListDepartmentCollaboratorsQueryVariables>(ListDepartmentCollaboratorsDocument, options);
        }
export function useListDepartmentCollaboratorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListDepartmentCollaboratorsQuery, ListDepartmentCollaboratorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDepartmentCollaboratorsQuery, ListDepartmentCollaboratorsQueryVariables>(ListDepartmentCollaboratorsDocument, options);
        }
export type ListDepartmentCollaboratorsQueryHookResult = ReturnType<typeof useListDepartmentCollaboratorsQuery>;
export type ListDepartmentCollaboratorsLazyQueryHookResult = ReturnType<typeof useListDepartmentCollaboratorsLazyQuery>;
export type ListDepartmentCollaboratorsSuspenseQueryHookResult = ReturnType<typeof useListDepartmentCollaboratorsSuspenseQuery>;
export type ListDepartmentCollaboratorsQueryResult = Apollo.QueryResult<ListDepartmentCollaboratorsQuery, ListDepartmentCollaboratorsQueryVariables>;
export const GetDepartmentHistoryDocument = gql`
    query GetDepartmentHistory($departmentId: ID!, $entityName: DepartmentBookEntity, $entityIDs: [String!], $start: String, $end: String, $limit: Int = 10, $nextToken: String) {
  getDepartmentHistory(
    departmentId: $departmentId
    entityName: $entityName
    entityIDs: $entityIDs
    start: $start
    end: $end
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      entityId
      user
      operation
      entityName
      timestamp
      name
      rollbackVersion
      publishedVersion
    }
    nextToken
  }
}
    `;

/**
 * __useGetDepartmentHistoryQuery__
 *
 * To run a query within a React component, call `useGetDepartmentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartmentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartmentHistoryQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      entityName: // value for 'entityName'
 *      entityIDs: // value for 'entityIDs'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetDepartmentHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetDepartmentHistoryQuery, GetDepartmentHistoryQueryVariables> & ({ variables: GetDepartmentHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDepartmentHistoryQuery, GetDepartmentHistoryQueryVariables>(GetDepartmentHistoryDocument, options);
      }
export function useGetDepartmentHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDepartmentHistoryQuery, GetDepartmentHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDepartmentHistoryQuery, GetDepartmentHistoryQueryVariables>(GetDepartmentHistoryDocument, options);
        }
export function useGetDepartmentHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDepartmentHistoryQuery, GetDepartmentHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDepartmentHistoryQuery, GetDepartmentHistoryQueryVariables>(GetDepartmentHistoryDocument, options);
        }
export type GetDepartmentHistoryQueryHookResult = ReturnType<typeof useGetDepartmentHistoryQuery>;
export type GetDepartmentHistoryLazyQueryHookResult = ReturnType<typeof useGetDepartmentHistoryLazyQuery>;
export type GetDepartmentHistorySuspenseQueryHookResult = ReturnType<typeof useGetDepartmentHistorySuspenseQuery>;
export type GetDepartmentHistoryQueryResult = Apollo.QueryResult<GetDepartmentHistoryQuery, GetDepartmentHistoryQueryVariables>;
export const ExportDepartmentDocument = gql`
    query ExportDepartment($departmentId: ID!, $version: String) {
  exportDepartment(departmentId: $departmentId, version: $version) {
    formatVersion
    departmentID
    departmentVersion
    checksum
    features
    procedures {
      id
      name
      text
      language
    }
    facts {
      name
      values
    }
    learnedBooks {
      ids
    }
    learnings {
      id
      stage
      questionType
      stepPath
      lexicalPath
      procedureId
      action
      literalValue
      choices
      conceptId
      technique
      retryTimeout
      retryMinimumDelay
      newSteps
      oauth2Metadata
    }
    contextualLearningInfo {
      procedureId
      learningId
      questionType
      stepPath
      lexicalPath
      contextValue
      contextVector
      contextMetadata
    }
  }
}
    `;

/**
 * __useExportDepartmentQuery__
 *
 * To run a query within a React component, call `useExportDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportDepartmentQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useExportDepartmentQuery(baseOptions: Apollo.QueryHookOptions<ExportDepartmentQuery, ExportDepartmentQueryVariables> & ({ variables: ExportDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportDepartmentQuery, ExportDepartmentQueryVariables>(ExportDepartmentDocument, options);
      }
export function useExportDepartmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportDepartmentQuery, ExportDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportDepartmentQuery, ExportDepartmentQueryVariables>(ExportDepartmentDocument, options);
        }
export function useExportDepartmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportDepartmentQuery, ExportDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportDepartmentQuery, ExportDepartmentQueryVariables>(ExportDepartmentDocument, options);
        }
export type ExportDepartmentQueryHookResult = ReturnType<typeof useExportDepartmentQuery>;
export type ExportDepartmentLazyQueryHookResult = ReturnType<typeof useExportDepartmentLazyQuery>;
export type ExportDepartmentSuspenseQueryHookResult = ReturnType<typeof useExportDepartmentSuspenseQuery>;
export type ExportDepartmentQueryResult = Apollo.QueryResult<ExportDepartmentQuery, ExportDepartmentQueryVariables>;
export const GetRequestQuestionDocument = gql`
    query GetRequestQuestion($id: ID!) {
  getRequestQuestion(id: $id) {
    id
    text
    contextId
    sentenceId
    answerTypeHint
    failedAnswerId
    failedAnswerReason
    summary
    request {
      id
      createdAt
      state
      procedureId
      procedureName
      assignee
    }
    ... on NativeCodeErrorQuestion {
      errorType
      errorMessage
      errorTraceback
    }
    ... on ParseErrorQuestion {
      errorTraceback
    }
    ... on ReviewConceptQuestion {
      lexicalPath
      conceptId
    }
    ... on ValueNotKnownQuestion {
      lexicalPath
      choices
      helpText
      isPlural
    }
  }
}
    `;

/**
 * __useGetRequestQuestionQuery__
 *
 * To run a query within a React component, call `useGetRequestQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestQuestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRequestQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetRequestQuestionQuery, GetRequestQuestionQueryVariables> & ({ variables: GetRequestQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestQuestionQuery, GetRequestQuestionQueryVariables>(GetRequestQuestionDocument, options);
      }
export function useGetRequestQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestQuestionQuery, GetRequestQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestQuestionQuery, GetRequestQuestionQueryVariables>(GetRequestQuestionDocument, options);
        }
export function useGetRequestQuestionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequestQuestionQuery, GetRequestQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequestQuestionQuery, GetRequestQuestionQueryVariables>(GetRequestQuestionDocument, options);
        }
export type GetRequestQuestionQueryHookResult = ReturnType<typeof useGetRequestQuestionQuery>;
export type GetRequestQuestionLazyQueryHookResult = ReturnType<typeof useGetRequestQuestionLazyQuery>;
export type GetRequestQuestionSuspenseQueryHookResult = ReturnType<typeof useGetRequestQuestionSuspenseQuery>;
export type GetRequestQuestionQueryResult = Apollo.QueryResult<GetRequestQuestionQuery, GetRequestQuestionQueryVariables>;
export const ListQuestionsByDepartmentDocument = gql`
    query ListQuestionsByDepartment($input: ListQuestionsByDepartmentInput!) {
  listQuestionsByDepartment(input: $input) {
    items {
      id
      text
      contextId
      sentenceId
      answerTypeHint
      failedAnswerId
      failedAnswerReason
      summary
      request {
        id
        createdAt
        state
        procedureId
        procedureName
        assignee
        worker {
          id
        }
      }
      ... on NativeCodeErrorQuestion {
        errorType
        errorMessage
        errorTraceback
      }
      ... on ParseErrorQuestion {
        errorTraceback
      }
      ... on ReviewConceptQuestion {
        lexicalPath
        conceptId
      }
      ... on ValueNotKnownQuestion {
        lexicalPath
        choices
        helpText
        isPlural
      }
    }
    total
    valueCounts {
      states {
        value
        count
      }
      procedures {
        value
        count
      }
    }
  }
}
    `;

/**
 * __useListQuestionsByDepartmentQuery__
 *
 * To run a query within a React component, call `useListQuestionsByDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useListQuestionsByDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListQuestionsByDepartmentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListQuestionsByDepartmentQuery(baseOptions: Apollo.QueryHookOptions<ListQuestionsByDepartmentQuery, ListQuestionsByDepartmentQueryVariables> & ({ variables: ListQuestionsByDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListQuestionsByDepartmentQuery, ListQuestionsByDepartmentQueryVariables>(ListQuestionsByDepartmentDocument, options);
      }
export function useListQuestionsByDepartmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListQuestionsByDepartmentQuery, ListQuestionsByDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListQuestionsByDepartmentQuery, ListQuestionsByDepartmentQueryVariables>(ListQuestionsByDepartmentDocument, options);
        }
export function useListQuestionsByDepartmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListQuestionsByDepartmentQuery, ListQuestionsByDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListQuestionsByDepartmentQuery, ListQuestionsByDepartmentQueryVariables>(ListQuestionsByDepartmentDocument, options);
        }
export type ListQuestionsByDepartmentQueryHookResult = ReturnType<typeof useListQuestionsByDepartmentQuery>;
export type ListQuestionsByDepartmentLazyQueryHookResult = ReturnType<typeof useListQuestionsByDepartmentLazyQuery>;
export type ListQuestionsByDepartmentSuspenseQueryHookResult = ReturnType<typeof useListQuestionsByDepartmentSuspenseQuery>;
export type ListQuestionsByDepartmentQueryResult = Apollo.QueryResult<ListQuestionsByDepartmentQuery, ListQuestionsByDepartmentQueryVariables>;
export const GetExceptionsStatusCountsDocument = gql`
    query getExceptionsStatusCounts($input: ListQuestionsByDepartmentInput!) {
  listQuestionsByDepartment(input: $input) {
    valueCounts {
      states {
        value
        count
      }
    }
  }
}
    `;

/**
 * __useGetExceptionsStatusCountsQuery__
 *
 * To run a query within a React component, call `useGetExceptionsStatusCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExceptionsStatusCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExceptionsStatusCountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetExceptionsStatusCountsQuery(baseOptions: Apollo.QueryHookOptions<GetExceptionsStatusCountsQuery, GetExceptionsStatusCountsQueryVariables> & ({ variables: GetExceptionsStatusCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExceptionsStatusCountsQuery, GetExceptionsStatusCountsQueryVariables>(GetExceptionsStatusCountsDocument, options);
      }
export function useGetExceptionsStatusCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExceptionsStatusCountsQuery, GetExceptionsStatusCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExceptionsStatusCountsQuery, GetExceptionsStatusCountsQueryVariables>(GetExceptionsStatusCountsDocument, options);
        }
export function useGetExceptionsStatusCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExceptionsStatusCountsQuery, GetExceptionsStatusCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExceptionsStatusCountsQuery, GetExceptionsStatusCountsQueryVariables>(GetExceptionsStatusCountsDocument, options);
        }
export type GetExceptionsStatusCountsQueryHookResult = ReturnType<typeof useGetExceptionsStatusCountsQuery>;
export type GetExceptionsStatusCountsLazyQueryHookResult = ReturnType<typeof useGetExceptionsStatusCountsLazyQuery>;
export type GetExceptionsStatusCountsSuspenseQueryHookResult = ReturnType<typeof useGetExceptionsStatusCountsSuspenseQuery>;
export type GetExceptionsStatusCountsQueryResult = Apollo.QueryResult<GetExceptionsStatusCountsQuery, GetExceptionsStatusCountsQueryVariables>;
export const GetExceptionRequestDocument = gql`
    query GetExceptionRequest($id: ID!) {
  getRequest(id: $id) {
    id
    stepPath
    contextId
    sentenceId
    createdAt
    handledAt
    state
    procedureId
    worker {
      id
      owner
      readers
      editors
      name
      description
      version
      departmentVersion
      knowledgeId
      departmentId
      procedureId
      entryCommand
      entryCommandId
      originalWorkerId
      createdAt
      state
      stateLastUpdatedAt
      attachments
      isArchived
      features
    }
    uiConcepts
    questions {
      id
      text
      summary
      contextId
      sentenceId
      answerTypeHint
      ... on NativeCodeErrorQuestion {
        errorType
        errorMessage
        errorTraceback
      }
      ... on ReviewConceptQuestion {
        lexicalPath
        conceptId
      }
      ... on ValueNotKnownQuestion {
        lexicalPath
        choices
        helpText
        isPlural
      }
    }
    answers {
      id
      requestId
      questionId
    }
    suggestedAnswers {
      id
      requestId
      questionId
      action {
        ... on ReplaceStepAction {
          _
          newSteps
        }
      }
    }
    contextPath {
      ctxId
      sentenceId
    }
  }
}
    `;

/**
 * __useGetExceptionRequestQuery__
 *
 * To run a query within a React component, call `useGetExceptionRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExceptionRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExceptionRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExceptionRequestQuery(baseOptions: Apollo.QueryHookOptions<GetExceptionRequestQuery, GetExceptionRequestQueryVariables> & ({ variables: GetExceptionRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExceptionRequestQuery, GetExceptionRequestQueryVariables>(GetExceptionRequestDocument, options);
      }
export function useGetExceptionRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExceptionRequestQuery, GetExceptionRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExceptionRequestQuery, GetExceptionRequestQueryVariables>(GetExceptionRequestDocument, options);
        }
export function useGetExceptionRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExceptionRequestQuery, GetExceptionRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExceptionRequestQuery, GetExceptionRequestQueryVariables>(GetExceptionRequestDocument, options);
        }
export type GetExceptionRequestQueryHookResult = ReturnType<typeof useGetExceptionRequestQuery>;
export type GetExceptionRequestLazyQueryHookResult = ReturnType<typeof useGetExceptionRequestLazyQuery>;
export type GetExceptionRequestSuspenseQueryHookResult = ReturnType<typeof useGetExceptionRequestSuspenseQuery>;
export type GetExceptionRequestQueryResult = Apollo.QueryResult<GetExceptionRequestQuery, GetExceptionRequestQueryVariables>;
export const GetDocumentBlocksDocument = gql`
    query GetDocumentBlocks($knowledgeId: ID!, $documentFactId: ID!, $boundingBoxes: GetDocumentBlocksInput) {
  getDocumentBlocks(
    knowledgeId: $knowledgeId
    documentFactId: $documentFactId
    boundingBoxes: $boundingBoxes
  ) {
    blocksByPage {
      pageNum
    }
    rawText
  }
}
    `;

/**
 * __useGetDocumentBlocksQuery__
 *
 * To run a query within a React component, call `useGetDocumentBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentBlocksQuery({
 *   variables: {
 *      knowledgeId: // value for 'knowledgeId'
 *      documentFactId: // value for 'documentFactId'
 *      boundingBoxes: // value for 'boundingBoxes'
 *   },
 * });
 */
export function useGetDocumentBlocksQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentBlocksQuery, GetDocumentBlocksQueryVariables> & ({ variables: GetDocumentBlocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentBlocksQuery, GetDocumentBlocksQueryVariables>(GetDocumentBlocksDocument, options);
      }
export function useGetDocumentBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentBlocksQuery, GetDocumentBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentBlocksQuery, GetDocumentBlocksQueryVariables>(GetDocumentBlocksDocument, options);
        }
export function useGetDocumentBlocksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentBlocksQuery, GetDocumentBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentBlocksQuery, GetDocumentBlocksQueryVariables>(GetDocumentBlocksDocument, options);
        }
export type GetDocumentBlocksQueryHookResult = ReturnType<typeof useGetDocumentBlocksQuery>;
export type GetDocumentBlocksLazyQueryHookResult = ReturnType<typeof useGetDocumentBlocksLazyQuery>;
export type GetDocumentBlocksSuspenseQueryHookResult = ReturnType<typeof useGetDocumentBlocksSuspenseQuery>;
export type GetDocumentBlocksQueryResult = Apollo.QueryResult<GetDocumentBlocksQuery, GetDocumentBlocksQueryVariables>;
export const GetHistoricalFactsDocument = gql`
    query GetHistoricalFacts($knowledgeId: ID!, $factIds: [HistoricalFactID!]!) {
  getHistoricalFacts(knowledgeId: $knowledgeId, factIds: $factIds) {
    id
    names
    locations
    dereferencedId
    type
    relations {
      factId
      name
      direction
    }
    value
    descriptions {
      name
      factId
    }
    referenceTo
    isDeleted
    parentFact {
      id
      knowledgeId
      names
      parentFactId
      locations
      value
      owner
      readers
      editors
      referenceTo
      viewUrl
      childProperties
      isDeleted
    }
    parentFactId
  }
}
    `;

/**
 * __useGetHistoricalFactsQuery__
 *
 * To run a query within a React component, call `useGetHistoricalFactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoricalFactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoricalFactsQuery({
 *   variables: {
 *      knowledgeId: // value for 'knowledgeId'
 *      factIds: // value for 'factIds'
 *   },
 * });
 */
export function useGetHistoricalFactsQuery(baseOptions: Apollo.QueryHookOptions<GetHistoricalFactsQuery, GetHistoricalFactsQueryVariables> & ({ variables: GetHistoricalFactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHistoricalFactsQuery, GetHistoricalFactsQueryVariables>(GetHistoricalFactsDocument, options);
      }
export function useGetHistoricalFactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHistoricalFactsQuery, GetHistoricalFactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHistoricalFactsQuery, GetHistoricalFactsQueryVariables>(GetHistoricalFactsDocument, options);
        }
export function useGetHistoricalFactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHistoricalFactsQuery, GetHistoricalFactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHistoricalFactsQuery, GetHistoricalFactsQueryVariables>(GetHistoricalFactsDocument, options);
        }
export type GetHistoricalFactsQueryHookResult = ReturnType<typeof useGetHistoricalFactsQuery>;
export type GetHistoricalFactsLazyQueryHookResult = ReturnType<typeof useGetHistoricalFactsLazyQuery>;
export type GetHistoricalFactsSuspenseQueryHookResult = ReturnType<typeof useGetHistoricalFactsSuspenseQuery>;
export type GetHistoricalFactsQueryResult = Apollo.QueryResult<GetHistoricalFactsQuery, GetHistoricalFactsQueryVariables>;
export const GetFactValueDocument = gql`
    query GetFactValue($knowledgeId: ID!, $factId: ID!, $epoch: Int!) {
  getFact(knowledgeId: $knowledgeId, factId: $factId, epoch: $epoch) {
    id
    knowledgeId
    value
  }
}
    `;

/**
 * __useGetFactValueQuery__
 *
 * To run a query within a React component, call `useGetFactValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFactValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFactValueQuery({
 *   variables: {
 *      knowledgeId: // value for 'knowledgeId'
 *      factId: // value for 'factId'
 *      epoch: // value for 'epoch'
 *   },
 * });
 */
export function useGetFactValueQuery(baseOptions: Apollo.QueryHookOptions<GetFactValueQuery, GetFactValueQueryVariables> & ({ variables: GetFactValueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFactValueQuery, GetFactValueQueryVariables>(GetFactValueDocument, options);
      }
export function useGetFactValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFactValueQuery, GetFactValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFactValueQuery, GetFactValueQueryVariables>(GetFactValueDocument, options);
        }
export function useGetFactValueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFactValueQuery, GetFactValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFactValueQuery, GetFactValueQueryVariables>(GetFactValueDocument, options);
        }
export type GetFactValueQueryHookResult = ReturnType<typeof useGetFactValueQuery>;
export type GetFactValueLazyQueryHookResult = ReturnType<typeof useGetFactValueLazyQuery>;
export type GetFactValueSuspenseQueryHookResult = ReturnType<typeof useGetFactValueSuspenseQuery>;
export type GetFactValueQueryResult = Apollo.QueryResult<GetFactValueQuery, GetFactValueQueryVariables>;
export const GetFactsAtStepPathDocument = gql`
    query GetFactsAtStepPath($workerId: ID!, $stepPath: [String!]!) {
  getFactsAtStepPath(workerId: $workerId, stepPath: $stepPath) {
    columns
    data
  }
}
    `;

/**
 * __useGetFactsAtStepPathQuery__
 *
 * To run a query within a React component, call `useGetFactsAtStepPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFactsAtStepPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFactsAtStepPathQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      stepPath: // value for 'stepPath'
 *   },
 * });
 */
export function useGetFactsAtStepPathQuery(baseOptions: Apollo.QueryHookOptions<GetFactsAtStepPathQuery, GetFactsAtStepPathQueryVariables> & ({ variables: GetFactsAtStepPathQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFactsAtStepPathQuery, GetFactsAtStepPathQueryVariables>(GetFactsAtStepPathDocument, options);
      }
export function useGetFactsAtStepPathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFactsAtStepPathQuery, GetFactsAtStepPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFactsAtStepPathQuery, GetFactsAtStepPathQueryVariables>(GetFactsAtStepPathDocument, options);
        }
export function useGetFactsAtStepPathSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFactsAtStepPathQuery, GetFactsAtStepPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFactsAtStepPathQuery, GetFactsAtStepPathQueryVariables>(GetFactsAtStepPathDocument, options);
        }
export type GetFactsAtStepPathQueryHookResult = ReturnType<typeof useGetFactsAtStepPathQuery>;
export type GetFactsAtStepPathLazyQueryHookResult = ReturnType<typeof useGetFactsAtStepPathLazyQuery>;
export type GetFactsAtStepPathSuspenseQueryHookResult = ReturnType<typeof useGetFactsAtStepPathSuspenseQuery>;
export type GetFactsAtStepPathQueryResult = Apollo.QueryResult<GetFactsAtStepPathQuery, GetFactsAtStepPathQueryVariables>;
export const GetFactDocument = gql`
    query GetFact($knowledgeId: ID!, $factId: ID!, $epoch: Int!) {
  getFact(knowledgeId: $knowledgeId, factId: $factId, epoch: $epoch) {
    id
    knowledgeId
    knowledge {
      id
      owner
      readers
      editors
      name
      description
      departmentId
      workerId
      parentKnowledgeId
      state
      brainVersion
    }
    names
    parentFact {
      id
      knowledgeId
      names
      parentFactId
      locations
      value
      owner
      readers
      editors
      referenceTo
      dereferencedId
      type
      viewUrl
      childProperties
      isDeleted
    }
    parentFactId
    locations
    relations {
      factId
      name
      direction
    }
    value
    descriptions {
      name
      factId
    }
    owner
    readers
    editors
    referenceTo
    dereferencedId
    type
    viewUrl
    childProperties
    isDeleted
  }
}
    `;

/**
 * __useGetFactQuery__
 *
 * To run a query within a React component, call `useGetFactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFactQuery({
 *   variables: {
 *      knowledgeId: // value for 'knowledgeId'
 *      factId: // value for 'factId'
 *      epoch: // value for 'epoch'
 *   },
 * });
 */
export function useGetFactQuery(baseOptions: Apollo.QueryHookOptions<GetFactQuery, GetFactQueryVariables> & ({ variables: GetFactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFactQuery, GetFactQueryVariables>(GetFactDocument, options);
      }
export function useGetFactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFactQuery, GetFactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFactQuery, GetFactQueryVariables>(GetFactDocument, options);
        }
export function useGetFactSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFactQuery, GetFactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFactQuery, GetFactQueryVariables>(GetFactDocument, options);
        }
export type GetFactQueryHookResult = ReturnType<typeof useGetFactQuery>;
export type GetFactLazyQueryHookResult = ReturnType<typeof useGetFactLazyQuery>;
export type GetFactSuspenseQueryHookResult = ReturnType<typeof useGetFactSuspenseQuery>;
export type GetFactQueryResult = Apollo.QueryResult<GetFactQuery, GetFactQueryVariables>;
export const GetFactsDocument = gql`
    query GetFacts($knowledgeId: ID!, $factIds: [ID!]!) {
  getFacts(knowledgeId: $knowledgeId, factIds: $factIds) {
    id
    dereferencedId
    value
    names
  }
}
    `;

/**
 * __useGetFactsQuery__
 *
 * To run a query within a React component, call `useGetFactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFactsQuery({
 *   variables: {
 *      knowledgeId: // value for 'knowledgeId'
 *      factIds: // value for 'factIds'
 *   },
 * });
 */
export function useGetFactsQuery(baseOptions: Apollo.QueryHookOptions<GetFactsQuery, GetFactsQueryVariables> & ({ variables: GetFactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFactsQuery, GetFactsQueryVariables>(GetFactsDocument, options);
      }
export function useGetFactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFactsQuery, GetFactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFactsQuery, GetFactsQueryVariables>(GetFactsDocument, options);
        }
export function useGetFactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFactsQuery, GetFactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFactsQuery, GetFactsQueryVariables>(GetFactsDocument, options);
        }
export type GetFactsQueryHookResult = ReturnType<typeof useGetFactsQuery>;
export type GetFactsLazyQueryHookResult = ReturnType<typeof useGetFactsLazyQuery>;
export type GetFactsSuspenseQueryHookResult = ReturnType<typeof useGetFactsSuspenseQuery>;
export type GetFactsQueryResult = Apollo.QueryResult<GetFactsQuery, GetFactsQueryVariables>;
export const ListKChatMessagesByWorkerDocument = gql`
    query ListKChatMessagesByWorker($workerId: ID!, $limit: Int = 50, $nextToken: String) {
  listKChatMessagesByWorker(
    workerId: $workerId
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      departmentId
      workerId
      message
      timestamp
      displayName
      role
    }
    nextToken
  }
}
    `;

/**
 * __useListKChatMessagesByWorkerQuery__
 *
 * To run a query within a React component, call `useListKChatMessagesByWorkerQuery` and pass it any options that fit your needs.
 * When your component renders, `useListKChatMessagesByWorkerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListKChatMessagesByWorkerQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useListKChatMessagesByWorkerQuery(baseOptions: Apollo.QueryHookOptions<ListKChatMessagesByWorkerQuery, ListKChatMessagesByWorkerQueryVariables> & ({ variables: ListKChatMessagesByWorkerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListKChatMessagesByWorkerQuery, ListKChatMessagesByWorkerQueryVariables>(ListKChatMessagesByWorkerDocument, options);
      }
export function useListKChatMessagesByWorkerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListKChatMessagesByWorkerQuery, ListKChatMessagesByWorkerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListKChatMessagesByWorkerQuery, ListKChatMessagesByWorkerQueryVariables>(ListKChatMessagesByWorkerDocument, options);
        }
export function useListKChatMessagesByWorkerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListKChatMessagesByWorkerQuery, ListKChatMessagesByWorkerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListKChatMessagesByWorkerQuery, ListKChatMessagesByWorkerQueryVariables>(ListKChatMessagesByWorkerDocument, options);
        }
export type ListKChatMessagesByWorkerQueryHookResult = ReturnType<typeof useListKChatMessagesByWorkerQuery>;
export type ListKChatMessagesByWorkerLazyQueryHookResult = ReturnType<typeof useListKChatMessagesByWorkerLazyQuery>;
export type ListKChatMessagesByWorkerSuspenseQueryHookResult = ReturnType<typeof useListKChatMessagesByWorkerSuspenseQuery>;
export type ListKChatMessagesByWorkerQueryResult = Apollo.QueryResult<ListKChatMessagesByWorkerQuery, ListKChatMessagesByWorkerQueryVariables>;
export const ListDepartmentLearnedAnswersDocument = gql`
    query listDepartmentLearnedAnswers($id: ID!, $limit: Int, $nextToken: String) {
  getDepartment(id: $id) {
    learnedAnswers(limit: $limit, nextToken: $nextToken) {
      nextToken
      items {
        id
        questionFilter {
          stepPath
          questionType
          lexicalPath
        }
        action {
          _
          ... on RetryStepAction {
            minimumDelay
            timeout
          }
          ... on UseConceptAction {
            conceptId
          }
          ... on UseLiteralValueAction {
            literalValue
            choices
          }
          ... on UseTechniqueAction {
            technique
          }
        }
        createdAt
        createdBy
        deletedAt
        deletedBy
        procedureId
        procedureName
        stage
        procedure {
          id
          name
          knowledgeId
          stage
        }
        contextValue
        contextMetadata
        contextualLearningInfos {
          items {
            ...ContextualLearningInfoFragment
          }
        }
      }
    }
  }
}
    ${ContextualLearningInfoFragmentFragmentDoc}`;

/**
 * __useListDepartmentLearnedAnswersQuery__
 *
 * To run a query within a React component, call `useListDepartmentLearnedAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDepartmentLearnedAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDepartmentLearnedAnswersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useListDepartmentLearnedAnswersQuery(baseOptions: Apollo.QueryHookOptions<ListDepartmentLearnedAnswersQuery, ListDepartmentLearnedAnswersQueryVariables> & ({ variables: ListDepartmentLearnedAnswersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDepartmentLearnedAnswersQuery, ListDepartmentLearnedAnswersQueryVariables>(ListDepartmentLearnedAnswersDocument, options);
      }
export function useListDepartmentLearnedAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDepartmentLearnedAnswersQuery, ListDepartmentLearnedAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDepartmentLearnedAnswersQuery, ListDepartmentLearnedAnswersQueryVariables>(ListDepartmentLearnedAnswersDocument, options);
        }
export function useListDepartmentLearnedAnswersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListDepartmentLearnedAnswersQuery, ListDepartmentLearnedAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDepartmentLearnedAnswersQuery, ListDepartmentLearnedAnswersQueryVariables>(ListDepartmentLearnedAnswersDocument, options);
        }
export type ListDepartmentLearnedAnswersQueryHookResult = ReturnType<typeof useListDepartmentLearnedAnswersQuery>;
export type ListDepartmentLearnedAnswersLazyQueryHookResult = ReturnType<typeof useListDepartmentLearnedAnswersLazyQuery>;
export type ListDepartmentLearnedAnswersSuspenseQueryHookResult = ReturnType<typeof useListDepartmentLearnedAnswersSuspenseQuery>;
export type ListDepartmentLearnedAnswersQueryResult = Apollo.QueryResult<ListDepartmentLearnedAnswersQuery, ListDepartmentLearnedAnswersQueryVariables>;
export const ListLearnedAnswersByProcedureDocument = gql`
    query ListLearnedAnswersByProcedure($procedureId: ID!, $departmentId: ID!, $limit: Int = 100, $nextToken: String, $filters: LearningsFilters) {
  listLearnedAnswersByProcedure(
    procedureId: $procedureId
    departmentId: $departmentId
    limit: $limit
    nextToken: $nextToken
    filters: $filters
  ) {
    items {
      id
      stage
      questionFilter {
        stepPath
        questionType
        lexicalPath
      }
      action {
        ... on RetryStepAction {
          minimumDelay
          timeout
        }
        ... on UseConceptAction {
          conceptId
        }
        ... on UseLiteralValueAction {
          literalValue
          choices
        }
        ... on UseTechniqueAction {
          technique
        }
      }
      createdAt
      createdBy
      deletedAt
      deletedBy
      updatedAt
      procedure {
        id
        name
        stage
      }
      contextValue
      contextMetadata
      stage
      contextualLearningInfos {
        items {
          ...ContextualLearningInfoFragment
        }
      }
    }
    nextToken
  }
}
    ${ContextualLearningInfoFragmentFragmentDoc}`;

/**
 * __useListLearnedAnswersByProcedureQuery__
 *
 * To run a query within a React component, call `useListLearnedAnswersByProcedureQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLearnedAnswersByProcedureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLearnedAnswersByProcedureQuery({
 *   variables: {
 *      procedureId: // value for 'procedureId'
 *      departmentId: // value for 'departmentId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListLearnedAnswersByProcedureQuery(baseOptions: Apollo.QueryHookOptions<ListLearnedAnswersByProcedureQuery, ListLearnedAnswersByProcedureQueryVariables> & ({ variables: ListLearnedAnswersByProcedureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLearnedAnswersByProcedureQuery, ListLearnedAnswersByProcedureQueryVariables>(ListLearnedAnswersByProcedureDocument, options);
      }
export function useListLearnedAnswersByProcedureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLearnedAnswersByProcedureQuery, ListLearnedAnswersByProcedureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLearnedAnswersByProcedureQuery, ListLearnedAnswersByProcedureQueryVariables>(ListLearnedAnswersByProcedureDocument, options);
        }
export function useListLearnedAnswersByProcedureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListLearnedAnswersByProcedureQuery, ListLearnedAnswersByProcedureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListLearnedAnswersByProcedureQuery, ListLearnedAnswersByProcedureQueryVariables>(ListLearnedAnswersByProcedureDocument, options);
        }
export type ListLearnedAnswersByProcedureQueryHookResult = ReturnType<typeof useListLearnedAnswersByProcedureQuery>;
export type ListLearnedAnswersByProcedureLazyQueryHookResult = ReturnType<typeof useListLearnedAnswersByProcedureLazyQuery>;
export type ListLearnedAnswersByProcedureSuspenseQueryHookResult = ReturnType<typeof useListLearnedAnswersByProcedureSuspenseQuery>;
export type ListLearnedAnswersByProcedureQueryResult = Apollo.QueryResult<ListLearnedAnswersByProcedureQuery, ListLearnedAnswersByProcedureQueryVariables>;
export const GetLearnedAnswerSuggestionsDocument = gql`
    query GetLearnedAnswerSuggestions($input: LearnedAnswerSuggestionsInput!) {
  getLearnedAnswerSuggestions(input: $input) {
    items {
      id
      createdAt
      createdBy
      deletedAt
      deletedBy
      procedureId
      procedureName
      contextValue
      contextMetadata
      questionFilter {
        stepPath
        questionType
        lexicalPath
      }
      action {
        _
        ... on RetryStepAction {
          minimumDelay
          timeout
        }
        ... on UseConceptAction {
          conceptId
        }
        ... on UseLiteralValueAction {
          literalValue
          choices
        }
        ... on UseTechniqueAction {
          technique
        }
      }
    }
    nextToken
  }
}
    `;

/**
 * __useGetLearnedAnswerSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetLearnedAnswerSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearnedAnswerSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearnedAnswerSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLearnedAnswerSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<GetLearnedAnswerSuggestionsQuery, GetLearnedAnswerSuggestionsQueryVariables> & ({ variables: GetLearnedAnswerSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearnedAnswerSuggestionsQuery, GetLearnedAnswerSuggestionsQueryVariables>(GetLearnedAnswerSuggestionsDocument, options);
      }
export function useGetLearnedAnswerSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearnedAnswerSuggestionsQuery, GetLearnedAnswerSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearnedAnswerSuggestionsQuery, GetLearnedAnswerSuggestionsQueryVariables>(GetLearnedAnswerSuggestionsDocument, options);
        }
export function useGetLearnedAnswerSuggestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLearnedAnswerSuggestionsQuery, GetLearnedAnswerSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLearnedAnswerSuggestionsQuery, GetLearnedAnswerSuggestionsQueryVariables>(GetLearnedAnswerSuggestionsDocument, options);
        }
export type GetLearnedAnswerSuggestionsQueryHookResult = ReturnType<typeof useGetLearnedAnswerSuggestionsQuery>;
export type GetLearnedAnswerSuggestionsLazyQueryHookResult = ReturnType<typeof useGetLearnedAnswerSuggestionsLazyQuery>;
export type GetLearnedAnswerSuggestionsSuspenseQueryHookResult = ReturnType<typeof useGetLearnedAnswerSuggestionsSuspenseQuery>;
export type GetLearnedAnswerSuggestionsQueryResult = Apollo.QueryResult<GetLearnedAnswerSuggestionsQuery, GetLearnedAnswerSuggestionsQueryVariables>;
export const GetContextualLearningInfoByRequestDocument = gql`
    query GetContextualLearningInfoByRequest($requestId: ID!) {
  getContextualLearningInfoByRequest(requestId: $requestId) {
    items {
      id
      createdAt
      createdBy
      procedureId
      learningId
      requestId
      procedureName
      contextMetadata
    }
  }
}
    `;

/**
 * __useGetContextualLearningInfoByRequestQuery__
 *
 * To run a query within a React component, call `useGetContextualLearningInfoByRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContextualLearningInfoByRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContextualLearningInfoByRequestQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useGetContextualLearningInfoByRequestQuery(baseOptions: Apollo.QueryHookOptions<GetContextualLearningInfoByRequestQuery, GetContextualLearningInfoByRequestQueryVariables> & ({ variables: GetContextualLearningInfoByRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContextualLearningInfoByRequestQuery, GetContextualLearningInfoByRequestQueryVariables>(GetContextualLearningInfoByRequestDocument, options);
      }
export function useGetContextualLearningInfoByRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContextualLearningInfoByRequestQuery, GetContextualLearningInfoByRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContextualLearningInfoByRequestQuery, GetContextualLearningInfoByRequestQueryVariables>(GetContextualLearningInfoByRequestDocument, options);
        }
export function useGetContextualLearningInfoByRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContextualLearningInfoByRequestQuery, GetContextualLearningInfoByRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContextualLearningInfoByRequestQuery, GetContextualLearningInfoByRequestQueryVariables>(GetContextualLearningInfoByRequestDocument, options);
        }
export type GetContextualLearningInfoByRequestQueryHookResult = ReturnType<typeof useGetContextualLearningInfoByRequestQuery>;
export type GetContextualLearningInfoByRequestLazyQueryHookResult = ReturnType<typeof useGetContextualLearningInfoByRequestLazyQuery>;
export type GetContextualLearningInfoByRequestSuspenseQueryHookResult = ReturnType<typeof useGetContextualLearningInfoByRequestSuspenseQuery>;
export type GetContextualLearningInfoByRequestQueryResult = Apollo.QueryResult<GetContextualLearningInfoByRequestQuery, GetContextualLearningInfoByRequestQueryVariables>;
export const GetLearnedAnswerByRequestAnswerIdDocument = gql`
    query GetLearnedAnswerByRequestAnswerId($requestAnswerId: ID!) {
  getLearnedAnswerByRequestAnswerId(requestAnswerId: $requestAnswerId) {
    id
    questionFilter {
      stepPath
      questionType
      lexicalPath
    }
    action {
      _
      ... on ReplaceStepAction {
        newSteps
      }
      ... on RetryStepAction {
        minimumDelay
        timeout
      }
      ... on UseConceptAction {
        conceptId
      }
      ... on UseLiteralValueAction {
        literalValue
        choices
      }
      ... on UseOauth2Action {
        accessToken
        refreshToken
      }
      ... on UseTechniqueAction {
        technique
      }
    }
    originalAnswerId
    createdAt
    createdBy
    deletedAt
    deletedBy
    procedureId
    procedureName
    procedure {
      id
      knowledgeId
      departmentId
      text
      name
      owner
      language
      public
      bookReference
      title
      version
    }
    contextValue
    contextMetadata
  }
}
    `;

/**
 * __useGetLearnedAnswerByRequestAnswerIdQuery__
 *
 * To run a query within a React component, call `useGetLearnedAnswerByRequestAnswerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearnedAnswerByRequestAnswerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearnedAnswerByRequestAnswerIdQuery({
 *   variables: {
 *      requestAnswerId: // value for 'requestAnswerId'
 *   },
 * });
 */
export function useGetLearnedAnswerByRequestAnswerIdQuery(baseOptions: Apollo.QueryHookOptions<GetLearnedAnswerByRequestAnswerIdQuery, GetLearnedAnswerByRequestAnswerIdQueryVariables> & ({ variables: GetLearnedAnswerByRequestAnswerIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearnedAnswerByRequestAnswerIdQuery, GetLearnedAnswerByRequestAnswerIdQueryVariables>(GetLearnedAnswerByRequestAnswerIdDocument, options);
      }
export function useGetLearnedAnswerByRequestAnswerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearnedAnswerByRequestAnswerIdQuery, GetLearnedAnswerByRequestAnswerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearnedAnswerByRequestAnswerIdQuery, GetLearnedAnswerByRequestAnswerIdQueryVariables>(GetLearnedAnswerByRequestAnswerIdDocument, options);
        }
export function useGetLearnedAnswerByRequestAnswerIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLearnedAnswerByRequestAnswerIdQuery, GetLearnedAnswerByRequestAnswerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLearnedAnswerByRequestAnswerIdQuery, GetLearnedAnswerByRequestAnswerIdQueryVariables>(GetLearnedAnswerByRequestAnswerIdDocument, options);
        }
export type GetLearnedAnswerByRequestAnswerIdQueryHookResult = ReturnType<typeof useGetLearnedAnswerByRequestAnswerIdQuery>;
export type GetLearnedAnswerByRequestAnswerIdLazyQueryHookResult = ReturnType<typeof useGetLearnedAnswerByRequestAnswerIdLazyQuery>;
export type GetLearnedAnswerByRequestAnswerIdSuspenseQueryHookResult = ReturnType<typeof useGetLearnedAnswerByRequestAnswerIdSuspenseQuery>;
export type GetLearnedAnswerByRequestAnswerIdQueryResult = Apollo.QueryResult<GetLearnedAnswerByRequestAnswerIdQuery, GetLearnedAnswerByRequestAnswerIdQueryVariables>;
export const GetLearnedAnswersSummaryByProcedureIdsDocument = gql`
    query getLearnedAnswersSummaryByProcedureIds($departmentId: ID!, $procedureIds: [ID!]!, $sinceTimestamp: String) {
  getLearnedAnswersSummaryByProcedureIds(
    departmentId: $departmentId
    procedureIds: $procedureIds
    sinceTimestamp: $sinceTimestamp
  ) {
    items {
      procedureId
      draftLearningsCreatedCount
      publishedLearningsCreatedCount
      draftLearningsUpdatedCount
      publishedLearningsUpdatedCount
    }
  }
}
    `;

/**
 * __useGetLearnedAnswersSummaryByProcedureIdsQuery__
 *
 * To run a query within a React component, call `useGetLearnedAnswersSummaryByProcedureIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearnedAnswersSummaryByProcedureIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearnedAnswersSummaryByProcedureIdsQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      procedureIds: // value for 'procedureIds'
 *      sinceTimestamp: // value for 'sinceTimestamp'
 *   },
 * });
 */
export function useGetLearnedAnswersSummaryByProcedureIdsQuery(baseOptions: Apollo.QueryHookOptions<GetLearnedAnswersSummaryByProcedureIdsQuery, GetLearnedAnswersSummaryByProcedureIdsQueryVariables> & ({ variables: GetLearnedAnswersSummaryByProcedureIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearnedAnswersSummaryByProcedureIdsQuery, GetLearnedAnswersSummaryByProcedureIdsQueryVariables>(GetLearnedAnswersSummaryByProcedureIdsDocument, options);
      }
export function useGetLearnedAnswersSummaryByProcedureIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearnedAnswersSummaryByProcedureIdsQuery, GetLearnedAnswersSummaryByProcedureIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearnedAnswersSummaryByProcedureIdsQuery, GetLearnedAnswersSummaryByProcedureIdsQueryVariables>(GetLearnedAnswersSummaryByProcedureIdsDocument, options);
        }
export function useGetLearnedAnswersSummaryByProcedureIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLearnedAnswersSummaryByProcedureIdsQuery, GetLearnedAnswersSummaryByProcedureIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLearnedAnswersSummaryByProcedureIdsQuery, GetLearnedAnswersSummaryByProcedureIdsQueryVariables>(GetLearnedAnswersSummaryByProcedureIdsDocument, options);
        }
export type GetLearnedAnswersSummaryByProcedureIdsQueryHookResult = ReturnType<typeof useGetLearnedAnswersSummaryByProcedureIdsQuery>;
export type GetLearnedAnswersSummaryByProcedureIdsLazyQueryHookResult = ReturnType<typeof useGetLearnedAnswersSummaryByProcedureIdsLazyQuery>;
export type GetLearnedAnswersSummaryByProcedureIdsSuspenseQueryHookResult = ReturnType<typeof useGetLearnedAnswersSummaryByProcedureIdsSuspenseQuery>;
export type GetLearnedAnswersSummaryByProcedureIdsQueryResult = Apollo.QueryResult<GetLearnedAnswersSummaryByProcedureIdsQuery, GetLearnedAnswersSummaryByProcedureIdsQueryVariables>;
export const GetLearnedAnswerDocument = gql`
    query GetLearnedAnswer($id: ID!) {
  getLearnedAnswer(id: $id) {
    id
    questionFilter {
      stepPath
      questionType
      lexicalPath
    }
    action {
      _
      ... on RetryStepAction {
        minimumDelay
        timeout
      }
      ... on UseConceptAction {
        conceptId
      }
      ... on UseLiteralValueAction {
        literalValue
        choices
      }
      ... on UseTechniqueAction {
        technique
      }
    }
    createdAt
    createdBy
    deletedAt
    deletedBy
    stage
    procedure {
      id
      name
      knowledgeId
    }
    contextValue
    contextMetadata
  }
}
    `;

/**
 * __useGetLearnedAnswerQuery__
 *
 * To run a query within a React component, call `useGetLearnedAnswerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearnedAnswerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearnedAnswerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLearnedAnswerQuery(baseOptions: Apollo.QueryHookOptions<GetLearnedAnswerQuery, GetLearnedAnswerQueryVariables> & ({ variables: GetLearnedAnswerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearnedAnswerQuery, GetLearnedAnswerQueryVariables>(GetLearnedAnswerDocument, options);
      }
export function useGetLearnedAnswerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearnedAnswerQuery, GetLearnedAnswerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearnedAnswerQuery, GetLearnedAnswerQueryVariables>(GetLearnedAnswerDocument, options);
        }
export function useGetLearnedAnswerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLearnedAnswerQuery, GetLearnedAnswerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLearnedAnswerQuery, GetLearnedAnswerQueryVariables>(GetLearnedAnswerDocument, options);
        }
export type GetLearnedAnswerQueryHookResult = ReturnType<typeof useGetLearnedAnswerQuery>;
export type GetLearnedAnswerLazyQueryHookResult = ReturnType<typeof useGetLearnedAnswerLazyQuery>;
export type GetLearnedAnswerSuspenseQueryHookResult = ReturnType<typeof useGetLearnedAnswerSuspenseQuery>;
export type GetLearnedAnswerQueryResult = Apollo.QueryResult<GetLearnedAnswerQuery, GetLearnedAnswerQueryVariables>;
export const GetUploadToS3UrlDocument = gql`
    query GetUploadToS3Url($scope: S3FileScope!, $scopeId: ID!, $filename: String!, $fields: AWSJSON, $expiresIn: Int = 300) {
  getUploadToS3Url(
    scope: $scope
    scopeId: $scopeId
    filename: $filename
    fields: $fields
    expiresIn: $expiresIn
  ) {
    url
    s3Url
    fields
  }
}
    `;

/**
 * __useGetUploadToS3UrlQuery__
 *
 * To run a query within a React component, call `useGetUploadToS3UrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadToS3UrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadToS3UrlQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      scopeId: // value for 'scopeId'
 *      filename: // value for 'filename'
 *      fields: // value for 'fields'
 *      expiresIn: // value for 'expiresIn'
 *   },
 * });
 */
export function useGetUploadToS3UrlQuery(baseOptions: Apollo.QueryHookOptions<GetUploadToS3UrlQuery, GetUploadToS3UrlQueryVariables> & ({ variables: GetUploadToS3UrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadToS3UrlQuery, GetUploadToS3UrlQueryVariables>(GetUploadToS3UrlDocument, options);
      }
export function useGetUploadToS3UrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadToS3UrlQuery, GetUploadToS3UrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadToS3UrlQuery, GetUploadToS3UrlQueryVariables>(GetUploadToS3UrlDocument, options);
        }
export function useGetUploadToS3UrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUploadToS3UrlQuery, GetUploadToS3UrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadToS3UrlQuery, GetUploadToS3UrlQueryVariables>(GetUploadToS3UrlDocument, options);
        }
export type GetUploadToS3UrlQueryHookResult = ReturnType<typeof useGetUploadToS3UrlQuery>;
export type GetUploadToS3UrlLazyQueryHookResult = ReturnType<typeof useGetUploadToS3UrlLazyQuery>;
export type GetUploadToS3UrlSuspenseQueryHookResult = ReturnType<typeof useGetUploadToS3UrlSuspenseQuery>;
export type GetUploadToS3UrlQueryResult = Apollo.QueryResult<GetUploadToS3UrlQuery, GetUploadToS3UrlQueryVariables>;
export const GetDownloadFromS3UrlDocument = gql`
    query GetDownloadFromS3Url($objectKey: String!, $expiresIn: Int = 300, $objectType: S3ObjectType = BRAIN_FILES, $onlyIfExists: Boolean) {
  getDownloadFromS3Url(
    objectKey: $objectKey
    expiresIn: $expiresIn
    objectType: $objectType
    onlyIfExists: $onlyIfExists
  ) {
    url
    s3Url
  }
}
    `;

/**
 * __useGetDownloadFromS3UrlQuery__
 *
 * To run a query within a React component, call `useGetDownloadFromS3UrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadFromS3UrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadFromS3UrlQuery({
 *   variables: {
 *      objectKey: // value for 'objectKey'
 *      expiresIn: // value for 'expiresIn'
 *      objectType: // value for 'objectType'
 *      onlyIfExists: // value for 'onlyIfExists'
 *   },
 * });
 */
export function useGetDownloadFromS3UrlQuery(baseOptions: Apollo.QueryHookOptions<GetDownloadFromS3UrlQuery, GetDownloadFromS3UrlQueryVariables> & ({ variables: GetDownloadFromS3UrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadFromS3UrlQuery, GetDownloadFromS3UrlQueryVariables>(GetDownloadFromS3UrlDocument, options);
      }
export function useGetDownloadFromS3UrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadFromS3UrlQuery, GetDownloadFromS3UrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadFromS3UrlQuery, GetDownloadFromS3UrlQueryVariables>(GetDownloadFromS3UrlDocument, options);
        }
export function useGetDownloadFromS3UrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDownloadFromS3UrlQuery, GetDownloadFromS3UrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDownloadFromS3UrlQuery, GetDownloadFromS3UrlQueryVariables>(GetDownloadFromS3UrlDocument, options);
        }
export type GetDownloadFromS3UrlQueryHookResult = ReturnType<typeof useGetDownloadFromS3UrlQuery>;
export type GetDownloadFromS3UrlLazyQueryHookResult = ReturnType<typeof useGetDownloadFromS3UrlLazyQuery>;
export type GetDownloadFromS3UrlSuspenseQueryHookResult = ReturnType<typeof useGetDownloadFromS3UrlSuspenseQuery>;
export type GetDownloadFromS3UrlQueryResult = Apollo.QueryResult<GetDownloadFromS3UrlQuery, GetDownloadFromS3UrlQueryVariables>;
export const AppSecretsDocument = gql`
    query appSecrets {
  appSecrets {
    googleMapApiKey
  }
}
    `;

/**
 * __useAppSecretsQuery__
 *
 * To run a query within a React component, call `useAppSecretsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppSecretsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppSecretsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppSecretsQuery(baseOptions?: Apollo.QueryHookOptions<AppSecretsQuery, AppSecretsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppSecretsQuery, AppSecretsQueryVariables>(AppSecretsDocument, options);
      }
export function useAppSecretsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppSecretsQuery, AppSecretsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppSecretsQuery, AppSecretsQueryVariables>(AppSecretsDocument, options);
        }
export function useAppSecretsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AppSecretsQuery, AppSecretsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppSecretsQuery, AppSecretsQueryVariables>(AppSecretsDocument, options);
        }
export type AppSecretsQueryHookResult = ReturnType<typeof useAppSecretsQuery>;
export type AppSecretsLazyQueryHookResult = ReturnType<typeof useAppSecretsLazyQuery>;
export type AppSecretsSuspenseQueryHookResult = ReturnType<typeof useAppSecretsSuspenseQuery>;
export type AppSecretsQueryResult = Apollo.QueryResult<AppSecretsQuery, AppSecretsQueryVariables>;
export const GetOwnerOrganizationDocument = gql`
    query GetOwnerOrganization($owner: String) {
  getOwnerOrganization(owner: $owner) {
    id
    name
    owner
    createdAt
    updatedAt
    billingStatus
  }
}
    `;

/**
 * __useGetOwnerOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOwnerOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerOrganizationQuery({
 *   variables: {
 *      owner: // value for 'owner'
 *   },
 * });
 */
export function useGetOwnerOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<GetOwnerOrganizationQuery, GetOwnerOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnerOrganizationQuery, GetOwnerOrganizationQueryVariables>(GetOwnerOrganizationDocument, options);
      }
export function useGetOwnerOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnerOrganizationQuery, GetOwnerOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnerOrganizationQuery, GetOwnerOrganizationQueryVariables>(GetOwnerOrganizationDocument, options);
        }
export function useGetOwnerOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOwnerOrganizationQuery, GetOwnerOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOwnerOrganizationQuery, GetOwnerOrganizationQueryVariables>(GetOwnerOrganizationDocument, options);
        }
export type GetOwnerOrganizationQueryHookResult = ReturnType<typeof useGetOwnerOrganizationQuery>;
export type GetOwnerOrganizationLazyQueryHookResult = ReturnType<typeof useGetOwnerOrganizationLazyQuery>;
export type GetOwnerOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetOwnerOrganizationSuspenseQuery>;
export type GetOwnerOrganizationQueryResult = Apollo.QueryResult<GetOwnerOrganizationQuery, GetOwnerOrganizationQueryVariables>;
export const GetWorkerDocumentDocument = gql`
    query getWorkerDocument($workerId: ID!, $documentToken: String) {
  getWorkerDocument(workerId: $workerId, documentToken: $documentToken) {
    lineId
    text
    parentId
    shouldPause
    language
    metadata {
      lineId
      parentId
    }
    internalMetadata {
      key
      value
    }
  }
}
    `;

/**
 * __useGetWorkerDocumentQuery__
 *
 * To run a query within a React component, call `useGetWorkerDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkerDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkerDocumentQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      documentToken: // value for 'documentToken'
 *   },
 * });
 */
export function useGetWorkerDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetWorkerDocumentQuery, GetWorkerDocumentQueryVariables> & ({ variables: GetWorkerDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkerDocumentQuery, GetWorkerDocumentQueryVariables>(GetWorkerDocumentDocument, options);
      }
export function useGetWorkerDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkerDocumentQuery, GetWorkerDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkerDocumentQuery, GetWorkerDocumentQueryVariables>(GetWorkerDocumentDocument, options);
        }
export function useGetWorkerDocumentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkerDocumentQuery, GetWorkerDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkerDocumentQuery, GetWorkerDocumentQueryVariables>(GetWorkerDocumentDocument, options);
        }
export type GetWorkerDocumentQueryHookResult = ReturnType<typeof useGetWorkerDocumentQuery>;
export type GetWorkerDocumentLazyQueryHookResult = ReturnType<typeof useGetWorkerDocumentLazyQuery>;
export type GetWorkerDocumentSuspenseQueryHookResult = ReturnType<typeof useGetWorkerDocumentSuspenseQuery>;
export type GetWorkerDocumentQueryResult = Apollo.QueryResult<GetWorkerDocumentQuery, GetWorkerDocumentQueryVariables>;
export const GetSentenceExecutionDataDocument = gql`
    query getSentenceExecutionData($workerId: ID!, $token: String, $documentToken: String) {
  getSentenceExecutionData(
    workerId: $workerId
    iterationToken: $token
    documentToken: $documentToken
  ) {
    lineId
    token
    status
    answer
    concepts
    requests
    iterationTokens
    epoch
    subDocuments {
      documentToken
      processName
    }
    miniPlaygrounds {
      documentToken
      processName
    }
    startedAt
    completedAt
  }
}
    `;

/**
 * __useGetSentenceExecutionDataQuery__
 *
 * To run a query within a React component, call `useGetSentenceExecutionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSentenceExecutionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSentenceExecutionDataQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      token: // value for 'token'
 *      documentToken: // value for 'documentToken'
 *   },
 * });
 */
export function useGetSentenceExecutionDataQuery(baseOptions: Apollo.QueryHookOptions<GetSentenceExecutionDataQuery, GetSentenceExecutionDataQueryVariables> & ({ variables: GetSentenceExecutionDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSentenceExecutionDataQuery, GetSentenceExecutionDataQueryVariables>(GetSentenceExecutionDataDocument, options);
      }
export function useGetSentenceExecutionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSentenceExecutionDataQuery, GetSentenceExecutionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSentenceExecutionDataQuery, GetSentenceExecutionDataQueryVariables>(GetSentenceExecutionDataDocument, options);
        }
export function useGetSentenceExecutionDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSentenceExecutionDataQuery, GetSentenceExecutionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSentenceExecutionDataQuery, GetSentenceExecutionDataQueryVariables>(GetSentenceExecutionDataDocument, options);
        }
export type GetSentenceExecutionDataQueryHookResult = ReturnType<typeof useGetSentenceExecutionDataQuery>;
export type GetSentenceExecutionDataLazyQueryHookResult = ReturnType<typeof useGetSentenceExecutionDataLazyQuery>;
export type GetSentenceExecutionDataSuspenseQueryHookResult = ReturnType<typeof useGetSentenceExecutionDataSuspenseQuery>;
export type GetSentenceExecutionDataQueryResult = Apollo.QueryResult<GetSentenceExecutionDataQuery, GetSentenceExecutionDataQueryVariables>;
export const GetDepartmentForWorkerDocument = gql`
    query GetDepartmentForWorker($workerId: ID!) {
  getDepartmentForWorker(workerId: $workerId) {
    id
  }
}
    `;

/**
 * __useGetDepartmentForWorkerQuery__
 *
 * To run a query within a React component, call `useGetDepartmentForWorkerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartmentForWorkerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartmentForWorkerQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *   },
 * });
 */
export function useGetDepartmentForWorkerQuery(baseOptions: Apollo.QueryHookOptions<GetDepartmentForWorkerQuery, GetDepartmentForWorkerQueryVariables> & ({ variables: GetDepartmentForWorkerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDepartmentForWorkerQuery, GetDepartmentForWorkerQueryVariables>(GetDepartmentForWorkerDocument, options);
      }
export function useGetDepartmentForWorkerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDepartmentForWorkerQuery, GetDepartmentForWorkerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDepartmentForWorkerQuery, GetDepartmentForWorkerQueryVariables>(GetDepartmentForWorkerDocument, options);
        }
export function useGetDepartmentForWorkerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDepartmentForWorkerQuery, GetDepartmentForWorkerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDepartmentForWorkerQuery, GetDepartmentForWorkerQueryVariables>(GetDepartmentForWorkerDocument, options);
        }
export type GetDepartmentForWorkerQueryHookResult = ReturnType<typeof useGetDepartmentForWorkerQuery>;
export type GetDepartmentForWorkerLazyQueryHookResult = ReturnType<typeof useGetDepartmentForWorkerLazyQuery>;
export type GetDepartmentForWorkerSuspenseQueryHookResult = ReturnType<typeof useGetDepartmentForWorkerSuspenseQuery>;
export type GetDepartmentForWorkerQueryResult = Apollo.QueryResult<GetDepartmentForWorkerQuery, GetDepartmentForWorkerQueryVariables>;
export const GetWorkerDocument = gql`
    query GetWorker($id: ID!) {
  getWorker(id: $id) {
    id
    owner
    readers
    editors
    name
    description
    version
    departmentVersion
    knowledgeId
    departmentId
    procedureId
    entryCommand
    entryCommandId
    originalWorkerId
    createdAt
    state
    stage
    stateLastUpdatedAt
    attachments
    isArchived
    features
    replayWorkerId
    ...WorkerForkExecutionInfo
  }
}
    ${WorkerForkExecutionInfoFragmentDoc}`;

/**
 * __useGetWorkerQuery__
 *
 * To run a query within a React component, call `useGetWorkerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkerQuery(baseOptions: Apollo.QueryHookOptions<GetWorkerQuery, GetWorkerQueryVariables> & ({ variables: GetWorkerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkerQuery, GetWorkerQueryVariables>(GetWorkerDocument, options);
      }
export function useGetWorkerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkerQuery, GetWorkerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkerQuery, GetWorkerQueryVariables>(GetWorkerDocument, options);
        }
export function useGetWorkerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkerQuery, GetWorkerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkerQuery, GetWorkerQueryVariables>(GetWorkerDocument, options);
        }
export type GetWorkerQueryHookResult = ReturnType<typeof useGetWorkerQuery>;
export type GetWorkerLazyQueryHookResult = ReturnType<typeof useGetWorkerLazyQuery>;
export type GetWorkerSuspenseQueryHookResult = ReturnType<typeof useGetWorkerSuspenseQuery>;
export type GetWorkerQueryResult = Apollo.QueryResult<GetWorkerQuery, GetWorkerQueryVariables>;
export const GetWorkerDependenciesDocument = gql`
    query getWorkerDependencies($workerId: ID!) {
  getWorker(id: $workerId) {
    requests {
      limit
      nextToken
      items {
        id
        stepPath
        contextId
        sentenceId
        createdAt
        handledAt
        state
        worker {
          id
        }
        uiConcepts
        questions {
          id
          text
          contextId
          sentenceId
          answerTypeHint
          ... on NativeCodeErrorQuestion {
            errorType
            errorMessage
            errorTraceback
          }
          ... on ReviewConceptQuestion {
            lexicalPath
            conceptId
          }
          ... on ValueNotKnownQuestion {
            lexicalPath
            choices
            helpText
            isPlural
          }
        }
        answers {
          id
          requestId
          questionId
        }
        suggestedAnswers {
          id
          requestId
          questionId
          action {
            ... on ReplaceStepAction {
              _
              newSteps
            }
          }
        }
        contextPath {
          ctxId
          sentenceId
        }
      }
    }
  }
}
    `;

/**
 * __useGetWorkerDependenciesQuery__
 *
 * To run a query within a React component, call `useGetWorkerDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkerDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkerDependenciesQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *   },
 * });
 */
export function useGetWorkerDependenciesQuery(baseOptions: Apollo.QueryHookOptions<GetWorkerDependenciesQuery, GetWorkerDependenciesQueryVariables> & ({ variables: GetWorkerDependenciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkerDependenciesQuery, GetWorkerDependenciesQueryVariables>(GetWorkerDependenciesDocument, options);
      }
export function useGetWorkerDependenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkerDependenciesQuery, GetWorkerDependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkerDependenciesQuery, GetWorkerDependenciesQueryVariables>(GetWorkerDependenciesDocument, options);
        }
export function useGetWorkerDependenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkerDependenciesQuery, GetWorkerDependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkerDependenciesQuery, GetWorkerDependenciesQueryVariables>(GetWorkerDependenciesDocument, options);
        }
export type GetWorkerDependenciesQueryHookResult = ReturnType<typeof useGetWorkerDependenciesQuery>;
export type GetWorkerDependenciesLazyQueryHookResult = ReturnType<typeof useGetWorkerDependenciesLazyQuery>;
export type GetWorkerDependenciesSuspenseQueryHookResult = ReturnType<typeof useGetWorkerDependenciesSuspenseQuery>;
export type GetWorkerDependenciesQueryResult = Apollo.QueryResult<GetWorkerDependenciesQuery, GetWorkerDependenciesQueryVariables>;
export const ListWorkersByDepartmentDocument = gql`
    query listWorkersByDepartment($departmentId: ID!, $limit: Int, $nextToken: String) {
  listWorkersByDepartment(
    departmentId: $departmentId
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      name
      createdAt
      isArchived
      features
    }
    nextToken
  }
}
    `;

/**
 * __useListWorkersByDepartmentQuery__
 *
 * To run a query within a React component, call `useListWorkersByDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkersByDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWorkersByDepartmentQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useListWorkersByDepartmentQuery(baseOptions: Apollo.QueryHookOptions<ListWorkersByDepartmentQuery, ListWorkersByDepartmentQueryVariables> & ({ variables: ListWorkersByDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWorkersByDepartmentQuery, ListWorkersByDepartmentQueryVariables>(ListWorkersByDepartmentDocument, options);
      }
export function useListWorkersByDepartmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWorkersByDepartmentQuery, ListWorkersByDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWorkersByDepartmentQuery, ListWorkersByDepartmentQueryVariables>(ListWorkersByDepartmentDocument, options);
        }
export function useListWorkersByDepartmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListWorkersByDepartmentQuery, ListWorkersByDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWorkersByDepartmentQuery, ListWorkersByDepartmentQueryVariables>(ListWorkersByDepartmentDocument, options);
        }
export type ListWorkersByDepartmentQueryHookResult = ReturnType<typeof useListWorkersByDepartmentQuery>;
export type ListWorkersByDepartmentLazyQueryHookResult = ReturnType<typeof useListWorkersByDepartmentLazyQuery>;
export type ListWorkersByDepartmentSuspenseQueryHookResult = ReturnType<typeof useListWorkersByDepartmentSuspenseQuery>;
export type ListWorkersByDepartmentQueryResult = Apollo.QueryResult<ListWorkersByDepartmentQuery, ListWorkersByDepartmentQueryVariables>;
export const GetStepPathForRunDocument = gql`
    query GetStepPathForRun($workerId: ID!, $contextId: ID!, $stepId: ID!) {
  getStepPathForRun(workerId: $workerId, contextId: $contextId, stepId: $stepId)
}
    `;

/**
 * __useGetStepPathForRunQuery__
 *
 * To run a query within a React component, call `useGetStepPathForRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStepPathForRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStepPathForRunQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      contextId: // value for 'contextId'
 *      stepId: // value for 'stepId'
 *   },
 * });
 */
export function useGetStepPathForRunQuery(baseOptions: Apollo.QueryHookOptions<GetStepPathForRunQuery, GetStepPathForRunQueryVariables> & ({ variables: GetStepPathForRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStepPathForRunQuery, GetStepPathForRunQueryVariables>(GetStepPathForRunDocument, options);
      }
export function useGetStepPathForRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStepPathForRunQuery, GetStepPathForRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStepPathForRunQuery, GetStepPathForRunQueryVariables>(GetStepPathForRunDocument, options);
        }
export function useGetStepPathForRunSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStepPathForRunQuery, GetStepPathForRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStepPathForRunQuery, GetStepPathForRunQueryVariables>(GetStepPathForRunDocument, options);
        }
export type GetStepPathForRunQueryHookResult = ReturnType<typeof useGetStepPathForRunQuery>;
export type GetStepPathForRunLazyQueryHookResult = ReturnType<typeof useGetStepPathForRunLazyQuery>;
export type GetStepPathForRunSuspenseQueryHookResult = ReturnType<typeof useGetStepPathForRunSuspenseQuery>;
export type GetStepPathForRunQueryResult = Apollo.QueryResult<GetStepPathForRunQuery, GetStepPathForRunQueryVariables>;
export const ParseAlangTextDocument = gql`
    query ParseAlangText($statement: String!, $scopeCode: String!, $language: String!, $departmentId: ID!, $version: String) {
  parseAlangText(
    statement: $statement
    scopeCode: $scopeCode
    language: $language
    departmentId: $departmentId
    version: $version
  ) {
    ast
    text
    error
  }
}
    `;

/**
 * __useParseAlangTextQuery__
 *
 * To run a query within a React component, call `useParseAlangTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useParseAlangTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParseAlangTextQuery({
 *   variables: {
 *      statement: // value for 'statement'
 *      scopeCode: // value for 'scopeCode'
 *      language: // value for 'language'
 *      departmentId: // value for 'departmentId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useParseAlangTextQuery(baseOptions: Apollo.QueryHookOptions<ParseAlangTextQuery, ParseAlangTextQueryVariables> & ({ variables: ParseAlangTextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParseAlangTextQuery, ParseAlangTextQueryVariables>(ParseAlangTextDocument, options);
      }
export function useParseAlangTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParseAlangTextQuery, ParseAlangTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParseAlangTextQuery, ParseAlangTextQueryVariables>(ParseAlangTextDocument, options);
        }
export function useParseAlangTextSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ParseAlangTextQuery, ParseAlangTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ParseAlangTextQuery, ParseAlangTextQueryVariables>(ParseAlangTextDocument, options);
        }
export type ParseAlangTextQueryHookResult = ReturnType<typeof useParseAlangTextQuery>;
export type ParseAlangTextLazyQueryHookResult = ReturnType<typeof useParseAlangTextLazyQuery>;
export type ParseAlangTextSuspenseQueryHookResult = ReturnType<typeof useParseAlangTextSuspenseQuery>;
export type ParseAlangTextQueryResult = Apollo.QueryResult<ParseAlangTextQuery, ParseAlangTextQueryVariables>;
export const GetProcedureDocument = gql`
    query GetProcedure($procedureId: ID!, $knowledgeId: ID, $departmentId: ID, $version: String, $procedureStage: ProcedureStage) {
  getProcedure(
    procedureId: $procedureId
    knowledgeId: $knowledgeId
    departmentId: $departmentId
    version: $version
    procedureStage: $procedureStage
  ) {
    id
    knowledgeId
    departmentId
    text
    name
    owner
    language
    bookReference
    stage
    schedules {
      name
      expression
      enabled
    }
    email {
      stage
      email
    }
    title
    version
    assignmentPolicy {
      policyType
      collaborator
    }
  }
}
    `;

/**
 * __useGetProcedureQuery__
 *
 * To run a query within a React component, call `useGetProcedureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcedureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcedureQuery({
 *   variables: {
 *      procedureId: // value for 'procedureId'
 *      knowledgeId: // value for 'knowledgeId'
 *      departmentId: // value for 'departmentId'
 *      version: // value for 'version'
 *      procedureStage: // value for 'procedureStage'
 *   },
 * });
 */
export function useGetProcedureQuery(baseOptions: Apollo.QueryHookOptions<GetProcedureQuery, GetProcedureQueryVariables> & ({ variables: GetProcedureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcedureQuery, GetProcedureQueryVariables>(GetProcedureDocument, options);
      }
export function useGetProcedureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcedureQuery, GetProcedureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcedureQuery, GetProcedureQueryVariables>(GetProcedureDocument, options);
        }
export function useGetProcedureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcedureQuery, GetProcedureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcedureQuery, GetProcedureQueryVariables>(GetProcedureDocument, options);
        }
export type GetProcedureQueryHookResult = ReturnType<typeof useGetProcedureQuery>;
export type GetProcedureLazyQueryHookResult = ReturnType<typeof useGetProcedureLazyQuery>;
export type GetProcedureSuspenseQueryHookResult = ReturnType<typeof useGetProcedureSuspenseQuery>;
export type GetProcedureQueryResult = Apollo.QueryResult<GetProcedureQuery, GetProcedureQueryVariables>;
export const ListProceduresByDepartmentDocument = gql`
    query ListProceduresByDepartment($departmentId: ID!, $limit: Int = 10, $version: String, $nextToken: String, $procedureFilter: ListProceduresFilter) {
  listProceduresByDepartment(
    departmentId: $departmentId
    limit: $limit
    version: $version
    nextToken: $nextToken
    procedureFilter: $procedureFilter
  ) {
    items {
      id
      knowledgeId
      departmentId
      name
      owner
      language
      public
      bookReference
      title
      version
      stage
      latestRunData {
        id
        triggeredAt
        status
      }
    }
    nextToken
  }
}
    `;

/**
 * __useListProceduresByDepartmentQuery__
 *
 * To run a query within a React component, call `useListProceduresByDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProceduresByDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProceduresByDepartmentQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      limit: // value for 'limit'
 *      version: // value for 'version'
 *      nextToken: // value for 'nextToken'
 *      procedureFilter: // value for 'procedureFilter'
 *   },
 * });
 */
export function useListProceduresByDepartmentQuery(baseOptions: Apollo.QueryHookOptions<ListProceduresByDepartmentQuery, ListProceduresByDepartmentQueryVariables> & ({ variables: ListProceduresByDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProceduresByDepartmentQuery, ListProceduresByDepartmentQueryVariables>(ListProceduresByDepartmentDocument, options);
      }
export function useListProceduresByDepartmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProceduresByDepartmentQuery, ListProceduresByDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProceduresByDepartmentQuery, ListProceduresByDepartmentQueryVariables>(ListProceduresByDepartmentDocument, options);
        }
export function useListProceduresByDepartmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListProceduresByDepartmentQuery, ListProceduresByDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProceduresByDepartmentQuery, ListProceduresByDepartmentQueryVariables>(ListProceduresByDepartmentDocument, options);
        }
export type ListProceduresByDepartmentQueryHookResult = ReturnType<typeof useListProceduresByDepartmentQuery>;
export type ListProceduresByDepartmentLazyQueryHookResult = ReturnType<typeof useListProceduresByDepartmentLazyQuery>;
export type ListProceduresByDepartmentSuspenseQueryHookResult = ReturnType<typeof useListProceduresByDepartmentSuspenseQuery>;
export type ListProceduresByDepartmentQueryResult = Apollo.QueryResult<ListProceduresByDepartmentQuery, ListProceduresByDepartmentQueryVariables>;
export const ListBasicWorkersByProcedureDocument = gql`
    query ListBasicWorkersByProcedure($procedureId: ID, $limit: Int = 1000, $nextToken: String, $stateFilter: String) {
  listWorkersByProcedure(
    procedureId: $procedureId
    limit: $limit
    nextToken: $nextToken
    stateFilter: $stateFilter
  ) {
    items {
      id
      name
      createdAt
      originalWorkerId
      state
      stage
    }
    nextToken
  }
}
    `;

/**
 * __useListBasicWorkersByProcedureQuery__
 *
 * To run a query within a React component, call `useListBasicWorkersByProcedureQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBasicWorkersByProcedureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBasicWorkersByProcedureQuery({
 *   variables: {
 *      procedureId: // value for 'procedureId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *      stateFilter: // value for 'stateFilter'
 *   },
 * });
 */
export function useListBasicWorkersByProcedureQuery(baseOptions?: Apollo.QueryHookOptions<ListBasicWorkersByProcedureQuery, ListBasicWorkersByProcedureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListBasicWorkersByProcedureQuery, ListBasicWorkersByProcedureQueryVariables>(ListBasicWorkersByProcedureDocument, options);
      }
export function useListBasicWorkersByProcedureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListBasicWorkersByProcedureQuery, ListBasicWorkersByProcedureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListBasicWorkersByProcedureQuery, ListBasicWorkersByProcedureQueryVariables>(ListBasicWorkersByProcedureDocument, options);
        }
export function useListBasicWorkersByProcedureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListBasicWorkersByProcedureQuery, ListBasicWorkersByProcedureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListBasicWorkersByProcedureQuery, ListBasicWorkersByProcedureQueryVariables>(ListBasicWorkersByProcedureDocument, options);
        }
export type ListBasicWorkersByProcedureQueryHookResult = ReturnType<typeof useListBasicWorkersByProcedureQuery>;
export type ListBasicWorkersByProcedureLazyQueryHookResult = ReturnType<typeof useListBasicWorkersByProcedureLazyQuery>;
export type ListBasicWorkersByProcedureSuspenseQueryHookResult = ReturnType<typeof useListBasicWorkersByProcedureSuspenseQuery>;
export type ListBasicWorkersByProcedureQueryResult = Apollo.QueryResult<ListBasicWorkersByProcedureQuery, ListBasicWorkersByProcedureQueryVariables>;
export const ListWorkersByProcedureDocument = gql`
    query ListWorkersByProcedure($procedureId: ID, $limit: Int = 1000, $nextToken: String, $stateFilter: String, $fromCreationDate: String, $toCreationDate: String, $stage: ProcedureStage, $includeReplayWorker: Boolean) {
  listWorkersByProcedure(
    procedureId: $procedureId
    limit: $limit
    nextToken: $nextToken
    stateFilter: $stateFilter
    fromCreationDate: $fromCreationDate
    toCreationDate: $toCreationDate
    stage: $stage
    includeReplayWorker: $includeReplayWorker
  ) {
    items {
      id
      owner
      name
      state
      knowledgeId
      departmentId
      procedureId
      createdAt
      originalWorkerId
      state
      stateLastUpdatedAt
      attachments
      replayWorkerId
    }
    nextToken
  }
}
    `;

/**
 * __useListWorkersByProcedureQuery__
 *
 * To run a query within a React component, call `useListWorkersByProcedureQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkersByProcedureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWorkersByProcedureQuery({
 *   variables: {
 *      procedureId: // value for 'procedureId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *      stateFilter: // value for 'stateFilter'
 *      fromCreationDate: // value for 'fromCreationDate'
 *      toCreationDate: // value for 'toCreationDate'
 *      stage: // value for 'stage'
 *      includeReplayWorker: // value for 'includeReplayWorker'
 *   },
 * });
 */
export function useListWorkersByProcedureQuery(baseOptions?: Apollo.QueryHookOptions<ListWorkersByProcedureQuery, ListWorkersByProcedureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWorkersByProcedureQuery, ListWorkersByProcedureQueryVariables>(ListWorkersByProcedureDocument, options);
      }
export function useListWorkersByProcedureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWorkersByProcedureQuery, ListWorkersByProcedureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWorkersByProcedureQuery, ListWorkersByProcedureQueryVariables>(ListWorkersByProcedureDocument, options);
        }
export function useListWorkersByProcedureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListWorkersByProcedureQuery, ListWorkersByProcedureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWorkersByProcedureQuery, ListWorkersByProcedureQueryVariables>(ListWorkersByProcedureDocument, options);
        }
export type ListWorkersByProcedureQueryHookResult = ReturnType<typeof useListWorkersByProcedureQuery>;
export type ListWorkersByProcedureLazyQueryHookResult = ReturnType<typeof useListWorkersByProcedureLazyQuery>;
export type ListWorkersByProcedureSuspenseQueryHookResult = ReturnType<typeof useListWorkersByProcedureSuspenseQuery>;
export type ListWorkersByProcedureQueryResult = Apollo.QueryResult<ListWorkersByProcedureQuery, ListWorkersByProcedureQueryVariables>;
export const ListWorkerOutputsByProcedureDocument = gql`
    query ListWorkerOutputsByProcedure($procedureId: ID!, $knowledgeId: ID, $page: Int, $pageSize: Int = 10, $decodeConcepts: Boolean, $departmentId: ID, $stateFilter: String, $fromDate: String, $toDate: String, $limit: Int = 10, $nextToken: String, $stage: ProcedureStage) {
  listWorkerOutputsByProcedure(
    procedureId: $procedureId
    knowledgeId: $knowledgeId
    page: $page
    pageSize: $pageSize
    decodeConcepts: $decodeConcepts
    departmentId: $departmentId
    stateFilter: $stateFilter
    fromDate: $fromDate
    toDate: $toDate
    limit: $limit
    nextToken: $nextToken
    stage: $stage
  ) {
    columns
    data
    nextToken
  }
}
    `;

/**
 * __useListWorkerOutputsByProcedureQuery__
 *
 * To run a query within a React component, call `useListWorkerOutputsByProcedureQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkerOutputsByProcedureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWorkerOutputsByProcedureQuery({
 *   variables: {
 *      procedureId: // value for 'procedureId'
 *      knowledgeId: // value for 'knowledgeId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      decodeConcepts: // value for 'decodeConcepts'
 *      departmentId: // value for 'departmentId'
 *      stateFilter: // value for 'stateFilter'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *      stage: // value for 'stage'
 *   },
 * });
 */
export function useListWorkerOutputsByProcedureQuery(baseOptions: Apollo.QueryHookOptions<ListWorkerOutputsByProcedureQuery, ListWorkerOutputsByProcedureQueryVariables> & ({ variables: ListWorkerOutputsByProcedureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWorkerOutputsByProcedureQuery, ListWorkerOutputsByProcedureQueryVariables>(ListWorkerOutputsByProcedureDocument, options);
      }
export function useListWorkerOutputsByProcedureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWorkerOutputsByProcedureQuery, ListWorkerOutputsByProcedureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWorkerOutputsByProcedureQuery, ListWorkerOutputsByProcedureQueryVariables>(ListWorkerOutputsByProcedureDocument, options);
        }
export function useListWorkerOutputsByProcedureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListWorkerOutputsByProcedureQuery, ListWorkerOutputsByProcedureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWorkerOutputsByProcedureQuery, ListWorkerOutputsByProcedureQueryVariables>(ListWorkerOutputsByProcedureDocument, options);
        }
export type ListWorkerOutputsByProcedureQueryHookResult = ReturnType<typeof useListWorkerOutputsByProcedureQuery>;
export type ListWorkerOutputsByProcedureLazyQueryHookResult = ReturnType<typeof useListWorkerOutputsByProcedureLazyQuery>;
export type ListWorkerOutputsByProcedureSuspenseQueryHookResult = ReturnType<typeof useListWorkerOutputsByProcedureSuspenseQuery>;
export type ListWorkerOutputsByProcedureQueryResult = Apollo.QueryResult<ListWorkerOutputsByProcedureQuery, ListWorkerOutputsByProcedureQueryVariables>;
export const ListSharedEntityByProcedureDocument = gql`
    query ListSharedEntityByProcedure($departmentId: ID!, $procedureId: ID!, $version: String, $limit: Int = 50, $nextToken: String) {
  listSharedEntityByProcedure(
    departmentId: $departmentId
    procedureId: $procedureId
    version: $version
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      entityId
      departmentId
      shareName
      fullShareId
      departmentVersion
    }
    nextToken
  }
}
    `;

/**
 * __useListSharedEntityByProcedureQuery__
 *
 * To run a query within a React component, call `useListSharedEntityByProcedureQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSharedEntityByProcedureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSharedEntityByProcedureQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      procedureId: // value for 'procedureId'
 *      version: // value for 'version'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useListSharedEntityByProcedureQuery(baseOptions: Apollo.QueryHookOptions<ListSharedEntityByProcedureQuery, ListSharedEntityByProcedureQueryVariables> & ({ variables: ListSharedEntityByProcedureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSharedEntityByProcedureQuery, ListSharedEntityByProcedureQueryVariables>(ListSharedEntityByProcedureDocument, options);
      }
export function useListSharedEntityByProcedureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSharedEntityByProcedureQuery, ListSharedEntityByProcedureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSharedEntityByProcedureQuery, ListSharedEntityByProcedureQueryVariables>(ListSharedEntityByProcedureDocument, options);
        }
export function useListSharedEntityByProcedureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSharedEntityByProcedureQuery, ListSharedEntityByProcedureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSharedEntityByProcedureQuery, ListSharedEntityByProcedureQueryVariables>(ListSharedEntityByProcedureDocument, options);
        }
export type ListSharedEntityByProcedureQueryHookResult = ReturnType<typeof useListSharedEntityByProcedureQuery>;
export type ListSharedEntityByProcedureLazyQueryHookResult = ReturnType<typeof useListSharedEntityByProcedureLazyQuery>;
export type ListSharedEntityByProcedureSuspenseQueryHookResult = ReturnType<typeof useListSharedEntityByProcedureSuspenseQuery>;
export type ListSharedEntityByProcedureQueryResult = Apollo.QueryResult<ListSharedEntityByProcedureQuery, ListSharedEntityByProcedureQueryVariables>;
export const ExportCodeForContextDocument = gql`
    query ExportCodeForContext($workerId: ID!, $contextId: ID) {
  exportCodeForContext(workerId: $workerId, contextId: $contextId)
}
    `;

/**
 * __useExportCodeForContextQuery__
 *
 * To run a query within a React component, call `useExportCodeForContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCodeForContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportCodeForContextQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      contextId: // value for 'contextId'
 *   },
 * });
 */
export function useExportCodeForContextQuery(baseOptions: Apollo.QueryHookOptions<ExportCodeForContextQuery, ExportCodeForContextQueryVariables> & ({ variables: ExportCodeForContextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportCodeForContextQuery, ExportCodeForContextQueryVariables>(ExportCodeForContextDocument, options);
      }
export function useExportCodeForContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportCodeForContextQuery, ExportCodeForContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportCodeForContextQuery, ExportCodeForContextQueryVariables>(ExportCodeForContextDocument, options);
        }
export function useExportCodeForContextSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportCodeForContextQuery, ExportCodeForContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportCodeForContextQuery, ExportCodeForContextQueryVariables>(ExportCodeForContextDocument, options);
        }
export type ExportCodeForContextQueryHookResult = ReturnType<typeof useExportCodeForContextQuery>;
export type ExportCodeForContextLazyQueryHookResult = ReturnType<typeof useExportCodeForContextLazyQuery>;
export type ExportCodeForContextSuspenseQueryHookResult = ReturnType<typeof useExportCodeForContextSuspenseQuery>;
export type ExportCodeForContextQueryResult = Apollo.QueryResult<ExportCodeForContextQuery, ExportCodeForContextQueryVariables>;
export const ListProcedureGroupsByDepartmentDocument = gql`
    query listProcedureGroupsByDepartment($departmentId: String!, $limit: Int = 10, $nextToken: String, $procedureFilter: ListProceduresFilter) {
  listProcedureGroupsByDepartmentv2(
    input: {departmentId: $departmentId, filter: $procedureFilter, paginationInput: {limit: $limit, nextToken: $nextToken}}
  ) {
    items {
      draftProcedure {
        ...procedureData
      }
      publishedProcedure {
        ...procedureData
      }
    }
    nextToken
  }
}
    ${ProcedureDataFragmentDoc}`;

/**
 * __useListProcedureGroupsByDepartmentQuery__
 *
 * To run a query within a React component, call `useListProcedureGroupsByDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProcedureGroupsByDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProcedureGroupsByDepartmentQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *      procedureFilter: // value for 'procedureFilter'
 *   },
 * });
 */
export function useListProcedureGroupsByDepartmentQuery(baseOptions: Apollo.QueryHookOptions<ListProcedureGroupsByDepartmentQuery, ListProcedureGroupsByDepartmentQueryVariables> & ({ variables: ListProcedureGroupsByDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProcedureGroupsByDepartmentQuery, ListProcedureGroupsByDepartmentQueryVariables>(ListProcedureGroupsByDepartmentDocument, options);
      }
export function useListProcedureGroupsByDepartmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProcedureGroupsByDepartmentQuery, ListProcedureGroupsByDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProcedureGroupsByDepartmentQuery, ListProcedureGroupsByDepartmentQueryVariables>(ListProcedureGroupsByDepartmentDocument, options);
        }
export function useListProcedureGroupsByDepartmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListProcedureGroupsByDepartmentQuery, ListProcedureGroupsByDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProcedureGroupsByDepartmentQuery, ListProcedureGroupsByDepartmentQueryVariables>(ListProcedureGroupsByDepartmentDocument, options);
        }
export type ListProcedureGroupsByDepartmentQueryHookResult = ReturnType<typeof useListProcedureGroupsByDepartmentQuery>;
export type ListProcedureGroupsByDepartmentLazyQueryHookResult = ReturnType<typeof useListProcedureGroupsByDepartmentLazyQuery>;
export type ListProcedureGroupsByDepartmentSuspenseQueryHookResult = ReturnType<typeof useListProcedureGroupsByDepartmentSuspenseQuery>;
export type ListProcedureGroupsByDepartmentQueryResult = Apollo.QueryResult<ListProcedureGroupsByDepartmentQuery, ListProcedureGroupsByDepartmentQueryVariables>;
export const ListProcedureGroupsSummaryByDepartmentDocument = gql`
    query listProcedureGroupsSummaryByDepartment($departmentId: String!, $limit: Int = 150, $nextToken: String, $procedureFilter: ListProceduresFilter) {
  proceduresSummary(
    input: {departmentId: $departmentId, filter: $procedureFilter, paginationInput: {limit: $limit, nextToken: $nextToken}}
  ) {
    items {
      draftProcedure {
        ...procedureSummary
      }
      publishedProcedure {
        ...procedureSummary
      }
    }
    nextToken
  }
}
    ${ProcedureSummaryFragmentDoc}`;

/**
 * __useListProcedureGroupsSummaryByDepartmentQuery__
 *
 * To run a query within a React component, call `useListProcedureGroupsSummaryByDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProcedureGroupsSummaryByDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProcedureGroupsSummaryByDepartmentQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *      procedureFilter: // value for 'procedureFilter'
 *   },
 * });
 */
export function useListProcedureGroupsSummaryByDepartmentQuery(baseOptions: Apollo.QueryHookOptions<ListProcedureGroupsSummaryByDepartmentQuery, ListProcedureGroupsSummaryByDepartmentQueryVariables> & ({ variables: ListProcedureGroupsSummaryByDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProcedureGroupsSummaryByDepartmentQuery, ListProcedureGroupsSummaryByDepartmentQueryVariables>(ListProcedureGroupsSummaryByDepartmentDocument, options);
      }
export function useListProcedureGroupsSummaryByDepartmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProcedureGroupsSummaryByDepartmentQuery, ListProcedureGroupsSummaryByDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProcedureGroupsSummaryByDepartmentQuery, ListProcedureGroupsSummaryByDepartmentQueryVariables>(ListProcedureGroupsSummaryByDepartmentDocument, options);
        }
export function useListProcedureGroupsSummaryByDepartmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListProcedureGroupsSummaryByDepartmentQuery, ListProcedureGroupsSummaryByDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProcedureGroupsSummaryByDepartmentQuery, ListProcedureGroupsSummaryByDepartmentQueryVariables>(ListProcedureGroupsSummaryByDepartmentDocument, options);
        }
export type ListProcedureGroupsSummaryByDepartmentQueryHookResult = ReturnType<typeof useListProcedureGroupsSummaryByDepartmentQuery>;
export type ListProcedureGroupsSummaryByDepartmentLazyQueryHookResult = ReturnType<typeof useListProcedureGroupsSummaryByDepartmentLazyQuery>;
export type ListProcedureGroupsSummaryByDepartmentSuspenseQueryHookResult = ReturnType<typeof useListProcedureGroupsSummaryByDepartmentSuspenseQuery>;
export type ListProcedureGroupsSummaryByDepartmentQueryResult = Apollo.QueryResult<ListProcedureGroupsSummaryByDepartmentQuery, ListProcedureGroupsSummaryByDepartmentQueryVariables>;
export const GetProcedureVisualizationUrlDocument = gql`
    query GetProcedureVisualizationUrl($procedureId: ID!, $departmentId: ID!, $onlyIfExists: Boolean = false, $expiresIn: Int = 300, $procedureStage: ProcedureStage = null) {
  getProcedureVisualizationUrl(
    procedureId: $procedureId
    departmentId: $departmentId
    onlyIfExists: $onlyIfExists
    expiresIn: $expiresIn
    procedureStage: $procedureStage
  ) {
    s3Url
    presignedUrl
  }
}
    `;

/**
 * __useGetProcedureVisualizationUrlQuery__
 *
 * To run a query within a React component, call `useGetProcedureVisualizationUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcedureVisualizationUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcedureVisualizationUrlQuery({
 *   variables: {
 *      procedureId: // value for 'procedureId'
 *      departmentId: // value for 'departmentId'
 *      onlyIfExists: // value for 'onlyIfExists'
 *      expiresIn: // value for 'expiresIn'
 *      procedureStage: // value for 'procedureStage'
 *   },
 * });
 */
export function useGetProcedureVisualizationUrlQuery(baseOptions: Apollo.QueryHookOptions<GetProcedureVisualizationUrlQuery, GetProcedureVisualizationUrlQueryVariables> & ({ variables: GetProcedureVisualizationUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcedureVisualizationUrlQuery, GetProcedureVisualizationUrlQueryVariables>(GetProcedureVisualizationUrlDocument, options);
      }
export function useGetProcedureVisualizationUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcedureVisualizationUrlQuery, GetProcedureVisualizationUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcedureVisualizationUrlQuery, GetProcedureVisualizationUrlQueryVariables>(GetProcedureVisualizationUrlDocument, options);
        }
export function useGetProcedureVisualizationUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcedureVisualizationUrlQuery, GetProcedureVisualizationUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcedureVisualizationUrlQuery, GetProcedureVisualizationUrlQueryVariables>(GetProcedureVisualizationUrlDocument, options);
        }
export type GetProcedureVisualizationUrlQueryHookResult = ReturnType<typeof useGetProcedureVisualizationUrlQuery>;
export type GetProcedureVisualizationUrlLazyQueryHookResult = ReturnType<typeof useGetProcedureVisualizationUrlLazyQuery>;
export type GetProcedureVisualizationUrlSuspenseQueryHookResult = ReturnType<typeof useGetProcedureVisualizationUrlSuspenseQuery>;
export type GetProcedureVisualizationUrlQueryResult = Apollo.QueryResult<GetProcedureVisualizationUrlQuery, GetProcedureVisualizationUrlQueryVariables>;
export const ProcedureGroupDocument = gql`
    query procedureGroup($procedureId: ID!, $departmentId: ID!) {
  procedureGroup(procedureId: $procedureId, departmentId: $departmentId) {
    draftProcedure {
      ...procedureData
    }
    publishedProcedure {
      ...procedureData
      schedules {
        name
        expression
        enabled
      }
    }
  }
}
    ${ProcedureDataFragmentDoc}`;

/**
 * __useProcedureGroupQuery__
 *
 * To run a query within a React component, call `useProcedureGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcedureGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcedureGroupQuery({
 *   variables: {
 *      procedureId: // value for 'procedureId'
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useProcedureGroupQuery(baseOptions: Apollo.QueryHookOptions<ProcedureGroupQuery, ProcedureGroupQueryVariables> & ({ variables: ProcedureGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcedureGroupQuery, ProcedureGroupQueryVariables>(ProcedureGroupDocument, options);
      }
export function useProcedureGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcedureGroupQuery, ProcedureGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcedureGroupQuery, ProcedureGroupQueryVariables>(ProcedureGroupDocument, options);
        }
export function useProcedureGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProcedureGroupQuery, ProcedureGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProcedureGroupQuery, ProcedureGroupQueryVariables>(ProcedureGroupDocument, options);
        }
export type ProcedureGroupQueryHookResult = ReturnType<typeof useProcedureGroupQuery>;
export type ProcedureGroupLazyQueryHookResult = ReturnType<typeof useProcedureGroupLazyQuery>;
export type ProcedureGroupSuspenseQueryHookResult = ReturnType<typeof useProcedureGroupSuspenseQuery>;
export type ProcedureGroupQueryResult = Apollo.QueryResult<ProcedureGroupQuery, ProcedureGroupQueryVariables>;
export const ProceduresMetricDocument = gql`
    query proceduresMetric($procedureIDs: [ID!]!, $departmentId: ID!, $startDate: String!, $endDate: String!, $timezone: String!) {
  proceduresMetric(
    input: {procedureIDs: $procedureIDs, departmentId: $departmentId, timezone: $timezone}
  ) {
    runMetric(startDate: $startDate, endDate: $endDate) {
      procedureID
      metric {
        totalRuns {
          values {
            date
            count
          }
        }
        runsWithException {
          values {
            date
            count
          }
          trendData {
            percentageChange
          }
        }
        completedRuns {
          values {
            date
            count
          }
          trendData {
            percentageChange
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProceduresMetricQuery__
 *
 * To run a query within a React component, call `useProceduresMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useProceduresMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProceduresMetricQuery({
 *   variables: {
 *      procedureIDs: // value for 'procedureIDs'
 *      departmentId: // value for 'departmentId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useProceduresMetricQuery(baseOptions: Apollo.QueryHookOptions<ProceduresMetricQuery, ProceduresMetricQueryVariables> & ({ variables: ProceduresMetricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProceduresMetricQuery, ProceduresMetricQueryVariables>(ProceduresMetricDocument, options);
      }
export function useProceduresMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProceduresMetricQuery, ProceduresMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProceduresMetricQuery, ProceduresMetricQueryVariables>(ProceduresMetricDocument, options);
        }
export function useProceduresMetricSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProceduresMetricQuery, ProceduresMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProceduresMetricQuery, ProceduresMetricQueryVariables>(ProceduresMetricDocument, options);
        }
export type ProceduresMetricQueryHookResult = ReturnType<typeof useProceduresMetricQuery>;
export type ProceduresMetricLazyQueryHookResult = ReturnType<typeof useProceduresMetricLazyQuery>;
export type ProceduresMetricSuspenseQueryHookResult = ReturnType<typeof useProceduresMetricSuspenseQuery>;
export type ProceduresMetricQueryResult = Apollo.QueryResult<ProceduresMetricQuery, ProceduresMetricQueryVariables>;
export const GetUnhandledRequestMetricDocument = gql`
    query getUnhandledRequestMetric($procedureIDs: [ID!]!, $departmentId: ID!, $endDate: String!, $timezone: String!, $startDate: String!) {
  proceduresMetric(
    input: {procedureIDs: $procedureIDs, departmentId: $departmentId, timezone: $timezone}
  ) {
    requestMetric(startDate: $startDate, endDate: $endDate) {
      procedureID
      metric {
        unhandledRequest {
          values {
            date
            count
          }
          trendData {
            percentageChange
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetUnhandledRequestMetricQuery__
 *
 * To run a query within a React component, call `useGetUnhandledRequestMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnhandledRequestMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnhandledRequestMetricQuery({
 *   variables: {
 *      procedureIDs: // value for 'procedureIDs'
 *      departmentId: // value for 'departmentId'
 *      endDate: // value for 'endDate'
 *      timezone: // value for 'timezone'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetUnhandledRequestMetricQuery(baseOptions: Apollo.QueryHookOptions<GetUnhandledRequestMetricQuery, GetUnhandledRequestMetricQueryVariables> & ({ variables: GetUnhandledRequestMetricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnhandledRequestMetricQuery, GetUnhandledRequestMetricQueryVariables>(GetUnhandledRequestMetricDocument, options);
      }
export function useGetUnhandledRequestMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnhandledRequestMetricQuery, GetUnhandledRequestMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnhandledRequestMetricQuery, GetUnhandledRequestMetricQueryVariables>(GetUnhandledRequestMetricDocument, options);
        }
export function useGetUnhandledRequestMetricSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnhandledRequestMetricQuery, GetUnhandledRequestMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnhandledRequestMetricQuery, GetUnhandledRequestMetricQueryVariables>(GetUnhandledRequestMetricDocument, options);
        }
export type GetUnhandledRequestMetricQueryHookResult = ReturnType<typeof useGetUnhandledRequestMetricQuery>;
export type GetUnhandledRequestMetricLazyQueryHookResult = ReturnType<typeof useGetUnhandledRequestMetricLazyQuery>;
export type GetUnhandledRequestMetricSuspenseQueryHookResult = ReturnType<typeof useGetUnhandledRequestMetricSuspenseQuery>;
export type GetUnhandledRequestMetricQueryResult = Apollo.QueryResult<GetUnhandledRequestMetricQuery, GetUnhandledRequestMetricQueryVariables>;
export const ListRequestsByProcedureDocument = gql`
    query ListRequestsByProcedure($procedureId: ID!, $departmentId: ID!, $limit: Int = 100, $nextToken: String, $state: RequestState, $procedureStage: ProcedureStage) {
  listRequestsByProcedure(
    procedureId: $procedureId
    departmentId: $departmentId
    limit: $limit
    nextToken: $nextToken
    state: $state
    procedureStage: $procedureStage
  ) {
    items {
      id
      stepPath
      contextId
      sentenceId
      createdAt
      handledAt
      state
      worker {
        id
        knowledgeId
      }
      uiConcepts
      questions {
        id
        text
        contextId
        sentenceId
        answerTypeHint
        ... on NativeCodeErrorQuestion {
          errorType
          errorMessage
          errorTraceback
        }
        ... on ReviewConceptQuestion {
          lexicalPath
          conceptId
        }
        ... on ValueNotKnownQuestion {
          lexicalPath
          choices
          helpText
          isPlural
        }
        ... on DomainNotIntegratedQuestion {
          domain
        }
        ... on MissingIntegrationCredentialQuestion {
          domain
        }
      }
      answers {
        id
        requestId
        questionId
        action {
          _
          ... on RetryStepAction {
            minimumDelay
            timeout
          }
          ... on UseConceptAction {
            conceptId
          }
          ... on UseLiteralValueAction {
            literalValue
          }
          ... on UseTechniqueAction {
            technique
          }
        }
        createdAt
        createdBy
      }
      contextPath {
        ctxId
        sentenceId
      }
    }
    limit
    nextToken
  }
}
    `;

/**
 * __useListRequestsByProcedureQuery__
 *
 * To run a query within a React component, call `useListRequestsByProcedureQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRequestsByProcedureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRequestsByProcedureQuery({
 *   variables: {
 *      procedureId: // value for 'procedureId'
 *      departmentId: // value for 'departmentId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *      state: // value for 'state'
 *      procedureStage: // value for 'procedureStage'
 *   },
 * });
 */
export function useListRequestsByProcedureQuery(baseOptions: Apollo.QueryHookOptions<ListRequestsByProcedureQuery, ListRequestsByProcedureQueryVariables> & ({ variables: ListRequestsByProcedureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRequestsByProcedureQuery, ListRequestsByProcedureQueryVariables>(ListRequestsByProcedureDocument, options);
      }
export function useListRequestsByProcedureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRequestsByProcedureQuery, ListRequestsByProcedureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRequestsByProcedureQuery, ListRequestsByProcedureQueryVariables>(ListRequestsByProcedureDocument, options);
        }
export function useListRequestsByProcedureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListRequestsByProcedureQuery, ListRequestsByProcedureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListRequestsByProcedureQuery, ListRequestsByProcedureQueryVariables>(ListRequestsByProcedureDocument, options);
        }
export type ListRequestsByProcedureQueryHookResult = ReturnType<typeof useListRequestsByProcedureQuery>;
export type ListRequestsByProcedureLazyQueryHookResult = ReturnType<typeof useListRequestsByProcedureLazyQuery>;
export type ListRequestsByProcedureSuspenseQueryHookResult = ReturnType<typeof useListRequestsByProcedureSuspenseQuery>;
export type ListRequestsByProcedureQueryResult = Apollo.QueryResult<ListRequestsByProcedureQuery, ListRequestsByProcedureQueryVariables>;
export const GetRequestDocument = gql`
    query GetRequest($id: ID!) {
  getRequest(id: $id) {
    id
    stepPath
    contextId
    sentenceId
    createdAt
    handledAt
    state
    procedureId
    worker {
      id
      knowledgeId
    }
    uiConcepts
    questions {
      id
      text
      contextId
      sentenceId
      answerTypeHint
      ... on NativeCodeErrorQuestion {
        errorType
        errorMessage
        errorTraceback
      }
      ... on ReviewConceptQuestion {
        lexicalPath
        conceptId
      }
      ... on ValueNotKnownQuestion {
        lexicalPath
        choices
        helpText
        isPlural
      }
      ... on DomainNotIntegratedQuestion {
        domain
      }
      ... on MissingIntegrationCredentialQuestion {
        domain
      }
    }
    answers {
      id
      requestId
      questionId
      action {
        _
        ... on RetryStepAction {
          minimumDelay
          timeout
        }
        ... on UseConceptAction {
          conceptId
        }
        ... on UseLiteralValueAction {
          literalValue
        }
        ... on UseTechniqueAction {
          technique
        }
      }
      createdAt
      createdBy
    }
    contextPath {
      ctxId
      sentenceId
    }
  }
}
    `;

/**
 * __useGetRequestQuery__
 *
 * To run a query within a React component, call `useGetRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRequestQuery(baseOptions: Apollo.QueryHookOptions<GetRequestQuery, GetRequestQueryVariables> & ({ variables: GetRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestQuery, GetRequestQueryVariables>(GetRequestDocument, options);
      }
export function useGetRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestQuery, GetRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestQuery, GetRequestQueryVariables>(GetRequestDocument, options);
        }
export function useGetRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequestQuery, GetRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequestQuery, GetRequestQueryVariables>(GetRequestDocument, options);
        }
export type GetRequestQueryHookResult = ReturnType<typeof useGetRequestQuery>;
export type GetRequestLazyQueryHookResult = ReturnType<typeof useGetRequestLazyQuery>;
export type GetRequestSuspenseQueryHookResult = ReturnType<typeof useGetRequestSuspenseQuery>;
export type GetRequestQueryResult = Apollo.QueryResult<GetRequestQuery, GetRequestQueryVariables>;
export const GetRequestAnswerDocument = gql`
    query GetRequestAnswer($id: ID!) {
  getRequestAnswer(id: $id) {
    id
    requestId
    questionId
    action {
      _
      ... on ReplaceStepAction {
        newSteps
      }
      ... on RetryStepAction {
        minimumDelay
        timeout
      }
      ... on UseConceptAction {
        conceptId
      }
      ... on UseLiteralValueAction {
        literalValue
        choices
      }
      ... on UseTechniqueAction {
        technique
      }
    }
    sourceLearning {
      id
    }
    derivedLearning {
      id
    }
    createdAt
    createdBy
    summary
  }
}
    `;

/**
 * __useGetRequestAnswerQuery__
 *
 * To run a query within a React component, call `useGetRequestAnswerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestAnswerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestAnswerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRequestAnswerQuery(baseOptions: Apollo.QueryHookOptions<GetRequestAnswerQuery, GetRequestAnswerQueryVariables> & ({ variables: GetRequestAnswerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestAnswerQuery, GetRequestAnswerQueryVariables>(GetRequestAnswerDocument, options);
      }
export function useGetRequestAnswerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestAnswerQuery, GetRequestAnswerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestAnswerQuery, GetRequestAnswerQueryVariables>(GetRequestAnswerDocument, options);
        }
export function useGetRequestAnswerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequestAnswerQuery, GetRequestAnswerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequestAnswerQuery, GetRequestAnswerQueryVariables>(GetRequestAnswerDocument, options);
        }
export type GetRequestAnswerQueryHookResult = ReturnType<typeof useGetRequestAnswerQuery>;
export type GetRequestAnswerLazyQueryHookResult = ReturnType<typeof useGetRequestAnswerLazyQuery>;
export type GetRequestAnswerSuspenseQueryHookResult = ReturnType<typeof useGetRequestAnswerSuspenseQuery>;
export type GetRequestAnswerQueryResult = Apollo.QueryResult<GetRequestAnswerQuery, GetRequestAnswerQueryVariables>;
export const GetUserDocument = gql`
    query getUser($departmentId: ID) {
  getUser(departmentId: $departmentId) {
    firstName
    lastName
    username
    company
    role
    preferences {
      lastUsedDepartmentId
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const OnNotifyKChatMessageUpdateDocument = gql`
    subscription OnNotifyKChatMessageUpdate($workerId: ID!, $departmentId: ID!) {
  onNotifyKChatMessageUpdate(workerId: $workerId, departmentId: $departmentId) {
    id
    departmentId
    workerId
    message
    timestamp
    displayName
    role
  }
}
    `;

/**
 * __useOnNotifyKChatMessageUpdateSubscription__
 *
 * To run a query within a React component, call `useOnNotifyKChatMessageUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNotifyKChatMessageUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNotifyKChatMessageUpdateSubscription({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useOnNotifyKChatMessageUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnNotifyKChatMessageUpdateSubscription, OnNotifyKChatMessageUpdateSubscriptionVariables> & ({ variables: OnNotifyKChatMessageUpdateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnNotifyKChatMessageUpdateSubscription, OnNotifyKChatMessageUpdateSubscriptionVariables>(OnNotifyKChatMessageUpdateDocument, options);
      }
export type OnNotifyKChatMessageUpdateSubscriptionHookResult = ReturnType<typeof useOnNotifyKChatMessageUpdateSubscription>;
export type OnNotifyKChatMessageUpdateSubscriptionResult = Apollo.SubscriptionResult<OnNotifyKChatMessageUpdateSubscription>;
export const OnPingDocument = gql`
    subscription OnPing($channel: String!) {
  onPing(channel: $channel) {
    channel
    data
  }
}
    `;

/**
 * __useOnPingSubscription__
 *
 * To run a query within a React component, call `useOnPingSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnPingSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnPingSubscription({
 *   variables: {
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useOnPingSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnPingSubscription, OnPingSubscriptionVariables> & ({ variables: OnPingSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnPingSubscription, OnPingSubscriptionVariables>(OnPingDocument, options);
      }
export type OnPingSubscriptionHookResult = ReturnType<typeof useOnPingSubscription>;
export type OnPingSubscriptionResult = Apollo.SubscriptionResult<OnPingSubscription>;
export const OnWorkerSentenceUpdateDocument = gql`
    subscription onWorkerSentenceUpdate($workerId: ID!, $documentToken: String) {
  onSentenceUpdate(workerId: $workerId, documentToken: $documentToken) {
    sentences {
      answer
      concepts
      epoch
      iterationTokens
      lineId
      requests
      status
      token
      epoch
      subDocuments {
        documentToken
        processName
      }
      miniPlaygrounds {
        documentToken
        processName
      }
      startedAt
      completedAt
    }
  }
}
    `;

/**
 * __useOnWorkerSentenceUpdateSubscription__
 *
 * To run a query within a React component, call `useOnWorkerSentenceUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnWorkerSentenceUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnWorkerSentenceUpdateSubscription({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      documentToken: // value for 'documentToken'
 *   },
 * });
 */
export function useOnWorkerSentenceUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnWorkerSentenceUpdateSubscription, OnWorkerSentenceUpdateSubscriptionVariables> & ({ variables: OnWorkerSentenceUpdateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnWorkerSentenceUpdateSubscription, OnWorkerSentenceUpdateSubscriptionVariables>(OnWorkerSentenceUpdateDocument, options);
      }
export type OnWorkerSentenceUpdateSubscriptionHookResult = ReturnType<typeof useOnWorkerSentenceUpdateSubscription>;
export type OnWorkerSentenceUpdateSubscriptionResult = Apollo.SubscriptionResult<OnWorkerSentenceUpdateSubscription>;
export const OnMiniPgSentenceUpdateDocument = gql`
    subscription onMiniPGSentenceUpdate($workerId: ID!, $documentToken: String) {
  onSentenceUpdate(workerId: $workerId, documentToken: $documentToken) {
    sentences {
      lineId
      token
      miniPlaygrounds {
        documentToken
        processName
      }
    }
  }
}
    `;

/**
 * __useOnMiniPgSentenceUpdateSubscription__
 *
 * To run a query within a React component, call `useOnMiniPgSentenceUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMiniPgSentenceUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMiniPgSentenceUpdateSubscription({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      documentToken: // value for 'documentToken'
 *   },
 * });
 */
export function useOnMiniPgSentenceUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnMiniPgSentenceUpdateSubscription, OnMiniPgSentenceUpdateSubscriptionVariables> & ({ variables: OnMiniPgSentenceUpdateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnMiniPgSentenceUpdateSubscription, OnMiniPgSentenceUpdateSubscriptionVariables>(OnMiniPgSentenceUpdateDocument, options);
      }
export type OnMiniPgSentenceUpdateSubscriptionHookResult = ReturnType<typeof useOnMiniPgSentenceUpdateSubscription>;
export type OnMiniPgSentenceUpdateSubscriptionResult = Apollo.SubscriptionResult<OnMiniPgSentenceUpdateSubscription>;
export const OnWorkerUpdateDocument = gql`
    subscription OnWorkerUpdate($id: ID!) {
  onNotifyWorkerUpdate(id: $id) {
    id
    owner
    readers
    editors
    name
    description
    version
    departmentVersion
    knowledgeId
    departmentId
    procedureId
    entryCommand
    entryCommandId
    originalWorkerId
    createdAt
    state
    stage
    stateLastUpdatedAt
    attachments
    isArchived
    features
    replayWorkerId
    ...WorkerForkExecutionInfo
  }
}
    ${WorkerForkExecutionInfoFragmentDoc}`;

/**
 * __useOnWorkerUpdateSubscription__
 *
 * To run a query within a React component, call `useOnWorkerUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnWorkerUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnWorkerUpdateSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnWorkerUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnWorkerUpdateSubscription, OnWorkerUpdateSubscriptionVariables> & ({ variables: OnWorkerUpdateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnWorkerUpdateSubscription, OnWorkerUpdateSubscriptionVariables>(OnWorkerUpdateDocument, options);
      }
export type OnWorkerUpdateSubscriptionHookResult = ReturnType<typeof useOnWorkerUpdateSubscription>;
export type OnWorkerUpdateSubscriptionResult = Apollo.SubscriptionResult<OnWorkerUpdateSubscription>;
export const OnWorkerStateUpdateDocument = gql`
    subscription OnWorkerStateUpdate($id: ID, $procedureId: ID) {
  onNotifyWorkerUpdate(id: $id, procedureId: $procedureId) {
    id
    state
  }
}
    `;

/**
 * __useOnWorkerStateUpdateSubscription__
 *
 * To run a query within a React component, call `useOnWorkerStateUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnWorkerStateUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnWorkerStateUpdateSubscription({
 *   variables: {
 *      id: // value for 'id'
 *      procedureId: // value for 'procedureId'
 *   },
 * });
 */
export function useOnWorkerStateUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnWorkerStateUpdateSubscription, OnWorkerStateUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnWorkerStateUpdateSubscription, OnWorkerStateUpdateSubscriptionVariables>(OnWorkerStateUpdateDocument, options);
      }
export type OnWorkerStateUpdateSubscriptionHookResult = ReturnType<typeof useOnWorkerStateUpdateSubscription>;
export type OnWorkerStateUpdateSubscriptionResult = Apollo.SubscriptionResult<OnWorkerStateUpdateSubscription>;
export const OnWorkerDocumentUpdateDocument = gql`
    subscription OnWorkerDocumentUpdate($workerId: ID!) {
  onWorkerDocumentUpdate(workerId: $workerId) {
    sentences {
      text
      parentId
      language
      lineId
      metadata {
        lineId
        parentId
      }
      internalMetadata {
        key
        value
      }
    }
    updatedAt
  }
}
    `;

/**
 * __useOnWorkerDocumentUpdateSubscription__
 *
 * To run a query within a React component, call `useOnWorkerDocumentUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnWorkerDocumentUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnWorkerDocumentUpdateSubscription({
 *   variables: {
 *      workerId: // value for 'workerId'
 *   },
 * });
 */
export function useOnWorkerDocumentUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnWorkerDocumentUpdateSubscription, OnWorkerDocumentUpdateSubscriptionVariables> & ({ variables: OnWorkerDocumentUpdateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnWorkerDocumentUpdateSubscription, OnWorkerDocumentUpdateSubscriptionVariables>(OnWorkerDocumentUpdateDocument, options);
      }
export type OnWorkerDocumentUpdateSubscriptionHookResult = ReturnType<typeof useOnWorkerDocumentUpdateSubscription>;
export type OnWorkerDocumentUpdateSubscriptionResult = Apollo.SubscriptionResult<OnWorkerDocumentUpdateSubscription>;
export const OnWorkerStatusDocument = gql`
    subscription OnWorkerStatus($id: ID!) {
  onWorkerStatus(id: $id) {
    id
    mood
    operation
    icons
    what
  }
}
    `;

/**
 * __useOnWorkerStatusSubscription__
 *
 * To run a query within a React component, call `useOnWorkerStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnWorkerStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnWorkerStatusSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnWorkerStatusSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnWorkerStatusSubscription, OnWorkerStatusSubscriptionVariables> & ({ variables: OnWorkerStatusSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnWorkerStatusSubscription, OnWorkerStatusSubscriptionVariables>(OnWorkerStatusDocument, options);
      }
export type OnWorkerStatusSubscriptionHookResult = ReturnType<typeof useOnWorkerStatusSubscription>;
export type OnWorkerStatusSubscriptionResult = Apollo.SubscriptionResult<OnWorkerStatusSubscription>;
export const OnNotifyWorkerCreationDocument = gql`
    subscription OnNotifyWorkerCreation($procedureId: ID!) {
  onNotifyWorkerCreation(procedureId: $procedureId) {
    id
    name
    createdAt
    originalWorkerId
    state
    attachments
    owner
    departmentId
    procedureId
    stage
  }
}
    `;

/**
 * __useOnNotifyWorkerCreationSubscription__
 *
 * To run a query within a React component, call `useOnNotifyWorkerCreationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNotifyWorkerCreationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNotifyWorkerCreationSubscription({
 *   variables: {
 *      procedureId: // value for 'procedureId'
 *   },
 * });
 */
export function useOnNotifyWorkerCreationSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnNotifyWorkerCreationSubscription, OnNotifyWorkerCreationSubscriptionVariables> & ({ variables: OnNotifyWorkerCreationSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnNotifyWorkerCreationSubscription, OnNotifyWorkerCreationSubscriptionVariables>(OnNotifyWorkerCreationDocument, options);
      }
export type OnNotifyWorkerCreationSubscriptionHookResult = ReturnType<typeof useOnNotifyWorkerCreationSubscription>;
export type OnNotifyWorkerCreationSubscriptionResult = Apollo.SubscriptionResult<OnNotifyWorkerCreationSubscription>;